import { jsx as Q, jsxs as l0, Fragment as O3 } from "react/jsx-runtime";
import { useFloating as w3, useTransitionStatus as S3, useClick as T3, useRole as N3, useDismiss as V3, useInteractions as z3, useId as y1, useMergeRefs as x3, FloatingPortal as I3, FloatingOverlay as Z3, FloatingFocusManager as B3 } from "@floating-ui/react";
import U3 from "clsx";
import r0, { forwardRef as T0, useState as F3, useRef as $3, useEffect as C1, useMemo as j3, isValidElement as A1, cloneElement as k3, useCallback as W3 } from "react";
const I0 = (e) => U3(e);
function s0(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Z0, D1;
function A0() {
  if (D1) return Z0;
  D1 = 1;
  var e = function(a, t, r, n, c, u, l, o) {
    if (process.env.NODE_ENV !== "production" && t === void 0)
      throw new Error("invariant requires an error message argument");
    if (!a) {
      var i;
      if (t === void 0)
        i = new Error(
          "Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings."
        );
      else {
        var s = [r, n, c, u, l, o], d = 0;
        i = new Error(
          t.replace(/%s/g, function() {
            return s[d++];
          })
        ), i.name = "Invariant Violation";
      }
      throw i.framesToPop = 1, i;
    }
  };
  return Z0 = e, Z0;
}
var Y3 = A0();
const J = /* @__PURE__ */ s0(Y3);
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var B0, P1;
function l1() {
  if (P1) return B0;
  P1 = 1;
  var e = Object.getOwnPropertySymbols, a = Object.prototype.hasOwnProperty, t = Object.prototype.propertyIsEnumerable;
  function r(c) {
    if (c == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(c);
  }
  function n() {
    try {
      if (!Object.assign)
        return !1;
      var c = new String("abc");
      if (c[5] = "de", Object.getOwnPropertyNames(c)[0] === "5")
        return !1;
      for (var u = {}, l = 0; l < 10; l++)
        u["_" + String.fromCharCode(l)] = l;
      var o = Object.getOwnPropertyNames(u).map(function(s) {
        return u[s];
      });
      if (o.join("") !== "0123456789")
        return !1;
      var i = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(s) {
        i[s] = s;
      }), Object.keys(Object.assign({}, i)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return B0 = n() ? Object.assign : function(c, u) {
    for (var l, o = r(c), i, s = 1; s < arguments.length; s++) {
      l = Object(arguments[s]);
      for (var d in l)
        a.call(l, d) && (o[d] = l[d]);
      if (e) {
        i = e(l);
        for (var f = 0; f < i.length; f++)
          t.call(l, i[f]) && (o[i[f]] = l[i[f]]);
      }
    }
    return o;
  }, B0;
}
var U0, M1;
function G3() {
  if (M1) return U0;
  M1 = 1;
  var e = l1(), a = {};
  process.env.NODE_ENV !== "production" && Object.freeze(a);
  var t = function(d) {
  };
  process.env.NODE_ENV !== "production" && (t = function(d) {
    if (d === void 0)
      throw new Error("invariant requires an error message argument");
  });
  function r(s, d, f, v, h, y, g, p) {
    if (t(d), !s) {
      var P;
      if (d === void 0)
        P = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
      else {
        var b = [f, v, h, y, g, p], H = 0;
        P = new Error(d.replace(/%s/g, function() {
          return b[H++];
        })), P.name = "Invariant Violation";
      }
      throw P.framesToPop = 1, P;
    }
  }
  var n = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var c = function(d) {
      for (var f = arguments.length, v = Array(f > 1 ? f - 1 : 0), h = 1; h < f; h++)
        v[h - 1] = arguments[h];
      var y = 0, g = "Warning: " + d.replace(/%s/g, function() {
        return v[y++];
      });
      typeof console < "u" && console.error(g);
      try {
        throw new Error(g);
      } catch {
      }
    };
    n = function(d, f) {
      if (f === void 0)
        throw new Error("`warning(condition, format, ...args)` requires a warning message argument");
      if (f.indexOf("Failed Composite propType: ") !== 0 && !d) {
        for (var v = arguments.length, h = Array(v > 2 ? v - 2 : 0), y = 2; y < v; y++)
          h[y - 2] = arguments[y];
        c.apply(void 0, [f].concat(h));
      }
    };
  }
  var u = "mixins";
  function l(s) {
    return s;
  }
  var o;
  process.env.NODE_ENV !== "production" ? o = {
    prop: "prop",
    context: "context",
    childContext: "child context"
  } : o = {};
  function i(s, d, f) {
    var v = [], h = {
      /**
       * An array of Mixin objects to include when defining your component.
       *
       * @type {array}
       * @optional
       */
      mixins: "DEFINE_MANY",
      /**
       * An object containing properties and methods that should be defined on
       * the component's constructor instead of its prototype (static methods).
       *
       * @type {object}
       * @optional
       */
      statics: "DEFINE_MANY",
      /**
       * Definition of prop types for this component.
       *
       * @type {object}
       * @optional
       */
      propTypes: "DEFINE_MANY",
      /**
       * Definition of context types for this component.
       *
       * @type {object}
       * @optional
       */
      contextTypes: "DEFINE_MANY",
      /**
       * Definition of context types this component sets for its children.
       *
       * @type {object}
       * @optional
       */
      childContextTypes: "DEFINE_MANY",
      // ==== Definition methods ====
      /**
       * Invoked when the component is mounted. Values in the mapping will be set on
       * `this.props` if that prop is not specified (i.e. using an `in` check).
       *
       * This method is invoked before `getInitialState` and therefore cannot rely
       * on `this.state` or use `this.setState`.
       *
       * @return {object}
       * @optional
       */
      getDefaultProps: "DEFINE_MANY_MERGED",
      /**
       * Invoked once before the component is mounted. The return value will be used
       * as the initial value of `this.state`.
       *
       *   getInitialState: function() {
       *     return {
       *       isOn: false,
       *       fooBaz: new BazFoo()
       *     }
       *   }
       *
       * @return {object}
       * @optional
       */
      getInitialState: "DEFINE_MANY_MERGED",
      /**
       * @return {object}
       * @optional
       */
      getChildContext: "DEFINE_MANY_MERGED",
      /**
       * Uses props from `this.props` and state from `this.state` to render the
       * structure of the component.
       *
       * No guarantees are made about when or how often this method is invoked, so
       * it must not have side effects.
       *
       *   render: function() {
       *     var name = this.props.name;
       *     return <div>Hello, {name}!</div>;
       *   }
       *
       * @return {ReactComponent}
       * @required
       */
      render: "DEFINE_ONCE",
      // ==== Delegate methods ====
      /**
       * Invoked when the component is initially created and about to be mounted.
       * This may have side effects, but any external subscriptions or data created
       * by this method must be cleaned up in `componentWillUnmount`.
       *
       * @optional
       */
      componentWillMount: "DEFINE_MANY",
      /**
       * Invoked when the component has been mounted and has a DOM representation.
       * However, there is no guarantee that the DOM node is in the document.
       *
       * Use this as an opportunity to operate on the DOM when the component has
       * been mounted (initialized and rendered) for the first time.
       *
       * @param {DOMElement} rootNode DOM element representing the component.
       * @optional
       */
      componentDidMount: "DEFINE_MANY",
      /**
       * Invoked before the component receives new props.
       *
       * Use this as an opportunity to react to a prop transition by updating the
       * state using `this.setState`. Current props are accessed via `this.props`.
       *
       *   componentWillReceiveProps: function(nextProps, nextContext) {
       *     this.setState({
       *       likesIncreasing: nextProps.likeCount > this.props.likeCount
       *     });
       *   }
       *
       * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
       * transition may cause a state change, but the opposite is not true. If you
       * need it, you are probably looking for `componentWillUpdate`.
       *
       * @param {object} nextProps
       * @optional
       */
      componentWillReceiveProps: "DEFINE_MANY",
      /**
       * Invoked while deciding if the component should be updated as a result of
       * receiving new props, state and/or context.
       *
       * Use this as an opportunity to `return false` when you're certain that the
       * transition to the new props/state/context will not require a component
       * update.
       *
       *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
       *     return !equal(nextProps, this.props) ||
       *       !equal(nextState, this.state) ||
       *       !equal(nextContext, this.context);
       *   }
       *
       * @param {object} nextProps
       * @param {?object} nextState
       * @param {?object} nextContext
       * @return {boolean} True if the component should update.
       * @optional
       */
      shouldComponentUpdate: "DEFINE_ONCE",
      /**
       * Invoked when the component is about to update due to a transition from
       * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
       * and `nextContext`.
       *
       * Use this as an opportunity to perform preparation before an update occurs.
       *
       * NOTE: You **cannot** use `this.setState()` in this method.
       *
       * @param {object} nextProps
       * @param {?object} nextState
       * @param {?object} nextContext
       * @param {ReactReconcileTransaction} transaction
       * @optional
       */
      componentWillUpdate: "DEFINE_MANY",
      /**
       * Invoked when the component's DOM representation has been updated.
       *
       * Use this as an opportunity to operate on the DOM when the component has
       * been updated.
       *
       * @param {object} prevProps
       * @param {?object} prevState
       * @param {?object} prevContext
       * @param {DOMElement} rootNode DOM element representing the component.
       * @optional
       */
      componentDidUpdate: "DEFINE_MANY",
      /**
       * Invoked when the component is about to be removed from its parent and have
       * its DOM representation destroyed.
       *
       * Use this as an opportunity to deallocate any external resources.
       *
       * NOTE: There is no `componentDidUnmount` since your component will have been
       * destroyed by that point.
       *
       * @optional
       */
      componentWillUnmount: "DEFINE_MANY",
      /**
       * Replacement for (deprecated) `componentWillMount`.
       *
       * @optional
       */
      UNSAFE_componentWillMount: "DEFINE_MANY",
      /**
       * Replacement for (deprecated) `componentWillReceiveProps`.
       *
       * @optional
       */
      UNSAFE_componentWillReceiveProps: "DEFINE_MANY",
      /**
       * Replacement for (deprecated) `componentWillUpdate`.
       *
       * @optional
       */
      UNSAFE_componentWillUpdate: "DEFINE_MANY",
      // ==== Advanced methods ====
      /**
       * Updates the component's currently mounted DOM representation.
       *
       * By default, this implements React's rendering and reconciliation algorithm.
       * Sophisticated clients may wish to override this.
       *
       * @param {ReactReconcileTransaction} transaction
       * @internal
       * @overridable
       */
      updateComponent: "OVERRIDE_BASE"
    }, y = {
      /**
       * This method is invoked after a component is instantiated and when it
       * receives new props. Return an object to update state in response to
       * prop changes. Return null to indicate no change to state.
       *
       * If an object is returned, its keys will be merged into the existing state.
       *
       * @return {object || null}
       * @optional
       */
      getDerivedStateFromProps: "DEFINE_MANY_MERGED"
    }, g = {
      displayName: function(M, C) {
        M.displayName = C;
      },
      mixins: function(M, C) {
        if (C)
          for (var O = 0; O < C.length; O++)
            b(M, C[O]);
      },
      childContextTypes: function(M, C) {
        process.env.NODE_ENV !== "production" && p(M, C, "childContext"), M.childContextTypes = e(
          {},
          M.childContextTypes,
          C
        );
      },
      contextTypes: function(M, C) {
        process.env.NODE_ENV !== "production" && p(M, C, "context"), M.contextTypes = e(
          {},
          M.contextTypes,
          C
        );
      },
      /**
       * Special case getDefaultProps which should move into statics but requires
       * automatic merging.
       */
      getDefaultProps: function(M, C) {
        M.getDefaultProps ? M.getDefaultProps = m(
          M.getDefaultProps,
          C
        ) : M.getDefaultProps = C;
      },
      propTypes: function(M, C) {
        process.env.NODE_ENV !== "production" && p(M, C, "prop"), M.propTypes = e({}, M.propTypes, C);
      },
      statics: function(M, C) {
        H(M, C);
      },
      autobind: function() {
      }
    };
    function p(M, C, O) {
      for (var F in C)
        C.hasOwnProperty(F) && process.env.NODE_ENV !== "production" && n(
          typeof C[F] == "function",
          "%s: %s type `%s` is invalid; it must be a function, usually from React.PropTypes.",
          M.displayName || "ReactClass",
          o[O],
          F
        );
    }
    function P(M, C) {
      var O = h.hasOwnProperty(C) ? h[C] : null;
      S.hasOwnProperty(C) && r(
        O === "OVERRIDE_BASE",
        "ReactClassInterface: You are attempting to override `%s` from your class specification. Ensure that your method names do not overlap with React methods.",
        C
      ), M && r(
        O === "DEFINE_MANY" || O === "DEFINE_MANY_MERGED",
        "ReactClassInterface: You are attempting to define `%s` on your component more than once. This conflict may be due to a mixin.",
        C
      );
    }
    function b(M, C) {
      if (!C) {
        if (process.env.NODE_ENV !== "production") {
          var O = typeof C, F = O === "object" && C !== null;
          process.env.NODE_ENV !== "production" && n(
            F,
            "%s: You're attempting to include a mixin that is either null or not an object. Check the mixins included by the component, as well as any mixins they include themselves. Expected object but got %s.",
            M.displayName || "ReactClass",
            C === null ? null : O
          );
        }
        return;
      }
      r(
        typeof C != "function",
        "ReactClass: You're attempting to use a component class or function as a mixin. Instead, just use a regular object."
      ), r(
        !d(C),
        "ReactClass: You're attempting to use a component as a mixin. Instead, just use a regular object."
      );
      var _ = M.prototype, q = _.__reactAutoBindPairs;
      C.hasOwnProperty(u) && g.mixins(M, C.mixins);
      for (var D in C)
        if (C.hasOwnProperty(D) && D !== u) {
          var N = C[D], z = _.hasOwnProperty(D);
          if (P(z, D), g.hasOwnProperty(D))
            g[D](M, N);
          else {
            var V = h.hasOwnProperty(D), j = typeof N == "function", B = j && !V && !z && C.autobind !== !1;
            if (B)
              q.push(D, N), _[D] = N;
            else if (z) {
              var U = h[D];
              r(
                V && (U === "DEFINE_MANY_MERGED" || U === "DEFINE_MANY"),
                "ReactClass: Unexpected spec policy %s for key %s when mixing in component specs.",
                U,
                D
              ), U === "DEFINE_MANY_MERGED" ? _[D] = m(_[D], N) : U === "DEFINE_MANY" && (_[D] = E(_[D], N));
            } else
              _[D] = N, process.env.NODE_ENV !== "production" && typeof N == "function" && C.displayName && (_[D].displayName = C.displayName + "_" + D);
          }
        }
    }
    function H(M, C) {
      if (C)
        for (var O in C) {
          var F = C[O];
          if (C.hasOwnProperty(O)) {
            var _ = O in g;
            r(
              !_,
              'ReactClass: You are attempting to define a reserved property, `%s`, that shouldn\'t be on the "statics" key. Define it as an instance property instead; it will still be accessible on the constructor.',
              O
            );
            var q = O in M;
            if (q) {
              var D = y.hasOwnProperty(O) ? y[O] : null;
              r(
                D === "DEFINE_MANY_MERGED",
                "ReactClass: You are attempting to define `%s` on your component more than once. This conflict may be due to a mixin.",
                O
              ), M[O] = m(M[O], F);
              return;
            }
            M[O] = F;
          }
        }
    }
    function A(M, C) {
      r(
        M && C && typeof M == "object" && typeof C == "object",
        "mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects."
      );
      for (var O in C)
        C.hasOwnProperty(O) && (r(
          M[O] === void 0,
          "mergeIntoWithNoDuplicateKeys(): Tried to merge two objects with the same key: `%s`. This conflict may be due to a mixin; in particular, this may be caused by two getInitialState() or getDefaultProps() methods returning objects with clashing keys.",
          O
        ), M[O] = C[O]);
      return M;
    }
    function m(M, C) {
      return function() {
        var F = M.apply(this, arguments), _ = C.apply(this, arguments);
        if (F == null)
          return _;
        if (_ == null)
          return F;
        var q = {};
        return A(q, F), A(q, _), q;
      };
    }
    function E(M, C) {
      return function() {
        M.apply(this, arguments), C.apply(this, arguments);
      };
    }
    function x(M, C) {
      var O = C.bind(M);
      if (process.env.NODE_ENV !== "production") {
        O.__reactBoundContext = M, O.__reactBoundMethod = C, O.__reactBoundArguments = null;
        var F = M.constructor.displayName, _ = O.bind;
        O.bind = function(q) {
          for (var D = arguments.length, N = Array(D > 1 ? D - 1 : 0), z = 1; z < D; z++)
            N[z - 1] = arguments[z];
          if (q !== M && q !== null)
            process.env.NODE_ENV !== "production" && n(
              !1,
              "bind(): React component methods may only be bound to the component instance. See %s",
              F
            );
          else if (!N.length)
            return process.env.NODE_ENV !== "production" && n(
              !1,
              "bind(): You are binding a component method to the component. React does this for you automatically in a high-performance way, so you can safely remove this call. See %s",
              F
            ), O;
          var V = _.apply(O, arguments);
          return V.__reactBoundContext = M, V.__reactBoundMethod = C, V.__reactBoundArguments = N, V;
        };
      }
      return O;
    }
    function I(M) {
      for (var C = M.__reactAutoBindPairs, O = 0; O < C.length; O += 2) {
        var F = C[O], _ = C[O + 1];
        M[F] = x(M, _);
      }
    }
    var T = {
      componentDidMount: function() {
        this.__isMounted = !0;
      }
    }, L = {
      componentWillUnmount: function() {
        this.__isMounted = !1;
      }
    }, S = {
      /**
       * TODO: This will be deprecated because state should always keep a consistent
       * type signature and the only use case for this, is to avoid that.
       */
      replaceState: function(M, C) {
        this.updater.enqueueReplaceState(this, M, C);
      },
      /**
       * Checks whether or not this composite component is mounted.
       * @return {boolean} True if mounted, false otherwise.
       * @protected
       * @final
       */
      isMounted: function() {
        return process.env.NODE_ENV !== "production" && (n(
          this.__didWarnIsMounted,
          "%s: isMounted is deprecated. Instead, make sure to clean up subscriptions and pending requests in componentWillUnmount to prevent memory leaks.",
          this.constructor && this.constructor.displayName || this.name || "Component"
        ), this.__didWarnIsMounted = !0), !!this.__isMounted;
      }
    }, $ = function() {
    };
    e(
      $.prototype,
      s.prototype,
      S
    );
    function Z(M) {
      var C = function(F, _, q) {
        process.env.NODE_ENV !== "production" && n(
          this instanceof C,
          "Something is calling a React component directly. Use a factory or JSX instead. See: https://fb.me/react-legacyfactory"
        ), this.__reactAutoBindPairs.length && I(this), this.props = F, this.context = _, this.refs = a, this.updater = q || f, this.state = null;
        var D = this.getInitialState ? this.getInitialState() : null;
        process.env.NODE_ENV !== "production" && D === void 0 && this.getInitialState._isMockFunction && (D = null), r(
          typeof D == "object" && !Array.isArray(D),
          "%s.getInitialState(): must return an object or null",
          C.displayName || "ReactCompositeComponent"
        ), this.state = D;
      };
      C.prototype = new $(), C.prototype.constructor = C, C.prototype.__reactAutoBindPairs = [], v.forEach(b.bind(null, C)), b(C, T), b(C, M), b(C, L), C.getDefaultProps && (C.defaultProps = C.getDefaultProps()), process.env.NODE_ENV !== "production" && (C.getDefaultProps && (C.getDefaultProps.isReactClassApproved = {}), C.prototype.getInitialState && (C.prototype.getInitialState.isReactClassApproved = {})), r(
        C.prototype.render,
        "createClass(...): Class specification must implement a `render` method."
      ), process.env.NODE_ENV !== "production" && (n(
        !C.prototype.componentShouldUpdate,
        "%s has a method called componentShouldUpdate(). Did you mean shouldComponentUpdate()? The name is phrased as a question because the function is expected to return a value.",
        M.displayName || "A component"
      ), n(
        !C.prototype.componentWillRecieveProps,
        "%s has a method called componentWillRecieveProps(). Did you mean componentWillReceiveProps()?",
        M.displayName || "A component"
      ), n(
        !C.prototype.UNSAFE_componentWillRecieveProps,
        "%s has a method called UNSAFE_componentWillRecieveProps(). Did you mean UNSAFE_componentWillReceiveProps()?",
        M.displayName || "A component"
      ));
      for (var O in h)
        C.prototype[O] || (C.prototype[O] = null);
      return C;
    }
    return Z;
  }
  return U0 = i, U0;
}
var F0, E1;
function Q3() {
  if (E1) return F0;
  E1 = 1;
  var e = r0, a = G3();
  if (typeof e > "u")
    throw Error(
      "create-react-class could not find the React object. If you are using script tags, make sure that React is being loaded before create-react-class."
    );
  var t = new e.Component().updater;
  return F0 = a(
    e.Component,
    e.isValidElement,
    t
  ), F0;
}
var K3 = Q3();
const u0 = /* @__PURE__ */ s0(K3);
var P0 = { exports: {} }, M0 = { exports: {} }, Y = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var L1;
function J3() {
  if (L1) return Y;
  L1 = 1;
  var e = typeof Symbol == "function" && Symbol.for, a = e ? Symbol.for("react.element") : 60103, t = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, n = e ? Symbol.for("react.strict_mode") : 60108, c = e ? Symbol.for("react.profiler") : 60114, u = e ? Symbol.for("react.provider") : 60109, l = e ? Symbol.for("react.context") : 60110, o = e ? Symbol.for("react.async_mode") : 60111, i = e ? Symbol.for("react.concurrent_mode") : 60111, s = e ? Symbol.for("react.forward_ref") : 60112, d = e ? Symbol.for("react.suspense") : 60113, f = e ? Symbol.for("react.suspense_list") : 60120, v = e ? Symbol.for("react.memo") : 60115, h = e ? Symbol.for("react.lazy") : 60116, y = e ? Symbol.for("react.block") : 60121, g = e ? Symbol.for("react.fundamental") : 60117, p = e ? Symbol.for("react.responder") : 60118, P = e ? Symbol.for("react.scope") : 60119;
  function b(A) {
    if (typeof A == "object" && A !== null) {
      var m = A.$$typeof;
      switch (m) {
        case a:
          switch (A = A.type, A) {
            case o:
            case i:
            case r:
            case c:
            case n:
            case d:
              return A;
            default:
              switch (A = A && A.$$typeof, A) {
                case l:
                case s:
                case h:
                case v:
                case u:
                  return A;
                default:
                  return m;
              }
          }
        case t:
          return m;
      }
    }
  }
  function H(A) {
    return b(A) === i;
  }
  return Y.AsyncMode = o, Y.ConcurrentMode = i, Y.ContextConsumer = l, Y.ContextProvider = u, Y.Element = a, Y.ForwardRef = s, Y.Fragment = r, Y.Lazy = h, Y.Memo = v, Y.Portal = t, Y.Profiler = c, Y.StrictMode = n, Y.Suspense = d, Y.isAsyncMode = function(A) {
    return H(A) || b(A) === o;
  }, Y.isConcurrentMode = H, Y.isContextConsumer = function(A) {
    return b(A) === l;
  }, Y.isContextProvider = function(A) {
    return b(A) === u;
  }, Y.isElement = function(A) {
    return typeof A == "object" && A !== null && A.$$typeof === a;
  }, Y.isForwardRef = function(A) {
    return b(A) === s;
  }, Y.isFragment = function(A) {
    return b(A) === r;
  }, Y.isLazy = function(A) {
    return b(A) === h;
  }, Y.isMemo = function(A) {
    return b(A) === v;
  }, Y.isPortal = function(A) {
    return b(A) === t;
  }, Y.isProfiler = function(A) {
    return b(A) === c;
  }, Y.isStrictMode = function(A) {
    return b(A) === n;
  }, Y.isSuspense = function(A) {
    return b(A) === d;
  }, Y.isValidElementType = function(A) {
    return typeof A == "string" || typeof A == "function" || A === r || A === i || A === c || A === n || A === d || A === f || typeof A == "object" && A !== null && (A.$$typeof === h || A.$$typeof === v || A.$$typeof === u || A.$$typeof === l || A.$$typeof === s || A.$$typeof === g || A.$$typeof === p || A.$$typeof === P || A.$$typeof === y);
  }, Y.typeOf = b, Y;
}
var G = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var b1;
function X3() {
  return b1 || (b1 = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, a = e ? Symbol.for("react.element") : 60103, t = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, n = e ? Symbol.for("react.strict_mode") : 60108, c = e ? Symbol.for("react.profiler") : 60114, u = e ? Symbol.for("react.provider") : 60109, l = e ? Symbol.for("react.context") : 60110, o = e ? Symbol.for("react.async_mode") : 60111, i = e ? Symbol.for("react.concurrent_mode") : 60111, s = e ? Symbol.for("react.forward_ref") : 60112, d = e ? Symbol.for("react.suspense") : 60113, f = e ? Symbol.for("react.suspense_list") : 60120, v = e ? Symbol.for("react.memo") : 60115, h = e ? Symbol.for("react.lazy") : 60116, y = e ? Symbol.for("react.block") : 60121, g = e ? Symbol.for("react.fundamental") : 60117, p = e ? Symbol.for("react.responder") : 60118, P = e ? Symbol.for("react.scope") : 60119;
    function b(w) {
      return typeof w == "string" || typeof w == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      w === r || w === i || w === c || w === n || w === d || w === f || typeof w == "object" && w !== null && (w.$$typeof === h || w.$$typeof === v || w.$$typeof === u || w.$$typeof === l || w.$$typeof === s || w.$$typeof === g || w.$$typeof === p || w.$$typeof === P || w.$$typeof === y);
    }
    function H(w) {
      if (typeof w == "object" && w !== null) {
        var o0 = w.$$typeof;
        switch (o0) {
          case a:
            var D0 = w.type;
            switch (D0) {
              case o:
              case i:
              case r:
              case c:
              case n:
              case d:
                return D0;
              default:
                var g1 = D0 && D0.$$typeof;
                switch (g1) {
                  case l:
                  case s:
                  case h:
                  case v:
                  case u:
                    return g1;
                  default:
                    return o0;
                }
            }
          case t:
            return o0;
        }
      }
    }
    var A = o, m = i, E = l, x = u, I = a, T = s, L = r, S = h, $ = v, Z = t, M = c, C = n, O = d, F = !1;
    function _(w) {
      return F || (F = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), q(w) || H(w) === o;
    }
    function q(w) {
      return H(w) === i;
    }
    function D(w) {
      return H(w) === l;
    }
    function N(w) {
      return H(w) === u;
    }
    function z(w) {
      return typeof w == "object" && w !== null && w.$$typeof === a;
    }
    function V(w) {
      return H(w) === s;
    }
    function j(w) {
      return H(w) === r;
    }
    function B(w) {
      return H(w) === h;
    }
    function U(w) {
      return H(w) === v;
    }
    function k(w) {
      return H(w) === t;
    }
    function K(w) {
      return H(w) === c;
    }
    function W(w) {
      return H(w) === n;
    }
    function a0(w) {
      return H(w) === d;
    }
    G.AsyncMode = A, G.ConcurrentMode = m, G.ContextConsumer = E, G.ContextProvider = x, G.Element = I, G.ForwardRef = T, G.Fragment = L, G.Lazy = S, G.Memo = $, G.Portal = Z, G.Profiler = M, G.StrictMode = C, G.Suspense = O, G.isAsyncMode = _, G.isConcurrentMode = q, G.isContextConsumer = D, G.isContextProvider = N, G.isElement = z, G.isForwardRef = V, G.isFragment = j, G.isLazy = B, G.isMemo = U, G.isPortal = k, G.isProfiler = K, G.isStrictMode = W, G.isSuspense = a0, G.isValidElementType = b, G.typeOf = H;
  }()), G;
}
var H1;
function N0() {
  return H1 || (H1 = 1, process.env.NODE_ENV === "production" ? M0.exports = J3() : M0.exports = X3()), M0.exports;
}
var $0, _1;
function s1() {
  if (_1) return $0;
  _1 = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return $0 = e, $0;
}
var j0, R1;
function p3() {
  return R1 || (R1 = 1, j0 = Function.call.bind(Object.prototype.hasOwnProperty)), j0;
}
var k0, O1;
function e2() {
  if (O1) return k0;
  O1 = 1;
  var e = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var a = /* @__PURE__ */ s1(), t = {}, r = /* @__PURE__ */ p3();
    e = function(c) {
      var u = "Warning: " + c;
      typeof console < "u" && console.error(u);
      try {
        throw new Error(u);
      } catch {
      }
    };
  }
  function n(c, u, l, o, i) {
    if (process.env.NODE_ENV !== "production") {
      for (var s in c)
        if (r(c, s)) {
          var d;
          try {
            if (typeof c[s] != "function") {
              var f = Error(
                (o || "React class") + ": " + l + " type `" + s + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof c[s] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw f.name = "Invariant Violation", f;
            }
            d = c[s](u, s, o, l, null, a);
          } catch (h) {
            d = h;
          }
          if (d && !(d instanceof Error) && e(
            (o || "React class") + ": type specification of " + l + " `" + s + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof d + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), d instanceof Error && !(d.message in t)) {
            t[d.message] = !0;
            var v = i ? i() : "";
            e(
              "Failed " + l + " type: " + d.message + (v ?? "")
            );
          }
        }
    }
  }
  return n.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (t = {});
  }, k0 = n, k0;
}
var W0, w1;
function a2() {
  if (w1) return W0;
  w1 = 1;
  var e = N0(), a = l1(), t = /* @__PURE__ */ s1(), r = /* @__PURE__ */ p3(), n = /* @__PURE__ */ e2(), c = function() {
  };
  process.env.NODE_ENV !== "production" && (c = function(l) {
    var o = "Warning: " + l;
    typeof console < "u" && console.error(o);
    try {
      throw new Error(o);
    } catch {
    }
  });
  function u() {
    return null;
  }
  return W0 = function(l, o) {
    var i = typeof Symbol == "function" && Symbol.iterator, s = "@@iterator";
    function d(q) {
      var D = q && (i && q[i] || q[s]);
      if (typeof D == "function")
        return D;
    }
    var f = "<<anonymous>>", v = {
      array: p("array"),
      bigint: p("bigint"),
      bool: p("boolean"),
      func: p("function"),
      number: p("number"),
      object: p("object"),
      string: p("string"),
      symbol: p("symbol"),
      any: P(),
      arrayOf: b,
      element: H(),
      elementType: A(),
      instanceOf: m,
      node: T(),
      objectOf: x,
      oneOf: E,
      oneOfType: I,
      shape: S,
      exact: $
    };
    function h(q, D) {
      return q === D ? q !== 0 || 1 / q === 1 / D : q !== q && D !== D;
    }
    function y(q, D) {
      this.message = q, this.data = D && typeof D == "object" ? D : {}, this.stack = "";
    }
    y.prototype = Error.prototype;
    function g(q) {
      if (process.env.NODE_ENV !== "production")
        var D = {}, N = 0;
      function z(j, B, U, k, K, W, a0) {
        if (k = k || f, W = W || U, a0 !== t) {
          if (o) {
            var w = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw w.name = "Invariant Violation", w;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var o0 = k + ":" + U;
            !D[o0] && // Avoid spamming the console because they are often not actionable except for lib authors
            N < 3 && (c(
              "You are manually calling a React.PropTypes validation function for the `" + W + "` prop on `" + k + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), D[o0] = !0, N++);
          }
        }
        return B[U] == null ? j ? B[U] === null ? new y("The " + K + " `" + W + "` is marked as required " + ("in `" + k + "`, but its value is `null`.")) : new y("The " + K + " `" + W + "` is marked as required in " + ("`" + k + "`, but its value is `undefined`.")) : null : q(B, U, k, K, W);
      }
      var V = z.bind(null, !1);
      return V.isRequired = z.bind(null, !0), V;
    }
    function p(q) {
      function D(N, z, V, j, B, U) {
        var k = N[z], K = C(k);
        if (K !== q) {
          var W = O(k);
          return new y(
            "Invalid " + j + " `" + B + "` of type " + ("`" + W + "` supplied to `" + V + "`, expected ") + ("`" + q + "`."),
            { expectedType: q }
          );
        }
        return null;
      }
      return g(D);
    }
    function P() {
      return g(u);
    }
    function b(q) {
      function D(N, z, V, j, B) {
        if (typeof q != "function")
          return new y("Property `" + B + "` of component `" + V + "` has invalid PropType notation inside arrayOf.");
        var U = N[z];
        if (!Array.isArray(U)) {
          var k = C(U);
          return new y("Invalid " + j + " `" + B + "` of type " + ("`" + k + "` supplied to `" + V + "`, expected an array."));
        }
        for (var K = 0; K < U.length; K++) {
          var W = q(U, K, V, j, B + "[" + K + "]", t);
          if (W instanceof Error)
            return W;
        }
        return null;
      }
      return g(D);
    }
    function H() {
      function q(D, N, z, V, j) {
        var B = D[N];
        if (!l(B)) {
          var U = C(B);
          return new y("Invalid " + V + " `" + j + "` of type " + ("`" + U + "` supplied to `" + z + "`, expected a single ReactElement."));
        }
        return null;
      }
      return g(q);
    }
    function A() {
      function q(D, N, z, V, j) {
        var B = D[N];
        if (!e.isValidElementType(B)) {
          var U = C(B);
          return new y("Invalid " + V + " `" + j + "` of type " + ("`" + U + "` supplied to `" + z + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return g(q);
    }
    function m(q) {
      function D(N, z, V, j, B) {
        if (!(N[z] instanceof q)) {
          var U = q.name || f, k = _(N[z]);
          return new y("Invalid " + j + " `" + B + "` of type " + ("`" + k + "` supplied to `" + V + "`, expected ") + ("instance of `" + U + "`."));
        }
        return null;
      }
      return g(D);
    }
    function E(q) {
      if (!Array.isArray(q))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? c(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : c("Invalid argument supplied to oneOf, expected an array.")), u;
      function D(N, z, V, j, B) {
        for (var U = N[z], k = 0; k < q.length; k++)
          if (h(U, q[k]))
            return null;
        var K = JSON.stringify(q, function(a0, w) {
          var o0 = O(w);
          return o0 === "symbol" ? String(w) : w;
        });
        return new y("Invalid " + j + " `" + B + "` of value `" + String(U) + "` " + ("supplied to `" + V + "`, expected one of " + K + "."));
      }
      return g(D);
    }
    function x(q) {
      function D(N, z, V, j, B) {
        if (typeof q != "function")
          return new y("Property `" + B + "` of component `" + V + "` has invalid PropType notation inside objectOf.");
        var U = N[z], k = C(U);
        if (k !== "object")
          return new y("Invalid " + j + " `" + B + "` of type " + ("`" + k + "` supplied to `" + V + "`, expected an object."));
        for (var K in U)
          if (r(U, K)) {
            var W = q(U, K, V, j, B + "." + K, t);
            if (W instanceof Error)
              return W;
          }
        return null;
      }
      return g(D);
    }
    function I(q) {
      if (!Array.isArray(q))
        return process.env.NODE_ENV !== "production" && c("Invalid argument supplied to oneOfType, expected an instance of array."), u;
      for (var D = 0; D < q.length; D++) {
        var N = q[D];
        if (typeof N != "function")
          return c(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + F(N) + " at index " + D + "."
          ), u;
      }
      function z(V, j, B, U, k) {
        for (var K = [], W = 0; W < q.length; W++) {
          var a0 = q[W], w = a0(V, j, B, U, k, t);
          if (w == null)
            return null;
          w.data && r(w.data, "expectedType") && K.push(w.data.expectedType);
        }
        var o0 = K.length > 0 ? ", expected one of type [" + K.join(", ") + "]" : "";
        return new y("Invalid " + U + " `" + k + "` supplied to " + ("`" + B + "`" + o0 + "."));
      }
      return g(z);
    }
    function T() {
      function q(D, N, z, V, j) {
        return Z(D[N]) ? null : new y("Invalid " + V + " `" + j + "` supplied to " + ("`" + z + "`, expected a ReactNode."));
      }
      return g(q);
    }
    function L(q, D, N, z, V) {
      return new y(
        (q || "React class") + ": " + D + " type `" + N + "." + z + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + V + "`."
      );
    }
    function S(q) {
      function D(N, z, V, j, B) {
        var U = N[z], k = C(U);
        if (k !== "object")
          return new y("Invalid " + j + " `" + B + "` of type `" + k + "` " + ("supplied to `" + V + "`, expected `object`."));
        for (var K in q) {
          var W = q[K];
          if (typeof W != "function")
            return L(V, j, B, K, O(W));
          var a0 = W(U, K, V, j, B + "." + K, t);
          if (a0)
            return a0;
        }
        return null;
      }
      return g(D);
    }
    function $(q) {
      function D(N, z, V, j, B) {
        var U = N[z], k = C(U);
        if (k !== "object")
          return new y("Invalid " + j + " `" + B + "` of type `" + k + "` " + ("supplied to `" + V + "`, expected `object`."));
        var K = a({}, N[z], q);
        for (var W in K) {
          var a0 = q[W];
          if (r(q, W) && typeof a0 != "function")
            return L(V, j, B, W, O(a0));
          if (!a0)
            return new y(
              "Invalid " + j + " `" + B + "` key `" + W + "` supplied to `" + V + "`.\nBad object: " + JSON.stringify(N[z], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(q), null, "  ")
            );
          var w = a0(U, W, V, j, B + "." + W, t);
          if (w)
            return w;
        }
        return null;
      }
      return g(D);
    }
    function Z(q) {
      switch (typeof q) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !q;
        case "object":
          if (Array.isArray(q))
            return q.every(Z);
          if (q === null || l(q))
            return !0;
          var D = d(q);
          if (D) {
            var N = D.call(q), z;
            if (D !== q.entries) {
              for (; !(z = N.next()).done; )
                if (!Z(z.value))
                  return !1;
            } else
              for (; !(z = N.next()).done; ) {
                var V = z.value;
                if (V && !Z(V[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function M(q, D) {
      return q === "symbol" ? !0 : D ? D["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && D instanceof Symbol : !1;
    }
    function C(q) {
      var D = typeof q;
      return Array.isArray(q) ? "array" : q instanceof RegExp ? "object" : M(D, q) ? "symbol" : D;
    }
    function O(q) {
      if (typeof q > "u" || q === null)
        return "" + q;
      var D = C(q);
      if (D === "object") {
        if (q instanceof Date)
          return "date";
        if (q instanceof RegExp)
          return "regexp";
      }
      return D;
    }
    function F(q) {
      var D = O(q);
      switch (D) {
        case "array":
        case "object":
          return "an " + D;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + D;
        default:
          return D;
      }
    }
    function _(q) {
      return !q.constructor || !q.constructor.name ? f : q.constructor.name;
    }
    return v.checkPropTypes = n, v.resetWarningCache = n.resetWarningCache, v.PropTypes = v, v;
  }, W0;
}
var Y0, S1;
function t2() {
  if (S1) return Y0;
  S1 = 1;
  var e = /* @__PURE__ */ s1();
  function a() {
  }
  function t() {
  }
  return t.resetWarningCache = a, Y0 = function() {
    function r(u, l, o, i, s, d) {
      if (d !== e) {
        var f = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw f.name = "Invariant Violation", f;
      }
    }
    r.isRequired = r;
    function n() {
      return r;
    }
    var c = {
      array: r,
      bigint: r,
      bool: r,
      func: r,
      number: r,
      object: r,
      string: r,
      symbol: r,
      any: r,
      arrayOf: n,
      element: r,
      elementType: r,
      instanceOf: n,
      node: r,
      objectOf: n,
      oneOf: n,
      oneOfType: n,
      shape: n,
      exact: n,
      checkPropTypes: t,
      resetWarningCache: a
    };
    return c.PropTypes = c, c;
  }, Y0;
}
var T1;
function r2() {
  if (T1) return P0.exports;
  if (T1 = 1, process.env.NODE_ENV !== "production") {
    var e = N0(), a = !0;
    P0.exports = /* @__PURE__ */ a2()(e.isElement, a);
  } else
    P0.exports = /* @__PURE__ */ t2()();
  return P0.exports;
}
var R = /* @__PURE__ */ r2();
const G0 = /* @__PURE__ */ s0(R);
var Q0, N1;
function c0() {
  if (N1) return Q0;
  N1 = 1;
  var e = function() {
  };
  return process.env.NODE_ENV !== "production" && (e = function(a, t, r) {
    var n = arguments.length;
    r = new Array(n > 2 ? n - 2 : 0);
    for (var c = 2; c < n; c++)
      r[c - 2] = arguments[c];
    if (t === void 0)
      throw new Error(
        "`warning(condition, format, ...args)` requires a warning message argument"
      );
    if (t.length < 10 || /^[s\W]*$/.test(t))
      throw new Error(
        "The warning format should be able to uniquely identify this warning. Please, use a more descriptive format than: " + t
      );
    if (!a) {
      var u = 0, l = "Warning: " + t.replace(/%s/g, function() {
        return r[u++];
      });
      typeof console < "u" && console.error(l);
      try {
        throw new Error(l);
      } catch {
      }
    }
  }), Q0 = e, Q0;
}
var n2 = c0();
const o2 = /* @__PURE__ */ s0(n2);
var V1 = {};
function v0(e, a) {
  if (a.indexOf("deprecated") !== -1) {
    if (V1[a])
      return;
    V1[a] = !0;
  }
  a = "[react-router] " + a;
  for (var t = arguments.length, r = Array(t > 2 ? t - 2 : 0), n = 2; n < t; n++)
    r[n - 2] = arguments[n];
  o2.apply(void 0, [e, a].concat(r));
}
function z1(e) {
  return e.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
function i2(e) {
  for (var a = "", t = [], r = [], n = void 0, c = 0, u = /:([a-zA-Z_$][a-zA-Z0-9_$]*)|\*\*|\*|\(|\)|\\\(|\\\)/g; n = u.exec(e); )
    n.index !== c && (r.push(e.slice(c, n.index)), a += z1(e.slice(c, n.index))), n[1] ? (a += "([^/]+)", t.push(n[1])) : n[0] === "**" ? (a += "(.*)", t.push("splat")) : n[0] === "*" ? (a += "(.*?)", t.push("splat")) : n[0] === "(" ? a += "(?:" : n[0] === ")" ? a += ")?" : n[0] === "\\(" ? a += "\\(" : n[0] === "\\)" && (a += "\\)"), r.push(n[0]), c = u.lastIndex;
  return c !== e.length && (r.push(e.slice(c, e.length)), a += z1(e.slice(c, e.length))), {
    pattern: e,
    regexpSource: a,
    paramNames: t,
    tokens: r
  };
}
var K0 = /* @__PURE__ */ Object.create(null);
function u1(e) {
  return K0[e] || (K0[e] = i2(e)), K0[e];
}
function q3(e, a) {
  e.charAt(0) !== "/" && (e = "/" + e);
  var t = u1(e), r = t.regexpSource, n = t.paramNames, c = t.tokens;
  e.charAt(e.length - 1) !== "/" && (r += "/?"), c[c.length - 1] === "*" && (r += "$");
  var u = a.match(new RegExp("^" + r, "i"));
  if (u == null)
    return null;
  var l = u[0], o = a.substr(l.length);
  if (o) {
    if (l.charAt(l.length - 1) !== "/")
      return null;
    o = "/" + o;
  }
  return {
    remainingPathname: o,
    paramNames: n,
    paramValues: u.slice(1).map(function(i) {
      return i && decodeURIComponent(i);
    })
  };
}
function m3(e) {
  return u1(e).paramNames;
}
function x1(e, a) {
  a = a || {};
  for (var t = u1(e), r = t.tokens, n = 0, c = "", u = 0, l = [], o = void 0, i = void 0, s = void 0, d = 0, f = r.length; d < f; ++d)
    if (o = r[d], o === "*" || o === "**")
      s = Array.isArray(a.splat) ? a.splat[u++] : a.splat, s != null || n > 0 || (process.env.NODE_ENV !== "production" ? J(!1, 'Missing splat #%s for path "%s"', u, e) : J(!1)), s != null && (c += encodeURI(s));
    else if (o === "(")
      l[n] = "", n += 1;
    else if (o === ")") {
      var v = l.pop();
      n -= 1, n ? l[n - 1] += v : c += v;
    } else if (o === "\\(")
      c += "(";
    else if (o === "\\)")
      c += ")";
    else if (o.charAt(0) === ":")
      if (i = o.substring(1), s = a[i], s != null || n > 0 || (process.env.NODE_ENV !== "production" ? J(!1, 'Missing "%s" parameter for path "%s"', i, e) : J(!1)), s == null) {
        if (n) {
          l[n - 1] = "";
          for (var h = r.indexOf(o), y = r.slice(h, r.length), g = -1, p = 0; p < y.length; p++)
            if (y[p] == ")") {
              g = p;
              break;
            }
          g > 0 || (process.env.NODE_ENV !== "production" ? J(!1, 'Path "%s" is missing end paren at segment "%s"', e, y.join("")) : J(!1)), d = h + g - 1;
        }
      } else n ? l[n - 1] += encodeURIComponent(s) : c += encodeURIComponent(s);
    else
      n ? l[n - 1] += o : c += o;
  return n <= 0 || (process.env.NODE_ENV !== "production" ? J(!1, 'Path "%s" is missing end paren', e) : J(!1)), c.replace(/\/+/g, "/");
}
function l2(e, a, t) {
  if (!e.path) return !1;
  var r = m3(e.path);
  return r.some(function(n) {
    return a.params[n] !== t.params[n];
  });
}
function I1(e, a) {
  var t = e && e.routes, r = a.routes, n = void 0, c = void 0, u = void 0;
  if (t) {
    var l = !1;
    n = t.filter(function(o) {
      if (l)
        return !0;
      var i = r.indexOf(o) === -1 || l2(o, e, a);
      return i && (l = !0), i;
    }), n.reverse(), u = [], c = [], r.forEach(function(o) {
      var i = t.indexOf(o) === -1, s = n.indexOf(o) !== -1;
      i || s ? u.push(o) : c.push(o);
    });
  } else
    n = [], c = [], u = r;
  return {
    leaveRoutes: n,
    changeRoutes: c,
    enterRoutes: u
  };
}
function c1(e, a, t) {
  var r = 0, n = !1, c = !1, u = !1, l = void 0;
  function o() {
    if (n = !0, c) {
      l = [].concat(Array.prototype.slice.call(arguments));
      return;
    }
    t.apply(this, arguments);
  }
  function i() {
    if (!n && (u = !0, !c)) {
      for (c = !0; !n && r < e && u; )
        u = !1, a.call(this, r++, i, o);
      if (c = !1, n) {
        t.apply(this, l);
        return;
      }
      r >= e && u && (n = !0, t());
    }
  }
  i();
}
function s2(e, a, t) {
  var r = e.length, n = [];
  if (r === 0) return t(null, n);
  var c = !1, u = 0;
  function l(o, i, s) {
    c || (i ? (c = !0, t(i)) : (n[o] = s, c = ++u === r, c && t(null, n)));
  }
  e.forEach(function(o, i) {
    a(o, i, function(s, d) {
      l(i, s, d);
    });
  });
}
function u2(e, a) {
  if (!(e instanceof a))
    throw new TypeError("Cannot call a class as a function");
}
var Z1 = function e() {
  var a = this;
  u2(this, e), this.hooks = [], this.add = function(t) {
    return a.hooks.push(t);
  }, this.remove = function(t) {
    return a.hooks = a.hooks.filter(function(r) {
      return r !== t;
    });
  }, this.has = function(t) {
    return a.hooks.indexOf(t) !== -1;
  }, this.clear = function() {
    return a.hooks = [];
  };
};
function c2() {
  var e = new Z1(), a = new Z1();
  function t(i, s, d, f) {
    var v = i.length < d, h = function() {
      for (var g = arguments.length, p = Array(g), P = 0; P < g; P++)
        p[P] = arguments[P];
      if (i.apply(s, p), v) {
        var b = p[p.length - 1];
        b();
      }
    };
    return f.add(h), h;
  }
  function r(i) {
    return i.reduce(function(s, d) {
      return d.onEnter && s.push(t(d.onEnter, d, 3, e)), s;
    }, []);
  }
  function n(i) {
    return i.reduce(function(s, d) {
      return d.onChange && s.push(t(d.onChange, d, 4, a)), s;
    }, []);
  }
  function c(i, s, d) {
    if (!i) {
      d();
      return;
    }
    var f = void 0;
    function v(h) {
      f = h;
    }
    c1(i, function(h, y, g) {
      s(h, v, function(p) {
        p || f ? g(p, f) : y();
      });
    }, d);
  }
  function u(i, s, d) {
    e.clear();
    var f = r(i);
    return c(f.length, function(v, h, y) {
      var g = function() {
        e.has(f[v]) && (y.apply(void 0, arguments), e.remove(f[v]));
      };
      f[v](s, h, g);
    }, d);
  }
  function l(i, s, d, f) {
    a.clear();
    var v = n(i);
    return c(v.length, function(h, y, g) {
      var p = function() {
        a.has(v[h]) && (g.apply(void 0, arguments), a.remove(v[h]));
      };
      v[h](s, d, y, p);
    }, f);
  }
  function o(i, s) {
    for (var d = 0, f = i.length; d < f; ++d)
      i[d].onLeave && i[d].onLeave.call(i[d], s);
  }
  return {
    runEnterHooks: u,
    runChangeHooks: l,
    runLeaveHooks: o
  };
}
var f2 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
  return typeof e;
} : function(e) {
  return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
};
function o1(e, a) {
  if (e == a) return !0;
  if (e == null || a == null) return !1;
  if (Array.isArray(e))
    return Array.isArray(a) && e.length === a.length && e.every(function(r, n) {
      return o1(r, a[n]);
    });
  if ((typeof e > "u" ? "undefined" : f2(e)) === "object") {
    for (var t in e)
      if (Object.prototype.hasOwnProperty.call(e, t))
        if (e[t] === void 0) {
          if (a[t] !== void 0)
            return !1;
        } else if (Object.prototype.hasOwnProperty.call(a, t)) {
          if (!o1(e[t], a[t]))
            return !1;
        } else return !1;
    return !0;
  }
  return String(e) === String(a);
}
function d2(e, a) {
  return a.charAt(0) !== "/" && (a = "/" + a), e.charAt(e.length - 1) !== "/" && (e += "/"), a.charAt(a.length - 1) !== "/" && (a += "/"), a === e;
}
function v2(e, a, t) {
  for (var r = e, n = [], c = [], u = 0, l = a.length; u < l; ++u) {
    var o = a[u], i = o.path || "";
    if (i.charAt(0) === "/" && (r = e, n = [], c = []), r !== null && i) {
      var s = q3(i, r);
      if (s ? (r = s.remainingPathname, n = [].concat(n, s.paramNames), c = [].concat(c, s.paramValues)) : r = null, r === "")
        return n.every(function(d, f) {
          return String(c[f]) === String(t[d]);
        });
    }
  }
  return !1;
}
function h2(e, a) {
  return a == null ? e == null : e == null ? !0 : o1(e, a);
}
function p2(e, a, t, r, n) {
  var c = e.pathname, u = e.query;
  return t == null || (c.charAt(0) !== "/" && (c = "/" + c), !d2(c, t.pathname) && (a || !v2(c, r, n))) ? !1 : h2(u, t.query);
}
function f1(e) {
  return e && typeof e.then == "function";
}
function q2(e, a, t) {
  if (a.component || a.components) {
    t(null, a.component || a.components);
    return;
  }
  var r = a.getComponent || a.getComponents;
  if (r) {
    var n = r.call(a, e, t);
    f1(n) && n.then(function(c) {
      return t(null, c);
    }, t);
  } else
    t();
}
function m2(e, a) {
  s2(e.routes, function(t, r, n) {
    q2(e, t, n);
  }, a);
}
var g2 = Object.assign || function(e) {
  for (var a = 1; a < arguments.length; a++) {
    var t = arguments[a];
    for (var r in t)
      Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
  }
  return e;
};
function B1(e) {
  return e == null || r0.isValidElement(e);
}
function g3(e) {
  return B1(e) || Array.isArray(e) && e.every(B1);
}
function y2(e, a) {
  return g2({}, e, a);
}
function V0(e) {
  var a = e.type, t = y2(a.defaultProps, e.props);
  if (t.children) {
    var r = y3(t.children, t);
    r.length && (t.childRoutes = r), delete t.children;
  }
  return t;
}
function y3(e, a) {
  var t = [];
  return r0.Children.forEach(e, function(r) {
    if (r0.isValidElement(r))
      if (r.type.createRouteFromReactElement) {
        var n = r.type.createRouteFromReactElement(r, a);
        n && t.push(n);
      } else
        t.push(V0(r));
  }), t;
}
function y0(e) {
  return g3(e) ? e = y3(e) : e && !Array.isArray(e) && (e = [e]), e;
}
var C2 = Object.assign || function(e) {
  for (var a = 1; a < arguments.length; a++) {
    var t = arguments[a];
    for (var r in t)
      Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
  }
  return e;
};
function C3(e, a, t, r, n) {
  if (e.childRoutes)
    return [null, e.childRoutes];
  if (!e.getChildRoutes)
    return [];
  var c = !0, u = void 0, l = {
    location: a,
    params: d1(t, r)
  }, o = e.getChildRoutes(l, function(i, s) {
    if (s = !i && y0(s), c) {
      u = [i, s];
      return;
    }
    n(i, s);
  });
  return f1(o) && o.then(function(i) {
    return n(null, y0(i));
  }, n), c = !1, u;
}
function A3(e, a, t, r, n) {
  if (e.indexRoute)
    n(null, e.indexRoute);
  else if (e.getIndexRoute) {
    var c = {
      location: a,
      params: d1(t, r)
    }, u = e.getIndexRoute(c, function(i, s) {
      n(i, !i && y0(s)[0]);
    });
    f1(u) && u.then(function(i) {
      return n(null, y0(i)[0]);
    }, n);
  } else if (e.childRoutes || e.getChildRoutes) {
    var l = function(s, d) {
      if (s) {
        n(s);
        return;
      }
      var f = d.filter(function(v) {
        return !v.path;
      });
      c1(f.length, function(v, h, y) {
        A3(f[v], a, t, r, function(g, p) {
          if (g || p) {
            var P = [f[v]].concat(Array.isArray(p) ? p : [p]);
            y(g, P);
          } else
            h();
        });
      }, function(v, h) {
        n(null, h);
      });
    }, o = C3(e, a, t, r, l);
    o && l.apply(void 0, o);
  } else
    n();
}
function A2(e, a, t) {
  return a.reduce(function(r, n, c) {
    var u = t && t[c];
    return Array.isArray(r[n]) ? r[n].push(u) : n in r ? r[n] = [r[n], u] : r[n] = u, r;
  }, e);
}
function d1(e, a) {
  return A2({}, e, a);
}
function D2(e, a, t, r, n, c) {
  var u = e.path || "";
  if (u.charAt(0) === "/" && (t = a.pathname, r = [], n = []), t !== null && u) {
    try {
      var l = q3(u, t);
      l ? (t = l.remainingPathname, r = [].concat(r, l.paramNames), n = [].concat(n, l.paramValues)) : t = null;
    } catch (d) {
      c(d);
    }
    if (t === "") {
      var o = {
        routes: [e],
        params: d1(r, n)
      };
      A3(e, a, r, n, function(d, f) {
        if (d)
          c(d);
        else {
          if (Array.isArray(f)) {
            var v;
            process.env.NODE_ENV !== "production" && v0(f.every(function(h) {
              return !h.path;
            }), "Index routes should not have paths"), (v = o.routes).push.apply(v, f);
          } else f && (process.env.NODE_ENV !== "production" && v0(!f.path, "Index routes should not have paths"), o.routes.push(f));
          c(null, o);
        }
      });
      return;
    }
  }
  if (t != null || e.childRoutes) {
    var i = function(f, v) {
      f ? c(f) : v ? i1(v, a, function(h, y) {
        h ? c(h) : y ? (y.routes.unshift(e), c(null, y)) : c();
      }, t, r, n) : c();
    }, s = C3(e, a, r, n, i);
    s && i.apply(void 0, s);
  } else
    c();
}
function i1(e, a, t, r) {
  var n = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : [], c = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : [];
  r === void 0 && (a.pathname.charAt(0) !== "/" && (a = C2({}, a, {
    pathname: "/" + a.pathname
  })), r = a.pathname), c1(e.length, function(u, l, o) {
    D2(e[u], a, r, n, c, function(i, s) {
      i || s ? o(i, s) : l();
    });
  }, t);
}
var J0 = Object.assign || function(e) {
  for (var a = 1; a < arguments.length; a++) {
    var t = arguments[a];
    for (var r in t)
      Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
  }
  return e;
};
function U1(e) {
  for (var a in e)
    if (Object.prototype.hasOwnProperty.call(e, a)) return !0;
  return !1;
}
function P2(e, a) {
  var t = {}, r = c2(), n = r.runEnterHooks, c = r.runChangeHooks, u = r.runLeaveHooks;
  function l(m, E) {
    return m = e.createLocation(m), p2(m, E, t.location, t.routes, t.params);
  }
  var o = void 0;
  function i(m, E) {
    o && o.location === m ? s(o, E) : i1(a, m, function(x, I) {
      x ? E(x) : I ? s(J0({}, I, { location: m }), E) : E();
    });
  }
  function s(m, E) {
    var x = I1(t, m), I = x.leaveRoutes, T = x.changeRoutes, L = x.enterRoutes;
    u(I, t), I.filter(function(Z) {
      return L.indexOf(Z) === -1;
    }).forEach(b), c(T, t, m, function(Z, M) {
      if (Z || M) return $(Z, M);
      n(L, m, S);
    });
    function S(Z, M) {
      if (Z || M) return $(Z, M);
      m2(m, function(C, O) {
        C ? E(C) : E(null, null, t = J0({}, m, { components: O }));
      });
    }
    function $(Z, M) {
      Z ? E(Z) : E(null, M);
    }
  }
  var d = 1;
  function f(m) {
    var E = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
    return m.__id__ || E && (m.__id__ = d++);
  }
  var v = /* @__PURE__ */ Object.create(null);
  function h(m) {
    return m.map(function(E) {
      return v[f(E)];
    }).filter(function(E) {
      return E;
    });
  }
  function y(m, E) {
    i1(a, m, function(x, I) {
      if (I == null) {
        E();
        return;
      }
      o = J0({}, I, { location: m });
      for (var T = h(I1(t, o).leaveRoutes), L = void 0, S = 0, $ = T.length; L == null && S < $; ++S)
        L = T[S](m);
      E(L);
    });
  }
  function g() {
    if (t.routes) {
      for (var m = h(t.routes), E = void 0, x = 0, I = m.length; typeof E != "string" && x < I; ++x)
        E = m[x]();
      return E;
    }
  }
  var p = void 0, P = void 0;
  function b(m) {
    var E = f(m);
    E && (delete v[E], U1(v) || (p && (p(), p = null), P && (P(), P = null)));
  }
  function H(m, E) {
    var x = !U1(v), I = f(m, !0);
    return v[I] = E, x && (p = e.listenBefore(y), e.listenBeforeUnload && (P = e.listenBeforeUnload(g))), function() {
      b(m);
    };
  }
  function A(m) {
    function E(I) {
      t.location === I ? m(null, t) : i(I, function(T, L, S) {
        T ? m(T) : L ? e.replace(L) : S ? m(null, S) : process.env.NODE_ENV !== "production" && v0(!1, 'Location "%s" did not match any routes', I.pathname + I.search + I.hash);
      });
    }
    var x = e.listen(E);
    return t.location ? m(null, t) : E(e.getCurrentLocation()), x;
  }
  return {
    isActive: l,
    match: i,
    listenBeforeLeavingRoute: H,
    listen: A
  };
}
function C0(e, a, t) {
  if (e[a]) return new Error("<" + t + '> should not have a "' + a + '" prop');
}
R.shape({
  listen: R.func.isRequired,
  push: R.func.isRequired,
  replace: R.func.isRequired,
  go: R.func.isRequired,
  goBack: R.func.isRequired,
  goForward: R.func.isRequired
});
var v1 = R.elementType, D3 = R.oneOfType([v1, R.object]), F1 = R.oneOfType([R.object, R.element]), $1 = R.oneOfType([F1, R.arrayOf(F1)]), M2 = N0();
function E2(e, a) {
  var t = {};
  return e.path && m3(e.path).forEach(function(r) {
    Object.prototype.hasOwnProperty.call(a, r) && (t[r] = a[r]);
  }), t;
}
var P3 = G0.shape({
  subscribe: G0.func.isRequired,
  eventIndex: G0.number.isRequired
});
function M3(e) {
  return "@@contextSubscriber/" + e;
}
var E3 = typeof r0.forwardRef < "u";
function L2(e) {
  var a, t, r = M3(e), n = r + "/listeners", c = r + "/eventIndex", u = r + "/subscribe", l = (t = {
    childContextTypes: (a = {}, a[r] = P3.isRequired, a),
    getChildContext: function() {
      var i;
      return i = {}, i[r] = {
        eventIndex: this[c],
        subscribe: this[u]
      }, i;
    },
    // this method will be updated to UNSAFE_componentWillMount below for React versions >= 16.3
    componentWillMount: function() {
      this[n] = [], this[c] = 0;
    },
    // this method will be updated to UNSAFE_componentWillReceiveProps below for React versions >= 16.3
    componentWillReceiveProps: function() {
      this[c]++;
    },
    componentDidUpdate: function() {
      var i = this;
      this[n].forEach(function(s) {
        return s(i[c]);
      });
    }
  }, t[u] = function(o) {
    var i = this;
    return this[n].push(o), function() {
      i[n] = i[n].filter(function(s) {
        return s !== o;
      });
    };
  }, t);
  return E3 && (l.UNSAFE_componentWillMount = l.componentWillMount, l.UNSAFE_componentWillReceiveProps = l.componentWillReceiveProps, delete l.componentWillMount, delete l.componentWillReceiveProps), l;
}
function b2(e) {
  var a, t, r = M3(e), n = r + "/lastRenderedEventIndex", c = r + "/handleContextUpdate", u = r + "/unsubscribe", l = (t = {
    contextTypes: (a = {}, a[r] = P3, a),
    getInitialState: function() {
      var i;
      return this.context[r] ? (i = {}, i[n] = this.context[r].eventIndex, i) : {};
    },
    componentDidMount: function() {
      this.context[r] && (this[u] = this.context[r].subscribe(this[c]));
    },
    // this method will be updated to UNSAFE_componentWillReceiveProps below for React versions >= 16.3
    componentWillReceiveProps: function() {
      var i;
      this.context[r] && this.setState((i = {}, i[n] = this.context[r].eventIndex, i));
    },
    componentWillUnmount: function() {
      this[u] && (this[u](), this[u] = null);
    }
  }, t[c] = function(o) {
    if (o !== this.state[n]) {
      var i;
      this.setState((i = {}, i[n] = o, i));
    }
  }, t);
  return E3 && (l.UNSAFE_componentWillReceiveProps = l.componentWillReceiveProps, delete l.componentWillReceiveProps), l;
}
var H2 = Object.assign || function(e) {
  for (var a = 1; a < arguments.length; a++) {
    var t = arguments[a];
    for (var r in t)
      Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
  }
  return e;
}, _2 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
  return typeof e;
} : function(e) {
  return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
}, R2 = u0({
  displayName: "RouterContext",
  mixins: [L2("router")],
  propTypes: {
    router: R.object.isRequired,
    location: R.object.isRequired,
    routes: R.array.isRequired,
    params: R.object.isRequired,
    components: R.array.isRequired,
    createElement: R.func.isRequired
  },
  getDefaultProps: function() {
    return {
      createElement: r0.createElement
    };
  },
  childContextTypes: {
    router: R.object.isRequired
  },
  getChildContext: function() {
    return {
      router: this.props.router
    };
  },
  createElement: function(a, t) {
    return a == null ? null : this.props.createElement(a, t);
  },
  render: function() {
    var a = this, t = this.props, r = t.location, n = t.routes, c = t.params, u = t.components, l = t.router, o = null;
    return u && (o = u.reduceRight(function(i, s, d) {
      if (s == null) return i;
      var f = n[d], v = E2(f, c), h = {
        location: r,
        params: c,
        route: f,
        router: l,
        routeParams: v,
        routes: n
      };
      if (g3(i))
        h.children = i;
      else if (i)
        for (var y in i)
          Object.prototype.hasOwnProperty.call(i, y) && (h[y] = i[y]);
      if ((typeof s > "u" ? "undefined" : _2(s)) === "object" && !M2.isValidElementType(s)) {
        var g = {};
        for (var p in s)
          Object.prototype.hasOwnProperty.call(s, p) && (g[p] = a.createElement(s[p], H2({
            key: p
          }, h)));
        return g;
      }
      return a.createElement(s, h);
    }, o)), o === null || o === !1 || r0.isValidElement(o) || (process.env.NODE_ENV !== "production" ? J(!1, "The root route must render a single element") : J(!1)), o;
  }
}), O2 = Object.assign || function(e) {
  for (var a = 1; a < arguments.length; a++) {
    var t = arguments[a];
    for (var r in t)
      Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
  }
  return e;
};
function w2(e, a, t) {
  var r = O2({}, e, {
    setRouteLeaveHook: a.listenBeforeLeavingRoute,
    isActive: a.isActive
  });
  return L3(r, t);
}
function L3(e, a) {
  var t = a.location, r = a.params, n = a.routes;
  return e.location = t, e.params = r, e.routes = n, e;
}
var S2 = Object.assign || function(e) {
  for (var a = 1; a < arguments.length; a++) {
    var t = arguments[a];
    for (var r in t)
      Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
  }
  return e;
};
function T2(e, a) {
  var t = {};
  for (var r in e)
    a.indexOf(r) >= 0 || Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
  return t;
}
var j1 = {
  history: R.object,
  children: $1,
  routes: $1,
  // alias for children
  render: R.func,
  createElement: R.func,
  onError: R.func,
  onUpdate: R.func,
  // PRIVATE: For client-side rehydration of server match.
  matchContext: R.object
}, N2 = typeof r0.forwardRef < "u", h0 = u0({
  displayName: "Router",
  propTypes: j1,
  getDefaultProps: function() {
    return {
      render: function(t) {
        return r0.createElement(R2, t);
      }
    };
  },
  getInitialState: function() {
    return {
      location: null,
      routes: null,
      params: null,
      components: null
    };
  },
  handleError: function(a) {
    if (this.props.onError)
      this.props.onError.call(this, a);
    else
      throw a;
  },
  createRouterObject: function(a) {
    var t = this.props.matchContext;
    if (t)
      return t.router;
    var r = this.props.history;
    return w2(r, this.transitionManager, a);
  },
  createTransitionManager: function() {
    var a = this.props.matchContext;
    if (a)
      return a.transitionManager;
    var t = this.props.history, r = this.props, n = r.routes, c = r.children;
    return t.getCurrentLocation || (process.env.NODE_ENV !== "production" ? J(!1, "You have provided a history object created with history v4.x or v2.x and earlier. This version of React Router is only compatible with v3 history objects. Please change to history v3.x.") : J(!1)), P2(t, y0(n || c));
  },
  // this method will be updated to UNSAFE_componentWillMount below for React versions >= 16.3
  componentWillMount: function() {
    var a = this;
    this.transitionManager = this.createTransitionManager(), this.router = this.createRouterObject(this.state), this._unlisten = this.transitionManager.listen(function(t, r) {
      t ? a.handleError(t) : (L3(a.router, r), a.setState(r, a.props.onUpdate));
    });
  },
  // this method will be updated to UNSAFE_componentWillReceiveProps below for React versions >= 16.3
  /* istanbul ignore next: sanity check */
  componentWillReceiveProps: function(a) {
    process.env.NODE_ENV !== "production" && v0(a.history === this.props.history, "You cannot change <Router history>; it will be ignored"), process.env.NODE_ENV !== "production" && v0((a.routes || a.children) === (this.props.routes || this.props.children), "You cannot change <Router routes>; it will be ignored");
  },
  componentWillUnmount: function() {
    this._unlisten && this._unlisten();
  },
  render: function() {
    var a = this.state, t = a.location, r = a.routes, n = a.params, c = a.components, u = this.props, l = u.createElement, o = u.render, i = T2(u, ["createElement", "render"]);
    return t == null ? null : (Object.keys(j1).forEach(function(s) {
      return delete i[s];
    }), o(S2({}, i, {
      router: this.router,
      location: t,
      routes: r,
      params: n,
      components: c,
      createElement: l
    })));
  }
});
N2 && (h0.prototype.UNSAFE_componentWillReceiveProps = h0.prototype.componentWillReceiveProps, h0.prototype.UNSAFE_componentWillMount = h0.prototype.componentWillMount, delete h0.prototype.componentWillReceiveProps, delete h0.prototype.componentWillMount);
var V2 = R.shape({
  push: R.func.isRequired,
  replace: R.func.isRequired,
  go: R.func.isRequired,
  goBack: R.func.isRequired,
  goForward: R.func.isRequired,
  setRouteLeaveHook: R.func.isRequired,
  isActive: R.func.isRequired
});
R.shape({
  pathname: R.string.isRequired,
  search: R.string.isRequired,
  state: R.object,
  action: R.string.isRequired,
  key: R.string
});
var X0 = Object.assign || function(e) {
  for (var a = 1; a < arguments.length; a++) {
    var t = arguments[a];
    for (var r in t)
      Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
  }
  return e;
};
function z2(e, a) {
  var t = {};
  for (var r in e)
    a.indexOf(r) >= 0 || Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
  return t;
}
function x2(e) {
  return e.button === 0;
}
function I2(e) {
  return !!(e.metaKey || e.altKey || e.ctrlKey || e.shiftKey);
}
function Z2(e) {
  for (var a in e)
    if (Object.prototype.hasOwnProperty.call(e, a)) return !1;
  return !0;
}
function k1(e, a) {
  return typeof e == "function" ? e(a.location) : e;
}
var b3 = u0({
  displayName: "Link",
  mixins: [b2("router")],
  contextTypes: {
    router: V2
  },
  propTypes: {
    to: R.oneOfType([R.string, R.object, R.func]),
    activeStyle: R.object,
    activeClassName: R.string,
    onlyActiveOnIndex: R.bool.isRequired,
    onClick: R.func,
    target: R.string,
    innerRef: R.oneOfType([R.string, R.func, R.shape({ current: R.elementType })])
  },
  getDefaultProps: function() {
    return {
      onlyActiveOnIndex: !1,
      style: {}
    };
  },
  handleClick: function(a) {
    if (this.props.onClick && this.props.onClick(a), !a.defaultPrevented) {
      var t = this.context.router;
      t || (process.env.NODE_ENV !== "production" ? J(!1, "<Link>s rendered outside of a router context cannot navigate.") : J(!1)), !(I2(a) || !x2(a)) && (this.props.target || (a.preventDefault(), t.push(k1(this.props.to, t))));
    }
  },
  render: function() {
    var a = this.props, t = a.to, r = a.activeClassName, n = a.activeStyle, c = a.onlyActiveOnIndex, u = a.innerRef, l = z2(a, ["to", "activeClassName", "activeStyle", "onlyActiveOnIndex", "innerRef"]), o = this.context.router;
    if (o) {
      if (!t)
        return r0.createElement("a", X0({}, l, { ref: u }));
      var i = k1(t, o);
      l.href = o.createHref(i), (r || n != null && !Z2(n)) && o.isActive(i, c) && (r && (l.className ? l.className += " " + r : l.className = r), n && (l.style = X0({}, l.style, n)));
    }
    return r0.createElement("a", X0({}, l, { onClick: this.handleClick, ref: u }));
  }
}), B2 = Object.assign || function(e) {
  for (var a = 1; a < arguments.length; a++) {
    var t = arguments[a];
    for (var r in t)
      Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
  }
  return e;
};
u0({
  displayName: "IndexLink",
  render: function() {
    return r0.createElement(b3, B2({}, this.props, { onlyActiveOnIndex: !0 }));
  }
});
var e1, W1;
function U2() {
  if (W1) return e1;
  W1 = 1;
  var e = N0(), a = {
    childContextTypes: !0,
    contextType: !0,
    contextTypes: !0,
    defaultProps: !0,
    displayName: !0,
    getDefaultProps: !0,
    getDerivedStateFromError: !0,
    getDerivedStateFromProps: !0,
    mixins: !0,
    propTypes: !0,
    type: !0
  }, t = {
    name: !0,
    length: !0,
    prototype: !0,
    caller: !0,
    callee: !0,
    arguments: !0,
    arity: !0
  }, r = {
    $$typeof: !0,
    render: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0
  }, n = {
    $$typeof: !0,
    compare: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0,
    type: !0
  }, c = {};
  c[e.ForwardRef] = r, c[e.Memo] = n;
  function u(h) {
    return e.isMemo(h) ? n : c[h.$$typeof] || a;
  }
  var l = Object.defineProperty, o = Object.getOwnPropertyNames, i = Object.getOwnPropertySymbols, s = Object.getOwnPropertyDescriptor, d = Object.getPrototypeOf, f = Object.prototype;
  function v(h, y, g) {
    if (typeof y != "string") {
      if (f) {
        var p = d(y);
        p && p !== f && v(h, p, g);
      }
      var P = o(y);
      i && (P = P.concat(i(y)));
      for (var b = u(h), H = u(y), A = 0; A < P.length; ++A) {
        var m = P[A];
        if (!t[m] && !(g && g[m]) && !(H && H[m]) && !(b && b[m])) {
          var E = s(y, m);
          try {
            l(h, m, E);
          } catch {
          }
        }
      }
    }
    return h;
  }
  return e1 = v, e1;
}
U2();
var H3 = u0({
  displayName: "Redirect",
  statics: {
    createRouteFromReactElement: function(a) {
      var t = V0(a);
      return t.from && (t.path = t.from), t.onEnter = function(r, n) {
        var c = r.location, u = r.params, l = void 0;
        if (t.to.charAt(0) === "/")
          l = x1(t.to, u);
        else if (!t.to)
          l = c.pathname;
        else {
          var o = r.routes.indexOf(t), i = H3.getRoutePattern(r.routes, o - 1), s = i.replace(/\/*$/, "/") + t.to;
          l = x1(s, u);
        }
        n({
          pathname: l,
          query: t.query || c.query,
          state: t.state || c.state
        });
      }, t;
    },
    getRoutePattern: function(a, t) {
      for (var r = "", n = t; n >= 0; n--) {
        var c = a[n], u = c.path || "";
        if (r = u.replace(/\/*$/, "/") + r, u.indexOf("/") === 0) break;
      }
      return "/" + r;
    }
  },
  propTypes: {
    path: R.string,
    from: R.string,
    // Alias for path
    to: R.string.isRequired,
    query: R.object,
    state: R.object,
    onEnter: C0,
    children: C0
  },
  /* istanbul ignore next: sanity check */
  render: function() {
    process.env.NODE_ENV !== "production" ? J(!1, "<Redirect> elements are for router configuration only and should not be rendered") : J(!1);
  }
});
u0({
  displayName: "IndexRedirect",
  statics: {
    createRouteFromReactElement: function(a, t) {
      t ? t.indexRoute = H3.createRouteFromReactElement(a) : process.env.NODE_ENV !== "production" && v0(!1, "An <IndexRedirect> does not make sense at the root of your route config");
    }
  },
  propTypes: {
    to: R.string.isRequired,
    query: R.object,
    state: R.object,
    onEnter: C0,
    children: C0
  },
  /* istanbul ignore next: sanity check */
  render: function() {
    process.env.NODE_ENV !== "production" ? J(!1, "<IndexRedirect> elements are for router configuration only and should not be rendered") : J(!1);
  }
});
u0({
  displayName: "IndexRoute",
  statics: {
    createRouteFromReactElement: function(a, t) {
      t ? t.indexRoute = V0(a) : process.env.NODE_ENV !== "production" && v0(!1, "An <IndexRoute> does not make sense at the root of your route config");
    }
  },
  propTypes: {
    path: C0,
    component: v1,
    components: D3,
    getComponent: R.func,
    getComponents: R.func
  },
  /* istanbul ignore next: sanity check */
  render: function() {
    process.env.NODE_ENV !== "production" ? J(!1, "<IndexRoute> elements are for router configuration only and should not be rendered") : J(!1);
  }
});
u0({
  displayName: "Route",
  statics: {
    createRouteFromReactElement: V0
  },
  propTypes: {
    path: R.string,
    component: v1,
    components: D3,
    getComponent: R.func,
    getComponents: R.func
  },
  /* istanbul ignore next: sanity check */
  render: function() {
    process.env.NODE_ENV !== "production" ? J(!1, "<Route> elements are for router configuration only and should not be rendered") : J(!1);
  }
});
var p0 = {}, Y1;
function z0() {
  return Y1 || (Y1 = 1, p0.__esModule = !0, p0.PUSH = "PUSH", p0.REPLACE = "REPLACE", p0.POP = "POP"), p0;
}
z0();
var E0 = {}, m0 = {}, a1, G1;
function F2() {
  return G1 || (G1 = 1, a1 = function(e) {
    return encodeURIComponent(e).replace(/[!'()*]/g, function(a) {
      return "%" + a.charCodeAt(0).toString(16).toUpperCase();
    });
  }), a1;
}
var Q1;
function $2() {
  if (Q1) return m0;
  Q1 = 1;
  var e = F2(), a = l1();
  function t(u) {
    switch (u.arrayFormat) {
      case "index":
        return function(l, o, i) {
          return o === null ? [
            n(l, u),
            "[",
            i,
            "]"
          ].join("") : [
            n(l, u),
            "[",
            n(i, u),
            "]=",
            n(o, u)
          ].join("");
        };
      case "bracket":
        return function(l, o) {
          return o === null ? n(l, u) : [
            n(l, u),
            "[]=",
            n(o, u)
          ].join("");
        };
      default:
        return function(l, o) {
          return o === null ? n(l, u) : [
            n(l, u),
            "=",
            n(o, u)
          ].join("");
        };
    }
  }
  function r(u) {
    var l;
    switch (u.arrayFormat) {
      case "index":
        return function(o, i, s) {
          if (l = /\[(\d*)\]$/.exec(o), o = o.replace(/\[\d*\]$/, ""), !l) {
            s[o] = i;
            return;
          }
          s[o] === void 0 && (s[o] = {}), s[o][l[1]] = i;
        };
      case "bracket":
        return function(o, i, s) {
          if (l = /(\[\])$/.exec(o), o = o.replace(/\[\]$/, ""), l) {
            if (s[o] === void 0) {
              s[o] = [i];
              return;
            }
          } else {
            s[o] = i;
            return;
          }
          s[o] = [].concat(s[o], i);
        };
      default:
        return function(o, i, s) {
          if (s[o] === void 0) {
            s[o] = i;
            return;
          }
          s[o] = [].concat(s[o], i);
        };
    }
  }
  function n(u, l) {
    return l.encode ? l.strict ? e(u) : encodeURIComponent(u) : u;
  }
  function c(u) {
    return Array.isArray(u) ? u.sort() : typeof u == "object" ? c(Object.keys(u)).sort(function(l, o) {
      return Number(l) - Number(o);
    }).map(function(l) {
      return u[l];
    }) : u;
  }
  return m0.extract = function(u) {
    return u.split("?")[1] || "";
  }, m0.parse = function(u, l) {
    l = a({ arrayFormat: "none" }, l);
    var o = r(l), i = /* @__PURE__ */ Object.create(null);
    return typeof u != "string" || (u = u.trim().replace(/^(\?|#|&)/, ""), !u) ? i : (u.split("&").forEach(function(s) {
      var d = s.replace(/\+/g, " ").split("="), f = d.shift(), v = d.length > 0 ? d.join("=") : void 0;
      v = v === void 0 ? null : decodeURIComponent(v), o(decodeURIComponent(f), v, i);
    }), Object.keys(i).sort().reduce(function(s, d) {
      var f = i[d];
      return f && typeof f == "object" && !Array.isArray(f) ? s[d] = c(f) : s[d] = f, s;
    }, /* @__PURE__ */ Object.create(null)));
  }, m0.stringify = function(u, l) {
    var o = {
      encode: !0,
      strict: !0,
      arrayFormat: "none"
    };
    l = a(o, l);
    var i = t(l);
    return u ? Object.keys(u).sort().map(function(s) {
      var d = u[s];
      if (d === void 0)
        return "";
      if (d === null)
        return n(s, l);
      if (Array.isArray(d)) {
        var f = [];
        return d.slice().forEach(function(v) {
          v !== void 0 && f.push(i(s, v, f.length));
        }), f.join("&");
      }
      return n(s, l) + "=" + n(d, l);
    }).filter(function(s) {
      return s.length > 0;
    }).join("&") : "";
  }, m0;
}
var L0 = {}, K1;
function h1() {
  if (K1) return L0;
  K1 = 1, L0.__esModule = !0;
  var e = c0(), a = t(e);
  function t(n) {
    return n && n.__esModule ? n : { default: n };
  }
  var r = function(c, u, l) {
    var o = c(u, l);
    c.length < 2 ? l(o) : process.env.NODE_ENV !== "production" && (0, a.default)(o === void 0, 'You should not "return" in a transition hook with a callback argument; call the callback instead');
  };
  return L0.default = r, L0;
}
var n0 = {}, t0 = {}, J1;
function f0() {
  if (J1) return t0;
  J1 = 1, t0.__esModule = !0, t0.createPath = t0.parsePath = t0.getQueryStringValueFromPath = t0.stripQueryStringValueFromPath = t0.addQueryStringValueToPath = void 0;
  var e = c0(), a = t(e);
  function t(u) {
    return u && u.__esModule ? u : { default: u };
  }
  t0.addQueryStringValueToPath = function(l, o, i) {
    var s = n(l), d = s.pathname, f = s.search, v = s.hash;
    return c({
      pathname: d,
      search: f + (f.indexOf("?") === -1 ? "?" : "&") + o + "=" + i,
      hash: v
    });
  }, t0.stripQueryStringValueFromPath = function(l, o) {
    var i = n(l), s = i.pathname, d = i.search, f = i.hash;
    return c({
      pathname: s,
      search: d.replace(new RegExp("([?&])" + o + "=[a-zA-Z0-9]+(&?)"), function(v, h, y) {
        return h === "?" ? h : y;
      }),
      hash: f
    });
  }, t0.getQueryStringValueFromPath = function(l, o) {
    var i = n(l), s = i.search, d = s.match(new RegExp("[?&]" + o + "=([a-zA-Z0-9]+)"));
    return d && d[1];
  };
  var r = function(l) {
    var o = l.match(/^(https?:)?\/\/[^\/]*/);
    return o == null ? l : l.substring(o[0].length);
  }, n = t0.parsePath = function(l) {
    var o = r(l), i = "", s = "";
    process.env.NODE_ENV !== "production" && (0, a.default)(l === o, 'A path must be pathname + search + hash only, not a full URL like "%s"', l);
    var d = o.indexOf("#");
    d !== -1 && (s = o.substring(d), o = o.substring(0, d));
    var f = o.indexOf("?");
    return f !== -1 && (i = o.substring(f), o = o.substring(0, f)), o === "" && (o = "/"), {
      pathname: o,
      search: i,
      hash: s
    };
  }, c = t0.createPath = function(l) {
    if (l == null || typeof l == "string") return l;
    var o = l.basename, i = l.pathname, s = l.search, d = l.hash, f = (o || "") + i;
    return s && s !== "?" && (f += s), d && (f += d), f;
  };
  return t0;
}
var X1;
function q0() {
  if (X1) return n0;
  X1 = 1, n0.__esModule = !0, n0.locationsAreEqual = n0.statesAreEqual = n0.createLocation = n0.createQuery = void 0;
  var e = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(d) {
    return typeof d;
  } : function(d) {
    return d && typeof Symbol == "function" && d.constructor === Symbol && d !== Symbol.prototype ? "symbol" : typeof d;
  }, a = Object.assign || function(d) {
    for (var f = 1; f < arguments.length; f++) {
      var v = arguments[f];
      for (var h in v)
        Object.prototype.hasOwnProperty.call(v, h) && (d[h] = v[h]);
    }
    return d;
  }, t = A0(), r = o(t), n = c0(), c = o(n), u = f0(), l = z0();
  function o(d) {
    return d && d.__esModule ? d : { default: d };
  }
  n0.createQuery = function(f) {
    return a(/* @__PURE__ */ Object.create(null), f);
  }, n0.createLocation = function() {
    var f = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "/", v = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : l.POP, h = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null, y = typeof f == "string" ? (0, u.parsePath)(f) : f;
    process.env.NODE_ENV !== "production" && (0, c.default)(!y.path, "Location descriptor objects should have a `pathname`, not a `path`.");
    var g = y.pathname || "/", p = y.search || "", P = y.hash || "", b = y.state;
    return {
      pathname: g,
      search: p,
      hash: P,
      state: b,
      action: v,
      key: h
    };
  };
  var i = function(f) {
    return Object.prototype.toString.call(f) === "[object Date]";
  }, s = n0.statesAreEqual = function d(f, v) {
    if (f === v) return !0;
    var h = typeof f > "u" ? "undefined" : e(f), y = typeof v > "u" ? "undefined" : e(v);
    if (h !== y) return !1;
    if (h === "function" && (process.env.NODE_ENV !== "production" ? (0, r.default)(!1, "You must not store functions in location state") : (0, r.default)(!1)), h === "object") {
      if (i(f) && i(v) && (process.env.NODE_ENV !== "production" ? (0, r.default)(!1, "You must not store Date objects in location state") : (0, r.default)(!1)), !Array.isArray(f)) {
        var g = Object.keys(f), p = Object.keys(v);
        return g.length === p.length && g.every(function(P) {
          return d(f[P], v[P]);
        });
      }
      return Array.isArray(v) && f.length === v.length && f.every(function(P, b) {
        return d(P, v[b]);
      });
    }
    return !1;
  };
  return n0.locationsAreEqual = function(f, v) {
    return f.key === v.key && // a.action === b.action && // Different action !== location change.
    f.pathname === v.pathname && f.search === v.search && f.hash === v.hash && s(f.state, v.state);
  }, n0;
}
var e3;
function j2() {
  if (e3) return E0;
  e3 = 1, E0.__esModule = !0;
  var e = Object.assign || function(s) {
    for (var d = 1; d < arguments.length; d++) {
      var f = arguments[d];
      for (var v in f)
        Object.prototype.hasOwnProperty.call(f, v) && (s[v] = f[v]);
    }
    return s;
  }, a = $2(), t = h1(), r = u(t), n = q0(), c = f0();
  function u(s) {
    return s && s.__esModule ? s : { default: s };
  }
  var l = function(d) {
    return (0, a.stringify)(d).replace(/%20/g, "+");
  }, o = a.parse, i = function(d) {
    return function() {
      var f = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, v = d(f), h = f.stringifyQuery, y = f.parseQueryString;
      typeof h != "function" && (h = l), typeof y != "function" && (y = o);
      var g = function(L) {
        return L && (L.query == null && (L.query = y(L.search.substring(1))), L);
      }, p = function(L, S) {
        if (S == null) return L;
        var $ = typeof L == "string" ? (0, c.parsePath)(L) : L, Z = h(S), M = Z ? "?" + Z : "";
        return e({}, $, {
          search: M
        });
      }, P = function() {
        return g(v.getCurrentLocation());
      }, b = function(L) {
        return v.listenBefore(function(S, $) {
          return (0, r.default)(L, g(S), $);
        });
      }, H = function(L) {
        return v.listen(function(S) {
          return L(g(S));
        });
      }, A = function(L) {
        return v.push(p(L, L.query));
      }, m = function(L) {
        return v.replace(p(L, L.query));
      }, E = function(L) {
        return v.createPath(p(L, L.query));
      }, x = function(L) {
        return v.createHref(p(L, L.query));
      }, I = function(L) {
        for (var S = arguments.length, $ = Array(S > 1 ? S - 1 : 0), Z = 1; Z < S; Z++)
          $[Z - 1] = arguments[Z];
        var M = v.createLocation.apply(v, [p(L, L.query)].concat($));
        return L.query && (M.query = (0, n.createQuery)(L.query)), g(M);
      };
      return e({}, v, {
        getCurrentLocation: P,
        listenBefore: b,
        listen: H,
        push: A,
        replace: m,
        createPath: E,
        createHref: x,
        createLocation: I
      });
    };
  };
  return E0.default = i, E0;
}
var k2 = j2();
const W2 = /* @__PURE__ */ s0(k2);
var b0 = {}, a3;
function Y2() {
  if (a3) return b0;
  a3 = 1, b0.__esModule = !0;
  var e = Object.assign || function(u) {
    for (var l = 1; l < arguments.length; l++) {
      var o = arguments[l];
      for (var i in o)
        Object.prototype.hasOwnProperty.call(o, i) && (u[i] = o[i]);
    }
    return u;
  }, a = h1(), t = n(a), r = f0();
  function n(u) {
    return u && u.__esModule ? u : { default: u };
  }
  var c = function(l) {
    return function() {
      var o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, i = l(o), s = o.basename, d = function(m) {
        return m && (s && m.basename == null && (m.pathname.toLowerCase().indexOf(s.toLowerCase()) === 0 ? (m.pathname = m.pathname.substring(s.length), m.basename = s, m.pathname === "" && (m.pathname = "/")) : m.basename = ""), m);
      }, f = function(m) {
        if (!s) return m;
        var E = typeof m == "string" ? (0, r.parsePath)(m) : m, x = E.pathname, I = s.slice(-1) === "/" ? s : s + "/", T = x.charAt(0) === "/" ? x.slice(1) : x, L = I + T;
        return e({}, E, {
          pathname: L
        });
      }, v = function() {
        return d(i.getCurrentLocation());
      }, h = function(m) {
        return i.listenBefore(function(E, x) {
          return (0, t.default)(m, d(E), x);
        });
      }, y = function(m) {
        return i.listen(function(E) {
          return m(d(E));
        });
      }, g = function(m) {
        return i.push(f(m));
      }, p = function(m) {
        return i.replace(f(m));
      }, P = function(m) {
        return i.createPath(f(m));
      }, b = function(m) {
        return i.createHref(f(m));
      }, H = function(m) {
        for (var E = arguments.length, x = Array(E > 1 ? E - 1 : 0), I = 1; I < E; I++)
          x[I - 1] = arguments[I];
        return d(i.createLocation.apply(i, [f(m)].concat(x)));
      };
      return e({}, i, {
        getCurrentLocation: v,
        listenBefore: h,
        listen: y,
        push: g,
        replace: p,
        createPath: P,
        createHref: b,
        createLocation: H
      });
    };
  };
  return b0.default = c, b0;
}
var G2 = Y2();
const Q2 = /* @__PURE__ */ s0(G2);
var H0 = {}, _0 = {}, R0 = {}, t3;
function K2() {
  return t3 || (t3 = 1, R0.__esModule = !0, R0.loopAsync = function(a, t, r) {
    var n = 0, c = !1, u = !1, l = !1, o = void 0, i = function() {
      for (var f = arguments.length, v = Array(f), h = 0; h < f; h++)
        v[h] = arguments[h];
      if (c = !0, u) {
        o = v;
        return;
      }
      r.apply(void 0, v);
    }, s = function d() {
      if (!c && (l = !0, !u)) {
        for (u = !0; !c && n < a && l; )
          l = !1, t(n++, d, i);
        if (u = !1, c) {
          r.apply(void 0, o);
          return;
        }
        n >= a && l && (c = !0, r());
      }
    };
    s();
  }), R0;
}
var r3;
function p1() {
  if (r3) return _0;
  r3 = 1, _0.__esModule = !0;
  var e = K2(), a = f0(), t = h1(), r = u(t), n = z0(), c = q0();
  function u(o) {
    return o && o.__esModule ? o : { default: o };
  }
  var l = function() {
    var i = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, s = i.getCurrentLocation, d = i.getUserConfirmation, f = i.pushLocation, v = i.replaceLocation, h = i.go, y = i.keyLength, g = void 0, p = void 0, P = [], b = [], H = [], A = function() {
      return p && p.action === n.POP ? H.indexOf(p.key) : g ? H.indexOf(g.key) : -1;
    }, m = function(_) {
      var q = A();
      g = _, g.action === n.PUSH ? H = [].concat(H.slice(0, q + 1), [g.key]) : g.action === n.REPLACE && (H[q] = g.key), b.forEach(function(D) {
        return D(g);
      });
    }, E = function(_) {
      return P.push(_), function() {
        return P = P.filter(function(q) {
          return q !== _;
        });
      };
    }, x = function(_) {
      return b.push(_), function() {
        return b = b.filter(function(q) {
          return q !== _;
        });
      };
    }, I = function(_, q) {
      (0, e.loopAsync)(P.length, function(D, N, z) {
        (0, r.default)(P[D], _, function(V) {
          return V != null ? z(V) : N();
        });
      }, function(D) {
        d && typeof D == "string" ? d(D, function(N) {
          return q(N !== !1);
        }) : q(D !== !1);
      });
    }, T = function(_) {
      g && (0, c.locationsAreEqual)(g, _) || p && (0, c.locationsAreEqual)(p, _) || (p = _, I(_, function(q) {
        if (p === _) {
          if (p = null, q) {
            if (_.action === n.PUSH) {
              var D = (0, a.createPath)(g), N = (0, a.createPath)(_);
              N === D && (0, c.statesAreEqual)(g.state, _.state) && (_.action = n.REPLACE);
            }
            _.action === n.POP ? m(_) : _.action === n.PUSH ? f(_) !== !1 && m(_) : _.action === n.REPLACE && v(_) !== !1 && m(_);
          } else if (g && _.action === n.POP) {
            var z = H.indexOf(g.key), V = H.indexOf(_.key);
            z !== -1 && V !== -1 && h(z - V);
          }
        }
      }));
    }, L = function(_) {
      return T(O(_, n.PUSH));
    }, S = function(_) {
      return T(O(_, n.REPLACE));
    }, $ = function() {
      return h(-1);
    }, Z = function() {
      return h(1);
    }, M = function() {
      return Math.random().toString(36).substr(2, y || 6);
    }, C = function(_) {
      return (0, a.createPath)(_);
    }, O = function(_, q) {
      var D = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : M();
      return (0, c.createLocation)(_, q, D);
    };
    return {
      getCurrentLocation: s,
      listenBefore: E,
      listen: x,
      transitionTo: T,
      push: L,
      replace: S,
      go: h,
      goBack: $,
      goForward: Z,
      createKey: M,
      createPath: a.createPath,
      createHref: C,
      createLocation: O
    };
  };
  return _0.default = l, _0;
}
var n3;
function J2() {
  if (n3) return H0;
  n3 = 1, H0.__esModule = !0;
  var e = Object.assign || function(v) {
    for (var h = 1; h < arguments.length; h++) {
      var y = arguments[h];
      for (var g in y)
        Object.prototype.hasOwnProperty.call(y, g) && (v[g] = y[g]);
    }
    return v;
  }, a = c0(), t = s(a), r = A0(), n = s(r), c = q0(), u = f0(), l = p1(), o = s(l), i = z0();
  function s(v) {
    return v && v.__esModule ? v : { default: v };
  }
  var d = function(h) {
    return h.filter(function(y) {
      return y.state;
    }).reduce(function(y, g) {
      return y[g.key] = g.state, y;
    }, {});
  }, f = function() {
    var h = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    Array.isArray(h) ? h = { entries: h } : typeof h == "string" && (h = { entries: [h] });
    var y = function() {
      var S = m[E], $ = (0, u.createPath)(S), Z = void 0, M = void 0;
      S.key && (Z = S.key, M = T(Z));
      var C = (0, u.parsePath)($);
      return (0, c.createLocation)(e({}, C, { state: M }), void 0, Z);
    }, g = function(S) {
      var $ = E + S;
      return $ >= 0 && $ < m.length;
    }, p = function(S) {
      if (S) {
        if (!g(S)) {
          process.env.NODE_ENV !== "production" && (0, t.default)(!1, "Cannot go(%s) there is not enough history", S);
          return;
        }
        E += S;
        var $ = y();
        H.transitionTo(e({}, $, { action: i.POP }));
      }
    }, P = function(S) {
      E += 1, E < m.length && m.splice(E), m.push(S), I(S.key, S.state);
    }, b = function(S) {
      m[E] = S, I(S.key, S.state);
    }, H = (0, o.default)(e({}, h, {
      getCurrentLocation: y,
      pushLocation: P,
      replaceLocation: b,
      go: p
    })), A = h, m = A.entries, E = A.current;
    typeof m == "string" ? m = [m] : Array.isArray(m) || (m = ["/"]), m = m.map(function(L) {
      return (0, c.createLocation)(L);
    }), E == null ? E = m.length - 1 : E >= 0 && E < m.length || (process.env.NODE_ENV !== "production" ? (0, n.default)(!1, "Current index must be >= 0 and < %s, was %s", m.length, E) : (0, n.default)(!1));
    var x = d(m), I = function(S, $) {
      return x[S] = $;
    }, T = function(S) {
      return x[S];
    };
    return e({}, H, {
      canGo: g
    });
  };
  return H0.default = f, H0;
}
J2();
function X2(e) {
  return function(a) {
    var t = W2(Q2(e))(a);
    return t;
  };
}
var O0 = {}, w0 = {}, o3;
function q1() {
  return o3 || (o3 = 1, w0.__esModule = !0, w0.canUseDOM = !!(typeof window < "u" && window.document && window.document.createElement)), w0;
}
var X = {}, i0 = {}, i3;
function x0() {
  return i3 || (i3 = 1, i0.__esModule = !0, i0.addEventListener = function(a, t, r) {
    return a.addEventListener ? a.addEventListener(t, r, !1) : a.attachEvent("on" + t, r);
  }, i0.removeEventListener = function(a, t, r) {
    return a.removeEventListener ? a.removeEventListener(t, r, !1) : a.detachEvent("on" + t, r);
  }, i0.supportsHistory = function() {
    var a = window.navigator.userAgent;
    return (a.indexOf("Android 2.") !== -1 || a.indexOf("Android 4.0") !== -1) && a.indexOf("Mobile Safari") !== -1 && a.indexOf("Chrome") === -1 && a.indexOf("Windows Phone") === -1 ? !1 : window.history && "pushState" in window.history;
  }, i0.supportsGoWithoutReloadUsingHash = function() {
    return window.navigator.userAgent.indexOf("Firefox") === -1;
  }, i0.supportsPopstateOnHashchange = function() {
    return window.navigator.userAgent.indexOf("Trident") === -1;
  }, i0.isExtraneousPopstateEvent = function(a) {
    return a.state === void 0 && navigator.userAgent.indexOf("CriOS") === -1;
  }), i0;
}
var d0 = {}, l3;
function _3() {
  if (l3) return d0;
  l3 = 1, d0.__esModule = !0, d0.readState = d0.saveState = void 0;
  var e = c0(), a = t(e);
  function t(l) {
    return l && l.__esModule ? l : { default: l };
  }
  var r = {
    QuotaExceededError: !0,
    QUOTA_EXCEEDED_ERR: !0
  }, n = {
    SecurityError: !0
  }, c = "@@History/", u = function(o) {
    return c + o;
  };
  return d0.saveState = function(o, i) {
    if (!window.sessionStorage) {
      process.env.NODE_ENV !== "production" && (0, a.default)(!1, "[history] Unable to save state; sessionStorage is not available");
      return;
    }
    try {
      i == null ? window.sessionStorage.removeItem(u(o)) : window.sessionStorage.setItem(u(o), JSON.stringify(i));
    } catch (s) {
      if (n[s.name]) {
        process.env.NODE_ENV !== "production" && (0, a.default)(!1, "[history] Unable to save state; sessionStorage is not available due to security settings");
        return;
      }
      if (r[s.name] && window.sessionStorage.length === 0) {
        process.env.NODE_ENV !== "production" && (0, a.default)(!1, "[history] Unable to save state; sessionStorage is not available in Safari private mode");
        return;
      }
      throw s;
    }
  }, d0.readState = function(o) {
    var i = void 0;
    try {
      i = window.sessionStorage.getItem(u(o));
    } catch (s) {
      if (n[s.name]) {
        process.env.NODE_ENV !== "production" && (0, a.default)(!1, "[history] Unable to read state; sessionStorage is not available due to security settings");
        return;
      }
    }
    if (i)
      try {
        return JSON.parse(i);
      } catch {
      }
  }, d0;
}
var s3;
function m1() {
  if (s3) return X;
  s3 = 1, X.__esModule = !0, X.go = X.replaceLocation = X.pushLocation = X.startListener = X.getUserConfirmation = X.getCurrentLocation = void 0;
  var e = q0(), a = x0(), t = _3(), r = f0(), n = q1(), c = "popstate", u = "hashchange", l = n.canUseDOM && !(0, a.supportsPopstateOnHashchange)(), o = function(f) {
    var v = f && f.key;
    return (0, e.createLocation)({
      pathname: window.location.pathname,
      search: window.location.search,
      hash: window.location.hash,
      state: v ? (0, t.readState)(v) : void 0
    }, void 0, v);
  }, i = X.getCurrentLocation = function() {
    var f = void 0;
    try {
      f = window.history.state || {};
    } catch {
      f = {};
    }
    return o(f);
  };
  X.getUserConfirmation = function(f, v) {
    return v(window.confirm(f));
  }, X.startListener = function(f) {
    var v = function(g) {
      (0, a.isExtraneousPopstateEvent)(g) || f(o(g.state));
    };
    (0, a.addEventListener)(window, c, v);
    var h = function() {
      return f(i());
    };
    return l && (0, a.addEventListener)(window, u, h), function() {
      (0, a.removeEventListener)(window, c, v), l && (0, a.removeEventListener)(window, u, h);
    };
  };
  var s = function(f, v) {
    var h = f.state, y = f.key;
    h !== void 0 && (0, t.saveState)(y, h), v({ key: y }, (0, r.createPath)(f));
  };
  return X.pushLocation = function(f) {
    return s(f, function(v, h) {
      return window.history.pushState(v, null, h);
    });
  }, X.replaceLocation = function(f) {
    return s(f, function(v, h) {
      return window.history.replaceState(v, null, h);
    });
  }, X.go = function(f) {
    f && window.history.go(f);
  }, X;
}
var t1 = {}, u3;
function e4() {
  return u3 || (u3 = 1, function(e) {
    e.__esModule = !0, e.replaceLocation = e.pushLocation = e.getCurrentLocation = e.go = e.getUserConfirmation = void 0;
    var a = m1();
    Object.defineProperty(e, "getUserConfirmation", {
      enumerable: !0,
      get: function() {
        return a.getUserConfirmation;
      }
    }), Object.defineProperty(e, "go", {
      enumerable: !0,
      get: function() {
        return a.go;
      }
    });
    var t = q0(), r = f0();
    e.getCurrentLocation = function() {
      return (0, t.createLocation)(window.location);
    }, e.pushLocation = function(c) {
      return window.location.href = (0, r.createPath)(c), !1;
    }, e.replaceLocation = function(c) {
      return window.location.replace((0, r.createPath)(c)), !1;
    };
  }(t1)), t1;
}
var c3;
function a4() {
  if (c3) return O0;
  c3 = 1, O0.__esModule = !0;
  var e = Object.assign || function(h) {
    for (var y = 1; y < arguments.length; y++) {
      var g = arguments[y];
      for (var p in g)
        Object.prototype.hasOwnProperty.call(g, p) && (h[p] = g[p]);
    }
    return h;
  }, a = A0(), t = f(a), r = q1(), n = m1(), c = d(n), u = e4(), l = d(u), o = x0(), i = p1(), s = f(i);
  function d(h) {
    if (h && h.__esModule)
      return h;
    var y = {};
    if (h != null)
      for (var g in h)
        Object.prototype.hasOwnProperty.call(h, g) && (y[g] = h[g]);
    return y.default = h, y;
  }
  function f(h) {
    return h && h.__esModule ? h : { default: h };
  }
  var v = function() {
    var y = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    r.canUseDOM || (process.env.NODE_ENV !== "production" ? (0, t.default)(!1, "Browser history needs a DOM") : (0, t.default)(!1));
    var g = y.forceRefresh || !(0, o.supportsHistory)(), p = g ? l : c, P = p.getUserConfirmation, b = p.getCurrentLocation, H = p.pushLocation, A = p.replaceLocation, m = p.go, E = (0, s.default)(e({
      getUserConfirmation: P
    }, y, {
      getCurrentLocation: b,
      pushLocation: H,
      replaceLocation: A,
      go: m
    })), x = 0, I = void 0, T = function(Z, M) {
      ++x === 1 && (I = c.startListener(E.transitionTo));
      var C = M ? E.listenBefore(Z) : E.listen(Z);
      return function() {
        C(), --x === 0 && I();
      };
    }, L = function(Z) {
      return T(Z, !0);
    }, S = function(Z) {
      return T(Z, !1);
    };
    return e({}, E, {
      listenBefore: L,
      listen: S
    });
  };
  return O0.default = v, O0;
}
var t4 = a4();
const r4 = /* @__PURE__ */ s0(t4);
var n4 = !!(typeof window < "u" && window.document && window.document.createElement);
function R3(e) {
  var a = void 0;
  return n4 && (a = X2(e)()), a;
}
R3(r4);
var S0 = {}, r1 = {}, f3;
function o4() {
  return f3 || (f3 = 1, function(e) {
    e.__esModule = !0, e.replaceLocation = e.pushLocation = e.startListener = e.getCurrentLocation = e.go = e.getUserConfirmation = void 0;
    var a = m1();
    Object.defineProperty(e, "getUserConfirmation", {
      enumerable: !0,
      get: function() {
        return a.getUserConfirmation;
      }
    }), Object.defineProperty(e, "go", {
      enumerable: !0,
      get: function() {
        return a.go;
      }
    });
    var t = c0(), r = o(t), n = q0(), c = x0(), u = _3(), l = f0();
    function o(g) {
      return g && g.__esModule ? g : { default: g };
    }
    var i = "hashchange", s = function() {
      var p = window.location.href, P = p.indexOf("#");
      return P === -1 ? "" : p.substring(P + 1);
    }, d = function(p) {
      return window.location.hash = p;
    }, f = function(p) {
      var P = window.location.href.indexOf("#");
      window.location.replace(window.location.href.slice(0, P >= 0 ? P : 0) + "#" + p);
    }, v = e.getCurrentLocation = function(p, P) {
      var b = p.decodePath(s()), H = (0, l.getQueryStringValueFromPath)(b, P), A = void 0;
      H && (b = (0, l.stripQueryStringValueFromPath)(b, P), A = (0, u.readState)(H));
      var m = (0, l.parsePath)(b);
      return m.state = A, (0, n.createLocation)(m, void 0, H);
    }, h = void 0;
    e.startListener = function(p, P, b) {
      var H = function() {
        var x = s(), I = P.encodePath(x);
        if (x !== I)
          f(I);
        else {
          var T = v(P, b);
          if (h && T.key && h.key === T.key) return;
          h = T, p(T);
        }
      }, A = s(), m = P.encodePath(A);
      return A !== m && f(m), (0, c.addEventListener)(window, i, H), function() {
        return (0, c.removeEventListener)(window, i, H);
      };
    };
    var y = function(p, P, b, H) {
      var A = p.state, m = p.key, E = P.encodePath((0, l.createPath)(p));
      A !== void 0 && (E = (0, l.addQueryStringValueToPath)(E, b, m), (0, u.saveState)(m, A)), h = p, H(E);
    };
    e.pushLocation = function(p, P, b) {
      return y(p, P, b, function(H) {
        s() !== H ? d(H) : process.env.NODE_ENV !== "production" && (0, r.default)(!1, "You cannot PUSH the same path using hash history");
      });
    }, e.replaceLocation = function(p, P, b) {
      return y(p, P, b, function(H) {
        s() !== H && f(H);
      });
    };
  }(r1)), r1;
}
var d3;
function i4() {
  if (d3) return S0;
  d3 = 1, S0.__esModule = !0;
  var e = Object.assign || function(p) {
    for (var P = 1; P < arguments.length; P++) {
      var b = arguments[P];
      for (var H in b)
        Object.prototype.hasOwnProperty.call(b, H) && (p[H] = b[H]);
    }
    return p;
  }, a = c0(), t = f(a), r = A0(), n = f(r), c = q1(), u = x0(), l = o4(), o = d(l), i = p1(), s = f(i);
  function d(p) {
    if (p && p.__esModule)
      return p;
    var P = {};
    if (p != null)
      for (var b in p)
        Object.prototype.hasOwnProperty.call(p, b) && (P[b] = p[b]);
    return P.default = p, P;
  }
  function f(p) {
    return p && p.__esModule ? p : { default: p };
  }
  var v = "_k", h = function(P) {
    return P.charAt(0) === "/" ? P : "/" + P;
  }, y = {
    hashbang: {
      encodePath: function(P) {
        return P.charAt(0) === "!" ? P : "!" + P;
      },
      decodePath: function(P) {
        return P.charAt(0) === "!" ? P.substring(1) : P;
      }
    },
    noslash: {
      encodePath: function(P) {
        return P.charAt(0) === "/" ? P.substring(1) : P;
      },
      decodePath: h
    },
    slash: {
      encodePath: h,
      decodePath: h
    }
  }, g = function() {
    var P = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    c.canUseDOM || (process.env.NODE_ENV !== "production" ? (0, n.default)(!1, "Hash history needs a DOM") : (0, n.default)(!1));
    var b = P.queryKey, H = P.hashType;
    process.env.NODE_ENV !== "production" && (0, t.default)(b !== !1, "Using { queryKey: false } no longer works. Instead, just don't use location state if you don't want a key in your URL query string"), typeof b != "string" && (b = v), H == null && (H = "slash"), H in y || (process.env.NODE_ENV !== "production" && (0, t.default)(!1, "Invalid hash type: %s", H), H = "slash");
    var A = y[H], m = o.getUserConfirmation, E = function() {
      return o.getCurrentLocation(A, b);
    }, x = function(q) {
      return o.pushLocation(q, A, b);
    }, I = function(q) {
      return o.replaceLocation(q, A, b);
    }, T = (0, s.default)(e({
      getUserConfirmation: m
    }, P, {
      getCurrentLocation: E,
      pushLocation: x,
      replaceLocation: I,
      go: o.go
    })), L = 0, S = void 0, $ = function(q, D) {
      ++L === 1 && (S = o.startListener(T.transitionTo, A, b));
      var N = D ? T.listenBefore(q) : T.listen(q);
      return function() {
        N(), --L === 0 && S();
      };
    }, Z = function(q) {
      return $(q, !0);
    }, M = function(q) {
      return $(q, !1);
    }, C = (0, u.supportsGoWithoutReloadUsingHash)(), O = function(q) {
      process.env.NODE_ENV !== "production" && (0, t.default)(C, "Hash history go(n) causes a full page reload in this browser"), T.go(q);
    }, F = function(q) {
      return "#" + A.encodePath(T.createHref(q));
    };
    return e({}, T, {
      listenBefore: Z,
      listen: M,
      go: O,
      createHref: F
    });
  };
  return S0.default = g, S0;
}
var l4 = i4();
const s4 = /* @__PURE__ */ s0(l4);
R3(s4);
const u4 = { ActionItem: ["M3.679 7.01a.68.68 0 0 1 .643 0l.461.249a.676.676 0 0 0 .969-.402l.15-.501a.68.68 0 0 1 .454-.454l.501-.15a.677.677 0 0 0 .402-.969l-.249-.461a.68.68 0 0 1 0-.643l.249-.461a.676.676 0 0 0-.402-.969l-.501-.15a.68.68 0 0 1-.454-.454l-.15-.501a.677.677 0 0 0-.969-.402l-.461.249a.68.68 0 0 1-.643 0L3.218.742a.676.676 0 0 0-.969.402l-.15.501a.68.68 0 0 1-.454.454l-.501.15a.677.677 0 0 0-.402.969l.249.461a.68.68 0 0 1 0 .643l-.249.461a.676.676 0 0 0 .402.969l.501.15a.68.68 0 0 1 .454.454l.15.501a.677.677 0 0 0 .969.402zm-.948-2.733a.29.29 0 0 1 .406-.081l.618.412L4.771 2.83a.294.294 0 0 1 .509.291l-1.172 2.05a.293.293 0 0 1-.417.098l-.879-.586a.29.29 0 0 1-.081-.406"], Alerts: ["M2 7.348a.84.84 0 0 1-.617-.256.85.85 0 0 1-.257-.62v-3.98a.85.85 0 0 1 .262-.625L2.634.618a.86.86 0 0 1 .627-.26h2.352q.36 0 .619.257a.84.84 0 0 1 .258.62v5.236a.84.84 0 0 1-.258.62.85.85 0 0 1-.62.257zm1.807-1.754a.37.37 0 0 0 .387-.385.37.37 0 0 0-.385-.388.38.38 0 0 0-.277.108.37.37 0 0 0-.11.277.374.374 0 0 0 .386.388Zm.005-1.37q.172 0 .291-.12a.4.4 0 0 0 .12-.288v-.928a.4.4 0 0 0-.118-.288.4.4 0 0 0-.288-.12.4.4 0 0 0-.29.118.4.4 0 0 0-.121.29v.928q0 .17.119.289.12.12.287.12Z"], Antenna: ["M1.205 3.333q0 .482.16.923.161.442.46.817.08.101.08.23a.3.3 0 0 1-.093.218.28.28 0 0 1-.222.086.27.27 0 0 1-.212-.106 3.5 3.5 0 0 1-.582-1.014 3.3 3.3 0 0 1-.205-1.154q0-.6.204-1.155.204-.556.583-1.014a.28.28 0 0 1 .212-.105.28.28 0 0 1 .222.087.3.3 0 0 1 .091.22.37.37 0 0 1-.08.232q-.297.375-.457.814-.16.44-.16.921Zm1.144 0a1.65 1.65 0 0 0 .284.935q.07.105.071.233 0 .13-.091.222a.3.3 0 0 1-.217.09.24.24 0 0 1-.199-.1 2.28 2.28 0 0 1 0-2.759.24.24 0 0 1 .199-.1q.126 0 .217.09.09.091.091.221a.4.4 0 0 1-.07.234 1.65 1.65 0 0 0-.285.934m1.272 3.334v-2.54a.9.9 0 0 1-.364-.324.86.86 0 0 1-.136-.47q0-.368.255-.623A.85.85 0 0 1 4 2.454q.368 0 .624.256.255.255.255.623a.86.86 0 0 1-.136.47.9.9 0 0 1-.364.325v2.539a.37.37 0 0 1-.11.27.37.37 0 0 1-.269.109.37.37 0 0 1-.27-.11.37.37 0 0 1-.11-.27Zm2.03-3.334a1.65 1.65 0 0 0-.284-.935.4.4 0 0 1-.071-.233q0-.13.091-.221a.3.3 0 0 1 .218-.09.24.24 0 0 1 .2.104 2.34 2.34 0 0 1 .462 1.375 2.26 2.26 0 0 1-.463 1.379.24.24 0 0 1-.199.1.3.3 0 0 1-.218-.09.3.3 0 0 1-.091-.22q0-.13.07-.234a1.65 1.65 0 0 0 .285-.935m1.144 0q0-.48-.16-.923a2.9 2.9 0 0 0-.46-.816.36.36 0 0 1-.08-.23.3.3 0 0 1 .312-.305.27.27 0 0 1 .21.105q.38.458.586 1.014t.206 1.155-.205 1.154q-.205.553-.582 1.014a.27.27 0 0 1-.212.105.3.3 0 0 1-.222-.087.3.3 0 0 1-.091-.219.37.37 0 0 1 .08-.231q.297-.375.457-.815t.16-.92Z"], ArrowEastLong: ["M5.813 4.44H.953a.43.43 0 0 1-.313-.128.43.43 0 0 1-.129-.313q0-.184.129-.313a.43.43 0 0 1 .313-.129h4.856l-1.122-1.12a.42.42 0 0 1-.132-.31.41.41 0 0 1 .132-.313.4.4 0 0 1 .31-.122.43.43 0 0 1 .312.127L7.18 3.69a.4.4 0 0 1 .095.146.48.48 0 0 1 0 .333.4.4 0 0 1-.095.143L5.31 6.188a.43.43 0 0 1-.307.127.43.43 0 0 1-.315-.127.43.43 0 0 1-.133-.313q0-.18.133-.312z"], ArrowEastShort: ["M5.133 4.44H1.615a.43.43 0 0 1-.313-.128.43.43 0 0 1-.129-.313q0-.184.129-.313a.43.43 0 0 1 .313-.129h3.518l-1.45-1.45a.435.435 0 0 1 .004-.627A.45.45 0 0 1 4 1.355a.42.42 0 0 1 .313.131l2.2 2.2a.43.43 0 0 1 .13.314.45.45 0 0 1-.13.313L4.31 6.517a.42.42 0 0 1-.31.13.43.43 0 0 1-.312-.13.43.43 0 0 1-.133-.315.43.43 0 0 1 .133-.316z"], ArrowEastToTable: ["M6.74.43H2.12l-.09.01C1.38.48.87 1.03.87 1.69v2.06c.03.19.19.33.39.33.21 0 .39-.17.39-.39v-.74h5.57v3.42c-.03.24-.23.42-.48.42h-1.5a.39.39 0 0 0-.33.39c0 .21.17.39.39.39h1.44l.09-.01C7.49 7.52 8 6.97 8 6.31V1.6C7.95.95 7.41.43 6.74.43m.48 1.74H1.65v-.54c.03-.24.23-.42.47-.42h4.62l.06.01c.24.03.42.23.42.47z", "M3.842 5.746 2.704 4.608l-.048-.041a.39.39 0 0 0-.503.041l-.041.048a.39.39 0 0 0 .041.503l.472.473H.39l-.058.004a.39.39 0 0 0 .058.776h2.235l-.472.472-.041.048a.39.39 0 0 0 .592.503l1.138-1.138a.4.4 0 0 0 .087-.132.4.4 0 0 0 .027-.17.4.4 0 0 0-.114-.249"], ArrowEastWest: ["M2.653 5.451H.948a.43.43 0 0 1-.313-.129.43.43 0 0 1-.129-.313.42.42 0 0 1 .13-.312.43.43 0 0 1 .312-.13h1.705l-.441-.44a.4.4 0 0 1-.125-.305.44.44 0 0 1 .435-.446q.183 0 .316.128l1.191 1.192a.43.43 0 0 1 .13.313.45.45 0 0 1-.13.314l-1.2 1.195a.427.427 0 0 1-.617-.008.43.43 0 0 1-.127-.309.4.4 0 0 1 .127-.309zm2.694-2.019.441.442a.4.4 0 0 1 .125.304.44.44 0 0 1-.435.446.44.44 0 0 1-.316-.128L3.971 3.304a.43.43 0 0 1-.13-.313.45.45 0 0 1 .13-.314l1.2-1.195a.427.427 0 0 1 .617.008.43.43 0 0 1 .127.309.4.4 0 0 1-.127.309l-.441.44h1.705q.184 0 .313.13.128.129.128.313a.43.43 0 0 1-.128.312.43.43 0 0 1-.313.13z"], ArrowIncrease: ["M5.002 1.933a.39.39 0 0 0 .081.665l.696.309-.907 2.117-.067.146a2.97 2.97 0 0 1-2.659 1.651H.585l-.079.005a.586.586 0 0 0 .079 1.166h1.561l.183-.004a4.14 4.14 0 0 0 3.619-2.503l.901-2.102.602.267A.39.39 0 0 0 8 3.294V.399a.39.39 0 0 0-.63-.308z"], ArrowLineIntoEast: ["M7 7a.5.5 0 0 0 1 0V1a.5.5 0 0 0-1 0zM2.654 1.154 2.7 1.1a.48.48 0 0 1 .625-.046l.054.046 2.56 2.56.023.024.036.046.035.061.022.055.017.066.007.054v.066l-.012.077-.012.043-.014.038-.023.045-.02.033-.018.024-.041.046-2.56 2.56a.481.481 0 0 1-.725-.625l.046-.054 1.74-1.741H.48a.48.48 0 0 1-.476-.415L0 3.998c0-.243.181-.444.415-.476l.065-.004h3.961l-1.74-1.741a.48.48 0 0 1-.046-.625Z"], ArrowLineIntoWest: ["M1 1a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0zm4.346 5.846L5.3 6.9a.48.48 0 0 1-.625.046L4.621 6.9l-2.56-2.56-.023-.024-.036-.046-.035-.061-.022-.055-.017-.066-.007-.054v-.066l.012-.077.012-.043.014-.038.023-.045.02-.033.018-.024.041-.046 2.56-2.56a.481.481 0 0 1 .725.625l-.046.054-1.74 1.741h3.961c.243 0 .444.181.476.415l.004.065a.48.48 0 0 1-.415.476l-.065.004H3.56L5.3 6.223a.48.48 0 0 1 .046.625Z"], ArrowNorthEastLong: ["M5.637 2.89 2.06 6.465a.36.36 0 0 1-.265.106.36.36 0 0 1-.37-.371.36.36 0 0 1 .105-.265l3.575-3.576H3.35a.37.37 0 0 1-.27-.11.37.37 0 0 1-.109-.269.37.37 0 0 1 .11-.27.37.37 0 0 1 .27-.11h2.666a.375.375 0 0 1 .38.38v2.667a.37.37 0 0 1-.11.27.37.37 0 0 1-.27.109.37.37 0 0 1-.27-.11.37.37 0 0 1-.11-.27z"], ArrowNorthEastShort: ["M5.313 3.357v2.429a.474.474 0 1 0 .948 0V2.213a.474.474 0 0 0-.474-.474H2.214a.474.474 0 1 0 0 .948h2.429L1.879 5.451a.474.474 0 0 0 .67.67z"], ArrowNortheastSouthwest: ["M4.827 1.043H4A.522.522 0 0 1 4 0h2.087c.288 0 .522.234.522.522v2.087a.522.522 0 0 1-1.044 0v-.828L3.673 3.673a.521.521 0 1 1-.738-.738zM4 6.957A.522.522 0 0 1 4 8H1.913a.52.52 0 0 1-.522-.522V5.391a.522.522 0 0 1 1.044 0v.827l1.892-1.892a.521.521 0 1 1 .738.738L3.173 6.957z"], ArrowSouthEastLong: ["M5.106 5.637 1.531 2.06a.36.36 0 0 1-.106-.265.36.36 0 0 1 .371-.37.36.36 0 0 1 .265.105l3.576 3.575V3.35q0-.159.11-.27a.37.37 0 0 1 .269-.109.37.37 0 0 1 .27.11q.11.11.11.27v2.666a.37.37 0 0 1-.11.27.37.37 0 0 1-.27.11H3.349a.37.37 0 0 1-.27-.11.37.37 0 0 1-.109-.27.37.37 0 0 1 .11-.27.37.37 0 0 1 .27-.11z"], ArrowSouthEastShort: ["M4.643 5.313H2.214a.474.474 0 1 0 0 .948h3.573a.474.474 0 0 0 .474-.474V2.214a.474.474 0 1 0-.948 0v2.429L2.549 1.879a.474.474 0 0 0-.67.67z"], ArrowTriangleEast: ["M2.5 5.533c0 .281.307.455.548.31L5.6 4.311a.362.362 0 0 0 0-.62L3.048 2.159a.362.362 0 0 0-.548.31z"], ArrowTriangleNorth: ["M3.69 2.397a.362.362 0 0 1 .62 0L5.842 4.95a.362.362 0 0 1-.31.548H2.468a.362.362 0 0 1-.31-.548z"], ArrowTriangleNorthSouth: ["M3.768 1.133a.27.27 0 0 1 .465 0l1.149 1.915a.271.271 0 0 1-.233.41H2.852a.271.271 0 0 1-.233-.41zm-.916 3.411a.271.271 0 0 0-.233.41L3.768 6.87a.27.27 0 0 0 .465 0l1.149-1.914a.271.271 0 0 0-.233-.411H2.852Z"], ArrowTriangleSouth: ["M2.468 2.501a.362.362 0 0 0-.31.548L3.69 5.602c.14.234.48.234.62 0l1.532-2.553a.362.362 0 0 0-.31-.548z"], ArrowTriangleWest: ["M5.496 2.47a.362.362 0 0 0-.547-.31L2.396 3.69a.362.362 0 0 0 0 .62l2.553 1.532a.362.362 0 0 0 .547-.31V2.469Z"], ArrowUTurnEast: ["m4.972.211.051-.059a.52.52 0 0 1 .679-.051l.059.051L7.848 2.24l.055.065.03.047.025.049.016.041.018.071.007.059v.072l-.012.084-.021.068-.033.069-.022.036-.019.027-.044.05-2.087 2.087a.521.521 0 0 1-.789-.68l.051-.059L6.219 3.13H2.957a1.914 1.914 0 0 0-1.91 1.797l-.003.116c0 1.017.794 1.849 1.797 1.91l.117.003h.348a.522.522 0 0 1 .071 1.039L3.305 8h-.348a2.956 2.956 0 0 1-.143-5.91l.143-.003H6.22L5.023.891a.524.524 0 0 1-.051-.68l.051-.059z"], ArrowWestLong: ["M2.191 4.44h4.86a.42.42 0 0 0 .311-.128.43.43 0 0 0 .127-.313.43.43 0 0 0-.129-.313.43.43 0 0 0-.313-.129H2.191l1.127-1.12a.42.42 0 0 0 .131-.31.41.41 0 0 0-.13-.313.4.4 0 0 0-.312-.122.43.43 0 0 0-.311.127L.825 3.69a.4.4 0 0 0-.095.146.48.48 0 0 0 0 .333q.03.079.095.143l1.871 1.876a.43.43 0 0 0 .307.127.43.43 0 0 0 .315-.127.43.43 0 0 0 .133-.313.43.43 0 0 0-.133-.312z"], ArrowWestShort: ["m2.867 4.44 1.45 1.45a.435.435 0 0 1-.004.627.45.45 0 0 1-.313.126.42.42 0 0 1-.313-.13l-2.2-2.2a.43.43 0 0 1-.13-.314.45.45 0 0 1 .13-.314L3.69 1.481a.42.42 0 0 1 .31-.13q.18 0 .312.13a.43.43 0 0 1 .133.315.43.43 0 0 1-.133.315L2.867 3.557h3.518q.184 0 .313.129t.129.313a.43.43 0 0 1-.129.313.43.43 0 0 1-.313.128z"], AutoRefill: ["M1.428 3.976q0 .658.32 1.229.32.57.874.927.128.091.173.236.046.146-.032.278a.35.35 0 0 1-.234.18.37.37 0 0 1-.292-.041 3.25 3.25 0 0 1-1.152-1.2 3.26 3.26 0 0 1-.39-1.994 4 4 0 0 1 .066-.377l-.083.05a.27.27 0 0 1-.259.025.4.4 0 0 1-.209-.183.37.37 0 0 1-.036-.288.36.36 0 0 1 .175-.23l1.01-.586a.37.37 0 0 1 .29-.035q.154.042.23.176l.582 1.003q.077.135.035.288a.36.36 0 0 1-.176.232.4.4 0 0 1-.302.038q-.168-.039-.218-.18l-.216-.375a3 3 0 0 0-.115.407 2 2 0 0 0-.04.42ZM4 1.398a2.6 2.6 0 0 0-1.16.286.48.48 0 0 1-.3.036.32.32 0 0 1-.227-.165.37.37 0 0 1-.033-.305q.05-.156.199-.23a3 3 0 0 1 .735-.287Q3.595.64 4 .64a3.3 3.3 0 0 1 2.274.903v-.096q0-.147.113-.239a.4.4 0 0 1 .267-.092q.16 0 .269.11t.11.27v1.166a.37.37 0 0 1-.11.27.37.37 0 0 1-.27.11H5.487a.37.37 0 0 1-.27-.11.37.37 0 0 1-.11-.27.37.37 0 0 1 .11-.27.37.37 0 0 1 .27-.11h.441a2.6 2.6 0 0 0-.864-.652A2.5 2.5 0 0 0 4 1.398m1.983 4.21a2.5 2.5 0 0 0 .416-.703 2.4 2.4 0 0 0 .157-.799.45.45 0 0 1 .122-.279.36.36 0 0 1 .27-.12.34.34 0 0 1 .269.127.4.4 0 0 1 .1.284 3.1 3.1 0 0 1-.174.96q-.16.458-.458.862a3.3 3.3 0 0 1-.744.736q-.43.307-.94.468l.064.038a.3.3 0 0 1 .149.222.4.4 0 0 1-.05.278.35.35 0 0 1-.23.172.37.37 0 0 1-.284-.04l-1.015-.583A.36.36 0 0 1 3.458 7a.37.37 0 0 1 .035-.29l.583-1.006a.35.35 0 0 1 .228-.173.37.37 0 0 1 .286.04.37.37 0 0 1 .175.23.36.36 0 0 1-.034.286l-.235.4a2.54 2.54 0 0 0 1.486-.878Z"], Autopause: ["M3 5V3h.667v2zm1.333 0V3H5v2zM4 7.667q-.9 0-1.688-.413A3.7 3.7 0 0 1 1 6.1V7H.333V5h2v.667h-.816a3.04 3.04 0 0 0 1.079.979Q3.25 7 4 7q.959 0 1.737-.55.78-.55 1.096-1.458l.65.15A3.6 3.6 0 0 1 6.15 6.97 3.57 3.57 0 0 1 4 7.667m-3.65-4q.059-.56.267-1.071a3.5 3.5 0 0 1 .575-.946l.475.475q-.267.341-.434.73-.165.386-.208.812zm1.783-2.009-.475-.475q.442-.366.95-.579A3.4 3.4 0 0 1 3.667.35v.667a2.7 2.7 0 0 0-.809.208 3.3 3.3 0 0 0-.725.433m3.742 0a3.3 3.3 0 0 0-.73-.433 2.7 2.7 0 0 0-.812-.208V.35q.56.05 1.071.258.513.209.946.575zm1.108 2.009a2.7 2.7 0 0 0-.208-.813 3.3 3.3 0 0 0-.433-.729l.475-.475q.366.433.575.946t.258 1.07z"], Badge: ["M2.4 5.3v.4q0 .127.086.214A.3.3 0 0 0 2.698 6a.3.3 0 0 0 .214-.086A.3.3 0 0 0 3 5.7v-.4h.4a.3.3 0 0 0 .214-.086.3.3 0 0 0 .086-.212.3.3 0 0 0-.086-.215A.3.3 0 0 0 3.4 4.7H3v-.4a.3.3 0 0 0-.086-.214A.3.3 0 0 0 2.702 4a.3.3 0 0 0-.215.086.3.3 0 0 0-.087.214v.4H2a.3.3 0 0 0-.214.086.3.3 0 0 0-.086.212q0 .127.086.215A.3.3 0 0 0 2 5.3zm2.1-.5h1.6a.194.194 0 0 0 .2-.2.194.194 0 0 0-.2-.2H4.5a.194.194 0 0 0-.2.2.194.194 0 0 0 .2.2m0 1h.9a.194.194 0 0 0 .2-.2.194.194 0 0 0-.2-.2h-.9a.194.194 0 0 0-.2.2.194.194 0 0 0 .2.2M1.4 7.2a.58.58 0 0 1-.424-.176A.58.58 0 0 1 .8 6.6V3a.58.58 0 0 1 .176-.424A.58.58 0 0 1 1.4 2.4h1.8v-1a.58.58 0 0 1 .176-.424A.58.58 0 0 1 3.8.8h.4a.58.58 0 0 1 .424.176.58.58 0 0 1 .176.424v1h1.8a.58.58 0 0 1 .424.176A.58.58 0 0 1 7.2 3v3.6a.58.58 0 0 1-.176.424.58.58 0 0 1-.424.176zM3.8 3h.4V1.4h-.4z"], Bank: ["M1.77 5.362v-1.52q0-.171.12-.288a.4.4 0 0 1 .29-.117.4.4 0 0 1 .286.117.4.4 0 0 1 .117.287v1.526a.4.4 0 0 1-.117.287.4.4 0 0 1-.287.117.4.4 0 0 1-.289-.12.4.4 0 0 1-.12-.29Zm2.076.005V3.84a.4.4 0 0 1 .117-.287.4.4 0 0 1 .287-.117.4.4 0 0 1 .287.117.4.4 0 0 1 .117.287v1.526a.4.4 0 0 1-.117.287.4.4 0 0 1-.287.117.4.4 0 0 1-.287-.117.4.4 0 0 1-.117-.287ZM1.198 7.175a.43.43 0 0 1-.312-.13.43.43 0 0 1-.13-.312q0-.184.13-.313a.43.43 0 0 1 .312-.129h6.104q.184 0 .313.13.129.128.129.312a.43.43 0 0 1-.13.313.43.43 0 0 1-.312.129zm4.719-1.813v-1.52q0-.171.12-.288a.4.4 0 0 1 .288-.117.4.4 0 0 1 .287.117.4.4 0 0 1 .117.287v1.526a.4.4 0 0 1-.117.287.4.4 0 0 1-.287.117.4.4 0 0 1-.289-.12.4.4 0 0 1-.12-.29Zm1.366-2.45H1.17a.4.4 0 0 1-.293-.12.4.4 0 0 1-.12-.293V2.24q0-.12.062-.217a.44.44 0 0 1 .166-.153L3.856.437A.85.85 0 0 1 4.25.342q.21 0 .394.095l2.846 1.42q.12.056.187.17a.5.5 0 0 1 .067.248v.172a.45.45 0 0 1-.134.33.44.44 0 0 1-.327.135"], Beaker: ["M1.667 7.068a.68.68 0 0 1-.665-.418.68.68 0 0 1 .096-.775l1.834-2.232v-1.93h-.271a.37.37 0 0 1-.27-.11.37.37 0 0 1-.11-.27.37.37 0 0 1 .11-.27.37.37 0 0 1 .27-.11h2.678a.373.373 0 0 1 .38.38.37.37 0 0 1-.11.27.37.37 0 0 1-.27.11h-.271v1.93l1.834 2.232a.68.68 0 0 1 .096.775.68.68 0 0 1-.665.418z"], BookOpen: ["M4 6.517a.7.7 0 0 1-.18-.025 1 1 0 0 1-.162-.067 3 3 0 0 0-.716-.317A2.8 2.8 0 0 0 2.167 6q-.35 0-.688.092-.337.09-.646.258a.32.32 0 0 1-.337-.008.32.32 0 0 1-.163-.292V2.033q0-.091.046-.175a.3.3 0 0 1 .138-.125q.383-.2.8-.3a3.63 3.63 0 0 1 2.683.4v4.034a3.46 3.46 0 0 1 1.833-.534 3.5 3.5 0 0 1 1.167.2v-4q.125.042.246.088.12.046.237.112.091.042.138.125.046.084.046.175V6.05a.32.32 0 0 1-.163.292.32.32 0 0 1-.337.008 3 3 0 0 0-.646-.258A2.6 2.6 0 0 0 5.833 6a2.8 2.8 0 0 0-1.491.425 1 1 0 0 1-.163.067.7.7 0 0 1-.179.025m.942-1.767q-.084.075-.18.03a.16.16 0 0 1-.095-.155V1.9a.16.16 0 0 1 .05-.117L6.05.45q.084-.084.183-.042.1.041.1.159v2.858a.14.14 0 0 1-.016.07.3.3 0 0 1-.042.055z"], Briefcase: ["M1.4 6.799a.58.58 0 0 1-.424-.176.58.58 0 0 1-.176-.424v-3.6a.58.58 0 0 1 .176-.424A.58.58 0 0 1 1.4 2h1.4v-.602q0-.248.176-.423A.58.58 0 0 1 3.401.8h1.201q.248 0 .423.176A.58.58 0 0 1 5.2 1.4V2h1.4a.58.58 0 0 1 .424.176.58.58 0 0 1 .176.424v3.6a.58.58 0 0 1-.176.424.58.58 0 0 1-.424.176H1.4Zm2-4.8h1.2v-.6H3.4z"], Calendar: ["M1.667 7.333a.64.64 0 0 1-.471-.195A.64.64 0 0 1 1 6.667V2q0-.275.196-.47a.64.64 0 0 1 .47-.197H2V1a.32.32 0 0 1 .096-.237.32.32 0 0 1 .237-.096q.142 0 .238.096A.32.32 0 0 1 2.667 1v.333h2.666V1a.32.32 0 0 1 .096-.237.32.32 0 0 1 .238-.096q.141 0 .237.096A.32.32 0 0 1 6 1v.333h.333q.275 0 .471.196T7 2v4.667q0 .275-.196.47a.64.64 0 0 1-.47.196H1.666Zm0-.666h4.666V3.333H1.667z"], Cart: ["M2.301 7.363a.64.64 0 0 1-.47-.196.64.64 0 0 1-.196-.47.64.64 0 0 1 .196-.471.64.64 0 0 1 .47-.196.64.64 0 0 1 .471.196q.196.195.196.47a.64.64 0 0 1-.196.471.64.64 0 0 1-.47.196Zm3.334 0a.64.64 0 0 1-.471-.196.64.64 0 0 1-.196-.47.64.64 0 0 1 .196-.471.64.64 0 0 1 .47-.196q.275 0 .472.196.195.195.195.47t-.195.471a.64.64 0 0 1-.471.196m-3.916-6.06H6.56q.226 0 .345.201.12.201.009.408L5.777 3.967a.7.7 0 0 1-.257.27.67.67 0 0 1-.353.096H2.702l-.349.637h3.615a.353.353 0 0 1 .363.364.35.35 0 0 1-.104.258.35.35 0 0 1-.259.105H2.301a.65.65 0 0 1-.596-.346.66.66 0 0 1-.015-.684l.444-.8L.95 1.363H.635a.35.35 0 0 1-.26-.104A.35.35 0 0 1 .272 1 .35.35 0 0 1 .377.741.35.35 0 0 1 .635.637h.53a.4.4 0 0 1 .2.056q.095.057.141.161l.213.45Z"], CellTower: ["M1.167 3.333a2.86 2.86 0 0 0 .599 1.74q.09.117.09.26a.34.34 0 0 1-.103.247.3.3 0 0 1-.246.094.3.3 0 0 1-.234-.124A3.7 3.7 0 0 1 .69 4.498a3.5 3.5 0 0 1-.002-2.335 3.7 3.7 0 0 1 .59-1.056A.3.3 0 0 1 1.51.99a.31.31 0 0 1 .244.097q.102.102.102.246c0 .144-.03.183-.089.26a2.86 2.86 0 0 0-.599 1.74Zm1.204 0q0 .224.06.447a1.4 1.4 0 0 0 .21.436q.08.12.08.26a.33.33 0 0 1-.102.243.31.31 0 0 1-.245.095.29.29 0 0 1-.227-.117 2.2 2.2 0 0 1-.344-.634 2.2 2.2 0 0 1-.116-.73 2.2 2.2 0 0 1 .466-1.364.29.29 0 0 1 .224-.117.31.31 0 0 1 .242.096.32.32 0 0 1 .1.24.46.46 0 0 1-.082.258q-.139.203-.203.43a1.7 1.7 0 0 0-.063.457m.901 3.296-.15.426a.36.36 0 0 1-.338.24.34.34 0 0 1-.3-.154.35.35 0 0 1-.042-.333l.979-2.732a1 1 0 0 1-.258-.31.9.9 0 0 1-.105-.433.9.9 0 0 1 .275-.667A.9.9 0 0 1 4 2.392q.393 0 .667.274a.9.9 0 0 1 .275.667.85.85 0 0 1-.105.428 1.2 1.2 0 0 1-.258.315l.979 2.737a.34.34 0 0 1-.04.328.33.33 0 0 1-.294.155.37.37 0 0 1-.213-.068.35.35 0 0 1-.138-.177l-.142-.422zm.24-.667h.976L4 4.57l-.488 1.393ZM5.63 3.333q0-.222-.06-.447a1.4 1.4 0 0 0-.21-.436.45.45 0 0 1-.08-.257q0-.138.102-.24a.32.32 0 0 1 .244-.099.27.27 0 0 1 .223.115q.233.31.344.655t.121.71a2.2 2.2 0 0 1-.466 1.364.28.28 0 0 1-.224.114.32.32 0 0 1-.242-.098.32.32 0 0 1-.1-.238.46.46 0 0 1 .082-.255q.139-.205.203-.43.063-.228.063-.458m1.204 0a2.86 2.86 0 0 0-.599-1.74.4.4 0 0 1-.09-.26q0-.144.103-.246T6.492.99a.3.3 0 0 1 .231.117 3.5 3.5 0 0 1 .79 2.227q0 .606-.186 1.17A3.3 3.3 0 0 1 6.73 5.56a.32.32 0 0 1-.235.118.31.31 0 0 1-.248-.098.34.34 0 0 1-.102-.247.42.42 0 0 1 .089-.26 2.86 2.86 0 0 0 .599-1.74Z"], Chart: ["M1.8 6.799a.58.58 0 0 1-.424-.176.58.58 0 0 1-.176-.424v-4.4a.58.58 0 0 1 .176-.424A.58.58 0 0 1 1.8 1.2h4.4a.58.58 0 0 1 .424.176.58.58 0 0 1 .176.424v4.4a.58.58 0 0 1-.176.424.58.58 0 0 1-.424.176H1.8Zm.902-3.6a.3.3 0 0 0-.214.086.3.3 0 0 0-.088.214v1.8q0 .127.086.214a.3.3 0 0 0 .212.086.3.3 0 0 0 .215-.086A.3.3 0 0 0 3 5.299v-1.8a.3.3 0 0 0-.086-.214.3.3 0 0 0-.212-.086m1.3-.8a.3.3 0 0 0-.214.086.3.3 0 0 0-.088.214v2.6q0 .127.086.214a.3.3 0 0 0 .212.086.3.3 0 0 0 .215-.086.3.3 0 0 0 .087-.214v-2.6a.3.3 0 0 0-.086-.214.3.3 0 0 0-.212-.086m1.3 2a.294.294 0 0 0-.302.3v.598a.295.295 0 0 0 .298.302.294.294 0 0 0 .302-.3v-.598a.295.295 0 0 0-.298-.302"], Chat: ["M7 6.867a.3.3 0 0 1-.233-.1L6 6H2.667a.64.64 0 0 1-.471-.196.64.64 0 0 1-.196-.47V5h3.667q.275 0 .47-.196a.64.64 0 0 0 .196-.47V2h.334q.275 0 .47.196.196.195.196.47v3.859q0 .15-.1.246A.33.33 0 0 1 7 6.867M1 5.2a.33.33 0 0 1-.233-.096.33.33 0 0 1-.1-.246V1.333q0-.275.196-.47a.64.64 0 0 1 .47-.196H5q.275 0 .47.195a.64.64 0 0 1 .197.471v2.334q0 .275-.196.47A.64.64 0 0 1 5 4.333H2l-.767.767A.3.3 0 0 1 1 5.2"], CheckmarkSingle: ["m3.22 4.889 2.74-2.74a.43.43 0 0 1 .313-.134q.18 0 .314.133a.43.43 0 0 1 .133.316.43.43 0 0 1-.133.315L3.533 5.836a.43.43 0 0 1-.313.133.43.43 0 0 1-.314-.133L1.482 4.412a.437.437 0 0 1 .004-.63.43.43 0 0 1 .315-.133.43.43 0 0 1 .315.133z"], ChevronDoubleEast: ["M2.895 4 1.32 2.415a.46.46 0 0 1-.136-.328.44.44 0 0 1 .136-.335.45.45 0 0 1 .332-.132.45.45 0 0 1 .331.132l1.914 1.914A.44.44 0 0 1 4 3.821a.5.5 0 0 1 0 .358.4.4 0 0 1-.103.155L1.983 6.248a.46.46 0 0 1-.327.136.44.44 0 0 1-.336-.136.45.45 0 0 1-.132-.331.45.45 0 0 1 .132-.332zm2.782 0L4.1 2.415a.46.46 0 0 1-.136-.328.44.44 0 0 1 .136-.335.45.45 0 0 1 .332-.132.45.45 0 0 1 .331.132l1.914 1.914a.44.44 0 0 1 .103.155.5.5 0 0 1 0 .358.4.4 0 0 1-.103.155L4.763 6.248a.46.46 0 0 1-.327.136.44.44 0 0 1-.336-.136.45.45 0 0 1-.132-.331.45.45 0 0 1 .132-.332z"], ChevronDoubleSouth: ["m4 5.7 1.585-1.577a.46.46 0 0 1 .328-.136.44.44 0 0 1 .335.136.45.45 0 0 1 .132.331.45.45 0 0 1-.132.332L4.334 6.702a.4.4 0 0 1-.155.103.5.5 0 0 1-.358 0 .4.4 0 0 1-.155-.103L1.752 4.786a.46.46 0 0 1-.136-.328.44.44 0 0 1 .136-.335.45.45 0 0 1 .331-.132.45.45 0 0 1 .332.132zm0-2.577 1.585-1.578a.46.46 0 0 1 .328-.136.44.44 0 0 1 .335.139.45.45 0 0 1 .132.331.45.45 0 0 1-.132.332L4.334 4.125a.4.4 0 0 1-.155.102.5.5 0 0 1-.358 0 .4.4 0 0 1-.155-.102L1.752 2.211a.46.46 0 0 1-.136-.327.45.45 0 0 1 .136-.336.45.45 0 0 1 .331-.135q.2 0 .334.135z"], ChevronDoubleWest: ["M2.323 4 3.9 5.585a.46.46 0 0 1 .136.328.44.44 0 0 1-.136.335.45.45 0 0 1-.332.132.45.45 0 0 1-.331-.132L1.323 4.334a.4.4 0 0 1-.103-.155.5.5 0 0 1 0-.358.4.4 0 0 1 .103-.155l1.914-1.914a.46.46 0 0 1 .327-.136.44.44 0 0 1 .336.136.45.45 0 0 1 .132.331.45.45 0 0 1-.132.332zm2.782 0L6.68 5.585a.46.46 0 0 1 .136.328.44.44 0 0 1-.136.335.45.45 0 0 1-.332.132.45.45 0 0 1-.331-.132L4.103 4.334A.4.4 0 0 1 4 4.18a.5.5 0 0 1 0-.358.4.4 0 0 1 .103-.155l1.914-1.914a.46.46 0 0 1 .327-.136.44.44 0 0 1 .336.136.45.45 0 0 1 .132.331.45.45 0 0 1-.132.332z"], ChevronNorthSouth: ["m4 6.464.939-.938a.47.47 0 0 1 .34-.143q.199 0 .341.143a.47.47 0 0 1 .143.341.47.47 0 0 1-.143.342L4.334 7.496a.4.4 0 0 1-.155.102.5.5 0 0 1-.358 0 .4.4 0 0 1-.155-.102L2.38 6.209a.47.47 0 0 1-.143-.341q0-.2.143-.342a.47.47 0 0 1 .342-.14q.2 0 .342.142zM4 1.57l-.939.939a.47.47 0 0 1-.34.142.47.47 0 0 1-.341-.142.47.47 0 0 1-.143-.342q0-.2.143-.342L3.666.539A.4.4 0 0 1 3.82.436a.5.5 0 0 1 .358 0 .4.4 0 0 1 .155.103L5.62 1.825a.47.47 0 0 1 .143.342.47.47 0 0 1-.143.342.47.47 0 0 1-.342.14.47.47 0 0 1-.342-.143z"], ChevronSingleEast: ["M4.17 4 2.585 2.415a.45.45 0 0 1-.132-.332.45.45 0 0 1 .464-.463.45.45 0 0 1 .331.132l1.914 1.914a.44.44 0 0 1 .103.155.5.5 0 0 1 0 .358.4.4 0 0 1-.103.155L3.248 6.248a.45.45 0 0 1-.331.132.45.45 0 0 1-.464-.463.45.45 0 0 1 .132-.332z"], ChevronSingleNorth: ["M4 3.58 2.415 5.165a.45.45 0 0 1-.332.132.45.45 0 0 1-.463-.464.45.45 0 0 1 .132-.331l1.914-1.914A.46.46 0 0 1 4 2.445q.193 0 .334.143l1.914 1.914a.45.45 0 0 1 .132.331.45.45 0 0 1-.463.464.45.45 0 0 1-.332-.132z"], ChevronSingleSouth: ["M4 5.546a.5.5 0 0 1-.179-.033.4.4 0 0 1-.155-.102L1.752 3.497a.45.45 0 0 1-.132-.332.45.45 0 0 1 .463-.463.45.45 0 0 1 .332.132L4 4.419l1.585-1.585a.45.45 0 0 1 .332-.132.45.45 0 0 1 .463.463.45.45 0 0 1-.132.332L4.334 5.41a.4.4 0 0 1-.155.102.5.5 0 0 1-.179.033Z"], ChevronSingleWest: ["m3.58 4 1.585 1.585a.45.45 0 0 1 .132.332.45.45 0 0 1-.464.463.45.45 0 0 1-.331-.132L2.588 4.334a.4.4 0 0 1-.103-.155.5.5 0 0 1 0-.358.4.4 0 0 1 .103-.155l1.914-1.914a.45.45 0 0 1 .331-.132.45.45 0 0 1 .464.463.45.45 0 0 1-.132.332z"], Chip: ["M2.75 4.832V3.166q0-.177.12-.297t.297-.12h1.666q.177 0 .297.12t.12.297v1.666q0 .177-.12.297a.4.4 0 0 1-.297.12H3.167a.4.4 0 0 1-.297-.12.4.4 0 0 1-.12-.297m0 2.5v-.416h-.833a.8.8 0 0 1-.589-.245.8.8 0 0 1-.245-.589V5.25H.667a.4.4 0 0 1-.297-.12.4.4 0 0 1-.12-.297q0-.177.12-.297t.297-.12h.416v-.833H.667a.4.4 0 0 1-.297-.12.4.4 0 0 1-.12-.296q0-.177.12-.297t.297-.12h.416v-.833q0-.345.245-.589a.8.8 0 0 1 .589-.245h.833V.666q0-.177.12-.297t.297-.12c.177 0 .217.04.297.12q.12.12.12.297v.416h.833V.666q0-.177.12-.297t.296-.12c.176 0 .217.04.297.12q.12.12.12.297v.416h.833q.345 0 .589.245.245.245.245.589v.833h.416q.177 0 .297.12t.12.297c0 .177-.04.217-.12.297a.4.4 0 0 1-.297.12h-.416v.833h.416q.177 0 .297.12t.12.296c0 .176-.04.217-.12.297a.4.4 0 0 1-.297.12h-.416v.833q0 .345-.245.589a.8.8 0 0 1-.589.245H5.25v.416q0 .177-.12.297a.4.4 0 0 1-.297.12.4.4 0 0 1-.297-.12.4.4 0 0 1-.12-.297v-.416h-.833v.416q0 .177-.12.297a.4.4 0 0 1-.296.12.4.4 0 0 1-.297-.12.4.4 0 0 1-.12-.297m3.333-1.25V1.916H1.917v4.166z"], CircleAlert: ["M3.998 5.6a.294.294 0 0 0 .302-.298A.294.294 0 0 0 4.002 5a.294.294 0 0 0-.302.298.294.294 0 0 0 .298.302m0-1.2a.3.3 0 0 0 .215-.086A.3.3 0 0 0 4.3 4.1V2.7a.3.3 0 0 0-.086-.214.3.3 0 0 0-.212-.086.3.3 0 0 0-.214.086.3.3 0 0 0-.088.214v1.4q0 .127.086.214a.3.3 0 0 0 .212.086m.004 2.8a3.1 3.1 0 0 1-1.244-.25A3.23 3.23 0 0 1 1.05 5.242 3.1 3.1 0 0 1 .8 3.996a3.1 3.1 0 0 1 .25-1.242A3.24 3.24 0 0 1 2.758 1.05Q3.341.8 4.004.8a3.1 3.1 0 0 1 1.242.25A3.24 3.24 0 0 1 6.95 2.756a3.1 3.1 0 0 1 .25 1.242q0 .66-.25 1.244A3.23 3.23 0 0 1 5.244 6.95a3.1 3.1 0 0 1-1.242.25"], CircleAlertOutline: ["M4.417 5.252a.418.418 0 1 1-.836 0 .418.418 0 0 1 .836 0M3.687 4V2.747a.313.313 0 1 1 .626 0V4a.313.313 0 1 1-.626 0", "M7.34 4A3.34 3.34 0 1 0 .66 4a3.34 3.34 0 0 0 6.68 0M1.286 4a2.714 2.714 0 1 1 5.428 0 2.714 2.714 0 0 1-5.428 0"], CircleCheckmark: ["m3.593 4.53-.665-.665a.35.35 0 0 0-.261-.103.354.354 0 0 0-.364.365.35.35 0 0 0 .104.26l.919.919a.37.37 0 0 0 .534 0l1.853-1.853a.35.35 0 0 0 .104-.26.353.353 0 0 0-.365-.365.35.35 0 0 0-.261.104zm.472 2.871a3.3 3.3 0 0 1-1.327-.268 3.4 3.4 0 0 1-1.08-.726 3.4 3.4 0 0 1-.726-1.08A3.3 3.3 0 0 1 .664 4q0-.708.268-1.328.267-.62.726-1.079a3.4 3.4 0 0 1 1.08-.726A3.3 3.3 0 0 1 4.065.599q.708 0 1.328.268.621.267 1.08.726.457.459.726 1.08.267.62.268 1.327c.001.707-.09.914-.268 1.328q-.268.62-.727 1.079a3.4 3.4 0 0 1-1.079.726 3.3 3.3 0 0 1-1.328.268"], CircleInfo: ["M4.006 5.7a.35.35 0 0 0 .259-.104.35.35 0 0 0 .104-.259V4.034a.35.35 0 0 0-.104-.26.35.35 0 0 0-.26-.104.35.35 0 0 0-.258.105.35.35 0 0 0-.105.259v1.303q0 .155.105.259a.35.35 0 0 0 .259.104m0-2.657a.36.36 0 0 0 .266-.107.36.36 0 0 0 .107-.266.36.36 0 0 0-.107-.266.36.36 0 0 0-.266-.107.36.36 0 0 0-.266.107.36.36 0 0 0-.107.266q0 .16.107.266.107.108.266.107m0 4.362a3.3 3.3 0 0 1-1.328-.268 3.4 3.4 0 0 1-1.08-.726 3.4 3.4 0 0 1-.726-1.08 3.3 3.3 0 0 1-.267-1.327q0-.708.267-1.328.268-.62.727-1.08A3.4 3.4 0 0 1 2.678.87 3.3 3.3 0 0 1 4.006.603q.707 0 1.328.267.62.267 1.079.727.459.458.726 1.079.268.62.268 1.328 0 .707-.268 1.328-.267.62-.726 1.079a3.4 3.4 0 0 1-1.08.726 3.3 3.3 0 0 1-1.327.268"], Close: ["M4.036 4.616 2.478 6.174a.42.42 0 0 1-.308.125.42.42 0 0 1-.309-.125.42.42 0 0 1-.125-.309.42.42 0 0 1 .125-.308L3.42 3.999 1.861 2.44a.42.42 0 0 1-.125-.309.42.42 0 0 1 .125-.309.42.42 0 0 1 .309-.124q.183 0 .308.124L4.036 3.38l1.558-1.558a.42.42 0 0 1 .31-.124q.183 0 .308.124a.42.42 0 0 1 .124.31.42.42 0 0 1-.124.308L4.654 3.999l1.558 1.558a.42.42 0 0 1 .124.308.42.42 0 0 1-.124.31.42.42 0 0 1-.309.124.42.42 0 0 1-.309-.125z"], Cloud: ["M2.167 6.667q-.759 0-1.296-.525a1.73 1.73 0 0 1-.538-1.284q0-.65.392-1.158a1.73 1.73 0 0 1 1.025-.65q.209-.766.833-1.242A2.28 2.28 0 0 1 4 1.333q.975 0 1.654.68a2.25 2.25 0 0 1 .68 1.654q.574.067.954.495.378.43.379 1.005 0 .624-.438 1.062a1.45 1.45 0 0 1-1.062.438z"], CloudDataTransfer: ["M2.17 6.67c-.51 0-.94-.18-1.29-.53-.35-.33-.55-.8-.54-1.28 0-.43.13-.82.39-1.16.25-.33.62-.56 1.03-.65.14-.51.42-.92.83-1.24.41-.31.9-.48 1.42-.48.65 0 1.2.23 1.65.68.45.43.69 1.03.68 1.65.38.04.7.21.95.49.25.29.38.62.38 1.01 0 .42-.15.77-.44 1.06-.28.29-.66.44-1.06.44H4.34V4.28l.3.29c.06.06.14.09.23.09.18 0 .33-.14.33-.32v-.02c0-.09-.03-.17-.09-.23l-.87-.87a.317.317 0 0 0-.45-.01l-.01.01-.87.87c-.06.06-.1.14-.1.23s.03.18.1.24c.06.06.14.09.23.09q.135 0 .24-.09l.3-.29v2.38h-1.5Z"], Collapse: ["M2.665 5.33H1.473a.46.46 0 0 1-.337-.137.46.46 0 0 1-.137-.337q0-.2.137-.336a.46.46 0 0 1 .337-.138h1.666q.2 0 .337.138a.46.46 0 0 1 .137.336v1.667a.46.46 0 0 1-.137.337.46.46 0 0 1-.337.137.46.46 0 0 1-.336-.137.46.46 0 0 1-.138-.337zm2.67-2.667h1.192q.2 0 .337.138a.46.46 0 0 1 .137.336.46.46 0 0 1-.137.337.46.46 0 0 1-.337.137H4.861a.46.46 0 0 1-.337-.137.46.46 0 0 1-.137-.337V1.471q0-.2.137-.337a.46.46 0 0 1 .337-.137q.2 0 .337.137a.46.46 0 0 1 .137.337z"], Compass: ["m2.792 5.432 1.683-.483a.67.67 0 0 0 .458-.458l.484-1.684a.16.16 0 0 0-.046-.162.16.16 0 0 0-.163-.046l-1.683.483a.67.67 0 0 0-.458.459l-.484 1.683a.16.16 0 0 0 .046.163.16.16 0 0 0 .163.045M4 4.516a.48.48 0 0 1-.354-.146.48.48 0 0 1-.146-.354.48.48 0 0 1 .146-.354A.48.48 0 0 1 4 3.516q.208 0 .354.146a.48.48 0 0 1 .146.354.48.48 0 0 1-.146.354.48.48 0 0 1-.354.146m0 2.833q-.691 0-1.3-.262a3.4 3.4 0 0 1-1.058-.713q-.45-.45-.713-1.058a3.25 3.25 0 0 1-.262-1.3q0-.692.262-1.3.263-.609.713-1.059T2.7.945A3.25 3.25 0 0 1 4 .682q.691 0 1.3.263.608.262 1.058.712t.713 1.059.262 1.3q0 .69-.262 1.3a3.4 3.4 0 0 1-.713 1.058q-.45.45-1.058.713a3.25 3.25 0 0 1-1.3.262"], Configuring: ["M1 6.333v-.666h.917l-.134-.117a2.1 2.1 0 0 1-.608-.875A3 3 0 0 1 1 3.683q0-.925.554-1.645.555-.722 1.446-.955v.7q-.6.217-.967.738a1.97 1.97 0 0 0-.366 1.162q0 .375.141.73.142.354.442.654l.083.083v-.817H3v2zm5.975-3H6.3a1.8 1.8 0 0 0-.18-.558 2.2 2.2 0 0 0-.37-.508l-.083-.084V3H5V1h2v.667h-.917l.134.116q.34.35.525.742.183.391.233.808m-1.308 4-.1-.5a2 2 0 0 1-.188-.087 2 2 0 0 1-.179-.113l-.483.15-.334-.566.384-.334a2 2 0 0 1-.017-.216q0-.101.017-.217l-.384-.333.334-.567.483.15a1.3 1.3 0 0 1 .18-.112q.087-.046.187-.088l.1-.5h.666l.1.5a1.3 1.3 0 0 1 .367.217l.483-.167.334.583-.384.334a1.3 1.3 0 0 1 0 .416l.384.334-.334.566-.483-.15a1.3 1.3 0 0 1-.18.113q-.087.046-.187.087l-.1.5zm.333-1q.275 0 .47-.196a.64.64 0 0 0 .197-.47.64.64 0 0 0-.196-.471A.64.64 0 0 0 6 5a.64.64 0 0 0-.47.196.64.64 0 0 0-.197.47q0 .275.196.471A.64.64 0 0 0 6 6.333"], Connectivity: ["M1.876 6.574a.35.35 0 0 1-.265.107.33.33 0 0 1-.254-.121 3.6 3.6 0 0 1-.596-1.02 3.4 3.4 0 0 1-.216-1.207q0-.717.272-1.347.27-.63.738-1.098a3.5 3.5 0 0 1 1.098-.738A3.4 3.4 0 0 1 4 .878a3.47 3.47 0 0 1 2.445 1.01q.466.467.738 1.098.272.63.272 1.347 0 .642-.216 1.207a3.6 3.6 0 0 1-.596 1.02.33.33 0 0 1-.251.124.34.34 0 0 1-.262-.104.34.34 0 0 1-.101-.254.42.42 0 0 1 .097-.273 2.77 2.77 0 0 0 .603-1.72 2.63 2.63 0 0 0-.795-1.934A2.63 2.63 0 0 0 4 1.605q-1.14 0-1.934.794a2.63 2.63 0 0 0-.794 1.934 2.67 2.67 0 0 0 .608 1.713.43.43 0 0 1 .1.27.34.34 0 0 1-.104.258m.964-.964a.37.37 0 0 1-.262.113.28.28 0 0 1-.243-.123 2.3 2.3 0 0 1-.312-.585 2 2 0 0 1-.115-.682q0-.871.61-1.481T4 2.242t1.481.61q.61.61.61 1.481A2.1 2.1 0 0 1 5.665 5.6a.3.3 0 0 1-.243.123.34.34 0 0 1-.262-.107.35.35 0 0 1-.104-.252.5.5 0 0 1 .082-.28q.105-.168.165-.355t.06-.396a1.3 1.3 0 0 0-.4-.962A1.3 1.3 0 0 0 4 2.97q-.562 0-.963.4a1.3 1.3 0 0 0-.4.962q0 .215.06.399t.165.351a.47.47 0 0 1 .082.277.35.35 0 0 1-.104.25ZM4 5.062a.7.7 0 0 1-.515-.214.7.7 0 0 1-.213-.515.7.7 0 0 1 .214-.514A.7.7 0 0 1 4 3.605a.7.7 0 0 1 .515.214.7.7 0 0 1 .213.515.7.7 0 0 1-.214.514.7.7 0 0 1-.514.214"], Console: ["M.66 1.55c0-.311 0-.467.06-.586A.56.56 0 0 1 .965.72c.118-.06.274-.06.585-.06h4.898c.312 0 .468 0 .587.06.105.054.19.14.243.244.061.119.061.275.061.587v2.588H5.67l-.066.005a.4.4 0 0 0-.23.117l-.703.704-.854-1.708-.03-.052a.418.418 0 0 0-.639-.057l-.992.991H.66V1.551Zm.974.502a.417.417 0 1 0 0-.835.417.417 0 0 0 0 .835m1.531-.418a.417.417 0 1 1-.835 0 .417.417 0 0 1 .835 0m.696.418a.417.417 0 1 0 0-.835.417.417 0 0 0 0 .835", "M5.843 4.974H7.34V6.45c0 .312 0 .468-.06.587a.56.56 0 0 1-.244.243c-.119.061-.275.061-.587.061H1.551c-.312 0-.468 0-.587-.06a.56.56 0 0 1-.243-.244C.66 6.917.66 6.761.66 6.45V4.974h1.67l.066-.005a.4.4 0 0 0 .23-.117l.703-.704.854 1.709.03.051c.146.21.452.244.639.057l.99-.99Z"], Copy: ["M3.07 6.022a.73.73 0 0 1-.537-.222.73.73 0 0 1-.222-.536V1.31a.73.73 0 0 1 .222-.536.73.73 0 0 1 .537-.222h2.952a.73.73 0 0 1 .537.222.73.73 0 0 1 .221.536v3.953a.73.73 0 0 1-.221.536.73.73 0 0 1-.537.222H3.07ZM1.645 7.447a.73.73 0 0 1-.537-.222.73.73 0 0 1-.222-.536V2.357a.37.37 0 0 1 .11-.27.37.37 0 0 1 .27-.109q.16 0 .269.11t.11.27v4.33h3.331a.37.37 0 0 1 .27.11q.11.11.11.27a.37.37 0 0 1-.11.27.37.37 0 0 1-.27.109z"], CreditCard: ["M7.333 2v4q0 .275-.196.47a.64.64 0 0 1-.47.197H1.333a.64.64 0 0 1-.47-.196A.64.64 0 0 1 .666 6V2q0-.275.195-.47a.64.64 0 0 1 .471-.197h5.334q.275 0 .47.196A.64.64 0 0 1 7.332 2Zm-6 .667h5.334V2H1.333zm0 1.333v2h5.334V4z"], Cube: ["M3.667 6.474V4.191l-2-1.159v2.284zm.666 0 2-1.158V3.032l-2 1.159zM4 3.616l1.975-1.142L4 1.332 2.025 2.474zM1.333 5.899A.65.65 0 0 1 1 5.324v-2.65a.65.65 0 0 1 .333-.575L3.667.757a.66.66 0 0 1 .666 0L6.667 2.1A.65.65 0 0 1 7 2.674v2.65a.65.65 0 0 1-.333.575L4.333 7.241a.66.66 0 0 1-.666 0z"], CubeOutbound: ["M6.559 4.511v-.03s-.01 0-.01-.01a.3.3 0 0 0-.17-.18c0-.01-.01-.01-.02-.01v-.01l-2.239-.84a.5.5 0 0 0-.24 0l-2.239.84-.01.01c-.01 0-.01.01-.02.01s-.01.01-.02.01l-.01.01a.28.28 0 0 0-.14.2s-.01 0-.01.01v2.07c.01.11.08.2.18.25L3.85 7.96v.01c.01 0 .03.01.04.01s.01 0 .01.01h.03s.01 0 .01.01h.12c0-.01.01-.01.01-.01h.03c.02-.01.03-.02.05-.03l2.239-1.12.03-.02c.1-.06.15-.16.15-.27V4.52zM3.67 7.13l-1.58-.79V5.07l1.58.59zM4 5.071l-1.29-.48L4 4.101l1.29.49zM5.91 6.34l-1.58.79V5.66l1.58-.59zM5.08.942l-.86-.85c-.01-.02-.03-.03-.05-.04l-.03-.02-.03-.01-.03-.01-.03-.01a.37.37 0 0 0-.29.1l-.84.84-.02.03c-.26.31.19.74.5.44l.27-.27v1.47c.02.17.16.3.33.3l.04-.01c.16-.01.29-.16.29-.33v-1.43l.27.27.04.03c.13.1.32.09.44-.03l.02-.03c.11-.13.1-.32-.02-.44"], Danger: ["M4 7.258a.7.7 0 0 1-.266-.05.7.7 0 0 1-.223-.153L.945 4.489a.7.7 0 0 1-.154-.223A.7.7 0 0 1 .742 4q0-.15.049-.266a.7.7 0 0 1 .152-.22L3.51.945a.7.7 0 0 1 .223-.154A.7.7 0 0 1 4 .742q.15 0 .266.049a.7.7 0 0 1 .223.154l2.566 2.566a.7.7 0 0 1 .154.223.7.7 0 0 1 .049.266q0 .15-.049.266a.7.7 0 0 1-.154.223L4.486 7.057a.7.7 0 0 1-.22.152.7.7 0 0 1-.266.049m-.002-3.042a.32.32 0 0 0 .236-.095.32.32 0 0 0 .096-.235V2.748a.324.324 0 0 0-.328-.332.32.32 0 0 0-.236.095.32.32 0 0 0-.096.234v1.139a.324.324 0 0 0 .328.332m0 1.06a.324.324 0 0 0 .332-.328.324.324 0 0 0-.328-.332.324.324 0 0 0-.332.328.324.324 0 0 0 .328.332"], Dashboard: ["M2.363 5.35h1.611a.37.37 0 0 0 .27-.11.37.37 0 0 0 .11-.27v-.277a.37.37 0 0 0-.11-.27.37.37 0 0 0-.27-.11h-1.61a.37.37 0 0 0-.27.11.37.37 0 0 0-.11.27v.277q0 .16.11.27t.27.11Zm2.996 0h.278a.37.37 0 0 0 .27-.11.37.37 0 0 0 .109-.27V3.03a.37.37 0 0 0-.11-.27.37.37 0 0 0-.27-.11H5.36a.37.37 0 0 0-.27.11.37.37 0 0 0-.109.27v1.94q0 .16.11.27t.27.11ZM2.363 3.686h1.611a.37.37 0 0 0 .27-.11.37.37 0 0 0 .11-.27V3.03a.37.37 0 0 0-.11-.27.37.37 0 0 0-.27-.11h-1.61a.37.37 0 0 0-.27.11.37.37 0 0 0-.11.27v.277q0 .16.11.27t.27.11ZM1.357 6.734a.73.73 0 0 1-.536-.221.73.73 0 0 1-.222-.537V2.024a.73.73 0 0 1 .222-.537.73.73 0 0 1 .536-.221h5.286a.73.73 0 0 1 .536.221.73.73 0 0 1 .222.537v3.952a.73.73 0 0 1-.222.537.73.73 0 0 1-.536.221z"], Deactivate: ["M2.726 1.713a.37.37 0 0 1-.114-.267q0-.153.114-.267l.36-.36a.74.74 0 0 1 .532-.22h2.358a.73.73 0 0 1 .537.222.73.73 0 0 1 .221.537v3.444a.35.35 0 0 1-.233.351.35.35 0 0 1-.413-.084zm-.702 5.689a.73.73 0 0 1-.537-.222.73.73 0 0 1-.221-.537V2.954a.74.74 0 0 1 .221-.534l.016-.017L.435 1.335a.32.32 0 0 1-.101-.244.35.35 0 0 1 .107-.243.37.37 0 0 1 .244-.102.32.32 0 0 1 .245.1l6.226 6.225a.33.33 0 0 1 .098.24.35.35 0 0 1-.098.248.34.34 0 0 1-.246.104.34.34 0 0 1-.247-.104L5.021 5.92l.495-.489 1.218 1.217v.008a.7.7 0 0 1-.221.529.74.74 0 0 1-.537.218z"], Document: ["M3 4.333h2a.32.32 0 0 0 .237-.096A.32.32 0 0 0 5.333 4a.32.32 0 0 0-.096-.237A.32.32 0 0 0 5 3.667H3a.32.32 0 0 0-.237.096.32.32 0 0 0-.096.237.32.32 0 0 0 .096.237.32.32 0 0 0 .237.096m0 1h2a.32.32 0 0 0 .237-.096A.32.32 0 0 0 5.333 5a.32.32 0 0 0-.096-.237A.32.32 0 0 0 5 4.667H3a.32.32 0 0 0-.237.096.32.32 0 0 0-.096.237.32.32 0 0 0 .096.237.32.32 0 0 0 .237.096m0 1h1a.32.32 0 0 0 .237-.096A.32.32 0 0 0 4.333 6a.32.32 0 0 0-.096-.237A.32.32 0 0 0 4 5.667H3a.32.32 0 0 0-.237.096.32.32 0 0 0-.096.237.32.32 0 0 0 .096.237.32.32 0 0 0 .237.096m-1 1a.64.64 0 0 1-.47-.196.64.64 0 0 1-.197-.47V1.333q0-.275.196-.47A.64.64 0 0 1 2 .666h2.392a.66.66 0 0 1 .466.191l1.617 1.617a.65.65 0 0 1 .192.467v3.725q0 .275-.196.47A.64.64 0 0 1 6 7.333zm2.333-4.666q0 .141.096.237A.32.32 0 0 0 4.667 3H6L4.333 1.333z"], DownloadTray: ["M4 5.437a.5.5 0 0 1-.179-.032.4.4 0 0 1-.155-.102L2.129 3.765a.44.44 0 0 1-.136-.331.48.48 0 0 1 .472-.478.45.45 0 0 1 .337.138l.724.724V1.056q0-.2.137-.337A.46.46 0 0 1 4 .582q.2 0 .337.137a.46.46 0 0 1 .137.337v2.762l.724-.724a.47.47 0 0 1 .67.006q.135.143.14.333a.44.44 0 0 1-.14.332L4.335 5.303a.4.4 0 0 1-.155.102.5.5 0 0 1-.179.032ZM1.53 7.418a.9.9 0 0 1-.67-.277.9.9 0 0 1-.278-.67v-.777q0-.2.137-.337a.46.46 0 0 1 .337-.137q.2 0 .337.137a.46.46 0 0 1 .137.337v.776h4.94v-.776q0-.2.137-.337a.46.46 0 0 1 .337-.137q.2 0 .337.137a.46.46 0 0 1 .137.337v.776a.9.9 0 0 1-.277.67.9.9 0 0 1-.67.278z"], Envelope: ["M1.333 6.667a.64.64 0 0 1-.47-.196A.64.64 0 0 1 .667 6V2q0-.275.196-.47a.64.64 0 0 1 .47-.197h5.334q.275 0 .47.196A.64.64 0 0 1 7.333 2v4q0 .275-.195.47a.64.64 0 0 1-.471.197zM4 4.275a.33.33 0 0 0 .175-.05L6.533 2.75a.28.28 0 0 0 .134-.242.27.27 0 0 0-.142-.25q-.142-.082-.292.009L4 3.667l-2.233-1.4q-.15-.092-.292-.004a.27.27 0 0 0-.142.245q0 .084.034.146a.22.22 0 0 0 .1.096l2.358 1.475a.35.35 0 0 0 .175.05"], Expand: ["M1.974 6.024h1.193q.2 0 .336.137a.46.46 0 0 1 .138.337.46.46 0 0 1-.138.337.46.46 0 0 1-.336.137H1.5a.46.46 0 0 1-.337-.137.46.46 0 0 1-.137-.337V4.831q0-.199.137-.336a.46.46 0 0 1 .337-.137q.2 0 .337.137a.46.46 0 0 1 .137.337zm4.052-4.052H4.833a.46.46 0 0 1-.336-.137.46.46 0 0 1-.138-.337q0-.2.138-.337a.46.46 0 0 1 .336-.137H6.5q.2 0 .337.137a.46.46 0 0 1 .137.337v1.667a.46.46 0 0 1-.137.337.46.46 0 0 1-.337.137.46.46 0 0 1-.337-.137.46.46 0 0 1-.137-.337z"], ExternalLink: ["M1.69 7.068a.73.73 0 0 1-.536-.222.73.73 0 0 1-.222-.537V1.691a.73.73 0 0 1 .222-.537.73.73 0 0 1 .537-.222h1.93a.37.37 0 0 1 .27.11.37.37 0 0 1 .109.27.37.37 0 0 1-.11.269.37.37 0 0 1-.27.11H1.69v4.618h4.62V4.38q0-.159.11-.27A.37.37 0 0 1 6.688 4q.16 0 .269.11t.11.27v1.93a.73.73 0 0 1-.222.536.73.73 0 0 1-.537.222zm4.62-4.849L3.557 4.97a.35.35 0 0 1-.263.105.36.36 0 0 1-.369-.371q0-.159.106-.264L5.78 1.69h-.735a.37.37 0 0 1-.27-.11.37.37 0 0 1-.11-.269q0-.16.11-.269a.37.37 0 0 1 .27-.11h1.643q.16 0 .269.11t.11.27v1.642a.37.37 0 0 1-.11.27.37.37 0 0 1-.27.11.37.37 0 0 1-.269-.11.37.37 0 0 1-.11-.27V2.22Z"], Feedback: ["m1.996 6.068-.687.687a.35.35 0 0 1-.413.081.354.354 0 0 1-.233-.353V1.357A.73.73 0 0 1 .885.821.73.73 0 0 1 1.42.599h5.286a.73.73 0 0 1 .536.222.73.73 0 0 1 .222.536V5.31a.73.73 0 0 1-.222.537.73.73 0 0 1-.536.222h-4.71Zm1.719-2.385v.65a.34.34 0 0 0 .35.35.34.34 0 0 0 .248-.1.34.34 0 0 0 .1-.25v-.65h.651a.34.34 0 0 0 .249-.1.34.34 0 0 0 .1-.25.34.34 0 0 0-.1-.249.34.34 0 0 0-.249-.1h-.65v-.65a.34.34 0 0 0-.101-.25.34.34 0 0 0-.249-.1.34.34 0 0 0-.249.1.34.34 0 0 0-.1.25v.65h-.65a.34.34 0 0 0-.25.1.34.34 0 0 0-.1.25q0 .147.1.248c.1.101.15.1.25.1z"], Filter: ["M3.657 6.316a.42.42 0 0 1-.311-.126.42.42 0 0 1-.126-.31q0-.185.13-.314a.43.43 0 0 1 .312-.129h.68a.433.433 0 0 1 .437.443.43.43 0 0 1-.442.436zM2.296 4.437a.42.42 0 0 1-.312-.125.42.42 0 0 1-.125-.31.433.433 0 0 1 .437-.444H5.7q.185 0 .311.13a.43.43 0 0 1 .126.313.42.42 0 0 1-.126.31.42.42 0 0 1-.311.126zm-1.02-1.879a.42.42 0 0 1-.31-.125.42.42 0 0 1-.126-.31q0-.186.129-.315a.43.43 0 0 1 .313-.128h5.441a.433.433 0 0 1 .437.443.43.43 0 0 1-.442.436H1.277Z"], Gauge: ["M3.483 5.167a.67.67 0 0 0 .525.196q.317-.013.459-.23l1.408-2.108q.075-.117-.02-.213-.098-.095-.213-.02L3.533 4.2q-.216.15-.237.454a.63.63 0 0 0 .187.513M1.7 6.667a.7.7 0 0 1-.337-.08.6.6 0 0 1-.246-.237 3.7 3.7 0 0 1-.334-.813 3.3 3.3 0 0 1-.116-.87q0-.692.262-1.3.263-.609.713-1.059T2.7 1.596A3.25 3.25 0 0 1 4 1.333q.684 0 1.283.259A3.37 3.37 0 0 1 7.05 3.337q.267.597.275 1.28a3.27 3.27 0 0 1-.45 1.733.6.6 0 0 1-.246.237.7.7 0 0 1-.337.08z"], Gear: ["M3.7 7.731a.43.43 0 0 1-.285-.107.43.43 0 0 1-.152-.268l-.087-.675a3 3 0 0 1-.191-.094 1 1 0 0 1-.185-.125l-.638.265a.4.4 0 0 1-.31.013.4.4 0 0 1-.232-.198L1.057 5.53a.44.44 0 0 1-.05-.295.4.4 0 0 1 .16-.248l.528-.408-.008-.113a1.4 1.4 0 0 1 0-.214l.008-.117-.52-.39a.38.38 0 0 1-.158-.254.46.46 0 0 1 .051-.301l.56-.978a.43.43 0 0 1 .533-.185l.603.245q.093-.07.207-.13a5 5 0 0 1 .21-.108l.082-.66a.4.4 0 0 1 .148-.267A.44.44 0 0 1 3.7 1h1.113q.159 0 .288.107.13.105.148.268l.08.67q.105.053.208.108.102.055.2.127l.61-.253a.4.4 0 0 1 .304-.012q.15.057.237.197l.56.98a.45.45 0 0 1 .049.3.4.4 0 0 1-.159.252l-.55.417q.01.054.012.111a4 4 0 0 1-.002.2l-.006.12.524.395a.423.423 0 0 1 .12.552l-.557 1a.4.4 0 0 1-.238.198.42.42 0 0 1-.314-.013l-.632-.265a3 3 0 0 1-.177.118q-.09.054-.181.093l-.088.686a.43.43 0 0 1-.152.268.43.43 0 0 1-.284.107zm.535-2.168q.505 0 .855-.35.351-.352.351-.856t-.35-.855a1.16 1.16 0 0 0-.856-.35q-.501 0-.854.35a1.16 1.16 0 0 0-.352.855q0 .505.352.856.353.35.854.35"], Globe: ["M4 7.494a3.4 3.4 0 0 1-1.366-.275 3.5 3.5 0 0 1-1.107-.746A3.5 3.5 0 0 1 .78 5.366 3.4 3.4 0 0 1 .506 4q0-.73.275-1.366t.746-1.107A3.5 3.5 0 0 1 2.634.78 3.4 3.4 0 0 1 4 .506q.73 0 1.366.275t1.107.746.746 1.107T7.493 4t-.274 1.366a3.5 3.5 0 0 1-.746 1.107 3.5 3.5 0 0 1-1.107.746A3.4 3.4 0 0 1 4 7.493Zm0-.884q1.013 0 1.739-.652.725-.652.833-1.624l-.001-.052-.002-.045a.6.6 0 0 1-.23.26.64.64 0 0 1-.353.1h-.634a.7.7 0 0 1-.51-.212.7.7 0 0 1-.213-.511v-.362H3.183v-.685a.7.7 0 0 1 .212-.514.7.7 0 0 1 .51-.214h.362a.7.7 0 0 1 .116-.39.6.6 0 0 1 .285-.232 3 3 0 0 0-.328-.063A2.4 2.4 0 0 0 4 1.39q-1.098 0-1.854.756C1.39 2.902 1.39 3.268 1.39 4q0 .024.002.047l.003.047h1.379q.602 0 1.024.422.423.423.422 1.023v.363H3.136v.554A2.5 2.5 0 0 0 4 6.61"], Heartbeat: ["m3.567 4.242-.284-.425a.3.3 0 0 0-.116-.109.3.3 0 0 0-.159-.041H1.033a.3.3 0 0 1-.166-.054.3.3 0 0 1-.109-.146 2 2 0 0 1-.07-.313 2.4 2.4 0 0 1-.021-.32q0-.784.525-1.309T2.5 1a1.98 1.98 0 0 1 1.5.7A1.98 1.98 0 0 1 5.5 1q.783 0 1.308.525t.525 1.308q0 .167-.02.321a2 2 0 0 1-.071.313.25.25 0 0 1-.104.145.3.3 0 0 1-.171.055H5.192l-.575-.85a.3.3 0 0 0-.13-.113.4.4 0 0 0-.17-.037.3.3 0 0 0-.188.062.34.34 0 0 0-.112.163zM4 6.892a.7.7 0 0 1-.233-.042.6.6 0 0 1-.209-.133 42 42 0 0 1-1.325-1.23 10 10 0 0 1-.875-.954q-.05-.067-.012-.133a.12.12 0 0 1 .112-.067h1.35l.575.85q.05.075.13.113.079.037.17.037.109 0 .188-.062a.34.34 0 0 0 .112-.163l.45-1.358.292.433a.32.32 0 0 0 .275.15h1.542q.075 0 .112.067.037.066-.012.133a10 10 0 0 1-.875.954q-.542.53-1.325 1.23a.6.6 0 0 1-.209.133.7.7 0 0 1-.233.042"], Help: ["m3.898 6.413-.09-.002a2.83 2.83 0 0 1-2.019-.88 2.82 2.82 0 0 1-.824-2.043q0-1.22.852-2.071A2.83 2.83 0 0 1 3.89.567q.61 0 1.14.229a2.96 2.96 0 0 1 1.556 1.557q.23.53.23 1.139 0 1.162-.665 2.134a5.1 5.1 0 0 1-1.666 1.55.4.4 0 0 1-.188.05.3.3 0 0 1-.172-.045.4.4 0 0 1-.133-.125.35.35 0 0 1-.06-.182zm-.014-1.076q.154 0 .26-.107a.36.36 0 0 0 .108-.26.36.36 0 0 0-.107-.261.36.36 0 0 0-.261-.107.36.36 0 0 0-.26.107.36.36 0 0 0-.108.26q0 .155.107.261a.36.36 0 0 0 .26.107Zm-.735-2.543q.102.043.202.003a.4.4 0 0 0 .167-.132.5.5 0 0 1 .166-.144.44.44 0 0 1 .21-.05.44.44 0 0 1 .304.105q.118.106.118.267 0 .106-.063.216-.063.111-.212.257-.205.182-.31.35a.6.6 0 0 0-.106.331q0 .11.077.187a.25.25 0 0 0 .186.077q.105 0 .177-.076a.6.6 0 0 0 .114-.178.8.8 0 0 1 .148-.253q.1-.114.186-.2a1.6 1.6 0 0 0 .28-.372.8.8 0 0 0 .088-.36.8.8 0 0 0-.265-.63q-.264-.238-.708-.238a1.04 1.04 0 0 0-.882.477.25.25 0 0 0-.024.212q.034.105.147.15Z"], History: ["M3.865 0c-.831 0-1.623.255-2.284.716L1.202.295a.256.256 0 0 0-.439.109L.334 2.118a.257.257 0 0 0 .291.315l1.714-.286a.256.256 0 0 0 .148-.424l-.294-.326a3.094 3.094 0 1 1-1.187 3.787.453.453 0 1 0-.837.347c.201.486.497.926.868 1.297A4 4 0 1 0 3.865 0", "M3.733 2.546a.436.436 0 0 0-.436.436v1.454c0 .146.073.282.194.363l.873.581a.437.437 0 0 0 .484-.726l-.678-.451v-1.22a.437.437 0 0 0-.437-.437"], Hyper: ["M2.488 1.466a1.486 1.486 0 1 0 0 2.973h2.214a.351.351 0 0 1 0 .702H2.488a2.188 2.188 0 1 1 1.843-3.369.351.351 0 0 1-.59.38 1.49 1.49 0 0 0-1.253-.686", "M5.512 6.534a1.486 1.486 0 1 0 0-2.973H3.298a.351.351 0 0 1 0-.702h2.214a2.188 2.188 0 1 1-1.843 3.369.351.351 0 0 1 .59-.38c.266.413.728.686 1.253.686"], Inspect: ["M3.792 3.203a.294.294 0 0 0 .416 0l1.35-1.35a.294.294 0 0 0 0-.416L4.208.087a.294.294 0 0 0-.416 0l-1.35 1.35a.294.294 0 0 0 0 .416zM3.2 3.79 1.85 2.44a.296.296 0 0 0-.41 0L.09 3.79a.29.29 0 0 0 0 .42l1.35 1.35c.11.11.3.11.41 0L3.2 4.21a.29.29 0 0 0 0-.42m-.76.29-.71.72c-.05.05-.12.05-.17 0l-.72-.72a.12.12 0 0 1 0-.16l.72-.72c.05-.05.12-.05.17 0l.71.72c.05.04.05.12 0 .16m5.47-.29L6.56 2.44a.296.296 0 0 0-.41 0L4.8 3.79a.29.29 0 0 0 0 .42l1.35 1.35c.11.11.3.11.41 0l1.35-1.35a.29.29 0 0 0 0-.42m-.75.29-.72.72c-.05.05-.12.05-.17 0l-.71-.72a.104.104 0 0 1 0-.16l.71-.72c.05-.05.12-.05.17 0l.72.72c.04.04.04.12 0 .16m-1.6 2.07L4.21 4.8a.29.29 0 0 0-.42 0L2.44 6.15c-.11.11-.11.3 0 .41l1.35 1.35c.12.12.3.12.42 0l1.35-1.35c.11-.11.11-.3 0-.41m-.76.29-.72.72c-.04.04-.12.04-.16 0l-.72-.72a.115.115 0 0 1 0-.17l.72-.71c.04-.05.12-.05.16 0l.72.71c.05.05.05.12 0 .17"], Invisible: ["M6.367 7.3 5.2 6.15a4 4 0 0 1-1.2.183q-1.116 0-2.042-.6A4.23 4.23 0 0 1 .508 4.15a.7.7 0 0 1-.083-.317.64.64 0 0 1 .083-.316A9 9 0 0 1 .9 2.883q.209-.308.483-.55l-.691-.7A.3.3 0 0 1 .6 1.404a.324.324 0 0 1 .333-.329q.143 0 .234.092l5.666 5.666a.33.33 0 0 1 .096.23.31.31 0 0 1-.096.237.32.32 0 0 1-.233.092.32.32 0 0 1-.233-.092M4 5.333q.092 0 .175-.008a1 1 0 0 0 .167-.033l-1.8-1.8a1 1 0 0 0-.034.166 2 2 0 0 0-.008.175q0 .625.438 1.063.437.438 1.062.437m0-4q1.116 0 2.046.605.93.603 1.454 1.587a.5.5 0 0 1 .063.146.8.8 0 0 1 .004.325.5.5 0 0 1-.059.146q-.157.308-.354.583a4 4 0 0 1-.437.517.35.35 0 0 1-.275.108.4.4 0 0 1-.275-.125L5.5 4.558a.27.27 0 0 1-.075-.137.3.3 0 0 1 .008-.163 1.3 1.3 0 0 0 .067-.425q0-.624-.438-1.062A1.45 1.45 0 0 0 4 2.333a1.3 1.3 0 0 0-.425.067.34.34 0 0 1-.167.008.27.27 0 0 1-.141-.075l-.275-.275a.36.36 0 0 1-.104-.366.35.35 0 0 1 .262-.267q.21-.042.42-.067A4 4 0 0 1 4 1.333m.658 1.884q.092.108.154.237a.8.8 0 0 1 .08.271q.008.066-.05.092-.059.024-.109-.025l-.683-.684Q4 3.058 4.03 3a.1.1 0 0 1 .095-.058q.159.016.292.087.134.07.241.188"], Lightning: ["M2.859 5.179h-.92a.42.42 0 0 1-.393-.236.41.41 0 0 1 .028-.459L4.3.557a.5.5 0 0 1 .252-.186.45.45 0 0 1 .31.01.47.47 0 0 1 .3.508l-.28 2.265H6.07a.41.41 0 0 1 .401.253.41.41 0 0 1-.066.472l-2.982 3.59a.46.46 0 0 1-.258.16.49.49 0 0 1-.527-.233.47.47 0 0 1-.056-.3l.276-1.917Z"], LightningSlash: ["M2.859 5.179h-.92a.42.42 0 0 1-.393-.236.41.41 0 0 1 .028-.459l.856-1.233L.88 1.7a.325.325 0 0 1 .46-.46l5.373 5.374a.325.325 0 0 1-.46.46L4.888 5.708l-1.463 1.76a.46.46 0 0 1-.258.16.49.49 0 0 1-.527-.232.47.47 0 0 1-.056-.3zm3.212-.897a.5.5 0 0 1-.738.034L3.48 2.462a.5.5 0 0 1-.057-.639l.88-1.266a.5.5 0 0 1 .251-.186.45.45 0 0 1 .31.01.47.47 0 0 1 .3.508l-.28 2.265h1.188a.41.41 0 0 1 .401.253.41.41 0 0 1-.066.472z"], Location: ["M4 7.164a.7.7 0 0 1-.248-.043.7.7 0 0 1-.222-.131 14 14 0 0 1-.978-.983 7 7 0 0 1-.709-.927 4.3 4.3 0 0 1-.43-.872 2.5 2.5 0 0 1-.147-.816q0-1.278.824-2.035Q2.915.599 4 .599t1.91.758q.824.757.824 2.035 0 .394-.146.816a4.3 4.3 0 0 1-.431.872q-.285.45-.71.927-.423.476-.977.983a.7.7 0 0 1-.222.13.7.7 0 0 1-.249.044ZM4 4.02q.285 0 .486-.2a.66.66 0 0 0 .2-.487.66.66 0 0 0-.2-.485A.66.66 0 0 0 4 2.647a.66.66 0 0 0-.486.2.66.66 0 0 0-.2.486q0 .285.2.486c.2.201.296.2.486.2Z"], Lock: ["M2 7.336a.64.64 0 0 1-.47-.196.64.64 0 0 1-.197-.47V3.335q0-.275.196-.471A.64.64 0 0 1 2 2.669h.333v-.667q0-.69.488-1.179A1.6 1.6 0 0 1 4 .336q.691 0 1.18.487.486.487.487 1.18v.666H6q.275 0 .47.196a.64.64 0 0 1 .197.47V6.67q0 .275-.196.47A.64.64 0 0 1 6 7.337zm2-1.667q.275 0 .47-.196a.64.64 0 0 0 .197-.47.64.64 0 0 0-.196-.471A.64.64 0 0 0 4 4.336a.64.64 0 0 0-.47.196.64.64 0 0 0-.197.47q0 .275.196.471T4 5.669m-1-3h2v-.667a.96.96 0 0 0-.292-.708A.96.96 0 0 0 4 1.002a.96.96 0 0 0-.708.292.96.96 0 0 0-.292.708z"], Mailbox: ["M1.333 7.333a.64.64 0 0 1-.47-.196.64.64 0 0 1-.196-.47V3.333q0-.275.196-.47a.64.64 0 0 1 .47-.196H2V1q0-.141.096-.238a.32.32 0 0 1 .237-.095h2q.142 0 .238.095A.32.32 0 0 1 4.667 1v.667a.32.32 0 0 1-.096.237.32.32 0 0 1-.238.096H2.667v2.333q0 .142.096.238A.32.32 0 0 0 3 4.667a.32.32 0 0 0 .237-.096.32.32 0 0 0 .096-.238V2.667h3.334q.275 0 .47.195a.64.64 0 0 1 .196.471v3.334q0 .275-.195.47a.64.64 0 0 1-.471.196z"], Manufacturing: ["M1.568 7.35a.53.53 0 0 1-.387-.16.53.53 0 0 1-.16-.387.53.53 0 0 1 .16-.387.53.53 0 0 1 .387-.158H2.1l-.814-2.664a1.03 1.03 0 0 1-.43-.385 1.03 1.03 0 0 1-.169-.572q0-.443.309-.752a1.02 1.02 0 0 1 .751-.31q.35 0 .622.203.271.204.38.525h.968V1.97a.35.35 0 0 1 .105-.258.35.35 0 0 1 .259-.105.36.36 0 0 1 .266.123l.547-.515a.4.4 0 0 1 .195-.103.33.33 0 0 1 .222.03l1.3.6a.29.29 0 0 1 .145.377.26.26 0 0 1-.161.144.3.3 0 0 1-.212-.015l-1.178-.542-.76.71v.438l.76.697 1.178-.538A.3.3 0 0 1 6.6 3a.25.25 0 0 1 .158.135.25.25 0 0 1 .014.217.33.33 0 0 1-.159.162l-1.294.612a.35.35 0 0 1-.423-.068l-.547-.516a.6.6 0 0 1-.123.087.3.3 0 0 1-.143.037.35.35 0 0 1-.259-.105.35.35 0 0 1-.105-.259V2.97H2.75a2 2 0 0 1-.069.161.7.7 0 0 1-.098.15l1.609 2.977h.724a.53.53 0 0 1 .387.158.53.53 0 0 1 .159.387.53.53 0 0 1-.159.388.53.53 0 0 1-.387.158zm.18-4.38a.32.32 0 0 0 .238-.096.32.32 0 0 0 .096-.237.32.32 0 0 0-.096-.238.32.32 0 0 0-.238-.096.32.32 0 0 0-.237.096.32.32 0 0 0-.096.238q0 .141.096.237a.32.32 0 0 0 .237.096"], Minus: ["M1.706 4.525a.5.5 0 0 1-.371-.154A.5.5 0 0 1 1.18 4q-.001-.216.154-.37a.5.5 0 0 1 .37-.155H5.89q.216 0 .37.154A.5.5 0 0 1 6.415 4a.5.5 0 0 1-.154.37.5.5 0 0 1-.371.155z"], Money: ["M1 6.399a.58.58 0 0 1-.424-.176.58.58 0 0 1-.176-.424v-3.1q0-.127.086-.214A.3.3 0 0 1 .698 2.4q.127 0 .214.086A.3.3 0 0 1 1 2.7v3.1h5.3a.3.3 0 0 1 .214.086.3.3 0 0 1 .086.212.3.3 0 0 1-.086.214.3.3 0 0 1-.214.088H1Zm1.2-1.2a.58.58 0 0 1-.424-.176.58.58 0 0 1-.176-.424v-2.4a.58.58 0 0 1 .176-.421.57.57 0 0 1 .424-.18H7q.241 0 .42.18.18.18.18.42v2.4q0 .249-.18.425a.58.58 0 0 1-.42.176zm.6-.6a.58.58 0 0 0-.18-.421.58.58 0 0 0-.42-.18v.6h.6Zm3.6 0H7v-.6a.57.57 0 0 0-.425.179.58.58 0 0 0-.175.42Zm-1.804-.2q.42 0 .712-.288a.96.96 0 0 0 .292-.708.97.97 0 0 0-.292-.713.96.96 0 0 0-.708-.29.96.96 0 0 0-.713.291.97.97 0 0 0-.287.709q0 .424.287.712a.96.96 0 0 0 .709.288ZM2.2 2.799a.58.58 0 0 0 .42-.176.57.57 0 0 0 .18-.424h-.6zm4.8 0v-.6h-.6a.58.58 0 0 0 .176.425.58.58 0 0 0 .424.175"], Network: ["M4 7.494q-.717 0-1.353-.277a3.6 3.6 0 0 1-1.112-.752 3.6 3.6 0 0 1-.752-1.112A3.4 3.4 0 0 1 .506 4q0-.72.277-1.355a3.6 3.6 0 0 1 .752-1.11A3.6 3.6 0 0 1 2.647.783 3.4 3.4 0 0 1 4 .506q.72 0 1.355.277a3.6 3.6 0 0 1 1.11.752q.475.476.752 1.11T7.494 4q0 .717-.277 1.353a3.6 3.6 0 0 1-.752 1.112 3.6 3.6 0 0 1-1.11.752A3.4 3.4 0 0 1 4 7.494m-.01-.896q.198-.29.357-.613.157-.323.258-.68H3.39a4.4 4.4 0 0 0 .6 1.293m-.843-.133a3 3 0 0 1-.262-.562 7 7 0 0 1-.178-.598h-.955q.227.408.583.71.356.305.813.45Zm1.691 0q.458-.146.818-.45.36-.302.588-.71h-.956q-.075.303-.182.598a3 3 0 0 1-.268.562M1.473 4.652h1.1A5 5 0 0 1 2.524 4a4 4 0 0 1 .05-.652h-1.1a2.5 2.5 0 0 0-.063.983q.022.16.063.321Zm1.767 0h1.515q.026-.166.033-.324a7 7 0 0 0 0-.658 3 3 0 0 0-.033-.322H3.24a4 4 0 0 0-.038.98q.014.157.038.325Zm2.182 0h1.095A2.7 2.7 0 0 0 6.601 4a2.5 2.5 0 0 0-.084-.652H5.422a6 6 0 0 1 .04.652 5 5 0 0 1-.04.652M5.288 2.69h.955a2.5 2.5 0 0 0-.587-.708 2.4 2.4 0 0 0-.818-.447q.16.266.268.56.107.293.182.595m-1.898 0h1.215a3.7 3.7 0 0 0-.254-.677 5 5 0 0 0-.36-.611 4.3 4.3 0 0 0-.6 1.288Zm-1.638 0h.955q.075-.302.178-.596.103-.293.263-.559a2.3 2.3 0 0 0-.813.447q-.355.3-.583.708"], Organization: ["M1.357 7.068a.73.73 0 0 1-.536-.222.73.73 0 0 1-.222-.537V2.722a.73.73 0 0 1 .222-.536.73.73 0 0 1 .536-.222h1.248v-.667a.73.73 0 0 1 .222-.536.73.73 0 0 1 .536-.222h1.274a.73.73 0 0 1 .536.222.73.73 0 0 1 .222.536v.667h1.248q.315 0 .536.222a.73.73 0 0 1 .222.536V6.31a.73.73 0 0 1-.222.537.73.73 0 0 1-.536.222H1.357Zm2.006-5.104h1.274v-.667H3.363z"], OrganizationAdd: ["M5.763 7.213A.32.32 0 0 0 6 7.31a.32.32 0 0 0 .238-.096.32.32 0 0 0 .095-.237V6.31H7a.32.32 0 0 0 .238-.096.32.32 0 0 0 .095-.237.32.32 0 0 0-.095-.238A.32.32 0 0 0 7 5.643h-.667v-.667a.32.32 0 0 0-.095-.238A.32.32 0 0 0 6 4.643a.32.32 0 0 0-.237.095.32.32 0 0 0-.096.238v.667H5a.32.32 0 0 0-.237.095.32.32 0 0 0-.096.238.32.32 0 0 0 .096.237A.32.32 0 0 0 5 6.31h.667v.667a.32.32 0 0 0 .096.237Z", "M3.363 1.964h1.274v-.667H3.363zM1.357 7.068a.73.73 0 0 1-.536-.222.73.73 0 0 1-.222-.537V2.722a.73.73 0 0 1 .222-.536.73.73 0 0 1 .536-.222h1.248v-.667a.73.73 0 0 1 .222-.536.73.73 0 0 1 .536-.222h1.274a.73.73 0 0 1 .536.222.73.73 0 0 1 .222.536v.667h1.248q.315 0 .536.222a.73.73 0 0 1 .222.536v.89q0 .171-.149.254a.32.32 0 0 1-.309.005 2 2 0 0 0-.456-.154A2.4 2.4 0 0 0 6 3.667q-.966 0-1.65.683A2.25 2.25 0 0 0 3.667 6a2.3 2.3 0 0 0 .083.616.35.35 0 0 1-.049.309.3.3 0 0 1-.258.143z"], Panels: ["M4.3 4.299h2.5v1.9a.58.58 0 0 1-.176.42.57.57 0 0 1-.424.18H4.3zm0-.6v-2.5h1.9a.58.58 0 0 1 .424.176.58.58 0 0 1 .176.425v1.9H4.3Zm-.6 0H1.2v-1.9q0-.247.18-.424A.58.58 0 0 1 1.8 1.2h1.9v2.5Zm0 .6v2.5H1.8a.58.58 0 0 1-.42-.18.58.58 0 0 1-.18-.42v-1.9z"], Pause: ["M5.667 6.917a.8.8 0 0 1-.589-.245.8.8 0 0 1-.245-.589V1.917q0-.345.245-.589a.8.8 0 0 1 .589-.245q.344 0 .588.245.245.245.245.589v4.166q0 .345-.245.589a.8.8 0 0 1-.588.245m-3.334 0a.8.8 0 0 1-.588-.245.8.8 0 0 1-.245-.589V1.917q0-.345.245-.589a.8.8 0 0 1 .588-.245q.345 0 .589.245.245.245.245.589v4.166q0 .345-.245.589a.8.8 0 0 1-.589.245"], Pencil: ["M1.282 7.16a.43.43 0 0 1-.313-.129.43.43 0 0 1-.13-.313v-.912a.87.87 0 0 1 .258-.622L5.23 1.055A.76.76 0 0 1 5.757.84a.76.76 0 0 1 .532.219l.66.655q.11.106.163.247a.8.8 0 0 1 0 .57.7.7 0 0 1-.162.247L2.825 6.902a.87.87 0 0 1-.622.258zm4.481-4.452.467-.462-.472-.476-.471.467z"], Performance: ["M1.667 7a.64.64 0 0 1-.471-.196.64.64 0 0 1-.196-.47V1.666a.64.64 0 0 1 .196-.471.64.64 0 0 1 .47-.195h4.667a.64.64 0 0 1 .471.196q.195.195.196.47v4.667a.64.64 0 0 1-.196.471.64.64 0 0 1-.47.196H1.666Zm4.666-4.583L4.317 4.683 3.233 3.6a.32.32 0 0 0-.466 0l-1.1 1.1v.95L3 4.317l1.1 1.1a.32.32 0 0 0 .246.096.3.3 0 0 0 .237-.113l1.75-1.983z"], Play: ["M2.248 6.205v-4.41q0-.205.142-.339a.47.47 0 0 1 .458-.118.5.5 0 0 1 .125.053l3.472 2.207a.46.46 0 0 1 .161.178.49.49 0 0 1 0 .448.46.46 0 0 1-.16.178L2.972 6.609a.5.5 0 0 1-.251.07.47.47 0 0 1-.332-.135.45.45 0 0 1-.142-.34Z"], Plus: ["M4.036 7.159a.43.43 0 0 1-.312-.129.43.43 0 0 1-.13-.313V4.445H1.319a.43.43 0 0 1-.313-.129.43.43 0 0 1-.129-.313.42.42 0 0 1 .13-.312.43.43 0 0 1 .312-.13H3.59v-2.28q0-.185.129-.314A.43.43 0 0 1 4.032.84a.43.43 0 0 1 .313.128q.128.129.128.313v2.277h2.282q.184 0 .313.129T7.197 4a.43.43 0 0 1-.13.313.43.43 0 0 1-.312.128H4.478v2.277a.43.43 0 0 1-.129.313.43.43 0 0 1-.313.129Z"], Profile: ["M4.117 4.991a1 1 0 0 1-.125.255.8.8 0 0 1-.12-.255 3 3 0 0 1-.102-.414h.456a2.3 2.3 0 0 1-.109.414m-.587-.067a1 1 0 0 0 .102.28 1.17 1.17 0 0 1-.74-.627h.573q.029.184.065.347m1.267.048a1.2 1.2 0 0 1-.442.232q.067-.117.107-.28t.069-.347h.573a1.15 1.15 0 0 1-.307.395m-1.37-.683h-.644A1 1 0 0 1 2.746 4a1 1 0 0 1 .038-.289h.643a2 2 0 0 0-.01.138 5 5 0 0 0 0 .287q.002.074.01.153m.836 0h-.53A2 2 0 0 1 3.72 4a2 2 0 0 1 .013-.289h.53q.009.08.007.149a5 5 0 0 0 0 .276q.002.069-.007.153m.945 0h-.64q.005-.072.005-.14v-.287q0-.071-.004-.15h.64a1 1 0 0 1 .029.142 1.3 1.3 0 0 1 0 .288 1 1 0 0 1-.03.147m-.104-.87H4.53a4 4 0 0 0-.069-.345 1 1 0 0 0-.107-.278 1.2 1.2 0 0 1 .749.623Zm-.878 0H3.77q.038-.222.102-.412a.8.8 0 0 1 .12-.253.8.8 0 0 1 .13.253q.07.19.104.412m-.761 0h-.573q.108-.231.303-.393.195-.164.437-.23a1 1 0 0 0-.102.278 6 6 0 0 0-.065.345", "M.82 6.513a.73.73 0 0 0 .537.221h5.286a.73.73 0 0 0 .536-.221.73.73 0 0 0 .222-.537V4.837a.23.23 0 0 0-.057-.156.25.25 0 0 0-.15-.082.67.67 0 0 1-.328-.226A.58.58 0 0 1 6.734 4q0-.21.132-.375a.66.66 0 0 1 .329-.224.25.25 0 0 0 .149-.082.23.23 0 0 0 .057-.156v-1.14a.73.73 0 0 0-.222-.536.73.73 0 0 0-.536-.221H1.357a.73.73 0 0 0-.536.221.73.73 0 0 0-.222.537V3.16q0 .09.057.157a.25.25 0 0 0 .15.083.66.66 0 0 1 .328.224q.132.165.132.375a.58.58 0 0 1-.132.373.67.67 0 0 1-.329.226.25.25 0 0 0-.149.083.23.23 0 0 0-.057.157v1.137q0 .315.222.537Zm2.503-.903q.317.138.677.138t.677-.138a1.78 1.78 0 0 0 .933-.933q.138-.317.138-.677t-.138-.677a1.78 1.78 0 0 0-.933-.933A1.7 1.7 0 0 0 4 2.252q-.36 0-.677.138a1.78 1.78 0 0 0-.933.933A1.7 1.7 0 0 0 2.252 4q0 .36.138.677a1.78 1.78 0 0 0 .933.933"], ProfileInstalled: ["M4.357 4.328V3.31a.34.34 0 0 0-.103-.252.34.34 0 0 0-.252-.103q-.15 0-.253.103a.34.34 0 0 0-.104.252v1.017l-.268-.26a.34.34 0 0 0-.245-.099.34.34 0 0 0-.252.105.34.34 0 0 0-.1.25q0 .15.1.249l.853.852A.37.37 0 0 0 4 5.54a.37.37 0 0 0 .267-.114l.853-.852a.35.35 0 0 0 .103-.246.33.33 0 0 0-.103-.253.34.34 0 0 0-.246-.102.35.35 0 0 0-.253.098zM2.024 7.4a.73.73 0 0 1-.537-.222.73.73 0 0 1-.221-.536v-3.69a.75.75 0 0 1 .22-.533l1.6-1.6a.74.74 0 0 1 .532-.22h2.358a.73.73 0 0 1 .537.222.73.73 0 0 1 .221.536v5.286a.73.73 0 0 1-.221.536.73.73 0 0 1-.537.222z"], Receipt: ["M1 6.933V.867q0-.06.05-.08t.092.021l.241.242a.16.16 0 0 0 .234 0l.266-.267a.16.16 0 0 1 .234 0l.266.267a.16.16 0 0 0 .234 0l.266-.267a.16.16 0 0 1 .234 0l.266.267a.16.16 0 0 0 .234 0l.266-.267a.16.16 0 0 1 .234 0l.266.267a.16.16 0 0 0 .234 0l.266-.267a.16.16 0 0 1 .234 0l.266.267a.16.16 0 0 0 .234 0l.266-.267a.16.16 0 0 1 .234 0l.266.267a.16.16 0 0 0 .234 0l.241-.242q.042-.04.092-.02T7 .867v6.066q0 .116-.1.159-.1.041-.183-.042l-.1-.1a.16.16 0 0 0-.234 0l-.266.267a.16.16 0 0 1-.234 0l-.266-.267a.16.16 0 0 0-.234 0l-.266.267a.16.16 0 0 1-.234 0l-.266-.267a.16.16 0 0 0-.234 0l-.266.267a.16.16 0 0 1-.234 0l-.266-.267a.16.16 0 0 0-.234 0l-.266.267a.16.16 0 0 1-.234 0l-.266-.267a.16.16 0 0 0-.234 0l-.266.267a.16.16 0 0 1-.234 0l-.266-.267a.16.16 0 0 0-.234 0l-.1.1q-.083.084-.183.042-.1-.041-.1-.159m1.333-1.266h3.334a.32.32 0 0 0 .237-.096A.32.32 0 0 0 6 5.333a.32.32 0 0 0-.096-.237A.32.32 0 0 0 5.667 5H2.333a.32.32 0 0 0-.237.096.32.32 0 0 0-.096.237q0 .142.096.238a.32.32 0 0 0 .237.096m0-1.334h3.334a.32.32 0 0 0 .237-.096A.32.32 0 0 0 6 4a.32.32 0 0 0-.096-.237.32.32 0 0 0-.237-.096H2.333a.32.32 0 0 0-.237.096A.32.32 0 0 0 2 4a.32.32 0 0 0 .096.237.32.32 0 0 0 .237.096m0-1.333h3.334a.32.32 0 0 0 .237-.096A.32.32 0 0 0 6 2.667a.32.32 0 0 0-.096-.238.32.32 0 0 0-.237-.096H2.333a.32.32 0 0 0-.237.096.32.32 0 0 0-.096.238q0 .141.096.237A.32.32 0 0 0 2.333 3"], ReleaseNotes: ["M5.96 6.352v.636q0 .08.059.138a.19.19 0 0 0 .275 0 .2.2 0 0 0 .06-.138v-.636h.636a.2.2 0 0 0 .138-.06.19.19 0 0 0 0-.275.2.2 0 0 0-.138-.059h-.637v-.636a.2.2 0 0 0-.059-.138.19.19 0 0 0-.275 0 .2.2 0 0 0-.059.138v.636h-.637a.2.2 0 0 0-.137.06.19.19 0 0 0 0 .275.2.2 0 0 0 .137.059zm.197 1.47q-.692 0-1.18-.488a1.6 1.6 0 0 1-.487-1.179q0-.691.487-1.18a1.6 1.6 0 0 1 1.18-.487q.69 0 1.179.488.487.488.487 1.179t-.487 1.18a1.6 1.6 0 0 1-1.18.487ZM2.87 3.142h2.62a.32.32 0 0 0 .237-.097.32.32 0 0 0 .096-.237.32.32 0 0 0-.096-.238.32.32 0 0 0-.237-.096H2.871a.32.32 0 0 0-.237.096.32.32 0 0 0-.096.238q0 .141.096.237a.32.32 0 0 0 .237.096Zm-1 4.043a.73.73 0 0 1-.535-.223.73.73 0 0 1-.223-.535v-4.62a.73.73 0 0 1 .223-.535.73.73 0 0 1 .535-.223h4.62a.73.73 0 0 1 .536.223.73.73 0 0 1 .222.536v1.81a.3.3 0 0 1-.144.265.33.33 0 0 1-.307.032q-.15-.045-.311-.068a2.4 2.4 0 0 0-.5-.02 1 1 0 0 0-.163.02.6.6 0 0 0-.16-.048 1 1 0 0 0-.173-.015H2.871a.32.32 0 0 0-.237.096.32.32 0 0 0-.096.237q0 .142.096.238a.32.32 0 0 0 .237.096h1.704a2.2 2.2 0 0 0-.49.642H2.87a.32.32 0 0 0-.237.096.32.32 0 0 0-.096.238q0 .141.096.237a.32.32 0 0 0 .237.096h.99q-.024.098-.03.193a3 3 0 0 0 .008.504q.015.143.053.278.045.165-.05.308a.3.3 0 0 1-.258.142z"], Return: ["m2.072 4.431.924.924a.42.42 0 0 1 0 .61.42.42 0 0 1-.611 0L.72 4.305a.427.427 0 0 1-.002-.608l1.667-1.664a.42.42 0 0 1 .61 0 .42.42 0 0 1 0 .61l-.923.924H6.72v-.692q0-.182.125-.307a.42.42 0 0 1 .305-.126q.18 0 .308.126a.42.42 0 0 1 .127.307v.692q0 .36-.253.612a.83.83 0 0 1-.612.253z"], Review: ["M4 6a.407.407 0 0 0 .416-.417.4.4 0 0 0-.12-.296.4.4 0 0 0-.296-.12.4.4 0 0 0-.296.12.4.4 0 0 0-.12.296q0 .176.12.296.121.12.296.121m1.2-3.017q0-.45-.304-.716Q4.592 2 4.092 2q-.375 0-.663.154a1.13 1.13 0 0 0-.454.446q-.058.092-.004.2a.33.33 0 0 0 .17.158.28.28 0 0 0 .209.004.4.4 0 0 0 .183-.137.6.6 0 0 1 .23-.192.7.7 0 0 1 .295-.066q.233 0 .38.125a.4.4 0 0 1 .145.316q0 .15-.1.317a1.4 1.4 0 0 1-.3.333 1.8 1.8 0 0 0-.325.359 1 1 0 0 0-.141.391.25.25 0 0 0 .07.213.3.3 0 0 0 .221.096.33.33 0 0 0 .213-.08.35.35 0 0 0 .12-.212.7.7 0 0 1 .092-.237q.068-.105.234-.271.315-.316.425-.509a.85.85 0 0 0 .108-.425M1.667 7a.64.64 0 0 1-.471-.196.64.64 0 0 1-.196-.47V1.666a.64.64 0 0 1 .196-.471.64.64 0 0 1 .47-.195h4.667a.64.64 0 0 1 .471.196q.196.195.196.47v4.667a.64.64 0 0 1-.196.471.64.64 0 0 1-.47.196z"], Routes: ["M1.442 4.442a.43.43 0 0 1-.313-.13A.43.43 0 0 1 1 4q0-.184.129-.313a.43.43 0 0 1 .313-.129h2.204l1.502-1.501h-.274a.43.43 0 0 1-.313-.13.43.43 0 0 1-.129-.312q0-.184.129-.313a.43.43 0 0 1 .313-.129h1.333q.184 0 .313.129t.129.313v1.333a.43.43 0 0 1-.129.313.43.43 0 0 1-.313.129.43.43 0 0 1-.313-.129.43.43 0 0 1-.128-.313v-.274l-1.51 1.51a.87.87 0 0 1-.623.258zm3.432 2.385a.43.43 0 0 1-.313-.129.43.43 0 0 1-.129-.313q0-.184.129-.313a.43.43 0 0 1 .313-.128h.265l-.538-.53a.43.43 0 0 1-.133-.315.43.43 0 0 1 .133-.315.44.44 0 0 1 .317-.136.43.43 0 0 1 .317.131l.53.538v-.265q0-.184.13-.313a.43.43 0 0 1 .312-.129q.184 0 .313.129t.129.313v1.333a.43.43 0 0 1-.129.313.43.43 0 0 1-.313.129z"], SIM: ["M2.667 6.332a.32.32 0 0 0 .237-.095A.32.32 0 0 0 3 5.998a.32.32 0 0 0-.096-.237.32.32 0 0 0-.237-.096.32.32 0 0 0-.238.095.32.32 0 0 0-.096.238q0 .142.096.238a.32.32 0 0 0 .238.095Zm0-1.333a.32.32 0 0 0 .237-.096A.32.32 0 0 0 3 4.666v-.667a.32.32 0 0 0-.096-.238.32.32 0 0 0-.237-.095.32.32 0 0 0-.238.095.32.32 0 0 0-.096.238v.667q0 .141.096.237A.32.32 0 0 0 2.667 5ZM4 6.332a.32.32 0 0 0 .237-.095.32.32 0 0 0 .096-.238v-.667a.32.32 0 0 0-.096-.237A.32.32 0 0 0 4 4.999a.32.32 0 0 0-.237.096.32.32 0 0 0-.096.237V6q0 .142.096.238A.32.32 0 0 0 4 6.332m0-2a.32.32 0 0 0 .237-.095.32.32 0 0 0 .096-.238.32.32 0 0 0-.096-.238A.32.32 0 0 0 4 3.666a.32.32 0 0 0-.237.095.32.32 0 0 0-.096.238q0 .141.096.238A.32.32 0 0 0 4 4.332m1.333 2a.32.32 0 0 0 .238-.095.32.32 0 0 0 .096-.238.32.32 0 0 0-.096-.237.32.32 0 0 0-.238-.096.32.32 0 0 0-.237.095A.32.32 0 0 0 5 6q0 .142.096.238a.32.32 0 0 0 .237.095Zm0-1.333a.32.32 0 0 0 .238-.096.32.32 0 0 0 .096-.237v-.667a.32.32 0 0 0-.096-.238.32.32 0 0 0-.238-.095.32.32 0 0 0-.237.095A.32.32 0 0 0 5 4v.667q0 .141.096.237A.32.32 0 0 0 5.333 5ZM2 7.332a.64.64 0 0 1-.47-.196.64.64 0 0 1-.197-.47V2.94a.66.66 0 0 1 .192-.467L3.142.857a.65.65 0 0 1 .466-.191H6q.275 0 .47.195a.64.64 0 0 1 .197.471v5.334q0 .275-.196.47A.64.64 0 0 1 6 7.332z"], Search: ["M3.275 5.55q-.95 0-1.613-.662A2.2 2.2 0 0 1 1 3.275q0-.95.662-1.613Q2.325 1 3.275 1t1.613.662q.662.663.662 1.613 0 .375-.107.694a2 2 0 0 1-.289.558l1.83 1.834q.123.13.124.311a.4.4 0 0 1-.13.307.42.42 0 0 1-.308.124.42.42 0 0 1-.309-.124L4.537 5.154a2 2 0 0 1-.568.289 2.2 2.2 0 0 1-.694.107m0-.883q.582 0 .987-.405c.405-.405.405-.599.405-.987s-.135-.717-.405-.987a1.34 1.34 0 0 0-.987-.405q-.582 0-.987.405c-.405.405-.405.599-.405.987s.135.717.405.987.599.405.987.405"], Select: ["M.444 1.778h7.111l.06-.004a.445.445 0 0 0-.059-.885H.444l-.06.004a.444.444 0 0 0 .06.885m0 2.37h4.741l.06-.004a.445.445 0 0 0-.059-.884H.444l-.06.004a.444.444 0 0 0 .06.884M2.815 5.63H.445l-.06.004a.444.444 0 0 0 .059.884h2.37l.06-.004a.444.444 0 0 0-.059-.884m4.969-2.307a.446.446 0 0 0-.61.152L5.689 5.95l-.782-.783-.05-.043a.445.445 0 0 0-.579.672l1.185 1.185.049.043c.206.154.509.1.646-.128l1.778-2.963.028-.054a.444.444 0 0 0-.18-.556"], Server: ["M3.468 1.92a.48.48 0 0 0-.354.146.48.48 0 0 0-.146.354q0 .21.146.354a.48.48 0 0 0 .354.146.48.48 0 0 0 .354-.146.48.48 0 0 0 .146-.354.48.48 0 0 0-.146-.354.48.48 0 0 0-.354-.146m0 3.47a.48.48 0 0 0-.354.145.48.48 0 0 0-.146.354q0 .21.146.354a.48.48 0 0 0 .354.146.48.48 0 0 0 .354-.146.48.48 0 0 0 .146-.354.48.48 0 0 0-.146-.354.48.48 0 0 0-.354-.146ZM2.279.852h5.378a.373.373 0 0 1 .38.383v2.36a.4.4 0 0 1-.11.28.36.36 0 0 1-.27.112H2.279a.36.36 0 0 1-.27-.112.4.4 0 0 1-.109-.28v-2.36a.373.373 0 0 1 .38-.383Zm0 3.468h5.378q.16 0 .27.113a.4.4 0 0 1 .109.279v2.36a.37.37 0 0 1-.11.272.37.37 0 0 1-.27.11H2.28a.37.37 0 0 1-.27-.11.37.37 0 0 1-.109-.271v-2.36q0-.166.11-.28a.36.36 0 0 1 .27-.112Z"], Shield: ["M4 7.316a.7.7 0 0 1-.208-.034A3.37 3.37 0 0 1 2 5.895a3.9 3.9 0 0 1-.667-2.18V2.142q0-.21.121-.375a.7.7 0 0 1 .313-.242l2-.75a.7.7 0 0 1 .466 0l2 .75q.192.075.313.242.12.166.12.375v1.575A3.9 3.9 0 0 1 6 5.896a3.37 3.37 0 0 1-1.792 1.387.7.7 0 0 1-.208.034Z"], ShieldSlash: ["M7.719 2.143V3.7a3.6 3.6 0 0 1-.147 1.022.41.41 0 0 1-.305.288.5.5 0 0 1-.213-.004.4.4 0 0 1-.203-.119L3.645 1.67a.37.37 0 0 1-.112-.265.4.4 0 0 1 .063-.212.37.37 0 0 1 .184-.146L4.719.7a.77.77 0 0 1 .53 0l1.977.74a.77.77 0 0 1 .356.275.72.72 0 0 1 .137.429ZM6.525 6.518a2.8 2.8 0 0 1-.603.486 3.4 3.4 0 0 1-.704.324.7.7 0 0 1-.234.038q-.044 0-.234-.04a3.43 3.43 0 0 1-1.822-1.411A3.95 3.95 0 0 1 2.25 3.7V2.243l-.608-.61a.33.33 0 0 1-.096-.243.334.334 0 0 1 .342-.34.33.33 0 0 1 .243.097l5.706 5.706a.33.33 0 0 1 .098.244.335.335 0 0 1-.342.342.33.33 0 0 1-.244-.097z"], Signal: ["M1.667 7a.64.64 0 0 1-.471-.196.64.64 0 0 1-.196-.47.64.64 0 0 1 .196-.471.64.64 0 0 1 .47-.196q.275 0 .472.196.195.195.195.47a.64.64 0 0 1-.196.471.64.64 0 0 1-.47.196m4.5 0a.47.47 0 0 1-.363-.158.65.65 0 0 1-.17-.375 4.6 4.6 0 0 0-.438-1.513 4.68 4.68 0 0 0-2.15-2.15 4.6 4.6 0 0 0-1.513-.437.65.65 0 0 1-.375-.171A.47.47 0 0 1 1 1.833a.46.46 0 0 1 .15-.354q.15-.137.358-.12a5.6 5.6 0 0 1 1.921.52 5.7 5.7 0 0 1 1.58 1.113q.683.683 1.112 1.579t.52 1.92a.46.46 0 0 1-.12.359.46.46 0 0 1-.354.15m-2 0a.5.5 0 0 1-.359-.146.66.66 0 0 1-.191-.354 2.5 2.5 0 0 0-.263-.754 2.7 2.7 0 0 0-.47-.63 2.7 2.7 0 0 0-.63-.47 2.5 2.5 0 0 0-.754-.263.66.66 0 0 1-.354-.191A.5.5 0 0 1 1 3.833q0-.216.15-.358.15-.141.358-.108.609.083 1.138.354a3.74 3.74 0 0 1 1.633 1.633q.27.53.354 1.138a.4.4 0 0 1-.108.358.47.47 0 0 1-.358.15"], Skull: ["M7.45 3.25A3.464 3.464 0 0 0 3.98 0 3.465 3.465 0 0 0 .53 3.28L.38 5.93c-.01.14.11.26.25.26h1.33l.19 1.49c.02.18.18.32.36.32h.41v-.73c-.01-.2.16-.36.36-.36.18 0 .34.14.36.32V8l.73-.01v-.72c0-.2.16-.37.36-.37.19 0 .34.14.36.32l.01.04v.73h.4c.19 0 .34-.14.36-.32l.18-1.5 1.33-.01c.14 0 .26-.12.25-.26zM2.36 5.09c-.5.01-.91-.4-.91-.9s.4-.91.9-.91c.51-.01.91.4.92.9 0 .5-.41.91-.91.91m3.27-.01c-.5 0-.91-.4-.91-.9 0-.51.4-.91.9-.92.51 0 .91.41.92.91 0 .5-.41.91-.91.91"], SpacebridgeDisabled: ["M6.903 1.076a.4.4 0 0 0-.558 0L5.112 2.318C3.8 1.165 2.257.73 1.494 1.493c-.771.771-.32 2.305.86 3.618L1.113 6.36a.4.4 0 0 0 0 .559c.15.15.399.15.558 0l5.232-5.294a.386.386 0 0 0 0-.559zm-2.81 2.27c-.728-.647-1.393-1.02-1.57-.833-.178.177.186.85.851 1.57l-.461.46c-.905-1.02-1.233-2.119-.86-2.491.372-.373 1.472-.063 2.51.833z", "M5.6 4.073c.523.807.665 1.57.372 1.862-.301.302-1.073.16-1.906-.38l-.577.576c1.17.806 2.377 1.02 3.033.372.638-.647.426-1.853-.364-2.988z", "m4.536 5.137.62-.611c.32.46.47.824.346.957-.142.124-.496-.018-.966-.346"], SpacebridgeEnabled: ["m5.578 1.87.745-.744c.15-.151.15-.4 0-.559a.4.4 0 0 0-.56 0l-.744.745a.4.4 0 0 0 0 .559c.15.15.399.15.559 0Z", "m6.145 3.529.169-.169a.386.386 0 0 0 0-.558.39.39 0 0 0-.55 0l-.107.106-.266-.292C4.026 1.25 2.314.682 1.49 1.507c-.639.639-.426 1.836.354 2.98l-.54.54a.4.4 0 0 0 0 .56c.16.15.407.15.558 0l.47-.47c.088.096.177.185.274.282h.001C3.973 6.767 5.684 7.334 6.5 6.518c.647-.647.434-1.844-.355-2.988Zm-.204 2.43c-.408.407-1.685-.018-2.775-1.118-1.1-1.09-1.526-2.367-1.118-2.784.408-.408 1.685.018 2.785 1.117.097.098.186.186.266.284l-.461.461-.133-.142-.133-.142c-.825-.816-1.65-1.312-1.862-1.108-.204.204.301 1.037 1.117 1.853s1.65 1.321 1.853 1.109c.133-.125-.018-.497-.337-.95l.435-.443c.523.807.665 1.561.363 1.863", "M1.676 7.448a.4.4 0 0 1 0-.558l.745-.745a.4.4 0 0 1 .558 0 .4.4 0 0 1 0 .558l-.744.745c-.16.151-.408.16-.559 0"], SplitBranch: ["M1.442 4.442a.43.43 0 0 1-.313-.13A.43.43 0 0 1 1 4q0-.184.129-.313a.43.43 0 0 1 .313-.129h2.204l1.502-1.502h-.274a.43.43 0 0 1-.313-.128.43.43 0 0 1-.129-.313q0-.184.129-.313a.43.43 0 0 1 .313-.129h1.333q.184 0 .313.129t.129.313v1.333a.43.43 0 0 1-.129.313.43.43 0 0 1-.313.129.43.43 0 0 1-.313-.129.43.43 0 0 1-.128-.313v-.274l-1.51 1.51a.87.87 0 0 1-.623.258zm3.432 2.385a.43.43 0 0 1-.313-.129.43.43 0 0 1-.129-.313q0-.184.129-.313a.43.43 0 0 1 .313-.129h.265L4.6 5.414a.43.43 0 0 1-.133-.315.43.43 0 0 1 .133-.315.44.44 0 0 1 .317-.136.43.43 0 0 1 .317.131l.53.538v-.265q0-.184.13-.313a.43.43 0 0 1 .312-.129q.184 0 .313.129t.129.313v1.333a.43.43 0 0 1-.129.313.43.43 0 0 1-.313.129z"], StatusActivating: ["M3.059 5.179h-.937a.38.38 0 0 1-.355-.21.39.39 0 0 1 .015-.418L4.276.682a.38.38 0 0 1 .227-.177.46.46 0 0 1 .512.189q.087.127.066.285l-.264 2.242h1.08q.257 0 .367.228a.38.38 0 0 1-.05.43l-2.706 3.43a.425.425 0 0 1-.517.122.43.43 0 0 1-.21-.193.4.4 0 0 1-.04-.275z"], StatusConfiguring: ["M3.443 7.423a.43.43 0 0 1-.284-.106.43.43 0 0 1-.151-.268l-.088-.676a3 3 0 0 1-.191-.094 1 1 0 0 1-.185-.124l-.638.264a.4.4 0 0 1-.309.013.4.4 0 0 1-.233-.198L.801 5.223a.44.44 0 0 1-.05-.296.4.4 0 0 1 .16-.248l.528-.407-.008-.114a1.4 1.4 0 0 1 0-.214q.005-.056.008-.116l-.52-.391a.38.38 0 0 1-.158-.254.46.46 0 0 1 .051-.301l.56-.978a.43.43 0 0 1 .533-.185l.603.245q.093-.069.207-.13a6 6 0 0 1 .21-.108l.083-.659A.4.4 0 0 1 3.155.8a.44.44 0 0 1 .288-.107h1.114q.158 0 .288.107.129.106.147.268l.08.67.208.108q.103.056.2.127l.61-.253a.4.4 0 0 1 .304-.011q.15.055.237.196l.56.981a.45.45 0 0 1 .049.3.4.4 0 0 1-.159.252l-.55.417q.01.054.012.11a4 4 0 0 1-.002.2l-.006.12.524.395a.423.423 0 0 1 .12.552l-.556 1a.4.4 0 0 1-.239.198.42.42 0 0 1-.314-.013l-.631-.264a3 3 0 0 1-.178.117q-.09.054-.181.093l-.088.687a.43.43 0 0 1-.152.268.43.43 0 0 1-.283.106zm.536-2.167q.505 0 .856-.35.35-.352.35-.856 0-.505-.35-.856a1.16 1.16 0 0 0-.856-.35 1.17 1.17 0 0 0-.854.35 1.16 1.16 0 0 0-.352.856q0 .504.352.855.353.35.854.35Z"], StatusConnected: ["M.833 1.333a.5.5 0 0 1 .5-.5 5.833 5.833 0 0 1 5.834 5.834.5.5 0 0 1-1 0 4.833 4.833 0 0 0-4.834-4.834.5.5 0 0 1-.5-.5m0 2a.5.5 0 0 1 .5-.5 3.833 3.833 0 0 1 3.834 3.834.5.5 0 0 1-1 0 2.833 2.833 0 0 0-2.834-2.834.5.5 0 0 1-.5-.5m.5 1.5a.5.5 0 0 0 0 1c.46 0 .834.373.834.834a.5.5 0 1 0 1 0 1.834 1.834 0 0 0-1.834-1.834"], StatusDeactivated: ["M6.286 1.714a.54.54 0 0 0-.762 0L4 3.238 2.476 1.714a.539.539 0 0 0-.762.762L3.238 4 1.714 5.524a.539.539 0 0 0 .762.762L4 4.762l1.524 1.524a.539.539 0 1 0 .762-.762L4.762 4l1.524-1.524a.54.54 0 0 0 0-.762"], StatusInventory: ["M1.866 1.081a.5.5 0 0 1 .432-.248H5.7a.5.5 0 0 1 .432.248l.851 1.459a.5.5 0 0 1 .068.252v3.875a.5.5 0 0 1-.5.5H1.447a.5.5 0 0 1-.5-.5V2.792a.5.5 0 0 1 .068-.252zm.719.752-.39.667H3.5v-.667zm1.914 0V2.5h1.304l-.389-.667H4.5ZM6.052 3.5H1.947v2.667h4.105zm-.831 2H4.18v-1h1.04v1Z"], StatusPaused: ["M2.667 1.333A.667.667 0 0 0 2 2v4a.667.667 0 0 0 1.333 0V2a.667.667 0 0 0-.666-.667m2.666 0A.667.667 0 0 0 4.667 2v4A.667.667 0 1 0 6 6V2a.667.667 0 0 0-.667-.667"], StatusReady: ["M4 2.09a1.91 1.91 0 1 0 0 3.82 1.91 1.91 0 0 0 0-3.82M1 4a3 3 0 1 1 6 0 3 3 0 0 1-6 0"], StatusShipped: ["M2.208 7.217a1.15 1.15 0 0 1-.844-.348 1.15 1.15 0 0 1-.347-.844H.875a.47.47 0 0 1-.347-.144.47.47 0 0 1-.145-.346q0-.201.145-.348a.47.47 0 0 1 .347-.145h.708a1.1 1.1 0 0 1 .285-.15 1 1 0 0 1 .34-.059q.18 0 .34.059t.285.15h1.692l.75-3.075H2.283a.47.47 0 0 1-.347-.144.47.47 0 0 1-.144-.346q0-.202.144-.348a.47.47 0 0 1 .347-.146H5.9q.225 0 .383.19a.45.45 0 0 1 .1.419l-.25 1.016h.192a1 1 0 0 1 .441.104q.21.105.359.296l.533.775a.95.95 0 0 1 .15.817l-.291 1.058a.48.48 0 0 1-.467.367H6.9q0 .5-.348.846-.347.346-.844.346a1.15 1.15 0 0 1-.844-.348 1.15 1.15 0 0 1-.347-.844H3.4q0 .5-.348.846-.347.346-.844.346m3.467-2.775h1.092l.05-.15-.492-.7h-.432zm-1.125.475.054-.212.13-.513.085-.37q.039-.171.073-.289l.05-.21.255-1.029.053-.21.025-.117-.75 3.075zM.594 4.683a.48.48 0 0 1-.348-.144.47.47 0 0 1-.146-.346q0-.201.144-.347A.47.47 0 0 1 .591 3.7h1.065q.202 0 .348.144a.47.47 0 0 1 .146.346q0 .201-.144.347a.47.47 0 0 1-.347.146zm.6-1.383a.48.48 0 0 1-.348-.144A.47.47 0 0 1 .7 2.81a.48.48 0 0 1 .144-.348.47.47 0 0 1 .347-.145h1.357q.202 0 .348.144a.47.47 0 0 1 .146.346q0 .201-.145.347a.47.47 0 0 1-.347.146zm1.013 2.933a.205.205 0 0 0 .21-.207.205.205 0 0 0-.207-.21.205.205 0 0 0-.21.208.205.205 0 0 0 .207.21Zm3.5 0a.205.205 0 0 0 .21-.207.205.205 0 0 0-.207-.21.205.205 0 0 0-.21.208.205.205 0 0 0 .207.21Z"], StatusTesting: ["M4 1a3 3 0 1 0 0 6 3 3 0 0 0 0-6M2.09 4A1.91 1.91 0 0 1 4 2.09v3.82A1.91 1.91 0 0 1 2.09 4"], SubmitTicket: ["M4.719 4.713a.34.34 0 0 0 .245-.105.34.34 0 0 0 .105-.245.34.34 0 0 0-.105-.246.34.34 0 0 0-.245-.104.34.34 0 0 0-.246.104.34.34 0 0 0-.104.246q0 .141.104.245t.246.105m0-1.033a.26.26 0 0 0 .17-.066.3.3 0 0 0 .102-.174.5.5 0 0 1 .075-.175q.054-.082.18-.207.248-.248.332-.404a.75.75 0 0 0 .085-.361.79.79 0 0 0-.262-.614q-.262-.236-.688-.236a1 1 0 0 0-.501.125.93.93 0 0 0-.358.356.18.18 0 0 0-.007.175.25.25 0 0 0 .14.134.23.23 0 0 0 .18.008.3.3 0 0 0 .146-.117.5.5 0 0 1 .176-.161.5.5 0 0 1 .224-.053.47.47 0 0 1 .326.111.38.38 0 0 1 .124.3.4.4 0 0 1-.067.221q-.067.105-.233.266-.227.195-.296.31a.74.74 0 0 0-.088.314.21.21 0 0 0 .06.173q.071.075.18.075M2.736 5.814a.73.73 0 0 1-.536-.222.73.73 0 0 1-.222-.536V1.104A.73.73 0 0 1 2.2.567a.73.73 0 0 1 .536-.222H6.69a.73.73 0 0 1 .536.222.73.73 0 0 1 .222.537v3.952a.73.73 0 0 1-.222.536.73.73 0 0 1-.536.222zM1.311 7.24a.73.73 0 0 1-.536-.222.73.73 0 0 1-.222-.536V2.15q0-.16.11-.27a.37.37 0 0 1 .27-.11q.158 0 .269.11.11.11.11.27v4.33h4.33q.16 0 .27.11a.37.37 0 0 1 .11.27.37.37 0 0 1-.11.27.37.37 0 0 1-.27.11h-4.33Z"], SwapSIM: ["M3.998 7.728a3.6 3.6 0 0 1-1.717-.417A3.75 3.75 0 0 1 .99 6.196v.503a.35.35 0 0 1-.105.258.35.35 0 0 1-.258.105.35.35 0 0 1-.259-.105.35.35 0 0 1-.104-.258v-1.35q0-.159.11-.27a.37.37 0 0 1 .269-.109h1.349a.35.35 0 0 1 .258.105.35.35 0 0 1 .105.258.35.35 0 0 1-.105.259.35.35 0 0 1-.258.105H1.53q.4.588 1.048.945A2.9 2.9 0 0 0 3.998 7a2.9 2.9 0 0 0 2.006-.766 2.93 2.93 0 0 0 .975-1.903.34.34 0 0 1 .129-.229.4.4 0 0 1 .255-.086.4.4 0 0 1 .26.092.24.24 0 0 1 .093.228q-.064.718-.381 1.336a3.78 3.78 0 0 1-1.963 1.794 3.6 3.6 0 0 1-1.374.262M4 1a2.9 2.9 0 0 0-2.006.766 2.93 2.93 0 0 0-.975 1.902.34.34 0 0 1-.129.23.4.4 0 0 1-.255.086.38.38 0 0 1-.26-.096.26.26 0 0 1-.091-.236 3.6 3.6 0 0 1 .38-1.325A3.8 3.8 0 0 1 2.621.535 3.6 3.6 0 0 1 4 .272a3.6 3.6 0 0 1 1.719.419q.785.419 1.289 1.113v-.503a.35.35 0 0 1 .106-.258.36.36 0 0 1 .26-.105.35.35 0 0 1 .258.105.35.35 0 0 1 .104.258v1.35a.37.37 0 0 1-.11.27.37.37 0 0 1-.269.109H6.008a.35.35 0 0 1-.258-.105.35.35 0 0 1-.105-.258q0-.154.105-.259a.35.35 0 0 1 .258-.105h.462a3 3 0 0 0-1.058-.948A2.9 2.9 0 0 0 4 1", "M3.148 5.453a.33.33 0 0 1-.33-.33V3.341a.33.33 0 0 1 .097-.233l.56-.56a.33.33 0 0 1 .233-.097h1.048a.33.33 0 0 1 .33.33v2.342a.33.33 0 0 1-.33.33z"], Sync: ["M1.5 4.02q0 .47.177.912t.552.818l.104.104V5.25q0-.177.12-.297t.297-.12c.177 0 .217.04.297.12q.12.12.12.297v1.667q0 .177-.12.297a.4.4 0 0 1-.297.12H1.083a.4.4 0 0 1-.297-.12.4.4 0 0 1-.12-.297q0-.177.12-.297t.297-.12h.73l-.167-.146a2.63 2.63 0 0 1-.76-1.094 3.7 3.7 0 0 1-.22-1.24 3.34 3.34 0 0 1 1.844-3 .32.32 0 0 1 .308-.01.38.38 0 0 1 .213.24.46.46 0 0 1-.005.313.45.45 0 0 1-.203.24 2.55 2.55 0 0 0-.964.921A2.44 2.44 0 0 0 1.5 4.021Zm5-.04q0-.47-.177-.912a2.4 2.4 0 0 0-.552-.818l-.104-.104v.604q0 .177-.12.297a.4.4 0 0 1-.297.12.4.4 0 0 1-.297-.12.4.4 0 0 1-.12-.297V1.083q0-.177.12-.297t.297-.12h1.667q.177 0 .297.12t.12.297-.12.297a.4.4 0 0 1-.297.12h-.73l.167.146a3.24 3.24 0 0 1 .98 2.333 3.34 3.34 0 0 1-1.844 3 .32.32 0 0 1-.308.01.38.38 0 0 1-.213-.239.46.46 0 0 1 .005-.312.44.44 0 0 1 .203-.24q.604-.334.964-.922c.36-.588.359-.825.359-1.297Z"], System: ["M1.673 3.407a3 3 0 0 1-.166-.08 1 1 0 0 1-.156-.098l-.218.066a.39.39 0 0 1-.436-.17l-.08-.137a.37.37 0 0 1-.047-.253.36.36 0 0 1 .127-.224l.165-.14a1 1 0 0 1 0-.363l-.165-.144a.37.37 0 0 1-.08-.47l.079-.14a.38.38 0 0 1 .442-.17l.213.066a1 1 0 0 1 .155-.098q.078-.042.166-.08l.044-.217A.38.38 0 0 1 2.091.45h.158q.138 0 .24.087a.4.4 0 0 1 .13.222l.044.213q.088.038.166.08.078.04.155.098l.214-.066a.39.39 0 0 1 .446.17l.076.131q.067.12.046.257a.36.36 0 0 1-.127.227l-.165.14a1 1 0 0 1 0 .362l.165.144a.37.37 0 0 1 .08.47l-.084.145a.37.37 0 0 1-.432.165l-.219-.066a1 1 0 0 1-.155.099 2 2 0 0 1-.165.079l-.044.217a.38.38 0 0 1-.375.305h-.158a.36.36 0 0 1-.24-.087.4.4 0 0 1-.13-.222zm.494-.586a.6.6 0 0 0 .446-.186.6.6 0 0 0 .186-.447.6.6 0 0 0-.186-.446.6.6 0 0 0-.447-.184.6.6 0 0 0-.445.185.6.6 0 0 0-.184.445.6.6 0 0 0 .185.447.6.6 0 0 0 .445.186M4.82 7.113a1.7 1.7 0 0 1-.33-.145 1.5 1.5 0 0 1-.288-.214l-.316.105a.44.44 0 0 1-.536-.198l-.09-.157a.45.45 0 0 1-.058-.303.44.44 0 0 1 .15-.27l.25-.218a1.9 1.9 0 0 1 0-.732l-.25-.221a.444.444 0 0 1-.093-.568l.09-.157a.44.44 0 0 1 .537-.199l.316.105q.13-.125.287-.214.156-.09.331-.145l.075-.341a.444.444 0 0 1 .442-.359h.2a.444.444 0 0 1 .442.358l.074.342a1.6 1.6 0 0 1 .613.359l.317-.105a.44.44 0 0 1 .537.198l.09.157a.45.45 0 0 1 .056.303.44.44 0 0 1-.15.27l-.25.217a1.9 1.9 0 0 1 0 .732l.25.222a.42.42 0 0 1 .15.268.44.44 0 0 1-.056.3l-.09.157a.44.44 0 0 1-.537.199l-.317-.105a1.5 1.5 0 0 1-.613.359l-.075.341a.444.444 0 0 1-.441.359h-.2a.444.444 0 0 1-.442-.358zm.617-.822a.9.9 0 0 0 .666-.275.9.9 0 0 0 .272-.668.9.9 0 0 0-.273-.669.9.9 0 0 0-.665-.275.9.9 0 0 0-.669.275.9.9 0 0 0-.275.668.9.9 0 0 0 .275.669.9.9 0 0 0 .669.275"], Tag: ["M3.725 7.333a.67.67 0 0 1-.475-.2L.867 4.75a.6.6 0 0 1-.146-.22.69.69 0 0 1 .146-.722L3.8.867a.7.7 0 0 1 .475-.2h2.392q.275 0 .47.195a.64.64 0 0 1 .196.471v2.392a.66.66 0 0 1-.191.467L4.2 7.133a.67.67 0 0 1-.475.2m2.108-4.666a.48.48 0 0 0 .354-.146.48.48 0 0 0 .146-.354.48.48 0 0 0-.146-.354.48.48 0 0 0-.354-.146.48.48 0 0 0-.354.145.48.48 0 0 0-.146.355q0 .209.146.354a.48.48 0 0 0 .354.146"], TagOutbound: ["m3.031 1.459.398-.402.006 1.418.004.046a.31.31 0 0 0 .306.262l.045-.003a.31.31 0 0 0 .262-.307l-.005-1.418.401.398.043.036a.31.31 0 0 0 .394-.037l.036-.043a.31.31 0 0 0-.037-.394L3.94.078 3.913.057 3.871.033 3.833.017l-.04-.011-.041-.005a.3.3 0 0 0-.123.018l-.04.018-.031.02-.042.036-.924.931-.03.034c-.227.291.19.682.469.401M2.85 4.21a.32.32 0 0 0-.33.33c0 .19.15.34.33.34s.33-.16.33-.34-.15-.33-.33-.33", "M6.22 5.44 4.13 3.37a.87.87 0 0 0-.59-.24H2.26c-.46.01-.82.38-.82.84v1.28c0 .21.09.43.25.58L3.78 7.9c.13.13.34.13.47 0l1.97-1.99c.13-.13.13-.34 0-.47M4.01 7.19 2.16 5.36a.17.17 0 0 1-.05-.12L2.1 3.96c0-.09.08-.16.17-.16h1.31c.03.01.06.02.08.04l1.85 1.84z"], TestMode: ["M4 1a3 3 0 1 0 0 6 3 3 0 0 0 0-6M2.09 4A1.91 1.91 0 0 1 4 2.09v3.82A1.91 1.91 0 0 1 2.09 4"], Transfer: ["M.537 7.138q.195.195.47.195h4q.275 0 .471-.195a.64.64 0 0 0 .196-.471V6.16a.75.75 0 0 0-.75-.75h-.956a.937.937 0 1 1 0-1.875h.956a.75.75 0 0 0 .75-.75V1.333a.64.64 0 0 0-.196-.47.64.64 0 0 0-.47-.196H2.616a.66.66 0 0 0-.467.191L.533 2.475a.65.65 0 0 0-.192.467v3.725q0 .275.196.47Z", "M6.27 4.913H3.973a.43.43 0 0 1-.313-.129.43.43 0 0 1-.129-.313q0-.183.13-.313a.43.43 0 0 1 .312-.128H6.27l-.279-.283a.4.4 0 0 1-.124-.305q0-.18.129-.313A.4.4 0 0 1 6.304 3q.185 0 .314.13l1.028 1.028a.43.43 0 0 1 .133.313.43.43 0 0 1-.133.314L6.614 5.818a.42.42 0 0 1-.307.127.43.43 0 0 1-.315-.132.42.42 0 0 1-.125-.308.42.42 0 0 1 .125-.309l.28-.283Z"], Trash: ["M2.333 7a.64.64 0 0 1-.47-.196.64.64 0 0 1-.196-.47V2a.32.32 0 0 1-.238-.096.32.32 0 0 1-.096-.237q0-.142.096-.238a.32.32 0 0 1 .238-.096H3q0-.141.096-.237A.32.32 0 0 1 3.333 1h1.334q.141 0 .237.096A.32.32 0 0 1 5 1.333h1.333q.142 0 .238.096a.32.32 0 0 1 .096.238.32.32 0 0 1-.096.237.32.32 0 0 1-.238.096v4.333a.64.64 0 0 1-.196.471.64.64 0 0 1-.47.196zm1-1.333a.32.32 0 0 0 .238-.096.32.32 0 0 0 .096-.238V3a.32.32 0 0 0-.096-.237.32.32 0 0 0-.238-.096.32.32 0 0 0-.237.096A.32.32 0 0 0 3 3v2.333q0 .142.096.238a.32.32 0 0 0 .237.096m1.334 0a.32.32 0 0 0 .237-.096A.32.32 0 0 0 5 5.333V3a.32.32 0 0 0-.096-.237.32.32 0 0 0-.237-.096.32.32 0 0 0-.238.096.32.32 0 0 0-.096.237v2.333q0 .142.096.238a.32.32 0 0 0 .238.096"], Type: ["M2.7 1.5c-.02-.05-.05-.07-.1-.07h-.71c-.05 0-.08.02-.1.07L.01 6.42c-.02.04 0 .07.05.07H.8c.05 0 .09-.03.1-.07l.35-.99h1.96l.34.99c.02.04.05.07.1.07h.76c.05 0 .06-.03.05-.07zM1.52 4.65l.7-1.96h.02l.69 1.96zm6.13-1.53c-.23-.2-.63-.3-1.19-.3-.31 0-.57.03-.77.1-.21.06-.39.15-.54.25-.04.02-.04.06-.02.1l.29.49c.02.04.06.05.1.01.09-.07.2-.12.33-.17.14-.05.31-.07.52-.07.31 0 .52.04.64.14q.18.135.18.45v.17c0 .03-.02.05-.05.05h-.75q-.69 0-1.08.27c-.27.19-.4.48-.4.87a1 1 0 0 0 .37.82c.11.09.24.16.39.2.15.05.31.07.48.07.26 0 .48-.04.65-.11.18-.08.31-.18.4-.31v.27c0 .04.03.07.08.07h.64c.05 0 .08-.03.08-.07V4.07c0-.44-.12-.75-.35-.95m-.46 2.16c0 .21-.07.37-.21.47-.14.09-.35.14-.61.14-.43 0-.64-.14-.64-.44 0-.17.07-.29.19-.37.13-.08.33-.12.61-.12h.61c.03 0 .05.02.05.05z"], Unlock: ["M4 5.667q.275 0 .47-.196A.64.64 0 0 0 4.668 5a.64.64 0 0 0-.196-.47A.64.64 0 0 0 4 4.332a.64.64 0 0 0-.47.196.64.64 0 0 0-.197.471q0 .275.196.47.196.197.471.197ZM2 7.333a.64.64 0 0 1-.47-.196.64.64 0 0 1-.197-.47V3.333q0-.275.196-.47A.64.64 0 0 1 2 2.666h2.333V2q0-.691.488-1.18A1.6 1.6 0 0 1 6 .334a1.6 1.6 0 0 1 1.088.405q.462.403.554.995a.2.2 0 0 1-.075.188.34.34 0 0 1-.234.078.43.43 0 0 1-.233-.058.33.33 0 0 1-.133-.192 1.06 1.06 0 0 0-.354-.533A.93.93 0 0 0 6 1a.96.96 0 0 0-.708.292A.96.96 0 0 0 5 2v.667h1q.275 0 .47.196a.64.64 0 0 1 .197.47v3.334q0 .275-.196.47A.64.64 0 0 1 6 7.333z"], UploadTray: ["M1.53 7.418a.9.9 0 0 1-.67-.277.9.9 0 0 1-.278-.67v-.777q0-.2.137-.337a.46.46 0 0 1 .337-.137q.2 0 .337.137a.46.46 0 0 1 .137.337v.776h4.94v-.776q0-.2.137-.337a.46.46 0 0 1 .337-.137q.2 0 .337.137a.46.46 0 0 1 .137.337v.776a.9.9 0 0 1-.277.67.9.9 0 0 1-.67.278zM3.526 2.4l-.724.724a.47.47 0 0 1-.67-.005.5.5 0 0 1-.14-.333.44.44 0 0 1 .14-.333L3.665.916A.4.4 0 0 1 3.82.814a.5.5 0 0 1 .358 0 .4.4 0 0 1 .155.102L5.87 2.453a.44.44 0 0 1 .136.332.48.48 0 0 1-.472.478.45.45 0 0 1-.337-.139L4.474 2.4v2.763a.46.46 0 0 1-.137.337.46.46 0 0 1-.337.137.46.46 0 0 1-.337-.137.46.46 0 0 1-.137-.337z"], User: ["M4 4q-.55 0-.942-.392a1.28 1.28 0 0 1-.391-.941q0-.55.391-.942.392-.392.942-.392c.55 0 .68.13.942.392q.39.392.391.942 0 .55-.391.941A1.28 1.28 0 0 1 4 4M1.333 6v-.267q0-.283.146-.52a.97.97 0 0 1 .388-.363 5 5 0 0 1 1.05-.387 4.6 4.6 0 0 1 2.166 0q.534.129 1.05.387.241.125.388.363a1 1 0 0 1 .146.52V6q0 .275-.196.47A.64.64 0 0 1 6 6.668H2a.64.64 0 0 1-.47-.196A.64.64 0 0 1 1.332 6Z"], Visible: ["M4 5.333q.624 0 1.063-.437A1.45 1.45 0 0 0 5.5 3.833q0-.624-.438-1.062A1.45 1.45 0 0 0 4 2.333q-.625 0-1.063.438A1.45 1.45 0 0 0 2.5 3.833q0 .625.438 1.063.437.437 1.062.437m0-.6a.87.87 0 0 1-.638-.262.87.87 0 0 1-.262-.638q0-.375.262-.637A.87.87 0 0 1 4 2.933a.87.87 0 0 1 .638.263.87.87 0 0 1 .262.637.87.87 0 0 1-.263.638.87.87 0 0 1-.637.262m0 1.6q-1.116 0-2.038-.6A4.3 4.3 0 0 1 .508 4.15a.7.7 0 0 1-.083-.317.64.64 0 0 1 .083-.316 4.3 4.3 0 0 1 1.454-1.584q.922-.6 2.038-.6 1.117 0 2.037.6a4.3 4.3 0 0 1 1.455 1.584.7.7 0 0 1 .083.316.64.64 0 0 1-.083.317 4.3 4.3 0 0 1-1.455 1.583q-.92.6-2.037.6"], Warning: ["M.933 6.8a.3.3 0 0 1-.266-.15.25.25 0 0 1-.038-.15.4.4 0 0 1 .046-.158l3.067-5.117a.25.25 0 0 1 .112-.108.34.34 0 0 1 .292 0 .25.25 0 0 1 .112.108l3.067 5.117a.4.4 0 0 1 .046.158.25.25 0 0 1-.038.15.34.34 0 0 1-.108.108.3.3 0 0 1-.158.042zm3.065-1a.294.294 0 0 0 .302-.298.294.294 0 0 0-.298-.302.294.294 0 0 0-.302.298.294.294 0 0 0 .298.302m0-1a.3.3 0 0 0 .215-.086A.3.3 0 0 0 4.3 4.5v-1a.3.3 0 0 0-.086-.214.3.3 0 0 0-.212-.086.3.3 0 0 0-.214.086.3.3 0 0 0-.088.214v1q0 .127.086.214a.3.3 0 0 0 .212.086"], ZeroData: ["M4 7.333q-.691 0-1.3-.262a3.4 3.4 0 0 1-1.058-.713q-.45-.45-.713-1.058A3.25 3.25 0 0 1 .667 4q0-.691.262-1.3.263-.609.713-1.058T2.7.929A3.25 3.25 0 0 1 4 .667q.691 0 1.3.262.608.263 1.058.713T7.071 2.7 7.333 4t-.262 1.3a3.4 3.4 0 0 1-.713 1.058q-.45.45-1.058.713a3.25 3.25 0 0 1-1.3.262m-.333-1.666h.666q.275 0 .471-.196A.64.64 0 0 0 5 5V3a.64.64 0 0 0-.196-.47.64.64 0 0 0-.47-.197h-.667a.64.64 0 0 0-.471.196A.64.64 0 0 0 3 3v2q0 .275.196.47a.64.64 0 0 0 .47.197Zm0-2.667h.666v2h-.666z"] };
var c4 = {
  DdsColorPaletteGrey3: "#00040f",
  DdsColorPaletteGrey10: "#14161f",
  DdsColorPaletteGrey20: "#2b2f3b",
  DdsColorPaletteGrey25: "#3a3c46",
  DdsColorPaletteGrey30: "#474a52",
  DdsColorPaletteGrey45: "#6e7079",
  DdsColorPaletteGrey50: "#797c86",
  DdsColorPaletteGrey60: "#95979e",
  DdsColorPaletteGrey75: "#bbbcc2",
  DdsColorPaletteGrey88: "#dedfe4",
  DdsColorPaletteGrey93: "#ebecef",
  DdsColorPaletteGrey98: "#f8f8fa",
  DdsColorPaletteGrey100: "#ffffff",
  DdsColorPaletteBlue10: "#090033",
  DdsColorPaletteBlue20: "#110165",
  DdsColorPaletteBlue30: "#1a0198",
  DdsColorPaletteBlue43: "#2401da",
  DdsColorPaletteBlue50: "#2a01fe",
  DdsColorPaletteBlue59: "#2f6aff",
  DdsColorPaletteBlue70: "#6692ff",
  DdsColorPaletteBlue80: "#99b6ff",
  DdsColorPaletteBlue90: "#ccdbff",
  DdsColorPaletteBlue95: "#e5edff",
  DdsColorPaletteGreen10: "#03301c",
  DdsColorPaletteGreen20: "#06603c",
  DdsColorPaletteGreen32: "#0a9959",
  DdsColorPaletteGreen43: "#0ecb76",
  DdsColorPaletteGreen50: "#0fe182",
  DdsColorPaletteGreen60: "#40f2a2",
  DdsColorPaletteGreen70: "#81f3c4",
  DdsColorPaletteGreen82: "#b1f1e2",
  DdsColorPaletteGreen90: "#cffce8",
  DdsColorPaletteGreen94: "#e2fdf1",
  DdsColorPaletteLime10: "#183300",
  DdsColorPaletteLime20: "#366501",
  DdsColorPaletteLime30: "#479801",
  DdsColorPaletteLime40: "#95cb01",
  DdsColorPaletteLime50: "#bffd11",
  DdsColorPaletteLime64: "#cdfe48",
  DdsColorPaletteLime73: "#dafe76",
  DdsColorPaletteLime80: "#e4fe9a",
  DdsColorPaletteLime90: "#ebffcc",
  DdsColorPaletteLime95: "#f5ffe5",
  DdsColorPaletteOrange10: "#2b0d08",
  DdsColorPaletteOrange20: "#561910",
  DdsColorPaletteOrange33: "#8e2a1a",
  DdsColorPaletteOrange38: "#c23200",
  DdsColorPaletteOrange50: "#ff4200",
  DdsColorPaletteOrange60: "#ff6631",
  DdsColorPaletteOrange70: "#ffb068",
  DdsColorPaletteOrange80: "#ffca99",
  DdsColorPaletteOrange90: "#ffe4cc",
  DdsColorPaletteOrange95: "#fff1e5",
  DdsColorPalettePink10: "#33001c",
  DdsColorPalettePink20: "#660039",
  DdsColorPalettePink33: "#a8005e",
  DdsColorPalettePink44: "#e0007d",
  DdsColorPalettePink55: "#ff1a99",
  DdsColorPalettePink66: "#ff54b3",
  DdsColorPalettePink70: "#ff66bb",
  DdsColorPalettePink80: "#ff99d2",
  DdsColorPalettePink90: "#ffcce8",
  DdsColorPalettePink95: "#ffe5fa",
  DdsColorPalettePurple10: "#190033",
  DdsColorPalettePurple20: "#330165",
  DdsColorPalettePurple30: "#4c0198",
  DdsColorPalettePurple40: "#6606c6",
  DdsColorPalettePurple50: "#8008f7",
  DdsColorPalettePurple60: "#a533ff",
  DdsColorPalettePurple75: "#c780ff",
  DdsColorPalettePurple80: "#d299ff",
  DdsColorPalettePurple90: "#e9ccff",
  DdsColorPalettePurple95: "#f4e5ff",
  DdsColorPaletteRed10: "#330000",
  DdsColorPaletteRed20: "#660000",
  DdsColorPaletteRed33: "#a80000",
  DdsColorPaletteRed43: "#db0000",
  DdsColorPaletteRed50: "#ff0000",
  DdsColorPaletteRed60: "#ff3333",
  DdsColorPaletteRed75: "#ff8282",
  DdsColorPaletteRed86: "#ffb8b8",
  DdsColorPaletteRed90: "#ffcccc",
  DdsColorPaletteRed95: "#ffe5e6",
  DdsColorPaletteTeal10: "#002833",
  DdsColorPaletteTeal20: "#005166",
  DdsColorPaletteTeal30: "#007999",
  DdsColorPaletteTeal40: "#099fc3",
  DdsColorPaletteTeal49: "#00ebfa",
  DdsColorPaletteTeal60: "#33daff",
  DdsColorPaletteTeal70: "#6dddf8",
  DdsColorPaletteTeal80: "#9ee9fa",
  DdsColorPaletteTeal90: "#cef4fd",
  DdsColorPaletteTeal95: "#e7f9fe",
  DdsColorPaletteYellow10: "#331c00",
  DdsColorPaletteYellow20: "#663800",
  DdsColorPaletteYellow33: "#a85d00",
  DdsColorPaletteYellow44: "#e0a500",
  DdsColorPaletteYellow50: "#ffbb00",
  DdsColorPaletteYellow66: "#ffe552",
  DdsColorPaletteYellow75: "#ffec80",
  DdsColorPaletteYellow80: "#fff099",
  DdsColorPaletteYellow90: "#fff7cc",
  DdsColorPaletteYellow95: "#fffbe5",
  DdsColorPaletteBlack: "#00040f",
  DdsColorPaletteWhite: "#ffffff",
  DdsColorTextPrimaryOndefault: "#00040f",
  DdsColorTextPrimaryOninverse: "#ffffff",
  DdsColorTextDiminishedOndefault: "#797c86",
  DdsColorTextDiminishedOninverse: "#bbbcc2",
  DdsColorTextDisabledOndefault: "#bbbcc2",
  DdsColorTextLinkDefault: "#6606c6",
  DdsColorTextLinkHover: "#330165",
  DdsColorTextLinkActive: "#4c0198",
  DdsColorTextLinkDisabled: "#d299ff",
  DdsColorTextInvalidOndefault: "#a80000",
  DdsColorTextDangerDefault: "#a80000",
  DdsColorTextDangerHover: "#660000",
  DdsColorTextDangerActive: "#330000",
  DdsColorTextDangerDisabled: "#ffb8b8",
  DdsColorTextWarningDefault: "#a85d00",
  DdsColorBorderControlDefault: "#bbbcc2",
  DdsColorBorderControlHover: "#95979e",
  DdsColorBorderControlActive: "#797c86",
  DdsColorBorderControlDisabled: "#dedfe4",
  DdsColorBorderControlInvalid: "#a80000",
  DdsColorBorderDividerDefault: "#dedfe4",
  DdsColorBorderDividerDark: "#6e7079",
  DdsColorBorderContainerDefault: "#dedfe4",
  DdsColorBorderNotificationCaution: "#ffbb00",
  DdsColorBorderNotificationError: "#a80000",
  DdsColorBorderNotificationHighlight: "#bffd11",
  DdsColorBorderNotificationNote: "#007999",
  DdsColorBorderNotificationSuccess: "#06603c",
  DdsColorBorderAdmin: "#ff8282",
  DdsColorInteractivePrimaryDefault: "#8008f7",
  DdsColorInteractivePrimaryHover: "#6606c6",
  DdsColorInteractivePrimaryActive: "#4c0198",
  DdsColorInteractivePrimaryDisabled: "#e9ccff",
  DdsColorInteractiveSecondaryDefault: "#ffffff",
  DdsColorInteractiveSecondaryHover: "#f8f8fa",
  DdsColorInteractiveSecondaryActive: "#ebecef",
  DdsColorInteractiveSecondaryDisabled: "#f8f8fa",
  DdsColorInteractiveDangerDefault: "#db0000",
  DdsColorInteractiveDangerHover: "#a80000",
  DdsColorInteractiveDangerActive: "#660000",
  DdsColorInteractiveDangerDisabled: "#ffb8b8",
  DdsColorInteractiveFocusringInner: "#ffffff",
  DdsColorInteractiveFocusringOuter: "#00040f",
  DdsColorRequiredindicator: "#a80000",
  DdsColorBackgroundDefault: "#ffffff",
  DdsColorBackgroundAlternative: "#f8f8fa",
  DdsColorBackgroundInverse: "#14161f",
  DdsColorBackgroundNotificationDanger: "#ffe5e6",
  DdsColorBackgroundNotificationError: "#ffe5e6",
  DdsColorBackgroundNotificationSuccess: "#e2fdf1",
  DdsColorBackgroundNotificationCaution: "#fff7cc",
  DdsColorBackgroundNotificationNeutral: "#f8f8fa",
  DdsColorBackgroundNotificationNote: "#e7f9fe",
  DdsColorBackgroundAdmin: "#ff8282",
  DdsColorBackgroundHighlight: "#dafe76",
  DdsColorIconDefault: "#00040f",
  DdsColorIconDiminished: "#797c86",
  DdsColorIconDanger: "#db0000",
  DdsColorIconDisabled: "#95979e",
  DdsColorIconSuccess: "#0a9959",
  DdsColorIconCaution: "#ff6631",
  DdsColorIconWarning: "#ffbb00",
  DdsColorIconNote: "#099fc3",
  DdsColorIconAdmin: "#ff8282",
  DdsColorFillNotificationError: "#db0000",
  DdsColorFillNotificationSuccess: "#0a9959",
  DdsColorFillNotificationCaution: "#ffbb00",
  DdsColorFillNotificationNote: "#099fc3",
  DdsColorFillNotificationHighlight: "#bffd11"
};
const v3 = "dds-icon-v0174";
function f4({
  className: e = "",
  fill: a = "currentColor",
  name: t = "CircleInfo",
  size: r = "medium",
  title: n,
  ...c
}) {
  const u = u4[t], l = a === "currentColor" ? "currentColor" : c4[a], o = {
    "aria-hidden": "true"
  };
  n !== void 0 && (delete o["aria-hidden"], o.role = "img");
  const i = (d = {}) => Object.keys(d).filter((f) => !!d[f]).join(" "), s = {
    [v3]: !0,
    [`${v3}--${r}`]: !0,
    [e]: e.length > 0
  };
  return u ? /* @__PURE__ */ l0(
    "svg",
    {
      className: i(s),
      ...c,
      viewBox: "0 0 8 8",
      preserveAspectRatio: "xMidYMid meet",
      fill: l,
      ...o,
      children: [
        n !== void 0 ? /* @__PURE__ */ Q("title", { children: n }) : "",
        u.map((d, f) => (
          // eslint-disable-next-line react/no-array-index-key
          /* @__PURE__ */ Q("path", { d }, `iconpath-${f}`)
        ))
      ]
    }
  ) : null;
}
const d4 = T0(
  ({
    ariaLabelText: e,
    buttonText: a,
    className: t,
    disabled: r,
    iconEnd: n,
    iconStart: c,
    loading: u,
    onClick: l,
    onKeyDown: o,
    onMouseDown: i,
    type: s,
    ...d
  }, f) => /* @__PURE__ */ l0(
    "button",
    {
      "aria-disabled": r || u ? "true" : void 0,
      "aria-label": e || void 0,
      className: t,
      onClick: r || u ? void 0 : l,
      onKeyDown: r || u ? void 0 : o,
      onMouseDown: r || u ? void 0 : i,
      type: s,
      ref: f,
      title: a || e,
      ...d,
      children: [
        u && /* @__PURE__ */ Q("span", { className: "dds-button__loading-indicator" }),
        a && /* @__PURE__ */ Q("span", { className: "dds-button__text", children: a }),
        c && /* @__PURE__ */ Q("span", { className: "dds-button__icon-start", children: c }),
        n && /* @__PURE__ */ Q("span", { className: "dds-button__icon-end", children: n })
      ]
    }
  )
), v4 = T0(
  ({ ariaLabelText: e, buttonText: a, className: t, href: r, iconEnd: n, iconStart: c, type: u, ...l }, o) => /* @__PURE__ */ l0(
    "a",
    {
      "aria-label": e || void 0,
      className: t,
      href: r,
      type: u,
      ref: o,
      title: a || e,
      ...l,
      children: [
        a && /* @__PURE__ */ Q("span", { className: "dds-button__text", children: a }),
        c && /* @__PURE__ */ Q("span", { className: "dds-button__icon-start", children: c }),
        n && /* @__PURE__ */ Q("span", { className: "dds-button__icon-end", children: n })
      ]
    }
  )
), h4 = b3, p4 = T0(
  ({ ariaLabelText: e, buttonText: a, className: t, iconEnd: r, iconStart: n, type: c, ...u }, l) => /* @__PURE__ */ l0(
    h4,
    {
      "aria-label": e || void 0,
      className: t,
      type: c,
      ref: l,
      title: a || e,
      ...u,
      children: [
        a && /* @__PURE__ */ Q("span", { className: "dds-button__text", children: a }),
        n && /* @__PURE__ */ Q("span", { className: "dds-button__icon-start", children: n }),
        r && /* @__PURE__ */ Q("span", { className: "dds-button__icon-end", children: r })
      ]
    }
  )
), g0 = "dds-button-v0205", q4 = T0(
  ({
    accessibleText: e,
    href: a,
    to: t,
    className: r = "",
    children: n,
    disabled: c = !1,
    loading: u = !1,
    onClick: l,
    onKeyDown: o,
    onMouseDown: i,
    iconStart: s,
    iconEnd: d,
    size: f = "medium",
    type: v,
    variant: h = "primary",
    noPadding: y,
    inverse: g = !1,
    ...p
  }, P) => {
    const b = () => n === void 0 && e === void 0 && s === void 0 && d === void 0 ? "Button" : n, H = () => {
      let L = e;
      return e === void 0 && n === void 0 && (s !== void 0 && (L = typeof s == "string" ? `${s} button` : "Icon button"), d !== void 0 && (L = typeof d == "string" ? `${d} button` : "Icon button")), L;
    }, A = b(), m = H(), E = (L) => typeof L == "string" ? /* @__PURE__ */ Q(f4, { name: L, size: f }) : L, x = (L = {}) => Object.keys(L).filter((S) => !!L[S]).join(" "), I = {
      [g0]: !0,
      [`${g0}--${f}`]: !0,
      [`${g0}--${h}`]: !0,
      [`${g0}--inverse`]: g,
      [r]: r.length > 0,
      [`${g0}--icon-only`]: A === void 0 || A.length === 0,
      "no-padding": !!(y && h === "tertiary")
    }, T = {
      ariaLabelText: m,
      buttonText: A,
      className: x(I),
      iconStart: E(s),
      iconEnd: E(d)
    };
    return t !== void 0 ? /* @__PURE__ */ Q(
      p4,
      {
        ...T,
        onClick: c || u ? void 0 : l,
        ref: P,
        to: t,
        ...p
      }
    ) : a && a.length > 0 ? /* @__PURE__ */ Q(
      v4,
      {
        ...T,
        onClick: l,
        href: a,
        type: v,
        ref: P,
        ...p
      }
    ) : /* @__PURE__ */ Q(
      d4,
      {
        ...T,
        disabled: c,
        loading: u,
        onClick: c || u ? void 0 : l,
        onKeyDown: c || u ? void 0 : o,
        onMouseDown: c || u ? void 0 : i,
        type: v || "button",
        ref: P,
        ...p
      }
    );
  }
), m4 = { ActionItem: ["M3.679 7.01a.68.68 0 0 1 .643 0l.461.249a.676.676 0 0 0 .969-.402l.15-.501a.68.68 0 0 1 .454-.454l.501-.15a.677.677 0 0 0 .402-.969l-.249-.461a.68.68 0 0 1 0-.643l.249-.461a.676.676 0 0 0-.402-.969l-.501-.15a.68.68 0 0 1-.454-.454l-.15-.501a.677.677 0 0 0-.969-.402l-.461.249a.68.68 0 0 1-.643 0L3.218.742a.676.676 0 0 0-.969.402l-.15.501a.68.68 0 0 1-.454.454l-.501.15a.677.677 0 0 0-.402.969l.249.461a.68.68 0 0 1 0 .643l-.249.461a.676.676 0 0 0 .402.969l.501.15a.68.68 0 0 1 .454.454l.15.501a.677.677 0 0 0 .969.402zm-.948-2.733a.29.29 0 0 1 .406-.081l.618.412L4.771 2.83a.294.294 0 0 1 .509.291l-1.172 2.05a.293.293 0 0 1-.417.098l-.879-.586a.29.29 0 0 1-.081-.406"], Alerts: ["M2 7.348a.84.84 0 0 1-.617-.256.85.85 0 0 1-.257-.62v-3.98a.85.85 0 0 1 .262-.625L2.634.618a.86.86 0 0 1 .627-.26h2.352q.36 0 .619.257a.84.84 0 0 1 .258.62v5.236a.84.84 0 0 1-.258.62.85.85 0 0 1-.62.257zm1.807-1.754a.37.37 0 0 0 .387-.385.37.37 0 0 0-.385-.388.38.38 0 0 0-.277.108.37.37 0 0 0-.11.277.374.374 0 0 0 .386.388Zm.005-1.37q.172 0 .291-.12a.4.4 0 0 0 .12-.288v-.928a.4.4 0 0 0-.118-.288.4.4 0 0 0-.288-.12.4.4 0 0 0-.29.118.4.4 0 0 0-.121.29v.928q0 .17.119.289.12.12.287.12Z"], Antenna: ["M1.205 3.333q0 .482.16.923.161.442.46.817.08.101.08.23a.3.3 0 0 1-.093.218.28.28 0 0 1-.222.086.27.27 0 0 1-.212-.106 3.5 3.5 0 0 1-.582-1.014 3.3 3.3 0 0 1-.205-1.154q0-.6.204-1.155.204-.556.583-1.014a.28.28 0 0 1 .212-.105.28.28 0 0 1 .222.087.3.3 0 0 1 .091.22.37.37 0 0 1-.08.232q-.297.375-.457.814-.16.44-.16.921Zm1.144 0a1.65 1.65 0 0 0 .284.935q.07.105.071.233 0 .13-.091.222a.3.3 0 0 1-.217.09.24.24 0 0 1-.199-.1 2.28 2.28 0 0 1 0-2.759.24.24 0 0 1 .199-.1q.126 0 .217.09.09.091.091.221a.4.4 0 0 1-.07.234 1.65 1.65 0 0 0-.285.934m1.272 3.334v-2.54a.9.9 0 0 1-.364-.324.86.86 0 0 1-.136-.47q0-.368.255-.623A.85.85 0 0 1 4 2.454q.368 0 .624.256.255.255.255.623a.86.86 0 0 1-.136.47.9.9 0 0 1-.364.325v2.539a.37.37 0 0 1-.11.27.37.37 0 0 1-.269.109.37.37 0 0 1-.27-.11.37.37 0 0 1-.11-.27Zm2.03-3.334a1.65 1.65 0 0 0-.284-.935.4.4 0 0 1-.071-.233q0-.13.091-.221a.3.3 0 0 1 .218-.09.24.24 0 0 1 .2.104 2.34 2.34 0 0 1 .462 1.375 2.26 2.26 0 0 1-.463 1.379.24.24 0 0 1-.199.1.3.3 0 0 1-.218-.09.3.3 0 0 1-.091-.22q0-.13.07-.234a1.65 1.65 0 0 0 .285-.935m1.144 0q0-.48-.16-.923a2.9 2.9 0 0 0-.46-.816.36.36 0 0 1-.08-.23.3.3 0 0 1 .312-.305.27.27 0 0 1 .21.105q.38.458.586 1.014t.206 1.155-.205 1.154q-.205.553-.582 1.014a.27.27 0 0 1-.212.105.3.3 0 0 1-.222-.087.3.3 0 0 1-.091-.219.37.37 0 0 1 .08-.231q.297-.375.457-.815t.16-.92Z"], ArrowEastLong: ["M5.813 4.44H.953a.43.43 0 0 1-.313-.128.43.43 0 0 1-.129-.313q0-.184.129-.313a.43.43 0 0 1 .313-.129h4.856l-1.122-1.12a.42.42 0 0 1-.132-.31.41.41 0 0 1 .132-.313.4.4 0 0 1 .31-.122.43.43 0 0 1 .312.127L7.18 3.69a.4.4 0 0 1 .095.146.48.48 0 0 1 0 .333.4.4 0 0 1-.095.143L5.31 6.188a.43.43 0 0 1-.307.127.43.43 0 0 1-.315-.127.43.43 0 0 1-.133-.313q0-.18.133-.312z"], ArrowEastShort: ["M5.133 4.44H1.615a.43.43 0 0 1-.313-.128.43.43 0 0 1-.129-.313q0-.184.129-.313a.43.43 0 0 1 .313-.129h3.518l-1.45-1.45a.435.435 0 0 1 .004-.627A.45.45 0 0 1 4 1.355a.42.42 0 0 1 .313.131l2.2 2.2a.43.43 0 0 1 .13.314.45.45 0 0 1-.13.313L4.31 6.517a.42.42 0 0 1-.31.13.43.43 0 0 1-.312-.13.43.43 0 0 1-.133-.315.43.43 0 0 1 .133-.316z"], ArrowEastToTable: ["M6.74.43H2.12l-.09.01C1.38.48.87 1.03.87 1.69v2.06c.03.19.19.33.39.33.21 0 .39-.17.39-.39v-.74h5.57v3.42c-.03.24-.23.42-.48.42h-1.5a.39.39 0 0 0-.33.39c0 .21.17.39.39.39h1.44l.09-.01C7.49 7.52 8 6.97 8 6.31V1.6C7.95.95 7.41.43 6.74.43m.48 1.74H1.65v-.54c.03-.24.23-.42.47-.42h4.62l.06.01c.24.03.42.23.42.47z", "M3.842 5.746 2.704 4.608l-.048-.041a.39.39 0 0 0-.503.041l-.041.048a.39.39 0 0 0 .041.503l.472.473H.39l-.058.004a.39.39 0 0 0 .058.776h2.235l-.472.472-.041.048a.39.39 0 0 0 .592.503l1.138-1.138a.4.4 0 0 0 .087-.132.4.4 0 0 0 .027-.17.4.4 0 0 0-.114-.249"], ArrowEastWest: ["M2.653 5.451H.948a.43.43 0 0 1-.313-.129.43.43 0 0 1-.129-.313.42.42 0 0 1 .13-.312.43.43 0 0 1 .312-.13h1.705l-.441-.44a.4.4 0 0 1-.125-.305.44.44 0 0 1 .435-.446q.183 0 .316.128l1.191 1.192a.43.43 0 0 1 .13.313.45.45 0 0 1-.13.314l-1.2 1.195a.427.427 0 0 1-.617-.008.43.43 0 0 1-.127-.309.4.4 0 0 1 .127-.309zm2.694-2.019.441.442a.4.4 0 0 1 .125.304.44.44 0 0 1-.435.446.44.44 0 0 1-.316-.128L3.971 3.304a.43.43 0 0 1-.13-.313.45.45 0 0 1 .13-.314l1.2-1.195a.427.427 0 0 1 .617.008.43.43 0 0 1 .127.309.4.4 0 0 1-.127.309l-.441.44h1.705q.184 0 .313.13.128.129.128.313a.43.43 0 0 1-.128.312.43.43 0 0 1-.313.13z"], ArrowIncrease: ["M5.002 1.933a.39.39 0 0 0 .081.665l.696.309-.907 2.117-.067.146a2.97 2.97 0 0 1-2.659 1.651H.585l-.079.005a.586.586 0 0 0 .079 1.166h1.561l.183-.004a4.14 4.14 0 0 0 3.619-2.503l.901-2.102.602.267A.39.39 0 0 0 8 3.294V.399a.39.39 0 0 0-.63-.308z"], ArrowLineIntoEast: ["M7 7a.5.5 0 0 0 1 0V1a.5.5 0 0 0-1 0zM2.654 1.154 2.7 1.1a.48.48 0 0 1 .625-.046l.054.046 2.56 2.56.023.024.036.046.035.061.022.055.017.066.007.054v.066l-.012.077-.012.043-.014.038-.023.045-.02.033-.018.024-.041.046-2.56 2.56a.481.481 0 0 1-.725-.625l.046-.054 1.74-1.741H.48a.48.48 0 0 1-.476-.415L0 3.998c0-.243.181-.444.415-.476l.065-.004h3.961l-1.74-1.741a.48.48 0 0 1-.046-.625Z"], ArrowLineIntoWest: ["M1 1a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0zm4.346 5.846L5.3 6.9a.48.48 0 0 1-.625.046L4.621 6.9l-2.56-2.56-.023-.024-.036-.046-.035-.061-.022-.055-.017-.066-.007-.054v-.066l.012-.077.012-.043.014-.038.023-.045.02-.033.018-.024.041-.046 2.56-2.56a.481.481 0 0 1 .725.625l-.046.054-1.74 1.741h3.961c.243 0 .444.181.476.415l.004.065a.48.48 0 0 1-.415.476l-.065.004H3.56L5.3 6.223a.48.48 0 0 1 .046.625Z"], ArrowNorthEastLong: ["M5.637 2.89 2.06 6.465a.36.36 0 0 1-.265.106.36.36 0 0 1-.37-.371.36.36 0 0 1 .105-.265l3.575-3.576H3.35a.37.37 0 0 1-.27-.11.37.37 0 0 1-.109-.269.37.37 0 0 1 .11-.27.37.37 0 0 1 .27-.11h2.666a.375.375 0 0 1 .38.38v2.667a.37.37 0 0 1-.11.27.37.37 0 0 1-.27.109.37.37 0 0 1-.27-.11.37.37 0 0 1-.11-.27z"], ArrowNorthEastShort: ["M5.313 3.357v2.429a.474.474 0 1 0 .948 0V2.213a.474.474 0 0 0-.474-.474H2.214a.474.474 0 1 0 0 .948h2.429L1.879 5.451a.474.474 0 0 0 .67.67z"], ArrowNortheastSouthwest: ["M4.827 1.043H4A.522.522 0 0 1 4 0h2.087c.288 0 .522.234.522.522v2.087a.522.522 0 0 1-1.044 0v-.828L3.673 3.673a.521.521 0 1 1-.738-.738zM4 6.957A.522.522 0 0 1 4 8H1.913a.52.52 0 0 1-.522-.522V5.391a.522.522 0 0 1 1.044 0v.827l1.892-1.892a.521.521 0 1 1 .738.738L3.173 6.957z"], ArrowSouthEastLong: ["M5.106 5.637 1.531 2.06a.36.36 0 0 1-.106-.265.36.36 0 0 1 .371-.37.36.36 0 0 1 .265.105l3.576 3.575V3.35q0-.159.11-.27a.37.37 0 0 1 .269-.109.37.37 0 0 1 .27.11q.11.11.11.27v2.666a.37.37 0 0 1-.11.27.37.37 0 0 1-.27.11H3.349a.37.37 0 0 1-.27-.11.37.37 0 0 1-.109-.27.37.37 0 0 1 .11-.27.37.37 0 0 1 .27-.11z"], ArrowSouthEastShort: ["M4.643 5.313H2.214a.474.474 0 1 0 0 .948h3.573a.474.474 0 0 0 .474-.474V2.214a.474.474 0 1 0-.948 0v2.429L2.549 1.879a.474.474 0 0 0-.67.67z"], ArrowTriangleEast: ["M2.5 5.533c0 .281.307.455.548.31L5.6 4.311a.362.362 0 0 0 0-.62L3.048 2.159a.362.362 0 0 0-.548.31z"], ArrowTriangleNorth: ["M3.69 2.397a.362.362 0 0 1 .62 0L5.842 4.95a.362.362 0 0 1-.31.548H2.468a.362.362 0 0 1-.31-.548z"], ArrowTriangleNorthSouth: ["M3.768 1.133a.27.27 0 0 1 .465 0l1.149 1.915a.271.271 0 0 1-.233.41H2.852a.271.271 0 0 1-.233-.41zm-.916 3.411a.271.271 0 0 0-.233.41L3.768 6.87a.27.27 0 0 0 .465 0l1.149-1.914a.271.271 0 0 0-.233-.411H2.852Z"], ArrowTriangleSouth: ["M2.468 2.501a.362.362 0 0 0-.31.548L3.69 5.602c.14.234.48.234.62 0l1.532-2.553a.362.362 0 0 0-.31-.548z"], ArrowTriangleWest: ["M5.496 2.47a.362.362 0 0 0-.547-.31L2.396 3.69a.362.362 0 0 0 0 .62l2.553 1.532a.362.362 0 0 0 .547-.31V2.469Z"], ArrowUTurnEast: ["m4.972.211.051-.059a.52.52 0 0 1 .679-.051l.059.051L7.848 2.24l.055.065.03.047.025.049.016.041.018.071.007.059v.072l-.012.084-.021.068-.033.069-.022.036-.019.027-.044.05-2.087 2.087a.521.521 0 0 1-.789-.68l.051-.059L6.219 3.13H2.957a1.914 1.914 0 0 0-1.91 1.797l-.003.116c0 1.017.794 1.849 1.797 1.91l.117.003h.348a.522.522 0 0 1 .071 1.039L3.305 8h-.348a2.956 2.956 0 0 1-.143-5.91l.143-.003H6.22L5.023.891a.524.524 0 0 1-.051-.68l.051-.059z"], ArrowWestLong: ["M2.191 4.44h4.86a.42.42 0 0 0 .311-.128.43.43 0 0 0 .127-.313.43.43 0 0 0-.129-.313.43.43 0 0 0-.313-.129H2.191l1.127-1.12a.42.42 0 0 0 .131-.31.41.41 0 0 0-.13-.313.4.4 0 0 0-.312-.122.43.43 0 0 0-.311.127L.825 3.69a.4.4 0 0 0-.095.146.48.48 0 0 0 0 .333q.03.079.095.143l1.871 1.876a.43.43 0 0 0 .307.127.43.43 0 0 0 .315-.127.43.43 0 0 0 .133-.313.43.43 0 0 0-.133-.312z"], ArrowWestShort: ["m2.867 4.44 1.45 1.45a.435.435 0 0 1-.004.627.45.45 0 0 1-.313.126.42.42 0 0 1-.313-.13l-2.2-2.2a.43.43 0 0 1-.13-.314.45.45 0 0 1 .13-.314L3.69 1.481a.42.42 0 0 1 .31-.13q.18 0 .312.13a.43.43 0 0 1 .133.315.43.43 0 0 1-.133.315L2.867 3.557h3.518q.184 0 .313.129t.129.313a.43.43 0 0 1-.129.313.43.43 0 0 1-.313.128z"], AutoRefill: ["M1.428 3.976q0 .658.32 1.229.32.57.874.927.128.091.173.236.046.146-.032.278a.35.35 0 0 1-.234.18.37.37 0 0 1-.292-.041 3.25 3.25 0 0 1-1.152-1.2 3.26 3.26 0 0 1-.39-1.994 4 4 0 0 1 .066-.377l-.083.05a.27.27 0 0 1-.259.025.4.4 0 0 1-.209-.183.37.37 0 0 1-.036-.288.36.36 0 0 1 .175-.23l1.01-.586a.37.37 0 0 1 .29-.035q.154.042.23.176l.582 1.003q.077.135.035.288a.36.36 0 0 1-.176.232.4.4 0 0 1-.302.038q-.168-.039-.218-.18l-.216-.375a3 3 0 0 0-.115.407 2 2 0 0 0-.04.42ZM4 1.398a2.6 2.6 0 0 0-1.16.286.48.48 0 0 1-.3.036.32.32 0 0 1-.227-.165.37.37 0 0 1-.033-.305q.05-.156.199-.23a3 3 0 0 1 .735-.287Q3.595.64 4 .64a3.3 3.3 0 0 1 2.274.903v-.096q0-.147.113-.239a.4.4 0 0 1 .267-.092q.16 0 .269.11t.11.27v1.166a.37.37 0 0 1-.11.27.37.37 0 0 1-.27.11H5.487a.37.37 0 0 1-.27-.11.37.37 0 0 1-.11-.27.37.37 0 0 1 .11-.27.37.37 0 0 1 .27-.11h.441a2.6 2.6 0 0 0-.864-.652A2.5 2.5 0 0 0 4 1.398m1.983 4.21a2.5 2.5 0 0 0 .416-.703 2.4 2.4 0 0 0 .157-.799.45.45 0 0 1 .122-.279.36.36 0 0 1 .27-.12.34.34 0 0 1 .269.127.4.4 0 0 1 .1.284 3.1 3.1 0 0 1-.174.96q-.16.458-.458.862a3.3 3.3 0 0 1-.744.736q-.43.307-.94.468l.064.038a.3.3 0 0 1 .149.222.4.4 0 0 1-.05.278.35.35 0 0 1-.23.172.37.37 0 0 1-.284-.04l-1.015-.583A.36.36 0 0 1 3.458 7a.37.37 0 0 1 .035-.29l.583-1.006a.35.35 0 0 1 .228-.173.37.37 0 0 1 .286.04.37.37 0 0 1 .175.23.36.36 0 0 1-.034.286l-.235.4a2.54 2.54 0 0 0 1.486-.878Z"], Autopause: ["M3 5V3h.667v2zm1.333 0V3H5v2zM4 7.667q-.9 0-1.688-.413A3.7 3.7 0 0 1 1 6.1V7H.333V5h2v.667h-.816a3.04 3.04 0 0 0 1.079.979Q3.25 7 4 7q.959 0 1.737-.55.78-.55 1.096-1.458l.65.15A3.6 3.6 0 0 1 6.15 6.97 3.57 3.57 0 0 1 4 7.667m-3.65-4q.059-.56.267-1.071a3.5 3.5 0 0 1 .575-.946l.475.475q-.267.341-.434.73-.165.386-.208.812zm1.783-2.009-.475-.475q.442-.366.95-.579A3.4 3.4 0 0 1 3.667.35v.667a2.7 2.7 0 0 0-.809.208 3.3 3.3 0 0 0-.725.433m3.742 0a3.3 3.3 0 0 0-.73-.433 2.7 2.7 0 0 0-.812-.208V.35q.56.05 1.071.258.513.209.946.575zm1.108 2.009a2.7 2.7 0 0 0-.208-.813 3.3 3.3 0 0 0-.433-.729l.475-.475q.366.433.575.946t.258 1.07z"], Badge: ["M2.4 5.3v.4q0 .127.086.214A.3.3 0 0 0 2.698 6a.3.3 0 0 0 .214-.086A.3.3 0 0 0 3 5.7v-.4h.4a.3.3 0 0 0 .214-.086.3.3 0 0 0 .086-.212.3.3 0 0 0-.086-.215A.3.3 0 0 0 3.4 4.7H3v-.4a.3.3 0 0 0-.086-.214A.3.3 0 0 0 2.702 4a.3.3 0 0 0-.215.086.3.3 0 0 0-.087.214v.4H2a.3.3 0 0 0-.214.086.3.3 0 0 0-.086.212q0 .127.086.215A.3.3 0 0 0 2 5.3zm2.1-.5h1.6a.194.194 0 0 0 .2-.2.194.194 0 0 0-.2-.2H4.5a.194.194 0 0 0-.2.2.194.194 0 0 0 .2.2m0 1h.9a.194.194 0 0 0 .2-.2.194.194 0 0 0-.2-.2h-.9a.194.194 0 0 0-.2.2.194.194 0 0 0 .2.2M1.4 7.2a.58.58 0 0 1-.424-.176A.58.58 0 0 1 .8 6.6V3a.58.58 0 0 1 .176-.424A.58.58 0 0 1 1.4 2.4h1.8v-1a.58.58 0 0 1 .176-.424A.58.58 0 0 1 3.8.8h.4a.58.58 0 0 1 .424.176.58.58 0 0 1 .176.424v1h1.8a.58.58 0 0 1 .424.176A.58.58 0 0 1 7.2 3v3.6a.58.58 0 0 1-.176.424.58.58 0 0 1-.424.176zM3.8 3h.4V1.4h-.4z"], Bank: ["M1.77 5.362v-1.52q0-.171.12-.288a.4.4 0 0 1 .29-.117.4.4 0 0 1 .286.117.4.4 0 0 1 .117.287v1.526a.4.4 0 0 1-.117.287.4.4 0 0 1-.287.117.4.4 0 0 1-.289-.12.4.4 0 0 1-.12-.29Zm2.076.005V3.84a.4.4 0 0 1 .117-.287.4.4 0 0 1 .287-.117.4.4 0 0 1 .287.117.4.4 0 0 1 .117.287v1.526a.4.4 0 0 1-.117.287.4.4 0 0 1-.287.117.4.4 0 0 1-.287-.117.4.4 0 0 1-.117-.287ZM1.198 7.175a.43.43 0 0 1-.312-.13.43.43 0 0 1-.13-.312q0-.184.13-.313a.43.43 0 0 1 .312-.129h6.104q.184 0 .313.13.129.128.129.312a.43.43 0 0 1-.13.313.43.43 0 0 1-.312.129zm4.719-1.813v-1.52q0-.171.12-.288a.4.4 0 0 1 .288-.117.4.4 0 0 1 .287.117.4.4 0 0 1 .117.287v1.526a.4.4 0 0 1-.117.287.4.4 0 0 1-.287.117.4.4 0 0 1-.289-.12.4.4 0 0 1-.12-.29Zm1.366-2.45H1.17a.4.4 0 0 1-.293-.12.4.4 0 0 1-.12-.293V2.24q0-.12.062-.217a.44.44 0 0 1 .166-.153L3.856.437A.85.85 0 0 1 4.25.342q.21 0 .394.095l2.846 1.42q.12.056.187.17a.5.5 0 0 1 .067.248v.172a.45.45 0 0 1-.134.33.44.44 0 0 1-.327.135"], Beaker: ["M1.667 7.068a.68.68 0 0 1-.665-.418.68.68 0 0 1 .096-.775l1.834-2.232v-1.93h-.271a.37.37 0 0 1-.27-.11.37.37 0 0 1-.11-.27.37.37 0 0 1 .11-.27.37.37 0 0 1 .27-.11h2.678a.373.373 0 0 1 .38.38.37.37 0 0 1-.11.27.37.37 0 0 1-.27.11h-.271v1.93l1.834 2.232a.68.68 0 0 1 .096.775.68.68 0 0 1-.665.418z"], BookOpen: ["M4 6.517a.7.7 0 0 1-.18-.025 1 1 0 0 1-.162-.067 3 3 0 0 0-.716-.317A2.8 2.8 0 0 0 2.167 6q-.35 0-.688.092-.337.09-.646.258a.32.32 0 0 1-.337-.008.32.32 0 0 1-.163-.292V2.033q0-.091.046-.175a.3.3 0 0 1 .138-.125q.383-.2.8-.3a3.63 3.63 0 0 1 2.683.4v4.034a3.46 3.46 0 0 1 1.833-.534 3.5 3.5 0 0 1 1.167.2v-4q.125.042.246.088.12.046.237.112.091.042.138.125.046.084.046.175V6.05a.32.32 0 0 1-.163.292.32.32 0 0 1-.337.008 3 3 0 0 0-.646-.258A2.6 2.6 0 0 0 5.833 6a2.8 2.8 0 0 0-1.491.425 1 1 0 0 1-.163.067.7.7 0 0 1-.179.025m.942-1.767q-.084.075-.18.03a.16.16 0 0 1-.095-.155V1.9a.16.16 0 0 1 .05-.117L6.05.45q.084-.084.183-.042.1.041.1.159v2.858a.14.14 0 0 1-.016.07.3.3 0 0 1-.042.055z"], Briefcase: ["M1.4 6.799a.58.58 0 0 1-.424-.176.58.58 0 0 1-.176-.424v-3.6a.58.58 0 0 1 .176-.424A.58.58 0 0 1 1.4 2h1.4v-.602q0-.248.176-.423A.58.58 0 0 1 3.401.8h1.201q.248 0 .423.176A.58.58 0 0 1 5.2 1.4V2h1.4a.58.58 0 0 1 .424.176.58.58 0 0 1 .176.424v3.6a.58.58 0 0 1-.176.424.58.58 0 0 1-.424.176H1.4Zm2-4.8h1.2v-.6H3.4z"], Calendar: ["M1.667 7.333a.64.64 0 0 1-.471-.195A.64.64 0 0 1 1 6.667V2q0-.275.196-.47a.64.64 0 0 1 .47-.197H2V1a.32.32 0 0 1 .096-.237.32.32 0 0 1 .237-.096q.142 0 .238.096A.32.32 0 0 1 2.667 1v.333h2.666V1a.32.32 0 0 1 .096-.237.32.32 0 0 1 .238-.096q.141 0 .237.096A.32.32 0 0 1 6 1v.333h.333q.275 0 .471.196T7 2v4.667q0 .275-.196.47a.64.64 0 0 1-.47.196H1.666Zm0-.666h4.666V3.333H1.667z"], Cart: ["M2.301 7.363a.64.64 0 0 1-.47-.196.64.64 0 0 1-.196-.47.64.64 0 0 1 .196-.471.64.64 0 0 1 .47-.196.64.64 0 0 1 .471.196q.196.195.196.47a.64.64 0 0 1-.196.471.64.64 0 0 1-.47.196Zm3.334 0a.64.64 0 0 1-.471-.196.64.64 0 0 1-.196-.47.64.64 0 0 1 .196-.471.64.64 0 0 1 .47-.196q.275 0 .472.196.195.195.195.47t-.195.471a.64.64 0 0 1-.471.196m-3.916-6.06H6.56q.226 0 .345.201.12.201.009.408L5.777 3.967a.7.7 0 0 1-.257.27.67.67 0 0 1-.353.096H2.702l-.349.637h3.615a.353.353 0 0 1 .363.364.35.35 0 0 1-.104.258.35.35 0 0 1-.259.105H2.301a.65.65 0 0 1-.596-.346.66.66 0 0 1-.015-.684l.444-.8L.95 1.363H.635a.35.35 0 0 1-.26-.104A.35.35 0 0 1 .272 1 .35.35 0 0 1 .377.741.35.35 0 0 1 .635.637h.53a.4.4 0 0 1 .2.056q.095.057.141.161l.213.45Z"], CellTower: ["M1.167 3.333a2.86 2.86 0 0 0 .599 1.74q.09.117.09.26a.34.34 0 0 1-.103.247.3.3 0 0 1-.246.094.3.3 0 0 1-.234-.124A3.7 3.7 0 0 1 .69 4.498a3.5 3.5 0 0 1-.002-2.335 3.7 3.7 0 0 1 .59-1.056A.3.3 0 0 1 1.51.99a.31.31 0 0 1 .244.097q.102.102.102.246c0 .144-.03.183-.089.26a2.86 2.86 0 0 0-.599 1.74Zm1.204 0q0 .224.06.447a1.4 1.4 0 0 0 .21.436q.08.12.08.26a.33.33 0 0 1-.102.243.31.31 0 0 1-.245.095.29.29 0 0 1-.227-.117 2.2 2.2 0 0 1-.344-.634 2.2 2.2 0 0 1-.116-.73 2.2 2.2 0 0 1 .466-1.364.29.29 0 0 1 .224-.117.31.31 0 0 1 .242.096.32.32 0 0 1 .1.24.46.46 0 0 1-.082.258q-.139.203-.203.43a1.7 1.7 0 0 0-.063.457m.901 3.296-.15.426a.36.36 0 0 1-.338.24.34.34 0 0 1-.3-.154.35.35 0 0 1-.042-.333l.979-2.732a1 1 0 0 1-.258-.31.9.9 0 0 1-.105-.433.9.9 0 0 1 .275-.667A.9.9 0 0 1 4 2.392q.393 0 .667.274a.9.9 0 0 1 .275.667.85.85 0 0 1-.105.428 1.2 1.2 0 0 1-.258.315l.979 2.737a.34.34 0 0 1-.04.328.33.33 0 0 1-.294.155.37.37 0 0 1-.213-.068.35.35 0 0 1-.138-.177l-.142-.422zm.24-.667h.976L4 4.57l-.488 1.393ZM5.63 3.333q0-.222-.06-.447a1.4 1.4 0 0 0-.21-.436.45.45 0 0 1-.08-.257q0-.138.102-.24a.32.32 0 0 1 .244-.099.27.27 0 0 1 .223.115q.233.31.344.655t.121.71a2.2 2.2 0 0 1-.466 1.364.28.28 0 0 1-.224.114.32.32 0 0 1-.242-.098.32.32 0 0 1-.1-.238.46.46 0 0 1 .082-.255q.139-.205.203-.43.063-.228.063-.458m1.204 0a2.86 2.86 0 0 0-.599-1.74.4.4 0 0 1-.09-.26q0-.144.103-.246T6.492.99a.3.3 0 0 1 .231.117 3.5 3.5 0 0 1 .79 2.227q0 .606-.186 1.17A3.3 3.3 0 0 1 6.73 5.56a.32.32 0 0 1-.235.118.31.31 0 0 1-.248-.098.34.34 0 0 1-.102-.247.42.42 0 0 1 .089-.26 2.86 2.86 0 0 0 .599-1.74Z"], Chart: ["M1.8 6.799a.58.58 0 0 1-.424-.176.58.58 0 0 1-.176-.424v-4.4a.58.58 0 0 1 .176-.424A.58.58 0 0 1 1.8 1.2h4.4a.58.58 0 0 1 .424.176.58.58 0 0 1 .176.424v4.4a.58.58 0 0 1-.176.424.58.58 0 0 1-.424.176H1.8Zm.902-3.6a.3.3 0 0 0-.214.086.3.3 0 0 0-.088.214v1.8q0 .127.086.214a.3.3 0 0 0 .212.086.3.3 0 0 0 .215-.086A.3.3 0 0 0 3 5.299v-1.8a.3.3 0 0 0-.086-.214.3.3 0 0 0-.212-.086m1.3-.8a.3.3 0 0 0-.214.086.3.3 0 0 0-.088.214v2.6q0 .127.086.214a.3.3 0 0 0 .212.086.3.3 0 0 0 .215-.086.3.3 0 0 0 .087-.214v-2.6a.3.3 0 0 0-.086-.214.3.3 0 0 0-.212-.086m1.3 2a.294.294 0 0 0-.302.3v.598a.295.295 0 0 0 .298.302.294.294 0 0 0 .302-.3v-.598a.295.295 0 0 0-.298-.302"], Chat: ["M7 6.867a.3.3 0 0 1-.233-.1L6 6H2.667a.64.64 0 0 1-.471-.196.64.64 0 0 1-.196-.47V5h3.667q.275 0 .47-.196a.64.64 0 0 0 .196-.47V2h.334q.275 0 .47.196.196.195.196.47v3.859q0 .15-.1.246A.33.33 0 0 1 7 6.867M1 5.2a.33.33 0 0 1-.233-.096.33.33 0 0 1-.1-.246V1.333q0-.275.196-.47a.64.64 0 0 1 .47-.196H5q.275 0 .47.195a.64.64 0 0 1 .197.471v2.334q0 .275-.196.47A.64.64 0 0 1 5 4.333H2l-.767.767A.3.3 0 0 1 1 5.2"], CheckmarkSingle: ["m3.22 4.889 2.74-2.74a.43.43 0 0 1 .313-.134q.18 0 .314.133a.43.43 0 0 1 .133.316.43.43 0 0 1-.133.315L3.533 5.836a.43.43 0 0 1-.313.133.43.43 0 0 1-.314-.133L1.482 4.412a.437.437 0 0 1 .004-.63.43.43 0 0 1 .315-.133.43.43 0 0 1 .315.133z"], ChevronDoubleEast: ["M2.895 4 1.32 2.415a.46.46 0 0 1-.136-.328.44.44 0 0 1 .136-.335.45.45 0 0 1 .332-.132.45.45 0 0 1 .331.132l1.914 1.914A.44.44 0 0 1 4 3.821a.5.5 0 0 1 0 .358.4.4 0 0 1-.103.155L1.983 6.248a.46.46 0 0 1-.327.136.44.44 0 0 1-.336-.136.45.45 0 0 1-.132-.331.45.45 0 0 1 .132-.332zm2.782 0L4.1 2.415a.46.46 0 0 1-.136-.328.44.44 0 0 1 .136-.335.45.45 0 0 1 .332-.132.45.45 0 0 1 .331.132l1.914 1.914a.44.44 0 0 1 .103.155.5.5 0 0 1 0 .358.4.4 0 0 1-.103.155L4.763 6.248a.46.46 0 0 1-.327.136.44.44 0 0 1-.336-.136.45.45 0 0 1-.132-.331.45.45 0 0 1 .132-.332z"], ChevronDoubleSouth: ["m4 5.7 1.585-1.577a.46.46 0 0 1 .328-.136.44.44 0 0 1 .335.136.45.45 0 0 1 .132.331.45.45 0 0 1-.132.332L4.334 6.702a.4.4 0 0 1-.155.103.5.5 0 0 1-.358 0 .4.4 0 0 1-.155-.103L1.752 4.786a.46.46 0 0 1-.136-.328.44.44 0 0 1 .136-.335.45.45 0 0 1 .331-.132.45.45 0 0 1 .332.132zm0-2.577 1.585-1.578a.46.46 0 0 1 .328-.136.44.44 0 0 1 .335.139.45.45 0 0 1 .132.331.45.45 0 0 1-.132.332L4.334 4.125a.4.4 0 0 1-.155.102.5.5 0 0 1-.358 0 .4.4 0 0 1-.155-.102L1.752 2.211a.46.46 0 0 1-.136-.327.45.45 0 0 1 .136-.336.45.45 0 0 1 .331-.135q.2 0 .334.135z"], ChevronDoubleWest: ["M2.323 4 3.9 5.585a.46.46 0 0 1 .136.328.44.44 0 0 1-.136.335.45.45 0 0 1-.332.132.45.45 0 0 1-.331-.132L1.323 4.334a.4.4 0 0 1-.103-.155.5.5 0 0 1 0-.358.4.4 0 0 1 .103-.155l1.914-1.914a.46.46 0 0 1 .327-.136.44.44 0 0 1 .336.136.45.45 0 0 1 .132.331.45.45 0 0 1-.132.332zm2.782 0L6.68 5.585a.46.46 0 0 1 .136.328.44.44 0 0 1-.136.335.45.45 0 0 1-.332.132.45.45 0 0 1-.331-.132L4.103 4.334A.4.4 0 0 1 4 4.18a.5.5 0 0 1 0-.358.4.4 0 0 1 .103-.155l1.914-1.914a.46.46 0 0 1 .327-.136.44.44 0 0 1 .336.136.45.45 0 0 1 .132.331.45.45 0 0 1-.132.332z"], ChevronNorthSouth: ["m4 6.464.939-.938a.47.47 0 0 1 .34-.143q.199 0 .341.143a.47.47 0 0 1 .143.341.47.47 0 0 1-.143.342L4.334 7.496a.4.4 0 0 1-.155.102.5.5 0 0 1-.358 0 .4.4 0 0 1-.155-.102L2.38 6.209a.47.47 0 0 1-.143-.341q0-.2.143-.342a.47.47 0 0 1 .342-.14q.2 0 .342.142zM4 1.57l-.939.939a.47.47 0 0 1-.34.142.47.47 0 0 1-.341-.142.47.47 0 0 1-.143-.342q0-.2.143-.342L3.666.539A.4.4 0 0 1 3.82.436a.5.5 0 0 1 .358 0 .4.4 0 0 1 .155.103L5.62 1.825a.47.47 0 0 1 .143.342.47.47 0 0 1-.143.342.47.47 0 0 1-.342.14.47.47 0 0 1-.342-.143z"], ChevronSingleEast: ["M4.17 4 2.585 2.415a.45.45 0 0 1-.132-.332.45.45 0 0 1 .464-.463.45.45 0 0 1 .331.132l1.914 1.914a.44.44 0 0 1 .103.155.5.5 0 0 1 0 .358.4.4 0 0 1-.103.155L3.248 6.248a.45.45 0 0 1-.331.132.45.45 0 0 1-.464-.463.45.45 0 0 1 .132-.332z"], ChevronSingleNorth: ["M4 3.58 2.415 5.165a.45.45 0 0 1-.332.132.45.45 0 0 1-.463-.464.45.45 0 0 1 .132-.331l1.914-1.914A.46.46 0 0 1 4 2.445q.193 0 .334.143l1.914 1.914a.45.45 0 0 1 .132.331.45.45 0 0 1-.463.464.45.45 0 0 1-.332-.132z"], ChevronSingleSouth: ["M4 5.546a.5.5 0 0 1-.179-.033.4.4 0 0 1-.155-.102L1.752 3.497a.45.45 0 0 1-.132-.332.45.45 0 0 1 .463-.463.45.45 0 0 1 .332.132L4 4.419l1.585-1.585a.45.45 0 0 1 .332-.132.45.45 0 0 1 .463.463.45.45 0 0 1-.132.332L4.334 5.41a.4.4 0 0 1-.155.102.5.5 0 0 1-.179.033Z"], ChevronSingleWest: ["m3.58 4 1.585 1.585a.45.45 0 0 1 .132.332.45.45 0 0 1-.464.463.45.45 0 0 1-.331-.132L2.588 4.334a.4.4 0 0 1-.103-.155.5.5 0 0 1 0-.358.4.4 0 0 1 .103-.155l1.914-1.914a.45.45 0 0 1 .331-.132.45.45 0 0 1 .464.463.45.45 0 0 1-.132.332z"], Chip: ["M2.75 4.832V3.166q0-.177.12-.297t.297-.12h1.666q.177 0 .297.12t.12.297v1.666q0 .177-.12.297a.4.4 0 0 1-.297.12H3.167a.4.4 0 0 1-.297-.12.4.4 0 0 1-.12-.297m0 2.5v-.416h-.833a.8.8 0 0 1-.589-.245.8.8 0 0 1-.245-.589V5.25H.667a.4.4 0 0 1-.297-.12.4.4 0 0 1-.12-.297q0-.177.12-.297t.297-.12h.416v-.833H.667a.4.4 0 0 1-.297-.12.4.4 0 0 1-.12-.296q0-.177.12-.297t.297-.12h.416v-.833q0-.345.245-.589a.8.8 0 0 1 .589-.245h.833V.666q0-.177.12-.297t.297-.12c.177 0 .217.04.297.12q.12.12.12.297v.416h.833V.666q0-.177.12-.297t.296-.12c.176 0 .217.04.297.12q.12.12.12.297v.416h.833q.345 0 .589.245.245.245.245.589v.833h.416q.177 0 .297.12t.12.297c0 .177-.04.217-.12.297a.4.4 0 0 1-.297.12h-.416v.833h.416q.177 0 .297.12t.12.296c0 .176-.04.217-.12.297a.4.4 0 0 1-.297.12h-.416v.833q0 .345-.245.589a.8.8 0 0 1-.589.245H5.25v.416q0 .177-.12.297a.4.4 0 0 1-.297.12.4.4 0 0 1-.297-.12.4.4 0 0 1-.12-.297v-.416h-.833v.416q0 .177-.12.297a.4.4 0 0 1-.296.12.4.4 0 0 1-.297-.12.4.4 0 0 1-.12-.297m3.333-1.25V1.916H1.917v4.166z"], CircleAlert: ["M3.998 5.6a.294.294 0 0 0 .302-.298A.294.294 0 0 0 4.002 5a.294.294 0 0 0-.302.298.294.294 0 0 0 .298.302m0-1.2a.3.3 0 0 0 .215-.086A.3.3 0 0 0 4.3 4.1V2.7a.3.3 0 0 0-.086-.214.3.3 0 0 0-.212-.086.3.3 0 0 0-.214.086.3.3 0 0 0-.088.214v1.4q0 .127.086.214a.3.3 0 0 0 .212.086m.004 2.8a3.1 3.1 0 0 1-1.244-.25A3.23 3.23 0 0 1 1.05 5.242 3.1 3.1 0 0 1 .8 3.996a3.1 3.1 0 0 1 .25-1.242A3.24 3.24 0 0 1 2.758 1.05Q3.341.8 4.004.8a3.1 3.1 0 0 1 1.242.25A3.24 3.24 0 0 1 6.95 2.756a3.1 3.1 0 0 1 .25 1.242q0 .66-.25 1.244A3.23 3.23 0 0 1 5.244 6.95a3.1 3.1 0 0 1-1.242.25"], CircleAlertOutline: ["M4.417 5.252a.418.418 0 1 1-.836 0 .418.418 0 0 1 .836 0M3.687 4V2.747a.313.313 0 1 1 .626 0V4a.313.313 0 1 1-.626 0", "M7.34 4A3.34 3.34 0 1 0 .66 4a3.34 3.34 0 0 0 6.68 0M1.286 4a2.714 2.714 0 1 1 5.428 0 2.714 2.714 0 0 1-5.428 0"], CircleCheckmark: ["m3.593 4.53-.665-.665a.35.35 0 0 0-.261-.103.354.354 0 0 0-.364.365.35.35 0 0 0 .104.26l.919.919a.37.37 0 0 0 .534 0l1.853-1.853a.35.35 0 0 0 .104-.26.353.353 0 0 0-.365-.365.35.35 0 0 0-.261.104zm.472 2.871a3.3 3.3 0 0 1-1.327-.268 3.4 3.4 0 0 1-1.08-.726 3.4 3.4 0 0 1-.726-1.08A3.3 3.3 0 0 1 .664 4q0-.708.268-1.328.267-.62.726-1.079a3.4 3.4 0 0 1 1.08-.726A3.3 3.3 0 0 1 4.065.599q.708 0 1.328.268.621.267 1.08.726.457.459.726 1.08.267.62.268 1.327c.001.707-.09.914-.268 1.328q-.268.62-.727 1.079a3.4 3.4 0 0 1-1.079.726 3.3 3.3 0 0 1-1.328.268"], CircleInfo: ["M4.006 5.7a.35.35 0 0 0 .259-.104.35.35 0 0 0 .104-.259V4.034a.35.35 0 0 0-.104-.26.35.35 0 0 0-.26-.104.35.35 0 0 0-.258.105.35.35 0 0 0-.105.259v1.303q0 .155.105.259a.35.35 0 0 0 .259.104m0-2.657a.36.36 0 0 0 .266-.107.36.36 0 0 0 .107-.266.36.36 0 0 0-.107-.266.36.36 0 0 0-.266-.107.36.36 0 0 0-.266.107.36.36 0 0 0-.107.266q0 .16.107.266.107.108.266.107m0 4.362a3.3 3.3 0 0 1-1.328-.268 3.4 3.4 0 0 1-1.08-.726 3.4 3.4 0 0 1-.726-1.08 3.3 3.3 0 0 1-.267-1.327q0-.708.267-1.328.268-.62.727-1.08A3.4 3.4 0 0 1 2.678.87 3.3 3.3 0 0 1 4.006.603q.707 0 1.328.267.62.267 1.079.727.459.458.726 1.079.268.62.268 1.328 0 .707-.268 1.328-.267.62-.726 1.079a3.4 3.4 0 0 1-1.08.726 3.3 3.3 0 0 1-1.327.268"], Close: ["M4.036 4.616 2.478 6.174a.42.42 0 0 1-.308.125.42.42 0 0 1-.309-.125.42.42 0 0 1-.125-.309.42.42 0 0 1 .125-.308L3.42 3.999 1.861 2.44a.42.42 0 0 1-.125-.309.42.42 0 0 1 .125-.309.42.42 0 0 1 .309-.124q.183 0 .308.124L4.036 3.38l1.558-1.558a.42.42 0 0 1 .31-.124q.183 0 .308.124a.42.42 0 0 1 .124.31.42.42 0 0 1-.124.308L4.654 3.999l1.558 1.558a.42.42 0 0 1 .124.308.42.42 0 0 1-.124.31.42.42 0 0 1-.309.124.42.42 0 0 1-.309-.125z"], Cloud: ["M2.167 6.667q-.759 0-1.296-.525a1.73 1.73 0 0 1-.538-1.284q0-.65.392-1.158a1.73 1.73 0 0 1 1.025-.65q.209-.766.833-1.242A2.28 2.28 0 0 1 4 1.333q.975 0 1.654.68a2.25 2.25 0 0 1 .68 1.654q.574.067.954.495.378.43.379 1.005 0 .624-.438 1.062a1.45 1.45 0 0 1-1.062.438z"], CloudDataTransfer: ["M2.17 6.67c-.51 0-.94-.18-1.29-.53-.35-.33-.55-.8-.54-1.28 0-.43.13-.82.39-1.16.25-.33.62-.56 1.03-.65.14-.51.42-.92.83-1.24.41-.31.9-.48 1.42-.48.65 0 1.2.23 1.65.68.45.43.69 1.03.68 1.65.38.04.7.21.95.49.25.29.38.62.38 1.01 0 .42-.15.77-.44 1.06-.28.29-.66.44-1.06.44H4.34V4.28l.3.29c.06.06.14.09.23.09.18 0 .33-.14.33-.32v-.02c0-.09-.03-.17-.09-.23l-.87-.87a.317.317 0 0 0-.45-.01l-.01.01-.87.87c-.06.06-.1.14-.1.23s.03.18.1.24c.06.06.14.09.23.09q.135 0 .24-.09l.3-.29v2.38h-1.5Z"], Collapse: ["M2.665 5.33H1.473a.46.46 0 0 1-.337-.137.46.46 0 0 1-.137-.337q0-.2.137-.336a.46.46 0 0 1 .337-.138h1.666q.2 0 .337.138a.46.46 0 0 1 .137.336v1.667a.46.46 0 0 1-.137.337.46.46 0 0 1-.337.137.46.46 0 0 1-.336-.137.46.46 0 0 1-.138-.337zm2.67-2.667h1.192q.2 0 .337.138a.46.46 0 0 1 .137.336.46.46 0 0 1-.137.337.46.46 0 0 1-.337.137H4.861a.46.46 0 0 1-.337-.137.46.46 0 0 1-.137-.337V1.471q0-.2.137-.337a.46.46 0 0 1 .337-.137q.2 0 .337.137a.46.46 0 0 1 .137.337z"], Compass: ["m2.792 5.432 1.683-.483a.67.67 0 0 0 .458-.458l.484-1.684a.16.16 0 0 0-.046-.162.16.16 0 0 0-.163-.046l-1.683.483a.67.67 0 0 0-.458.459l-.484 1.683a.16.16 0 0 0 .046.163.16.16 0 0 0 .163.045M4 4.516a.48.48 0 0 1-.354-.146.48.48 0 0 1-.146-.354.48.48 0 0 1 .146-.354A.48.48 0 0 1 4 3.516q.208 0 .354.146a.48.48 0 0 1 .146.354.48.48 0 0 1-.146.354.48.48 0 0 1-.354.146m0 2.833q-.691 0-1.3-.262a3.4 3.4 0 0 1-1.058-.713q-.45-.45-.713-1.058a3.25 3.25 0 0 1-.262-1.3q0-.692.262-1.3.263-.609.713-1.059T2.7.945A3.25 3.25 0 0 1 4 .682q.691 0 1.3.263.608.262 1.058.712t.713 1.059.262 1.3q0 .69-.262 1.3a3.4 3.4 0 0 1-.713 1.058q-.45.45-1.058.713a3.25 3.25 0 0 1-1.3.262"], Configuring: ["M1 6.333v-.666h.917l-.134-.117a2.1 2.1 0 0 1-.608-.875A3 3 0 0 1 1 3.683q0-.925.554-1.645.555-.722 1.446-.955v.7q-.6.217-.967.738a1.97 1.97 0 0 0-.366 1.162q0 .375.141.73.142.354.442.654l.083.083v-.817H3v2zm5.975-3H6.3a1.8 1.8 0 0 0-.18-.558 2.2 2.2 0 0 0-.37-.508l-.083-.084V3H5V1h2v.667h-.917l.134.116q.34.35.525.742.183.391.233.808m-1.308 4-.1-.5a2 2 0 0 1-.188-.087 2 2 0 0 1-.179-.113l-.483.15-.334-.566.384-.334a2 2 0 0 1-.017-.216q0-.101.017-.217l-.384-.333.334-.567.483.15a1.3 1.3 0 0 1 .18-.112q.087-.046.187-.088l.1-.5h.666l.1.5a1.3 1.3 0 0 1 .367.217l.483-.167.334.583-.384.334a1.3 1.3 0 0 1 0 .416l.384.334-.334.566-.483-.15a1.3 1.3 0 0 1-.18.113q-.087.046-.187.087l-.1.5zm.333-1q.275 0 .47-.196a.64.64 0 0 0 .197-.47.64.64 0 0 0-.196-.471A.64.64 0 0 0 6 5a.64.64 0 0 0-.47.196.64.64 0 0 0-.197.47q0 .275.196.471A.64.64 0 0 0 6 6.333"], Connectivity: ["M1.876 6.574a.35.35 0 0 1-.265.107.33.33 0 0 1-.254-.121 3.6 3.6 0 0 1-.596-1.02 3.4 3.4 0 0 1-.216-1.207q0-.717.272-1.347.27-.63.738-1.098a3.5 3.5 0 0 1 1.098-.738A3.4 3.4 0 0 1 4 .878a3.47 3.47 0 0 1 2.445 1.01q.466.467.738 1.098.272.63.272 1.347 0 .642-.216 1.207a3.6 3.6 0 0 1-.596 1.02.33.33 0 0 1-.251.124.34.34 0 0 1-.262-.104.34.34 0 0 1-.101-.254.42.42 0 0 1 .097-.273 2.77 2.77 0 0 0 .603-1.72 2.63 2.63 0 0 0-.795-1.934A2.63 2.63 0 0 0 4 1.605q-1.14 0-1.934.794a2.63 2.63 0 0 0-.794 1.934 2.67 2.67 0 0 0 .608 1.713.43.43 0 0 1 .1.27.34.34 0 0 1-.104.258m.964-.964a.37.37 0 0 1-.262.113.28.28 0 0 1-.243-.123 2.3 2.3 0 0 1-.312-.585 2 2 0 0 1-.115-.682q0-.871.61-1.481T4 2.242t1.481.61q.61.61.61 1.481A2.1 2.1 0 0 1 5.665 5.6a.3.3 0 0 1-.243.123.34.34 0 0 1-.262-.107.35.35 0 0 1-.104-.252.5.5 0 0 1 .082-.28q.105-.168.165-.355t.06-.396a1.3 1.3 0 0 0-.4-.962A1.3 1.3 0 0 0 4 2.97q-.562 0-.963.4a1.3 1.3 0 0 0-.4.962q0 .215.06.399t.165.351a.47.47 0 0 1 .082.277.35.35 0 0 1-.104.25ZM4 5.062a.7.7 0 0 1-.515-.214.7.7 0 0 1-.213-.515.7.7 0 0 1 .214-.514A.7.7 0 0 1 4 3.605a.7.7 0 0 1 .515.214.7.7 0 0 1 .213.515.7.7 0 0 1-.214.514.7.7 0 0 1-.514.214"], Console: ["M.66 1.55c0-.311 0-.467.06-.586A.56.56 0 0 1 .965.72c.118-.06.274-.06.585-.06h4.898c.312 0 .468 0 .587.06.105.054.19.14.243.244.061.119.061.275.061.587v2.588H5.67l-.066.005a.4.4 0 0 0-.23.117l-.703.704-.854-1.708-.03-.052a.418.418 0 0 0-.639-.057l-.992.991H.66V1.551Zm.974.502a.417.417 0 1 0 0-.835.417.417 0 0 0 0 .835m1.531-.418a.417.417 0 1 1-.835 0 .417.417 0 0 1 .835 0m.696.418a.417.417 0 1 0 0-.835.417.417 0 0 0 0 .835", "M5.843 4.974H7.34V6.45c0 .312 0 .468-.06.587a.56.56 0 0 1-.244.243c-.119.061-.275.061-.587.061H1.551c-.312 0-.468 0-.587-.06a.56.56 0 0 1-.243-.244C.66 6.917.66 6.761.66 6.45V4.974h1.67l.066-.005a.4.4 0 0 0 .23-.117l.703-.704.854 1.709.03.051c.146.21.452.244.639.057l.99-.99Z"], Copy: ["M3.07 6.022a.73.73 0 0 1-.537-.222.73.73 0 0 1-.222-.536V1.31a.73.73 0 0 1 .222-.536.73.73 0 0 1 .537-.222h2.952a.73.73 0 0 1 .537.222.73.73 0 0 1 .221.536v3.953a.73.73 0 0 1-.221.536.73.73 0 0 1-.537.222H3.07ZM1.645 7.447a.73.73 0 0 1-.537-.222.73.73 0 0 1-.222-.536V2.357a.37.37 0 0 1 .11-.27.37.37 0 0 1 .27-.109q.16 0 .269.11t.11.27v4.33h3.331a.37.37 0 0 1 .27.11q.11.11.11.27a.37.37 0 0 1-.11.27.37.37 0 0 1-.27.109z"], CreditCard: ["M7.333 2v4q0 .275-.196.47a.64.64 0 0 1-.47.197H1.333a.64.64 0 0 1-.47-.196A.64.64 0 0 1 .666 6V2q0-.275.195-.47a.64.64 0 0 1 .471-.197h5.334q.275 0 .47.196A.64.64 0 0 1 7.332 2Zm-6 .667h5.334V2H1.333zm0 1.333v2h5.334V4z"], Cube: ["M3.667 6.474V4.191l-2-1.159v2.284zm.666 0 2-1.158V3.032l-2 1.159zM4 3.616l1.975-1.142L4 1.332 2.025 2.474zM1.333 5.899A.65.65 0 0 1 1 5.324v-2.65a.65.65 0 0 1 .333-.575L3.667.757a.66.66 0 0 1 .666 0L6.667 2.1A.65.65 0 0 1 7 2.674v2.65a.65.65 0 0 1-.333.575L4.333 7.241a.66.66 0 0 1-.666 0z"], CubeOutbound: ["M6.559 4.511v-.03s-.01 0-.01-.01a.3.3 0 0 0-.17-.18c0-.01-.01-.01-.02-.01v-.01l-2.239-.84a.5.5 0 0 0-.24 0l-2.239.84-.01.01c-.01 0-.01.01-.02.01s-.01.01-.02.01l-.01.01a.28.28 0 0 0-.14.2s-.01 0-.01.01v2.07c.01.11.08.2.18.25L3.85 7.96v.01c.01 0 .03.01.04.01s.01 0 .01.01h.03s.01 0 .01.01h.12c0-.01.01-.01.01-.01h.03c.02-.01.03-.02.05-.03l2.239-1.12.03-.02c.1-.06.15-.16.15-.27V4.52zM3.67 7.13l-1.58-.79V5.07l1.58.59zM4 5.071l-1.29-.48L4 4.101l1.29.49zM5.91 6.34l-1.58.79V5.66l1.58-.59zM5.08.942l-.86-.85c-.01-.02-.03-.03-.05-.04l-.03-.02-.03-.01-.03-.01-.03-.01a.37.37 0 0 0-.29.1l-.84.84-.02.03c-.26.31.19.74.5.44l.27-.27v1.47c.02.17.16.3.33.3l.04-.01c.16-.01.29-.16.29-.33v-1.43l.27.27.04.03c.13.1.32.09.44-.03l.02-.03c.11-.13.1-.32-.02-.44"], Danger: ["M4 7.258a.7.7 0 0 1-.266-.05.7.7 0 0 1-.223-.153L.945 4.489a.7.7 0 0 1-.154-.223A.7.7 0 0 1 .742 4q0-.15.049-.266a.7.7 0 0 1 .152-.22L3.51.945a.7.7 0 0 1 .223-.154A.7.7 0 0 1 4 .742q.15 0 .266.049a.7.7 0 0 1 .223.154l2.566 2.566a.7.7 0 0 1 .154.223.7.7 0 0 1 .049.266q0 .15-.049.266a.7.7 0 0 1-.154.223L4.486 7.057a.7.7 0 0 1-.22.152.7.7 0 0 1-.266.049m-.002-3.042a.32.32 0 0 0 .236-.095.32.32 0 0 0 .096-.235V2.748a.324.324 0 0 0-.328-.332.32.32 0 0 0-.236.095.32.32 0 0 0-.096.234v1.139a.324.324 0 0 0 .328.332m0 1.06a.324.324 0 0 0 .332-.328.324.324 0 0 0-.328-.332.324.324 0 0 0-.332.328.324.324 0 0 0 .328.332"], Dashboard: ["M2.363 5.35h1.611a.37.37 0 0 0 .27-.11.37.37 0 0 0 .11-.27v-.277a.37.37 0 0 0-.11-.27.37.37 0 0 0-.27-.11h-1.61a.37.37 0 0 0-.27.11.37.37 0 0 0-.11.27v.277q0 .16.11.27t.27.11Zm2.996 0h.278a.37.37 0 0 0 .27-.11.37.37 0 0 0 .109-.27V3.03a.37.37 0 0 0-.11-.27.37.37 0 0 0-.27-.11H5.36a.37.37 0 0 0-.27.11.37.37 0 0 0-.109.27v1.94q0 .16.11.27t.27.11ZM2.363 3.686h1.611a.37.37 0 0 0 .27-.11.37.37 0 0 0 .11-.27V3.03a.37.37 0 0 0-.11-.27.37.37 0 0 0-.27-.11h-1.61a.37.37 0 0 0-.27.11.37.37 0 0 0-.11.27v.277q0 .16.11.27t.27.11ZM1.357 6.734a.73.73 0 0 1-.536-.221.73.73 0 0 1-.222-.537V2.024a.73.73 0 0 1 .222-.537.73.73 0 0 1 .536-.221h5.286a.73.73 0 0 1 .536.221.73.73 0 0 1 .222.537v3.952a.73.73 0 0 1-.222.537.73.73 0 0 1-.536.221z"], Deactivate: ["M2.726 1.713a.37.37 0 0 1-.114-.267q0-.153.114-.267l.36-.36a.74.74 0 0 1 .532-.22h2.358a.73.73 0 0 1 .537.222.73.73 0 0 1 .221.537v3.444a.35.35 0 0 1-.233.351.35.35 0 0 1-.413-.084zm-.702 5.689a.73.73 0 0 1-.537-.222.73.73 0 0 1-.221-.537V2.954a.74.74 0 0 1 .221-.534l.016-.017L.435 1.335a.32.32 0 0 1-.101-.244.35.35 0 0 1 .107-.243.37.37 0 0 1 .244-.102.32.32 0 0 1 .245.1l6.226 6.225a.33.33 0 0 1 .098.24.35.35 0 0 1-.098.248.34.34 0 0 1-.246.104.34.34 0 0 1-.247-.104L5.021 5.92l.495-.489 1.218 1.217v.008a.7.7 0 0 1-.221.529.74.74 0 0 1-.537.218z"], Document: ["M3 4.333h2a.32.32 0 0 0 .237-.096A.32.32 0 0 0 5.333 4a.32.32 0 0 0-.096-.237A.32.32 0 0 0 5 3.667H3a.32.32 0 0 0-.237.096.32.32 0 0 0-.096.237.32.32 0 0 0 .096.237.32.32 0 0 0 .237.096m0 1h2a.32.32 0 0 0 .237-.096A.32.32 0 0 0 5.333 5a.32.32 0 0 0-.096-.237A.32.32 0 0 0 5 4.667H3a.32.32 0 0 0-.237.096.32.32 0 0 0-.096.237.32.32 0 0 0 .096.237.32.32 0 0 0 .237.096m0 1h1a.32.32 0 0 0 .237-.096A.32.32 0 0 0 4.333 6a.32.32 0 0 0-.096-.237A.32.32 0 0 0 4 5.667H3a.32.32 0 0 0-.237.096.32.32 0 0 0-.096.237.32.32 0 0 0 .096.237.32.32 0 0 0 .237.096m-1 1a.64.64 0 0 1-.47-.196.64.64 0 0 1-.197-.47V1.333q0-.275.196-.47A.64.64 0 0 1 2 .666h2.392a.66.66 0 0 1 .466.191l1.617 1.617a.65.65 0 0 1 .192.467v3.725q0 .275-.196.47A.64.64 0 0 1 6 7.333zm2.333-4.666q0 .141.096.237A.32.32 0 0 0 4.667 3H6L4.333 1.333z"], DownloadTray: ["M4 5.437a.5.5 0 0 1-.179-.032.4.4 0 0 1-.155-.102L2.129 3.765a.44.44 0 0 1-.136-.331.48.48 0 0 1 .472-.478.45.45 0 0 1 .337.138l.724.724V1.056q0-.2.137-.337A.46.46 0 0 1 4 .582q.2 0 .337.137a.46.46 0 0 1 .137.337v2.762l.724-.724a.47.47 0 0 1 .67.006q.135.143.14.333a.44.44 0 0 1-.14.332L4.335 5.303a.4.4 0 0 1-.155.102.5.5 0 0 1-.179.032ZM1.53 7.418a.9.9 0 0 1-.67-.277.9.9 0 0 1-.278-.67v-.777q0-.2.137-.337a.46.46 0 0 1 .337-.137q.2 0 .337.137a.46.46 0 0 1 .137.337v.776h4.94v-.776q0-.2.137-.337a.46.46 0 0 1 .337-.137q.2 0 .337.137a.46.46 0 0 1 .137.337v.776a.9.9 0 0 1-.277.67.9.9 0 0 1-.67.278z"], Envelope: ["M1.333 6.667a.64.64 0 0 1-.47-.196A.64.64 0 0 1 .667 6V2q0-.275.196-.47a.64.64 0 0 1 .47-.197h5.334q.275 0 .47.196A.64.64 0 0 1 7.333 2v4q0 .275-.195.47a.64.64 0 0 1-.471.197zM4 4.275a.33.33 0 0 0 .175-.05L6.533 2.75a.28.28 0 0 0 .134-.242.27.27 0 0 0-.142-.25q-.142-.082-.292.009L4 3.667l-2.233-1.4q-.15-.092-.292-.004a.27.27 0 0 0-.142.245q0 .084.034.146a.22.22 0 0 0 .1.096l2.358 1.475a.35.35 0 0 0 .175.05"], Expand: ["M1.974 6.024h1.193q.2 0 .336.137a.46.46 0 0 1 .138.337.46.46 0 0 1-.138.337.46.46 0 0 1-.336.137H1.5a.46.46 0 0 1-.337-.137.46.46 0 0 1-.137-.337V4.831q0-.199.137-.336a.46.46 0 0 1 .337-.137q.2 0 .337.137a.46.46 0 0 1 .137.337zm4.052-4.052H4.833a.46.46 0 0 1-.336-.137.46.46 0 0 1-.138-.337q0-.2.138-.337a.46.46 0 0 1 .336-.137H6.5q.2 0 .337.137a.46.46 0 0 1 .137.337v1.667a.46.46 0 0 1-.137.337.46.46 0 0 1-.337.137.46.46 0 0 1-.337-.137.46.46 0 0 1-.137-.337z"], ExternalLink: ["M1.69 7.068a.73.73 0 0 1-.536-.222.73.73 0 0 1-.222-.537V1.691a.73.73 0 0 1 .222-.537.73.73 0 0 1 .537-.222h1.93a.37.37 0 0 1 .27.11.37.37 0 0 1 .109.27.37.37 0 0 1-.11.269.37.37 0 0 1-.27.11H1.69v4.618h4.62V4.38q0-.159.11-.27A.37.37 0 0 1 6.688 4q.16 0 .269.11t.11.27v1.93a.73.73 0 0 1-.222.536.73.73 0 0 1-.537.222zm4.62-4.849L3.557 4.97a.35.35 0 0 1-.263.105.36.36 0 0 1-.369-.371q0-.159.106-.264L5.78 1.69h-.735a.37.37 0 0 1-.27-.11.37.37 0 0 1-.11-.269q0-.16.11-.269a.37.37 0 0 1 .27-.11h1.643q.16 0 .269.11t.11.27v1.642a.37.37 0 0 1-.11.27.37.37 0 0 1-.27.11.37.37 0 0 1-.269-.11.37.37 0 0 1-.11-.27V2.22Z"], Feedback: ["m1.996 6.068-.687.687a.35.35 0 0 1-.413.081.354.354 0 0 1-.233-.353V1.357A.73.73 0 0 1 .885.821.73.73 0 0 1 1.42.599h5.286a.73.73 0 0 1 .536.222.73.73 0 0 1 .222.536V5.31a.73.73 0 0 1-.222.537.73.73 0 0 1-.536.222h-4.71Zm1.719-2.385v.65a.34.34 0 0 0 .35.35.34.34 0 0 0 .248-.1.34.34 0 0 0 .1-.25v-.65h.651a.34.34 0 0 0 .249-.1.34.34 0 0 0 .1-.25.34.34 0 0 0-.1-.249.34.34 0 0 0-.249-.1h-.65v-.65a.34.34 0 0 0-.101-.25.34.34 0 0 0-.249-.1.34.34 0 0 0-.249.1.34.34 0 0 0-.1.25v.65h-.65a.34.34 0 0 0-.25.1.34.34 0 0 0-.1.25q0 .147.1.248c.1.101.15.1.25.1z"], Filter: ["M3.657 6.316a.42.42 0 0 1-.311-.126.42.42 0 0 1-.126-.31q0-.185.13-.314a.43.43 0 0 1 .312-.129h.68a.433.433 0 0 1 .437.443.43.43 0 0 1-.442.436zM2.296 4.437a.42.42 0 0 1-.312-.125.42.42 0 0 1-.125-.31.433.433 0 0 1 .437-.444H5.7q.185 0 .311.13a.43.43 0 0 1 .126.313.42.42 0 0 1-.126.31.42.42 0 0 1-.311.126zm-1.02-1.879a.42.42 0 0 1-.31-.125.42.42 0 0 1-.126-.31q0-.186.129-.315a.43.43 0 0 1 .313-.128h5.441a.433.433 0 0 1 .437.443.43.43 0 0 1-.442.436H1.277Z"], Gauge: ["M3.483 5.167a.67.67 0 0 0 .525.196q.317-.013.459-.23l1.408-2.108q.075-.117-.02-.213-.098-.095-.213-.02L3.533 4.2q-.216.15-.237.454a.63.63 0 0 0 .187.513M1.7 6.667a.7.7 0 0 1-.337-.08.6.6 0 0 1-.246-.237 3.7 3.7 0 0 1-.334-.813 3.3 3.3 0 0 1-.116-.87q0-.692.262-1.3.263-.609.713-1.059T2.7 1.596A3.25 3.25 0 0 1 4 1.333q.684 0 1.283.259A3.37 3.37 0 0 1 7.05 3.337q.267.597.275 1.28a3.27 3.27 0 0 1-.45 1.733.6.6 0 0 1-.246.237.7.7 0 0 1-.337.08z"], Gear: ["M3.7 7.731a.43.43 0 0 1-.285-.107.43.43 0 0 1-.152-.268l-.087-.675a3 3 0 0 1-.191-.094 1 1 0 0 1-.185-.125l-.638.265a.4.4 0 0 1-.31.013.4.4 0 0 1-.232-.198L1.057 5.53a.44.44 0 0 1-.05-.295.4.4 0 0 1 .16-.248l.528-.408-.008-.113a1.4 1.4 0 0 1 0-.214l.008-.117-.52-.39a.38.38 0 0 1-.158-.254.46.46 0 0 1 .051-.301l.56-.978a.43.43 0 0 1 .533-.185l.603.245q.093-.07.207-.13a5 5 0 0 1 .21-.108l.082-.66a.4.4 0 0 1 .148-.267A.44.44 0 0 1 3.7 1h1.113q.159 0 .288.107.13.105.148.268l.08.67q.105.053.208.108.102.055.2.127l.61-.253a.4.4 0 0 1 .304-.012q.15.057.237.197l.56.98a.45.45 0 0 1 .049.3.4.4 0 0 1-.159.252l-.55.417q.01.054.012.111a4 4 0 0 1-.002.2l-.006.12.524.395a.423.423 0 0 1 .12.552l-.557 1a.4.4 0 0 1-.238.198.42.42 0 0 1-.314-.013l-.632-.265a3 3 0 0 1-.177.118q-.09.054-.181.093l-.088.686a.43.43 0 0 1-.152.268.43.43 0 0 1-.284.107zm.535-2.168q.505 0 .855-.35.351-.352.351-.856t-.35-.855a1.16 1.16 0 0 0-.856-.35q-.501 0-.854.35a1.16 1.16 0 0 0-.352.855q0 .505.352.856.353.35.854.35"], Globe: ["M4 7.494a3.4 3.4 0 0 1-1.366-.275 3.5 3.5 0 0 1-1.107-.746A3.5 3.5 0 0 1 .78 5.366 3.4 3.4 0 0 1 .506 4q0-.73.275-1.366t.746-1.107A3.5 3.5 0 0 1 2.634.78 3.4 3.4 0 0 1 4 .506q.73 0 1.366.275t1.107.746.746 1.107T7.493 4t-.274 1.366a3.5 3.5 0 0 1-.746 1.107 3.5 3.5 0 0 1-1.107.746A3.4 3.4 0 0 1 4 7.493Zm0-.884q1.013 0 1.739-.652.725-.652.833-1.624l-.001-.052-.002-.045a.6.6 0 0 1-.23.26.64.64 0 0 1-.353.1h-.634a.7.7 0 0 1-.51-.212.7.7 0 0 1-.213-.511v-.362H3.183v-.685a.7.7 0 0 1 .212-.514.7.7 0 0 1 .51-.214h.362a.7.7 0 0 1 .116-.39.6.6 0 0 1 .285-.232 3 3 0 0 0-.328-.063A2.4 2.4 0 0 0 4 1.39q-1.098 0-1.854.756C1.39 2.902 1.39 3.268 1.39 4q0 .024.002.047l.003.047h1.379q.602 0 1.024.422.423.423.422 1.023v.363H3.136v.554A2.5 2.5 0 0 0 4 6.61"], Heartbeat: ["m3.567 4.242-.284-.425a.3.3 0 0 0-.116-.109.3.3 0 0 0-.159-.041H1.033a.3.3 0 0 1-.166-.054.3.3 0 0 1-.109-.146 2 2 0 0 1-.07-.313 2.4 2.4 0 0 1-.021-.32q0-.784.525-1.309T2.5 1a1.98 1.98 0 0 1 1.5.7A1.98 1.98 0 0 1 5.5 1q.783 0 1.308.525t.525 1.308q0 .167-.02.321a2 2 0 0 1-.071.313.25.25 0 0 1-.104.145.3.3 0 0 1-.171.055H5.192l-.575-.85a.3.3 0 0 0-.13-.113.4.4 0 0 0-.17-.037.3.3 0 0 0-.188.062.34.34 0 0 0-.112.163zM4 6.892a.7.7 0 0 1-.233-.042.6.6 0 0 1-.209-.133 42 42 0 0 1-1.325-1.23 10 10 0 0 1-.875-.954q-.05-.067-.012-.133a.12.12 0 0 1 .112-.067h1.35l.575.85q.05.075.13.113.079.037.17.037.109 0 .188-.062a.34.34 0 0 0 .112-.163l.45-1.358.292.433a.32.32 0 0 0 .275.15h1.542q.075 0 .112.067.037.066-.012.133a10 10 0 0 1-.875.954q-.542.53-1.325 1.23a.6.6 0 0 1-.209.133.7.7 0 0 1-.233.042"], Help: ["m3.898 6.413-.09-.002a2.83 2.83 0 0 1-2.019-.88 2.82 2.82 0 0 1-.824-2.043q0-1.22.852-2.071A2.83 2.83 0 0 1 3.89.567q.61 0 1.14.229a2.96 2.96 0 0 1 1.556 1.557q.23.53.23 1.139 0 1.162-.665 2.134a5.1 5.1 0 0 1-1.666 1.55.4.4 0 0 1-.188.05.3.3 0 0 1-.172-.045.4.4 0 0 1-.133-.125.35.35 0 0 1-.06-.182zm-.014-1.076q.154 0 .26-.107a.36.36 0 0 0 .108-.26.36.36 0 0 0-.107-.261.36.36 0 0 0-.261-.107.36.36 0 0 0-.26.107.36.36 0 0 0-.108.26q0 .155.107.261a.36.36 0 0 0 .26.107Zm-.735-2.543q.102.043.202.003a.4.4 0 0 0 .167-.132.5.5 0 0 1 .166-.144.44.44 0 0 1 .21-.05.44.44 0 0 1 .304.105q.118.106.118.267 0 .106-.063.216-.063.111-.212.257-.205.182-.31.35a.6.6 0 0 0-.106.331q0 .11.077.187a.25.25 0 0 0 .186.077q.105 0 .177-.076a.6.6 0 0 0 .114-.178.8.8 0 0 1 .148-.253q.1-.114.186-.2a1.6 1.6 0 0 0 .28-.372.8.8 0 0 0 .088-.36.8.8 0 0 0-.265-.63q-.264-.238-.708-.238a1.04 1.04 0 0 0-.882.477.25.25 0 0 0-.024.212q.034.105.147.15Z"], History: ["M3.865 0c-.831 0-1.623.255-2.284.716L1.202.295a.256.256 0 0 0-.439.109L.334 2.118a.257.257 0 0 0 .291.315l1.714-.286a.256.256 0 0 0 .148-.424l-.294-.326a3.094 3.094 0 1 1-1.187 3.787.453.453 0 1 0-.837.347c.201.486.497.926.868 1.297A4 4 0 1 0 3.865 0", "M3.733 2.546a.436.436 0 0 0-.436.436v1.454c0 .146.073.282.194.363l.873.581a.437.437 0 0 0 .484-.726l-.678-.451v-1.22a.437.437 0 0 0-.437-.437"], Hyper: ["M2.488 1.466a1.486 1.486 0 1 0 0 2.973h2.214a.351.351 0 0 1 0 .702H2.488a2.188 2.188 0 1 1 1.843-3.369.351.351 0 0 1-.59.38 1.49 1.49 0 0 0-1.253-.686", "M5.512 6.534a1.486 1.486 0 1 0 0-2.973H3.298a.351.351 0 0 1 0-.702h2.214a2.188 2.188 0 1 1-1.843 3.369.351.351 0 0 1 .59-.38c.266.413.728.686 1.253.686"], Inspect: ["M3.792 3.203a.294.294 0 0 0 .416 0l1.35-1.35a.294.294 0 0 0 0-.416L4.208.087a.294.294 0 0 0-.416 0l-1.35 1.35a.294.294 0 0 0 0 .416zM3.2 3.79 1.85 2.44a.296.296 0 0 0-.41 0L.09 3.79a.29.29 0 0 0 0 .42l1.35 1.35c.11.11.3.11.41 0L3.2 4.21a.29.29 0 0 0 0-.42m-.76.29-.71.72c-.05.05-.12.05-.17 0l-.72-.72a.12.12 0 0 1 0-.16l.72-.72c.05-.05.12-.05.17 0l.71.72c.05.04.05.12 0 .16m5.47-.29L6.56 2.44a.296.296 0 0 0-.41 0L4.8 3.79a.29.29 0 0 0 0 .42l1.35 1.35c.11.11.3.11.41 0l1.35-1.35a.29.29 0 0 0 0-.42m-.75.29-.72.72c-.05.05-.12.05-.17 0l-.71-.72a.104.104 0 0 1 0-.16l.71-.72c.05-.05.12-.05.17 0l.72.72c.04.04.04.12 0 .16m-1.6 2.07L4.21 4.8a.29.29 0 0 0-.42 0L2.44 6.15c-.11.11-.11.3 0 .41l1.35 1.35c.12.12.3.12.42 0l1.35-1.35c.11-.11.11-.3 0-.41m-.76.29-.72.72c-.04.04-.12.04-.16 0l-.72-.72a.115.115 0 0 1 0-.17l.72-.71c.04-.05.12-.05.16 0l.72.71c.05.05.05.12 0 .17"], Invisible: ["M6.367 7.3 5.2 6.15a4 4 0 0 1-1.2.183q-1.116 0-2.042-.6A4.23 4.23 0 0 1 .508 4.15a.7.7 0 0 1-.083-.317.64.64 0 0 1 .083-.316A9 9 0 0 1 .9 2.883q.209-.308.483-.55l-.691-.7A.3.3 0 0 1 .6 1.404a.324.324 0 0 1 .333-.329q.143 0 .234.092l5.666 5.666a.33.33 0 0 1 .096.23.31.31 0 0 1-.096.237.32.32 0 0 1-.233.092.32.32 0 0 1-.233-.092M4 5.333q.092 0 .175-.008a1 1 0 0 0 .167-.033l-1.8-1.8a1 1 0 0 0-.034.166 2 2 0 0 0-.008.175q0 .625.438 1.063.437.438 1.062.437m0-4q1.116 0 2.046.605.93.603 1.454 1.587a.5.5 0 0 1 .063.146.8.8 0 0 1 .004.325.5.5 0 0 1-.059.146q-.157.308-.354.583a4 4 0 0 1-.437.517.35.35 0 0 1-.275.108.4.4 0 0 1-.275-.125L5.5 4.558a.27.27 0 0 1-.075-.137.3.3 0 0 1 .008-.163 1.3 1.3 0 0 0 .067-.425q0-.624-.438-1.062A1.45 1.45 0 0 0 4 2.333a1.3 1.3 0 0 0-.425.067.34.34 0 0 1-.167.008.27.27 0 0 1-.141-.075l-.275-.275a.36.36 0 0 1-.104-.366.35.35 0 0 1 .262-.267q.21-.042.42-.067A4 4 0 0 1 4 1.333m.658 1.884q.092.108.154.237a.8.8 0 0 1 .08.271q.008.066-.05.092-.059.024-.109-.025l-.683-.684Q4 3.058 4.03 3a.1.1 0 0 1 .095-.058q.159.016.292.087.134.07.241.188"], Lightning: ["M2.859 5.179h-.92a.42.42 0 0 1-.393-.236.41.41 0 0 1 .028-.459L4.3.557a.5.5 0 0 1 .252-.186.45.45 0 0 1 .31.01.47.47 0 0 1 .3.508l-.28 2.265H6.07a.41.41 0 0 1 .401.253.41.41 0 0 1-.066.472l-2.982 3.59a.46.46 0 0 1-.258.16.49.49 0 0 1-.527-.233.47.47 0 0 1-.056-.3l.276-1.917Z"], LightningSlash: ["M2.859 5.179h-.92a.42.42 0 0 1-.393-.236.41.41 0 0 1 .028-.459l.856-1.233L.88 1.7a.325.325 0 0 1 .46-.46l5.373 5.374a.325.325 0 0 1-.46.46L4.888 5.708l-1.463 1.76a.46.46 0 0 1-.258.16.49.49 0 0 1-.527-.232.47.47 0 0 1-.056-.3zm3.212-.897a.5.5 0 0 1-.738.034L3.48 2.462a.5.5 0 0 1-.057-.639l.88-1.266a.5.5 0 0 1 .251-.186.45.45 0 0 1 .31.01.47.47 0 0 1 .3.508l-.28 2.265h1.188a.41.41 0 0 1 .401.253.41.41 0 0 1-.066.472z"], Location: ["M4 7.164a.7.7 0 0 1-.248-.043.7.7 0 0 1-.222-.131 14 14 0 0 1-.978-.983 7 7 0 0 1-.709-.927 4.3 4.3 0 0 1-.43-.872 2.5 2.5 0 0 1-.147-.816q0-1.278.824-2.035Q2.915.599 4 .599t1.91.758q.824.757.824 2.035 0 .394-.146.816a4.3 4.3 0 0 1-.431.872q-.285.45-.71.927-.423.476-.977.983a.7.7 0 0 1-.222.13.7.7 0 0 1-.249.044ZM4 4.02q.285 0 .486-.2a.66.66 0 0 0 .2-.487.66.66 0 0 0-.2-.485A.66.66 0 0 0 4 2.647a.66.66 0 0 0-.486.2.66.66 0 0 0-.2.486q0 .285.2.486c.2.201.296.2.486.2Z"], Lock: ["M2 7.336a.64.64 0 0 1-.47-.196.64.64 0 0 1-.197-.47V3.335q0-.275.196-.471A.64.64 0 0 1 2 2.669h.333v-.667q0-.69.488-1.179A1.6 1.6 0 0 1 4 .336q.691 0 1.18.487.486.487.487 1.18v.666H6q.275 0 .47.196a.64.64 0 0 1 .197.47V6.67q0 .275-.196.47A.64.64 0 0 1 6 7.337zm2-1.667q.275 0 .47-.196a.64.64 0 0 0 .197-.47.64.64 0 0 0-.196-.471A.64.64 0 0 0 4 4.336a.64.64 0 0 0-.47.196.64.64 0 0 0-.197.47q0 .275.196.471T4 5.669m-1-3h2v-.667a.96.96 0 0 0-.292-.708A.96.96 0 0 0 4 1.002a.96.96 0 0 0-.708.292.96.96 0 0 0-.292.708z"], Mailbox: ["M1.333 7.333a.64.64 0 0 1-.47-.196.64.64 0 0 1-.196-.47V3.333q0-.275.196-.47a.64.64 0 0 1 .47-.196H2V1q0-.141.096-.238a.32.32 0 0 1 .237-.095h2q.142 0 .238.095A.32.32 0 0 1 4.667 1v.667a.32.32 0 0 1-.096.237.32.32 0 0 1-.238.096H2.667v2.333q0 .142.096.238A.32.32 0 0 0 3 4.667a.32.32 0 0 0 .237-.096.32.32 0 0 0 .096-.238V2.667h3.334q.275 0 .47.195a.64.64 0 0 1 .196.471v3.334q0 .275-.195.47a.64.64 0 0 1-.471.196z"], Manufacturing: ["M1.568 7.35a.53.53 0 0 1-.387-.16.53.53 0 0 1-.16-.387.53.53 0 0 1 .16-.387.53.53 0 0 1 .387-.158H2.1l-.814-2.664a1.03 1.03 0 0 1-.43-.385 1.03 1.03 0 0 1-.169-.572q0-.443.309-.752a1.02 1.02 0 0 1 .751-.31q.35 0 .622.203.271.204.38.525h.968V1.97a.35.35 0 0 1 .105-.258.35.35 0 0 1 .259-.105.36.36 0 0 1 .266.123l.547-.515a.4.4 0 0 1 .195-.103.33.33 0 0 1 .222.03l1.3.6a.29.29 0 0 1 .145.377.26.26 0 0 1-.161.144.3.3 0 0 1-.212-.015l-1.178-.542-.76.71v.438l.76.697 1.178-.538A.3.3 0 0 1 6.6 3a.25.25 0 0 1 .158.135.25.25 0 0 1 .014.217.33.33 0 0 1-.159.162l-1.294.612a.35.35 0 0 1-.423-.068l-.547-.516a.6.6 0 0 1-.123.087.3.3 0 0 1-.143.037.35.35 0 0 1-.259-.105.35.35 0 0 1-.105-.259V2.97H2.75a2 2 0 0 1-.069.161.7.7 0 0 1-.098.15l1.609 2.977h.724a.53.53 0 0 1 .387.158.53.53 0 0 1 .159.387.53.53 0 0 1-.159.388.53.53 0 0 1-.387.158zm.18-4.38a.32.32 0 0 0 .238-.096.32.32 0 0 0 .096-.237.32.32 0 0 0-.096-.238.32.32 0 0 0-.238-.096.32.32 0 0 0-.237.096.32.32 0 0 0-.096.238q0 .141.096.237a.32.32 0 0 0 .237.096"], Minus: ["M1.706 4.525a.5.5 0 0 1-.371-.154A.5.5 0 0 1 1.18 4q-.001-.216.154-.37a.5.5 0 0 1 .37-.155H5.89q.216 0 .37.154A.5.5 0 0 1 6.415 4a.5.5 0 0 1-.154.37.5.5 0 0 1-.371.155z"], Money: ["M1 6.399a.58.58 0 0 1-.424-.176.58.58 0 0 1-.176-.424v-3.1q0-.127.086-.214A.3.3 0 0 1 .698 2.4q.127 0 .214.086A.3.3 0 0 1 1 2.7v3.1h5.3a.3.3 0 0 1 .214.086.3.3 0 0 1 .086.212.3.3 0 0 1-.086.214.3.3 0 0 1-.214.088H1Zm1.2-1.2a.58.58 0 0 1-.424-.176.58.58 0 0 1-.176-.424v-2.4a.58.58 0 0 1 .176-.421.57.57 0 0 1 .424-.18H7q.241 0 .42.18.18.18.18.42v2.4q0 .249-.18.425a.58.58 0 0 1-.42.176zm.6-.6a.58.58 0 0 0-.18-.421.58.58 0 0 0-.42-.18v.6h.6Zm3.6 0H7v-.6a.57.57 0 0 0-.425.179.58.58 0 0 0-.175.42Zm-1.804-.2q.42 0 .712-.288a.96.96 0 0 0 .292-.708.97.97 0 0 0-.292-.713.96.96 0 0 0-.708-.29.96.96 0 0 0-.713.291.97.97 0 0 0-.287.709q0 .424.287.712a.96.96 0 0 0 .709.288ZM2.2 2.799a.58.58 0 0 0 .42-.176.57.57 0 0 0 .18-.424h-.6zm4.8 0v-.6h-.6a.58.58 0 0 0 .176.425.58.58 0 0 0 .424.175"], Network: ["M4 7.494q-.717 0-1.353-.277a3.6 3.6 0 0 1-1.112-.752 3.6 3.6 0 0 1-.752-1.112A3.4 3.4 0 0 1 .506 4q0-.72.277-1.355a3.6 3.6 0 0 1 .752-1.11A3.6 3.6 0 0 1 2.647.783 3.4 3.4 0 0 1 4 .506q.72 0 1.355.277a3.6 3.6 0 0 1 1.11.752q.475.476.752 1.11T7.494 4q0 .717-.277 1.353a3.6 3.6 0 0 1-.752 1.112 3.6 3.6 0 0 1-1.11.752A3.4 3.4 0 0 1 4 7.494m-.01-.896q.198-.29.357-.613.157-.323.258-.68H3.39a4.4 4.4 0 0 0 .6 1.293m-.843-.133a3 3 0 0 1-.262-.562 7 7 0 0 1-.178-.598h-.955q.227.408.583.71.356.305.813.45Zm1.691 0q.458-.146.818-.45.36-.302.588-.71h-.956q-.075.303-.182.598a3 3 0 0 1-.268.562M1.473 4.652h1.1A5 5 0 0 1 2.524 4a4 4 0 0 1 .05-.652h-1.1a2.5 2.5 0 0 0-.063.983q.022.16.063.321Zm1.767 0h1.515q.026-.166.033-.324a7 7 0 0 0 0-.658 3 3 0 0 0-.033-.322H3.24a4 4 0 0 0-.038.98q.014.157.038.325Zm2.182 0h1.095A2.7 2.7 0 0 0 6.601 4a2.5 2.5 0 0 0-.084-.652H5.422a6 6 0 0 1 .04.652 5 5 0 0 1-.04.652M5.288 2.69h.955a2.5 2.5 0 0 0-.587-.708 2.4 2.4 0 0 0-.818-.447q.16.266.268.56.107.293.182.595m-1.898 0h1.215a3.7 3.7 0 0 0-.254-.677 5 5 0 0 0-.36-.611 4.3 4.3 0 0 0-.6 1.288Zm-1.638 0h.955q.075-.302.178-.596.103-.293.263-.559a2.3 2.3 0 0 0-.813.447q-.355.3-.583.708"], Organization: ["M1.357 7.068a.73.73 0 0 1-.536-.222.73.73 0 0 1-.222-.537V2.722a.73.73 0 0 1 .222-.536.73.73 0 0 1 .536-.222h1.248v-.667a.73.73 0 0 1 .222-.536.73.73 0 0 1 .536-.222h1.274a.73.73 0 0 1 .536.222.73.73 0 0 1 .222.536v.667h1.248q.315 0 .536.222a.73.73 0 0 1 .222.536V6.31a.73.73 0 0 1-.222.537.73.73 0 0 1-.536.222H1.357Zm2.006-5.104h1.274v-.667H3.363z"], OrganizationAdd: ["M5.763 7.213A.32.32 0 0 0 6 7.31a.32.32 0 0 0 .238-.096.32.32 0 0 0 .095-.237V6.31H7a.32.32 0 0 0 .238-.096.32.32 0 0 0 .095-.237.32.32 0 0 0-.095-.238A.32.32 0 0 0 7 5.643h-.667v-.667a.32.32 0 0 0-.095-.238A.32.32 0 0 0 6 4.643a.32.32 0 0 0-.237.095.32.32 0 0 0-.096.238v.667H5a.32.32 0 0 0-.237.095.32.32 0 0 0-.096.238.32.32 0 0 0 .096.237A.32.32 0 0 0 5 6.31h.667v.667a.32.32 0 0 0 .096.237Z", "M3.363 1.964h1.274v-.667H3.363zM1.357 7.068a.73.73 0 0 1-.536-.222.73.73 0 0 1-.222-.537V2.722a.73.73 0 0 1 .222-.536.73.73 0 0 1 .536-.222h1.248v-.667a.73.73 0 0 1 .222-.536.73.73 0 0 1 .536-.222h1.274a.73.73 0 0 1 .536.222.73.73 0 0 1 .222.536v.667h1.248q.315 0 .536.222a.73.73 0 0 1 .222.536v.89q0 .171-.149.254a.32.32 0 0 1-.309.005 2 2 0 0 0-.456-.154A2.4 2.4 0 0 0 6 3.667q-.966 0-1.65.683A2.25 2.25 0 0 0 3.667 6a2.3 2.3 0 0 0 .083.616.35.35 0 0 1-.049.309.3.3 0 0 1-.258.143z"], Panels: ["M4.3 4.299h2.5v1.9a.58.58 0 0 1-.176.42.57.57 0 0 1-.424.18H4.3zm0-.6v-2.5h1.9a.58.58 0 0 1 .424.176.58.58 0 0 1 .176.425v1.9H4.3Zm-.6 0H1.2v-1.9q0-.247.18-.424A.58.58 0 0 1 1.8 1.2h1.9v2.5Zm0 .6v2.5H1.8a.58.58 0 0 1-.42-.18.58.58 0 0 1-.18-.42v-1.9z"], Pause: ["M5.667 6.917a.8.8 0 0 1-.589-.245.8.8 0 0 1-.245-.589V1.917q0-.345.245-.589a.8.8 0 0 1 .589-.245q.344 0 .588.245.245.245.245.589v4.166q0 .345-.245.589a.8.8 0 0 1-.588.245m-3.334 0a.8.8 0 0 1-.588-.245.8.8 0 0 1-.245-.589V1.917q0-.345.245-.589a.8.8 0 0 1 .588-.245q.345 0 .589.245.245.245.245.589v4.166q0 .345-.245.589a.8.8 0 0 1-.589.245"], Pencil: ["M1.282 7.16a.43.43 0 0 1-.313-.129.43.43 0 0 1-.13-.313v-.912a.87.87 0 0 1 .258-.622L5.23 1.055A.76.76 0 0 1 5.757.84a.76.76 0 0 1 .532.219l.66.655q.11.106.163.247a.8.8 0 0 1 0 .57.7.7 0 0 1-.162.247L2.825 6.902a.87.87 0 0 1-.622.258zm4.481-4.452.467-.462-.472-.476-.471.467z"], Performance: ["M1.667 7a.64.64 0 0 1-.471-.196.64.64 0 0 1-.196-.47V1.666a.64.64 0 0 1 .196-.471.64.64 0 0 1 .47-.195h4.667a.64.64 0 0 1 .471.196q.195.195.196.47v4.667a.64.64 0 0 1-.196.471.64.64 0 0 1-.47.196H1.666Zm4.666-4.583L4.317 4.683 3.233 3.6a.32.32 0 0 0-.466 0l-1.1 1.1v.95L3 4.317l1.1 1.1a.32.32 0 0 0 .246.096.3.3 0 0 0 .237-.113l1.75-1.983z"], Play: ["M2.248 6.205v-4.41q0-.205.142-.339a.47.47 0 0 1 .458-.118.5.5 0 0 1 .125.053l3.472 2.207a.46.46 0 0 1 .161.178.49.49 0 0 1 0 .448.46.46 0 0 1-.16.178L2.972 6.609a.5.5 0 0 1-.251.07.47.47 0 0 1-.332-.135.45.45 0 0 1-.142-.34Z"], Plus: ["M4.036 7.159a.43.43 0 0 1-.312-.129.43.43 0 0 1-.13-.313V4.445H1.319a.43.43 0 0 1-.313-.129.43.43 0 0 1-.129-.313.42.42 0 0 1 .13-.312.43.43 0 0 1 .312-.13H3.59v-2.28q0-.185.129-.314A.43.43 0 0 1 4.032.84a.43.43 0 0 1 .313.128q.128.129.128.313v2.277h2.282q.184 0 .313.129T7.197 4a.43.43 0 0 1-.13.313.43.43 0 0 1-.312.128H4.478v2.277a.43.43 0 0 1-.129.313.43.43 0 0 1-.313.129Z"], Profile: ["M4.117 4.991a1 1 0 0 1-.125.255.8.8 0 0 1-.12-.255 3 3 0 0 1-.102-.414h.456a2.3 2.3 0 0 1-.109.414m-.587-.067a1 1 0 0 0 .102.28 1.17 1.17 0 0 1-.74-.627h.573q.029.184.065.347m1.267.048a1.2 1.2 0 0 1-.442.232q.067-.117.107-.28t.069-.347h.573a1.15 1.15 0 0 1-.307.395m-1.37-.683h-.644A1 1 0 0 1 2.746 4a1 1 0 0 1 .038-.289h.643a2 2 0 0 0-.01.138 5 5 0 0 0 0 .287q.002.074.01.153m.836 0h-.53A2 2 0 0 1 3.72 4a2 2 0 0 1 .013-.289h.53q.009.08.007.149a5 5 0 0 0 0 .276q.002.069-.007.153m.945 0h-.64q.005-.072.005-.14v-.287q0-.071-.004-.15h.64a1 1 0 0 1 .029.142 1.3 1.3 0 0 1 0 .288 1 1 0 0 1-.03.147m-.104-.87H4.53a4 4 0 0 0-.069-.345 1 1 0 0 0-.107-.278 1.2 1.2 0 0 1 .749.623Zm-.878 0H3.77q.038-.222.102-.412a.8.8 0 0 1 .12-.253.8.8 0 0 1 .13.253q.07.19.104.412m-.761 0h-.573q.108-.231.303-.393.195-.164.437-.23a1 1 0 0 0-.102.278 6 6 0 0 0-.065.345", "M.82 6.513a.73.73 0 0 0 .537.221h5.286a.73.73 0 0 0 .536-.221.73.73 0 0 0 .222-.537V4.837a.23.23 0 0 0-.057-.156.25.25 0 0 0-.15-.082.67.67 0 0 1-.328-.226A.58.58 0 0 1 6.734 4q0-.21.132-.375a.66.66 0 0 1 .329-.224.25.25 0 0 0 .149-.082.23.23 0 0 0 .057-.156v-1.14a.73.73 0 0 0-.222-.536.73.73 0 0 0-.536-.221H1.357a.73.73 0 0 0-.536.221.73.73 0 0 0-.222.537V3.16q0 .09.057.157a.25.25 0 0 0 .15.083.66.66 0 0 1 .328.224q.132.165.132.375a.58.58 0 0 1-.132.373.67.67 0 0 1-.329.226.25.25 0 0 0-.149.083.23.23 0 0 0-.057.157v1.137q0 .315.222.537Zm2.503-.903q.317.138.677.138t.677-.138a1.78 1.78 0 0 0 .933-.933q.138-.317.138-.677t-.138-.677a1.78 1.78 0 0 0-.933-.933A1.7 1.7 0 0 0 4 2.252q-.36 0-.677.138a1.78 1.78 0 0 0-.933.933A1.7 1.7 0 0 0 2.252 4q0 .36.138.677a1.78 1.78 0 0 0 .933.933"], ProfileInstalled: ["M4.357 4.328V3.31a.34.34 0 0 0-.103-.252.34.34 0 0 0-.252-.103q-.15 0-.253.103a.34.34 0 0 0-.104.252v1.017l-.268-.26a.34.34 0 0 0-.245-.099.34.34 0 0 0-.252.105.34.34 0 0 0-.1.25q0 .15.1.249l.853.852A.37.37 0 0 0 4 5.54a.37.37 0 0 0 .267-.114l.853-.852a.35.35 0 0 0 .103-.246.33.33 0 0 0-.103-.253.34.34 0 0 0-.246-.102.35.35 0 0 0-.253.098zM2.024 7.4a.73.73 0 0 1-.537-.222.73.73 0 0 1-.221-.536v-3.69a.75.75 0 0 1 .22-.533l1.6-1.6a.74.74 0 0 1 .532-.22h2.358a.73.73 0 0 1 .537.222.73.73 0 0 1 .221.536v5.286a.73.73 0 0 1-.221.536.73.73 0 0 1-.537.222z"], Receipt: ["M1 6.933V.867q0-.06.05-.08t.092.021l.241.242a.16.16 0 0 0 .234 0l.266-.267a.16.16 0 0 1 .234 0l.266.267a.16.16 0 0 0 .234 0l.266-.267a.16.16 0 0 1 .234 0l.266.267a.16.16 0 0 0 .234 0l.266-.267a.16.16 0 0 1 .234 0l.266.267a.16.16 0 0 0 .234 0l.266-.267a.16.16 0 0 1 .234 0l.266.267a.16.16 0 0 0 .234 0l.266-.267a.16.16 0 0 1 .234 0l.266.267a.16.16 0 0 0 .234 0l.241-.242q.042-.04.092-.02T7 .867v6.066q0 .116-.1.159-.1.041-.183-.042l-.1-.1a.16.16 0 0 0-.234 0l-.266.267a.16.16 0 0 1-.234 0l-.266-.267a.16.16 0 0 0-.234 0l-.266.267a.16.16 0 0 1-.234 0l-.266-.267a.16.16 0 0 0-.234 0l-.266.267a.16.16 0 0 1-.234 0l-.266-.267a.16.16 0 0 0-.234 0l-.266.267a.16.16 0 0 1-.234 0l-.266-.267a.16.16 0 0 0-.234 0l-.266.267a.16.16 0 0 1-.234 0l-.266-.267a.16.16 0 0 0-.234 0l-.1.1q-.083.084-.183.042-.1-.041-.1-.159m1.333-1.266h3.334a.32.32 0 0 0 .237-.096A.32.32 0 0 0 6 5.333a.32.32 0 0 0-.096-.237A.32.32 0 0 0 5.667 5H2.333a.32.32 0 0 0-.237.096.32.32 0 0 0-.096.237q0 .142.096.238a.32.32 0 0 0 .237.096m0-1.334h3.334a.32.32 0 0 0 .237-.096A.32.32 0 0 0 6 4a.32.32 0 0 0-.096-.237.32.32 0 0 0-.237-.096H2.333a.32.32 0 0 0-.237.096A.32.32 0 0 0 2 4a.32.32 0 0 0 .096.237.32.32 0 0 0 .237.096m0-1.333h3.334a.32.32 0 0 0 .237-.096A.32.32 0 0 0 6 2.667a.32.32 0 0 0-.096-.238.32.32 0 0 0-.237-.096H2.333a.32.32 0 0 0-.237.096.32.32 0 0 0-.096.238q0 .141.096.237A.32.32 0 0 0 2.333 3"], ReleaseNotes: ["M5.96 6.352v.636q0 .08.059.138a.19.19 0 0 0 .275 0 .2.2 0 0 0 .06-.138v-.636h.636a.2.2 0 0 0 .138-.06.19.19 0 0 0 0-.275.2.2 0 0 0-.138-.059h-.637v-.636a.2.2 0 0 0-.059-.138.19.19 0 0 0-.275 0 .2.2 0 0 0-.059.138v.636h-.637a.2.2 0 0 0-.137.06.19.19 0 0 0 0 .275.2.2 0 0 0 .137.059zm.197 1.47q-.692 0-1.18-.488a1.6 1.6 0 0 1-.487-1.179q0-.691.487-1.18a1.6 1.6 0 0 1 1.18-.487q.69 0 1.179.488.487.488.487 1.179t-.487 1.18a1.6 1.6 0 0 1-1.18.487ZM2.87 3.142h2.62a.32.32 0 0 0 .237-.097.32.32 0 0 0 .096-.237.32.32 0 0 0-.096-.238.32.32 0 0 0-.237-.096H2.871a.32.32 0 0 0-.237.096.32.32 0 0 0-.096.238q0 .141.096.237a.32.32 0 0 0 .237.096Zm-1 4.043a.73.73 0 0 1-.535-.223.73.73 0 0 1-.223-.535v-4.62a.73.73 0 0 1 .223-.535.73.73 0 0 1 .535-.223h4.62a.73.73 0 0 1 .536.223.73.73 0 0 1 .222.536v1.81a.3.3 0 0 1-.144.265.33.33 0 0 1-.307.032q-.15-.045-.311-.068a2.4 2.4 0 0 0-.5-.02 1 1 0 0 0-.163.02.6.6 0 0 0-.16-.048 1 1 0 0 0-.173-.015H2.871a.32.32 0 0 0-.237.096.32.32 0 0 0-.096.237q0 .142.096.238a.32.32 0 0 0 .237.096h1.704a2.2 2.2 0 0 0-.49.642H2.87a.32.32 0 0 0-.237.096.32.32 0 0 0-.096.238q0 .141.096.237a.32.32 0 0 0 .237.096h.99q-.024.098-.03.193a3 3 0 0 0 .008.504q.015.143.053.278.045.165-.05.308a.3.3 0 0 1-.258.142z"], Return: ["m2.072 4.431.924.924a.42.42 0 0 1 0 .61.42.42 0 0 1-.611 0L.72 4.305a.427.427 0 0 1-.002-.608l1.667-1.664a.42.42 0 0 1 .61 0 .42.42 0 0 1 0 .61l-.923.924H6.72v-.692q0-.182.125-.307a.42.42 0 0 1 .305-.126q.18 0 .308.126a.42.42 0 0 1 .127.307v.692q0 .36-.253.612a.83.83 0 0 1-.612.253z"], Review: ["M4 6a.407.407 0 0 0 .416-.417.4.4 0 0 0-.12-.296.4.4 0 0 0-.296-.12.4.4 0 0 0-.296.12.4.4 0 0 0-.12.296q0 .176.12.296.121.12.296.121m1.2-3.017q0-.45-.304-.716Q4.592 2 4.092 2q-.375 0-.663.154a1.13 1.13 0 0 0-.454.446q-.058.092-.004.2a.33.33 0 0 0 .17.158.28.28 0 0 0 .209.004.4.4 0 0 0 .183-.137.6.6 0 0 1 .23-.192.7.7 0 0 1 .295-.066q.233 0 .38.125a.4.4 0 0 1 .145.316q0 .15-.1.317a1.4 1.4 0 0 1-.3.333 1.8 1.8 0 0 0-.325.359 1 1 0 0 0-.141.391.25.25 0 0 0 .07.213.3.3 0 0 0 .221.096.33.33 0 0 0 .213-.08.35.35 0 0 0 .12-.212.7.7 0 0 1 .092-.237q.068-.105.234-.271.315-.316.425-.509a.85.85 0 0 0 .108-.425M1.667 7a.64.64 0 0 1-.471-.196.64.64 0 0 1-.196-.47V1.666a.64.64 0 0 1 .196-.471.64.64 0 0 1 .47-.195h4.667a.64.64 0 0 1 .471.196q.196.195.196.47v4.667a.64.64 0 0 1-.196.471.64.64 0 0 1-.47.196z"], Routes: ["M1.442 4.442a.43.43 0 0 1-.313-.13A.43.43 0 0 1 1 4q0-.184.129-.313a.43.43 0 0 1 .313-.129h2.204l1.502-1.501h-.274a.43.43 0 0 1-.313-.13.43.43 0 0 1-.129-.312q0-.184.129-.313a.43.43 0 0 1 .313-.129h1.333q.184 0 .313.129t.129.313v1.333a.43.43 0 0 1-.129.313.43.43 0 0 1-.313.129.43.43 0 0 1-.313-.129.43.43 0 0 1-.128-.313v-.274l-1.51 1.51a.87.87 0 0 1-.623.258zm3.432 2.385a.43.43 0 0 1-.313-.129.43.43 0 0 1-.129-.313q0-.184.129-.313a.43.43 0 0 1 .313-.128h.265l-.538-.53a.43.43 0 0 1-.133-.315.43.43 0 0 1 .133-.315.44.44 0 0 1 .317-.136.43.43 0 0 1 .317.131l.53.538v-.265q0-.184.13-.313a.43.43 0 0 1 .312-.129q.184 0 .313.129t.129.313v1.333a.43.43 0 0 1-.129.313.43.43 0 0 1-.313.129z"], SIM: ["M2.667 6.332a.32.32 0 0 0 .237-.095A.32.32 0 0 0 3 5.998a.32.32 0 0 0-.096-.237.32.32 0 0 0-.237-.096.32.32 0 0 0-.238.095.32.32 0 0 0-.096.238q0 .142.096.238a.32.32 0 0 0 .238.095Zm0-1.333a.32.32 0 0 0 .237-.096A.32.32 0 0 0 3 4.666v-.667a.32.32 0 0 0-.096-.238.32.32 0 0 0-.237-.095.32.32 0 0 0-.238.095.32.32 0 0 0-.096.238v.667q0 .141.096.237A.32.32 0 0 0 2.667 5ZM4 6.332a.32.32 0 0 0 .237-.095.32.32 0 0 0 .096-.238v-.667a.32.32 0 0 0-.096-.237A.32.32 0 0 0 4 4.999a.32.32 0 0 0-.237.096.32.32 0 0 0-.096.237V6q0 .142.096.238A.32.32 0 0 0 4 6.332m0-2a.32.32 0 0 0 .237-.095.32.32 0 0 0 .096-.238.32.32 0 0 0-.096-.238A.32.32 0 0 0 4 3.666a.32.32 0 0 0-.237.095.32.32 0 0 0-.096.238q0 .141.096.238A.32.32 0 0 0 4 4.332m1.333 2a.32.32 0 0 0 .238-.095.32.32 0 0 0 .096-.238.32.32 0 0 0-.096-.237.32.32 0 0 0-.238-.096.32.32 0 0 0-.237.095A.32.32 0 0 0 5 6q0 .142.096.238a.32.32 0 0 0 .237.095Zm0-1.333a.32.32 0 0 0 .238-.096.32.32 0 0 0 .096-.237v-.667a.32.32 0 0 0-.096-.238.32.32 0 0 0-.238-.095.32.32 0 0 0-.237.095A.32.32 0 0 0 5 4v.667q0 .141.096.237A.32.32 0 0 0 5.333 5ZM2 7.332a.64.64 0 0 1-.47-.196.64.64 0 0 1-.197-.47V2.94a.66.66 0 0 1 .192-.467L3.142.857a.65.65 0 0 1 .466-.191H6q.275 0 .47.195a.64.64 0 0 1 .197.471v5.334q0 .275-.196.47A.64.64 0 0 1 6 7.332z"], Search: ["M3.275 5.55q-.95 0-1.613-.662A2.2 2.2 0 0 1 1 3.275q0-.95.662-1.613Q2.325 1 3.275 1t1.613.662q.662.663.662 1.613 0 .375-.107.694a2 2 0 0 1-.289.558l1.83 1.834q.123.13.124.311a.4.4 0 0 1-.13.307.42.42 0 0 1-.308.124.42.42 0 0 1-.309-.124L4.537 5.154a2 2 0 0 1-.568.289 2.2 2.2 0 0 1-.694.107m0-.883q.582 0 .987-.405c.405-.405.405-.599.405-.987s-.135-.717-.405-.987a1.34 1.34 0 0 0-.987-.405q-.582 0-.987.405c-.405.405-.405.599-.405.987s.135.717.405.987.599.405.987.405"], Select: ["M.444 1.778h7.111l.06-.004a.445.445 0 0 0-.059-.885H.444l-.06.004a.444.444 0 0 0 .06.885m0 2.37h4.741l.06-.004a.445.445 0 0 0-.059-.884H.444l-.06.004a.444.444 0 0 0 .06.884M2.815 5.63H.445l-.06.004a.444.444 0 0 0 .059.884h2.37l.06-.004a.444.444 0 0 0-.059-.884m4.969-2.307a.446.446 0 0 0-.61.152L5.689 5.95l-.782-.783-.05-.043a.445.445 0 0 0-.579.672l1.185 1.185.049.043c.206.154.509.1.646-.128l1.778-2.963.028-.054a.444.444 0 0 0-.18-.556"], Server: ["M3.468 1.92a.48.48 0 0 0-.354.146.48.48 0 0 0-.146.354q0 .21.146.354a.48.48 0 0 0 .354.146.48.48 0 0 0 .354-.146.48.48 0 0 0 .146-.354.48.48 0 0 0-.146-.354.48.48 0 0 0-.354-.146m0 3.47a.48.48 0 0 0-.354.145.48.48 0 0 0-.146.354q0 .21.146.354a.48.48 0 0 0 .354.146.48.48 0 0 0 .354-.146.48.48 0 0 0 .146-.354.48.48 0 0 0-.146-.354.48.48 0 0 0-.354-.146ZM2.279.852h5.378a.373.373 0 0 1 .38.383v2.36a.4.4 0 0 1-.11.28.36.36 0 0 1-.27.112H2.279a.36.36 0 0 1-.27-.112.4.4 0 0 1-.109-.28v-2.36a.373.373 0 0 1 .38-.383Zm0 3.468h5.378q.16 0 .27.113a.4.4 0 0 1 .109.279v2.36a.37.37 0 0 1-.11.272.37.37 0 0 1-.27.11H2.28a.37.37 0 0 1-.27-.11.37.37 0 0 1-.109-.271v-2.36q0-.166.11-.28a.36.36 0 0 1 .27-.112Z"], Shield: ["M4 7.316a.7.7 0 0 1-.208-.034A3.37 3.37 0 0 1 2 5.895a3.9 3.9 0 0 1-.667-2.18V2.142q0-.21.121-.375a.7.7 0 0 1 .313-.242l2-.75a.7.7 0 0 1 .466 0l2 .75q.192.075.313.242.12.166.12.375v1.575A3.9 3.9 0 0 1 6 5.896a3.37 3.37 0 0 1-1.792 1.387.7.7 0 0 1-.208.034Z"], ShieldSlash: ["M7.719 2.143V3.7a3.6 3.6 0 0 1-.147 1.022.41.41 0 0 1-.305.288.5.5 0 0 1-.213-.004.4.4 0 0 1-.203-.119L3.645 1.67a.37.37 0 0 1-.112-.265.4.4 0 0 1 .063-.212.37.37 0 0 1 .184-.146L4.719.7a.77.77 0 0 1 .53 0l1.977.74a.77.77 0 0 1 .356.275.72.72 0 0 1 .137.429ZM6.525 6.518a2.8 2.8 0 0 1-.603.486 3.4 3.4 0 0 1-.704.324.7.7 0 0 1-.234.038q-.044 0-.234-.04a3.43 3.43 0 0 1-1.822-1.411A3.95 3.95 0 0 1 2.25 3.7V2.243l-.608-.61a.33.33 0 0 1-.096-.243.334.334 0 0 1 .342-.34.33.33 0 0 1 .243.097l5.706 5.706a.33.33 0 0 1 .098.244.335.335 0 0 1-.342.342.33.33 0 0 1-.244-.097z"], Signal: ["M1.667 7a.64.64 0 0 1-.471-.196.64.64 0 0 1-.196-.47.64.64 0 0 1 .196-.471.64.64 0 0 1 .47-.196q.275 0 .472.196.195.195.195.47a.64.64 0 0 1-.196.471.64.64 0 0 1-.47.196m4.5 0a.47.47 0 0 1-.363-.158.65.65 0 0 1-.17-.375 4.6 4.6 0 0 0-.438-1.513 4.68 4.68 0 0 0-2.15-2.15 4.6 4.6 0 0 0-1.513-.437.65.65 0 0 1-.375-.171A.47.47 0 0 1 1 1.833a.46.46 0 0 1 .15-.354q.15-.137.358-.12a5.6 5.6 0 0 1 1.921.52 5.7 5.7 0 0 1 1.58 1.113q.683.683 1.112 1.579t.52 1.92a.46.46 0 0 1-.12.359.46.46 0 0 1-.354.15m-2 0a.5.5 0 0 1-.359-.146.66.66 0 0 1-.191-.354 2.5 2.5 0 0 0-.263-.754 2.7 2.7 0 0 0-.47-.63 2.7 2.7 0 0 0-.63-.47 2.5 2.5 0 0 0-.754-.263.66.66 0 0 1-.354-.191A.5.5 0 0 1 1 3.833q0-.216.15-.358.15-.141.358-.108.609.083 1.138.354a3.74 3.74 0 0 1 1.633 1.633q.27.53.354 1.138a.4.4 0 0 1-.108.358.47.47 0 0 1-.358.15"], Skull: ["M7.45 3.25A3.464 3.464 0 0 0 3.98 0 3.465 3.465 0 0 0 .53 3.28L.38 5.93c-.01.14.11.26.25.26h1.33l.19 1.49c.02.18.18.32.36.32h.41v-.73c-.01-.2.16-.36.36-.36.18 0 .34.14.36.32V8l.73-.01v-.72c0-.2.16-.37.36-.37.19 0 .34.14.36.32l.01.04v.73h.4c.19 0 .34-.14.36-.32l.18-1.5 1.33-.01c.14 0 .26-.12.25-.26zM2.36 5.09c-.5.01-.91-.4-.91-.9s.4-.91.9-.91c.51-.01.91.4.92.9 0 .5-.41.91-.91.91m3.27-.01c-.5 0-.91-.4-.91-.9 0-.51.4-.91.9-.92.51 0 .91.41.92.91 0 .5-.41.91-.91.91"], SpacebridgeDisabled: ["M6.903 1.076a.4.4 0 0 0-.558 0L5.112 2.318C3.8 1.165 2.257.73 1.494 1.493c-.771.771-.32 2.305.86 3.618L1.113 6.36a.4.4 0 0 0 0 .559c.15.15.399.15.558 0l5.232-5.294a.386.386 0 0 0 0-.559zm-2.81 2.27c-.728-.647-1.393-1.02-1.57-.833-.178.177.186.85.851 1.57l-.461.46c-.905-1.02-1.233-2.119-.86-2.491.372-.373 1.472-.063 2.51.833z", "M5.6 4.073c.523.807.665 1.57.372 1.862-.301.302-1.073.16-1.906-.38l-.577.576c1.17.806 2.377 1.02 3.033.372.638-.647.426-1.853-.364-2.988z", "m4.536 5.137.62-.611c.32.46.47.824.346.957-.142.124-.496-.018-.966-.346"], SpacebridgeEnabled: ["m5.578 1.87.745-.744c.15-.151.15-.4 0-.559a.4.4 0 0 0-.56 0l-.744.745a.4.4 0 0 0 0 .559c.15.15.399.15.559 0Z", "m6.145 3.529.169-.169a.386.386 0 0 0 0-.558.39.39 0 0 0-.55 0l-.107.106-.266-.292C4.026 1.25 2.314.682 1.49 1.507c-.639.639-.426 1.836.354 2.98l-.54.54a.4.4 0 0 0 0 .56c.16.15.407.15.558 0l.47-.47c.088.096.177.185.274.282h.001C3.973 6.767 5.684 7.334 6.5 6.518c.647-.647.434-1.844-.355-2.988Zm-.204 2.43c-.408.407-1.685-.018-2.775-1.118-1.1-1.09-1.526-2.367-1.118-2.784.408-.408 1.685.018 2.785 1.117.097.098.186.186.266.284l-.461.461-.133-.142-.133-.142c-.825-.816-1.65-1.312-1.862-1.108-.204.204.301 1.037 1.117 1.853s1.65 1.321 1.853 1.109c.133-.125-.018-.497-.337-.95l.435-.443c.523.807.665 1.561.363 1.863", "M1.676 7.448a.4.4 0 0 1 0-.558l.745-.745a.4.4 0 0 1 .558 0 .4.4 0 0 1 0 .558l-.744.745c-.16.151-.408.16-.559 0"], SplitBranch: ["M1.442 4.442a.43.43 0 0 1-.313-.13A.43.43 0 0 1 1 4q0-.184.129-.313a.43.43 0 0 1 .313-.129h2.204l1.502-1.502h-.274a.43.43 0 0 1-.313-.128.43.43 0 0 1-.129-.313q0-.184.129-.313a.43.43 0 0 1 .313-.129h1.333q.184 0 .313.129t.129.313v1.333a.43.43 0 0 1-.129.313.43.43 0 0 1-.313.129.43.43 0 0 1-.313-.129.43.43 0 0 1-.128-.313v-.274l-1.51 1.51a.87.87 0 0 1-.623.258zm3.432 2.385a.43.43 0 0 1-.313-.129.43.43 0 0 1-.129-.313q0-.184.129-.313a.43.43 0 0 1 .313-.129h.265L4.6 5.414a.43.43 0 0 1-.133-.315.43.43 0 0 1 .133-.315.44.44 0 0 1 .317-.136.43.43 0 0 1 .317.131l.53.538v-.265q0-.184.13-.313a.43.43 0 0 1 .312-.129q.184 0 .313.129t.129.313v1.333a.43.43 0 0 1-.129.313.43.43 0 0 1-.313.129z"], StatusActivating: ["M3.059 5.179h-.937a.38.38 0 0 1-.355-.21.39.39 0 0 1 .015-.418L4.276.682a.38.38 0 0 1 .227-.177.46.46 0 0 1 .512.189q.087.127.066.285l-.264 2.242h1.08q.257 0 .367.228a.38.38 0 0 1-.05.43l-2.706 3.43a.425.425 0 0 1-.517.122.43.43 0 0 1-.21-.193.4.4 0 0 1-.04-.275z"], StatusConfiguring: ["M3.443 7.423a.43.43 0 0 1-.284-.106.43.43 0 0 1-.151-.268l-.088-.676a3 3 0 0 1-.191-.094 1 1 0 0 1-.185-.124l-.638.264a.4.4 0 0 1-.309.013.4.4 0 0 1-.233-.198L.801 5.223a.44.44 0 0 1-.05-.296.4.4 0 0 1 .16-.248l.528-.407-.008-.114a1.4 1.4 0 0 1 0-.214q.005-.056.008-.116l-.52-.391a.38.38 0 0 1-.158-.254.46.46 0 0 1 .051-.301l.56-.978a.43.43 0 0 1 .533-.185l.603.245q.093-.069.207-.13a6 6 0 0 1 .21-.108l.083-.659A.4.4 0 0 1 3.155.8a.44.44 0 0 1 .288-.107h1.114q.158 0 .288.107.129.106.147.268l.08.67.208.108q.103.056.2.127l.61-.253a.4.4 0 0 1 .304-.011q.15.055.237.196l.56.981a.45.45 0 0 1 .049.3.4.4 0 0 1-.159.252l-.55.417q.01.054.012.11a4 4 0 0 1-.002.2l-.006.12.524.395a.423.423 0 0 1 .12.552l-.556 1a.4.4 0 0 1-.239.198.42.42 0 0 1-.314-.013l-.631-.264a3 3 0 0 1-.178.117q-.09.054-.181.093l-.088.687a.43.43 0 0 1-.152.268.43.43 0 0 1-.283.106zm.536-2.167q.505 0 .856-.35.35-.352.35-.856 0-.505-.35-.856a1.16 1.16 0 0 0-.856-.35 1.17 1.17 0 0 0-.854.35 1.16 1.16 0 0 0-.352.856q0 .504.352.855.353.35.854.35Z"], StatusConnected: ["M.833 1.333a.5.5 0 0 1 .5-.5 5.833 5.833 0 0 1 5.834 5.834.5.5 0 0 1-1 0 4.833 4.833 0 0 0-4.834-4.834.5.5 0 0 1-.5-.5m0 2a.5.5 0 0 1 .5-.5 3.833 3.833 0 0 1 3.834 3.834.5.5 0 0 1-1 0 2.833 2.833 0 0 0-2.834-2.834.5.5 0 0 1-.5-.5m.5 1.5a.5.5 0 0 0 0 1c.46 0 .834.373.834.834a.5.5 0 1 0 1 0 1.834 1.834 0 0 0-1.834-1.834"], StatusDeactivated: ["M6.286 1.714a.54.54 0 0 0-.762 0L4 3.238 2.476 1.714a.539.539 0 0 0-.762.762L3.238 4 1.714 5.524a.539.539 0 0 0 .762.762L4 4.762l1.524 1.524a.539.539 0 1 0 .762-.762L4.762 4l1.524-1.524a.54.54 0 0 0 0-.762"], StatusInventory: ["M1.866 1.081a.5.5 0 0 1 .432-.248H5.7a.5.5 0 0 1 .432.248l.851 1.459a.5.5 0 0 1 .068.252v3.875a.5.5 0 0 1-.5.5H1.447a.5.5 0 0 1-.5-.5V2.792a.5.5 0 0 1 .068-.252zm.719.752-.39.667H3.5v-.667zm1.914 0V2.5h1.304l-.389-.667H4.5ZM6.052 3.5H1.947v2.667h4.105zm-.831 2H4.18v-1h1.04v1Z"], StatusPaused: ["M2.667 1.333A.667.667 0 0 0 2 2v4a.667.667 0 0 0 1.333 0V2a.667.667 0 0 0-.666-.667m2.666 0A.667.667 0 0 0 4.667 2v4A.667.667 0 1 0 6 6V2a.667.667 0 0 0-.667-.667"], StatusReady: ["M4 2.09a1.91 1.91 0 1 0 0 3.82 1.91 1.91 0 0 0 0-3.82M1 4a3 3 0 1 1 6 0 3 3 0 0 1-6 0"], StatusShipped: ["M2.208 7.217a1.15 1.15 0 0 1-.844-.348 1.15 1.15 0 0 1-.347-.844H.875a.47.47 0 0 1-.347-.144.47.47 0 0 1-.145-.346q0-.201.145-.348a.47.47 0 0 1 .347-.145h.708a1.1 1.1 0 0 1 .285-.15 1 1 0 0 1 .34-.059q.18 0 .34.059t.285.15h1.692l.75-3.075H2.283a.47.47 0 0 1-.347-.144.47.47 0 0 1-.144-.346q0-.202.144-.348a.47.47 0 0 1 .347-.146H5.9q.225 0 .383.19a.45.45 0 0 1 .1.419l-.25 1.016h.192a1 1 0 0 1 .441.104q.21.105.359.296l.533.775a.95.95 0 0 1 .15.817l-.291 1.058a.48.48 0 0 1-.467.367H6.9q0 .5-.348.846-.347.346-.844.346a1.15 1.15 0 0 1-.844-.348 1.15 1.15 0 0 1-.347-.844H3.4q0 .5-.348.846-.347.346-.844.346m3.467-2.775h1.092l.05-.15-.492-.7h-.432zm-1.125.475.054-.212.13-.513.085-.37q.039-.171.073-.289l.05-.21.255-1.029.053-.21.025-.117-.75 3.075zM.594 4.683a.48.48 0 0 1-.348-.144.47.47 0 0 1-.146-.346q0-.201.144-.347A.47.47 0 0 1 .591 3.7h1.065q.202 0 .348.144a.47.47 0 0 1 .146.346q0 .201-.144.347a.47.47 0 0 1-.347.146zm.6-1.383a.48.48 0 0 1-.348-.144A.47.47 0 0 1 .7 2.81a.48.48 0 0 1 .144-.348.47.47 0 0 1 .347-.145h1.357q.202 0 .348.144a.47.47 0 0 1 .146.346q0 .201-.145.347a.47.47 0 0 1-.347.146zm1.013 2.933a.205.205 0 0 0 .21-.207.205.205 0 0 0-.207-.21.205.205 0 0 0-.21.208.205.205 0 0 0 .207.21Zm3.5 0a.205.205 0 0 0 .21-.207.205.205 0 0 0-.207-.21.205.205 0 0 0-.21.208.205.205 0 0 0 .207.21Z"], StatusTesting: ["M4 1a3 3 0 1 0 0 6 3 3 0 0 0 0-6M2.09 4A1.91 1.91 0 0 1 4 2.09v3.82A1.91 1.91 0 0 1 2.09 4"], SubmitTicket: ["M4.719 4.713a.34.34 0 0 0 .245-.105.34.34 0 0 0 .105-.245.34.34 0 0 0-.105-.246.34.34 0 0 0-.245-.104.34.34 0 0 0-.246.104.34.34 0 0 0-.104.246q0 .141.104.245t.246.105m0-1.033a.26.26 0 0 0 .17-.066.3.3 0 0 0 .102-.174.5.5 0 0 1 .075-.175q.054-.082.18-.207.248-.248.332-.404a.75.75 0 0 0 .085-.361.79.79 0 0 0-.262-.614q-.262-.236-.688-.236a1 1 0 0 0-.501.125.93.93 0 0 0-.358.356.18.18 0 0 0-.007.175.25.25 0 0 0 .14.134.23.23 0 0 0 .18.008.3.3 0 0 0 .146-.117.5.5 0 0 1 .176-.161.5.5 0 0 1 .224-.053.47.47 0 0 1 .326.111.38.38 0 0 1 .124.3.4.4 0 0 1-.067.221q-.067.105-.233.266-.227.195-.296.31a.74.74 0 0 0-.088.314.21.21 0 0 0 .06.173q.071.075.18.075M2.736 5.814a.73.73 0 0 1-.536-.222.73.73 0 0 1-.222-.536V1.104A.73.73 0 0 1 2.2.567a.73.73 0 0 1 .536-.222H6.69a.73.73 0 0 1 .536.222.73.73 0 0 1 .222.537v3.952a.73.73 0 0 1-.222.536.73.73 0 0 1-.536.222zM1.311 7.24a.73.73 0 0 1-.536-.222.73.73 0 0 1-.222-.536V2.15q0-.16.11-.27a.37.37 0 0 1 .27-.11q.158 0 .269.11.11.11.11.27v4.33h4.33q.16 0 .27.11a.37.37 0 0 1 .11.27.37.37 0 0 1-.11.27.37.37 0 0 1-.27.11h-4.33Z"], SwapSIM: ["M3.998 7.728a3.6 3.6 0 0 1-1.717-.417A3.75 3.75 0 0 1 .99 6.196v.503a.35.35 0 0 1-.105.258.35.35 0 0 1-.258.105.35.35 0 0 1-.259-.105.35.35 0 0 1-.104-.258v-1.35q0-.159.11-.27a.37.37 0 0 1 .269-.109h1.349a.35.35 0 0 1 .258.105.35.35 0 0 1 .105.258.35.35 0 0 1-.105.259.35.35 0 0 1-.258.105H1.53q.4.588 1.048.945A2.9 2.9 0 0 0 3.998 7a2.9 2.9 0 0 0 2.006-.766 2.93 2.93 0 0 0 .975-1.903.34.34 0 0 1 .129-.229.4.4 0 0 1 .255-.086.4.4 0 0 1 .26.092.24.24 0 0 1 .093.228q-.064.718-.381 1.336a3.78 3.78 0 0 1-1.963 1.794 3.6 3.6 0 0 1-1.374.262M4 1a2.9 2.9 0 0 0-2.006.766 2.93 2.93 0 0 0-.975 1.902.34.34 0 0 1-.129.23.4.4 0 0 1-.255.086.38.38 0 0 1-.26-.096.26.26 0 0 1-.091-.236 3.6 3.6 0 0 1 .38-1.325A3.8 3.8 0 0 1 2.621.535 3.6 3.6 0 0 1 4 .272a3.6 3.6 0 0 1 1.719.419q.785.419 1.289 1.113v-.503a.35.35 0 0 1 .106-.258.36.36 0 0 1 .26-.105.35.35 0 0 1 .258.105.35.35 0 0 1 .104.258v1.35a.37.37 0 0 1-.11.27.37.37 0 0 1-.269.109H6.008a.35.35 0 0 1-.258-.105.35.35 0 0 1-.105-.258q0-.154.105-.259a.35.35 0 0 1 .258-.105h.462a3 3 0 0 0-1.058-.948A2.9 2.9 0 0 0 4 1", "M3.148 5.453a.33.33 0 0 1-.33-.33V3.341a.33.33 0 0 1 .097-.233l.56-.56a.33.33 0 0 1 .233-.097h1.048a.33.33 0 0 1 .33.33v2.342a.33.33 0 0 1-.33.33z"], Sync: ["M1.5 4.02q0 .47.177.912t.552.818l.104.104V5.25q0-.177.12-.297t.297-.12c.177 0 .217.04.297.12q.12.12.12.297v1.667q0 .177-.12.297a.4.4 0 0 1-.297.12H1.083a.4.4 0 0 1-.297-.12.4.4 0 0 1-.12-.297q0-.177.12-.297t.297-.12h.73l-.167-.146a2.63 2.63 0 0 1-.76-1.094 3.7 3.7 0 0 1-.22-1.24 3.34 3.34 0 0 1 1.844-3 .32.32 0 0 1 .308-.01.38.38 0 0 1 .213.24.46.46 0 0 1-.005.313.45.45 0 0 1-.203.24 2.55 2.55 0 0 0-.964.921A2.44 2.44 0 0 0 1.5 4.021Zm5-.04q0-.47-.177-.912a2.4 2.4 0 0 0-.552-.818l-.104-.104v.604q0 .177-.12.297a.4.4 0 0 1-.297.12.4.4 0 0 1-.297-.12.4.4 0 0 1-.12-.297V1.083q0-.177.12-.297t.297-.12h1.667q.177 0 .297.12t.12.297-.12.297a.4.4 0 0 1-.297.12h-.73l.167.146a3.24 3.24 0 0 1 .98 2.333 3.34 3.34 0 0 1-1.844 3 .32.32 0 0 1-.308.01.38.38 0 0 1-.213-.239.46.46 0 0 1 .005-.312.44.44 0 0 1 .203-.24q.604-.334.964-.922c.36-.588.359-.825.359-1.297Z"], System: ["M1.673 3.407a3 3 0 0 1-.166-.08 1 1 0 0 1-.156-.098l-.218.066a.39.39 0 0 1-.436-.17l-.08-.137a.37.37 0 0 1-.047-.253.36.36 0 0 1 .127-.224l.165-.14a1 1 0 0 1 0-.363l-.165-.144a.37.37 0 0 1-.08-.47l.079-.14a.38.38 0 0 1 .442-.17l.213.066a1 1 0 0 1 .155-.098q.078-.042.166-.08l.044-.217A.38.38 0 0 1 2.091.45h.158q.138 0 .24.087a.4.4 0 0 1 .13.222l.044.213q.088.038.166.08.078.04.155.098l.214-.066a.39.39 0 0 1 .446.17l.076.131q.067.12.046.257a.36.36 0 0 1-.127.227l-.165.14a1 1 0 0 1 0 .362l.165.144a.37.37 0 0 1 .08.47l-.084.145a.37.37 0 0 1-.432.165l-.219-.066a1 1 0 0 1-.155.099 2 2 0 0 1-.165.079l-.044.217a.38.38 0 0 1-.375.305h-.158a.36.36 0 0 1-.24-.087.4.4 0 0 1-.13-.222zm.494-.586a.6.6 0 0 0 .446-.186.6.6 0 0 0 .186-.447.6.6 0 0 0-.186-.446.6.6 0 0 0-.447-.184.6.6 0 0 0-.445.185.6.6 0 0 0-.184.445.6.6 0 0 0 .185.447.6.6 0 0 0 .445.186M4.82 7.113a1.7 1.7 0 0 1-.33-.145 1.5 1.5 0 0 1-.288-.214l-.316.105a.44.44 0 0 1-.536-.198l-.09-.157a.45.45 0 0 1-.058-.303.44.44 0 0 1 .15-.27l.25-.218a1.9 1.9 0 0 1 0-.732l-.25-.221a.444.444 0 0 1-.093-.568l.09-.157a.44.44 0 0 1 .537-.199l.316.105q.13-.125.287-.214.156-.09.331-.145l.075-.341a.444.444 0 0 1 .442-.359h.2a.444.444 0 0 1 .442.358l.074.342a1.6 1.6 0 0 1 .613.359l.317-.105a.44.44 0 0 1 .537.198l.09.157a.45.45 0 0 1 .056.303.44.44 0 0 1-.15.27l-.25.217a1.9 1.9 0 0 1 0 .732l.25.222a.42.42 0 0 1 .15.268.44.44 0 0 1-.056.3l-.09.157a.44.44 0 0 1-.537.199l-.317-.105a1.5 1.5 0 0 1-.613.359l-.075.341a.444.444 0 0 1-.441.359h-.2a.444.444 0 0 1-.442-.358zm.617-.822a.9.9 0 0 0 .666-.275.9.9 0 0 0 .272-.668.9.9 0 0 0-.273-.669.9.9 0 0 0-.665-.275.9.9 0 0 0-.669.275.9.9 0 0 0-.275.668.9.9 0 0 0 .275.669.9.9 0 0 0 .669.275"], Tag: ["M3.725 7.333a.67.67 0 0 1-.475-.2L.867 4.75a.6.6 0 0 1-.146-.22.69.69 0 0 1 .146-.722L3.8.867a.7.7 0 0 1 .475-.2h2.392q.275 0 .47.195a.64.64 0 0 1 .196.471v2.392a.66.66 0 0 1-.191.467L4.2 7.133a.67.67 0 0 1-.475.2m2.108-4.666a.48.48 0 0 0 .354-.146.48.48 0 0 0 .146-.354.48.48 0 0 0-.146-.354.48.48 0 0 0-.354-.146.48.48 0 0 0-.354.145.48.48 0 0 0-.146.355q0 .209.146.354a.48.48 0 0 0 .354.146"], TagOutbound: ["m3.031 1.459.398-.402.006 1.418.004.046a.31.31 0 0 0 .306.262l.045-.003a.31.31 0 0 0 .262-.307l-.005-1.418.401.398.043.036a.31.31 0 0 0 .394-.037l.036-.043a.31.31 0 0 0-.037-.394L3.94.078 3.913.057 3.871.033 3.833.017l-.04-.011-.041-.005a.3.3 0 0 0-.123.018l-.04.018-.031.02-.042.036-.924.931-.03.034c-.227.291.19.682.469.401M2.85 4.21a.32.32 0 0 0-.33.33c0 .19.15.34.33.34s.33-.16.33-.34-.15-.33-.33-.33", "M6.22 5.44 4.13 3.37a.87.87 0 0 0-.59-.24H2.26c-.46.01-.82.38-.82.84v1.28c0 .21.09.43.25.58L3.78 7.9c.13.13.34.13.47 0l1.97-1.99c.13-.13.13-.34 0-.47M4.01 7.19 2.16 5.36a.17.17 0 0 1-.05-.12L2.1 3.96c0-.09.08-.16.17-.16h1.31c.03.01.06.02.08.04l1.85 1.84z"], TestMode: ["M4 1a3 3 0 1 0 0 6 3 3 0 0 0 0-6M2.09 4A1.91 1.91 0 0 1 4 2.09v3.82A1.91 1.91 0 0 1 2.09 4"], Transfer: ["M.537 7.138q.195.195.47.195h4q.275 0 .471-.195a.64.64 0 0 0 .196-.471V6.16a.75.75 0 0 0-.75-.75h-.956a.937.937 0 1 1 0-1.875h.956a.75.75 0 0 0 .75-.75V1.333a.64.64 0 0 0-.196-.47.64.64 0 0 0-.47-.196H2.616a.66.66 0 0 0-.467.191L.533 2.475a.65.65 0 0 0-.192.467v3.725q0 .275.196.47Z", "M6.27 4.913H3.973a.43.43 0 0 1-.313-.129.43.43 0 0 1-.129-.313q0-.183.13-.313a.43.43 0 0 1 .312-.128H6.27l-.279-.283a.4.4 0 0 1-.124-.305q0-.18.129-.313A.4.4 0 0 1 6.304 3q.185 0 .314.13l1.028 1.028a.43.43 0 0 1 .133.313.43.43 0 0 1-.133.314L6.614 5.818a.42.42 0 0 1-.307.127.43.43 0 0 1-.315-.132.42.42 0 0 1-.125-.308.42.42 0 0 1 .125-.309l.28-.283Z"], Trash: ["M2.333 7a.64.64 0 0 1-.47-.196.64.64 0 0 1-.196-.47V2a.32.32 0 0 1-.238-.096.32.32 0 0 1-.096-.237q0-.142.096-.238a.32.32 0 0 1 .238-.096H3q0-.141.096-.237A.32.32 0 0 1 3.333 1h1.334q.141 0 .237.096A.32.32 0 0 1 5 1.333h1.333q.142 0 .238.096a.32.32 0 0 1 .096.238.32.32 0 0 1-.096.237.32.32 0 0 1-.238.096v4.333a.64.64 0 0 1-.196.471.64.64 0 0 1-.47.196zm1-1.333a.32.32 0 0 0 .238-.096.32.32 0 0 0 .096-.238V3a.32.32 0 0 0-.096-.237.32.32 0 0 0-.238-.096.32.32 0 0 0-.237.096A.32.32 0 0 0 3 3v2.333q0 .142.096.238a.32.32 0 0 0 .237.096m1.334 0a.32.32 0 0 0 .237-.096A.32.32 0 0 0 5 5.333V3a.32.32 0 0 0-.096-.237.32.32 0 0 0-.237-.096.32.32 0 0 0-.238.096.32.32 0 0 0-.096.237v2.333q0 .142.096.238a.32.32 0 0 0 .238.096"], Type: ["M2.7 1.5c-.02-.05-.05-.07-.1-.07h-.71c-.05 0-.08.02-.1.07L.01 6.42c-.02.04 0 .07.05.07H.8c.05 0 .09-.03.1-.07l.35-.99h1.96l.34.99c.02.04.05.07.1.07h.76c.05 0 .06-.03.05-.07zM1.52 4.65l.7-1.96h.02l.69 1.96zm6.13-1.53c-.23-.2-.63-.3-1.19-.3-.31 0-.57.03-.77.1-.21.06-.39.15-.54.25-.04.02-.04.06-.02.1l.29.49c.02.04.06.05.1.01.09-.07.2-.12.33-.17.14-.05.31-.07.52-.07.31 0 .52.04.64.14q.18.135.18.45v.17c0 .03-.02.05-.05.05h-.75q-.69 0-1.08.27c-.27.19-.4.48-.4.87a1 1 0 0 0 .37.82c.11.09.24.16.39.2.15.05.31.07.48.07.26 0 .48-.04.65-.11.18-.08.31-.18.4-.31v.27c0 .04.03.07.08.07h.64c.05 0 .08-.03.08-.07V4.07c0-.44-.12-.75-.35-.95m-.46 2.16c0 .21-.07.37-.21.47-.14.09-.35.14-.61.14-.43 0-.64-.14-.64-.44 0-.17.07-.29.19-.37.13-.08.33-.12.61-.12h.61c.03 0 .05.02.05.05z"], Unlock: ["M4 5.667q.275 0 .47-.196A.64.64 0 0 0 4.668 5a.64.64 0 0 0-.196-.47A.64.64 0 0 0 4 4.332a.64.64 0 0 0-.47.196.64.64 0 0 0-.197.471q0 .275.196.47.196.197.471.197ZM2 7.333a.64.64 0 0 1-.47-.196.64.64 0 0 1-.197-.47V3.333q0-.275.196-.47A.64.64 0 0 1 2 2.666h2.333V2q0-.691.488-1.18A1.6 1.6 0 0 1 6 .334a1.6 1.6 0 0 1 1.088.405q.462.403.554.995a.2.2 0 0 1-.075.188.34.34 0 0 1-.234.078.43.43 0 0 1-.233-.058.33.33 0 0 1-.133-.192 1.06 1.06 0 0 0-.354-.533A.93.93 0 0 0 6 1a.96.96 0 0 0-.708.292A.96.96 0 0 0 5 2v.667h1q.275 0 .47.196a.64.64 0 0 1 .197.47v3.334q0 .275-.196.47A.64.64 0 0 1 6 7.333z"], UploadTray: ["M1.53 7.418a.9.9 0 0 1-.67-.277.9.9 0 0 1-.278-.67v-.777q0-.2.137-.337a.46.46 0 0 1 .337-.137q.2 0 .337.137a.46.46 0 0 1 .137.337v.776h4.94v-.776q0-.2.137-.337a.46.46 0 0 1 .337-.137q.2 0 .337.137a.46.46 0 0 1 .137.337v.776a.9.9 0 0 1-.277.67.9.9 0 0 1-.67.278zM3.526 2.4l-.724.724a.47.47 0 0 1-.67-.005.5.5 0 0 1-.14-.333.44.44 0 0 1 .14-.333L3.665.916A.4.4 0 0 1 3.82.814a.5.5 0 0 1 .358 0 .4.4 0 0 1 .155.102L5.87 2.453a.44.44 0 0 1 .136.332.48.48 0 0 1-.472.478.45.45 0 0 1-.337-.139L4.474 2.4v2.763a.46.46 0 0 1-.137.337.46.46 0 0 1-.337.137.46.46 0 0 1-.337-.137.46.46 0 0 1-.137-.337z"], User: ["M4 4q-.55 0-.942-.392a1.28 1.28 0 0 1-.391-.941q0-.55.391-.942.392-.392.942-.392c.55 0 .68.13.942.392q.39.392.391.942 0 .55-.391.941A1.28 1.28 0 0 1 4 4M1.333 6v-.267q0-.283.146-.52a.97.97 0 0 1 .388-.363 5 5 0 0 1 1.05-.387 4.6 4.6 0 0 1 2.166 0q.534.129 1.05.387.241.125.388.363a1 1 0 0 1 .146.52V6q0 .275-.196.47A.64.64 0 0 1 6 6.668H2a.64.64 0 0 1-.47-.196A.64.64 0 0 1 1.332 6Z"], Visible: ["M4 5.333q.624 0 1.063-.437A1.45 1.45 0 0 0 5.5 3.833q0-.624-.438-1.062A1.45 1.45 0 0 0 4 2.333q-.625 0-1.063.438A1.45 1.45 0 0 0 2.5 3.833q0 .625.438 1.063.437.437 1.062.437m0-.6a.87.87 0 0 1-.638-.262.87.87 0 0 1-.262-.638q0-.375.262-.637A.87.87 0 0 1 4 2.933a.87.87 0 0 1 .638.263.87.87 0 0 1 .262.637.87.87 0 0 1-.263.638.87.87 0 0 1-.637.262m0 1.6q-1.116 0-2.038-.6A4.3 4.3 0 0 1 .508 4.15a.7.7 0 0 1-.083-.317.64.64 0 0 1 .083-.316 4.3 4.3 0 0 1 1.454-1.584q.922-.6 2.038-.6 1.117 0 2.037.6a4.3 4.3 0 0 1 1.455 1.584.7.7 0 0 1 .083.316.64.64 0 0 1-.083.317 4.3 4.3 0 0 1-1.455 1.583q-.92.6-2.037.6"], Warning: ["M.933 6.8a.3.3 0 0 1-.266-.15.25.25 0 0 1-.038-.15.4.4 0 0 1 .046-.158l3.067-5.117a.25.25 0 0 1 .112-.108.34.34 0 0 1 .292 0 .25.25 0 0 1 .112.108l3.067 5.117a.4.4 0 0 1 .046.158.25.25 0 0 1-.038.15.34.34 0 0 1-.108.108.3.3 0 0 1-.158.042zm3.065-1a.294.294 0 0 0 .302-.298.294.294 0 0 0-.298-.302.294.294 0 0 0-.302.298.294.294 0 0 0 .298.302m0-1a.3.3 0 0 0 .215-.086A.3.3 0 0 0 4.3 4.5v-1a.3.3 0 0 0-.086-.214.3.3 0 0 0-.212-.086.3.3 0 0 0-.214.086.3.3 0 0 0-.088.214v1q0 .127.086.214a.3.3 0 0 0 .212.086"], ZeroData: ["M4 7.333q-.691 0-1.3-.262a3.4 3.4 0 0 1-1.058-.713q-.45-.45-.713-1.058A3.25 3.25 0 0 1 .667 4q0-.691.262-1.3.263-.609.713-1.058T2.7.929A3.25 3.25 0 0 1 4 .667q.691 0 1.3.262.608.263 1.058.713T7.071 2.7 7.333 4t-.262 1.3a3.4 3.4 0 0 1-.713 1.058q-.45.45-1.058.713a3.25 3.25 0 0 1-1.3.262m-.333-1.666h.666q.275 0 .471-.196A.64.64 0 0 0 5 5V3a.64.64 0 0 0-.196-.47.64.64 0 0 0-.47-.197h-.667a.64.64 0 0 0-.471.196A.64.64 0 0 0 3 3v2q0 .275.196.47a.64.64 0 0 0 .47.197Zm0-2.667h.666v2h-.666z"] };
var g4 = {
  DdsColorPaletteGrey3: "#00040f",
  DdsColorPaletteGrey10: "#14161f",
  DdsColorPaletteGrey20: "#2b2f3b",
  DdsColorPaletteGrey25: "#3a3c46",
  DdsColorPaletteGrey30: "#474a52",
  DdsColorPaletteGrey45: "#6e7079",
  DdsColorPaletteGrey50: "#797c86",
  DdsColorPaletteGrey60: "#95979e",
  DdsColorPaletteGrey75: "#bbbcc2",
  DdsColorPaletteGrey88: "#dedfe4",
  DdsColorPaletteGrey93: "#ebecef",
  DdsColorPaletteGrey98: "#f8f8fa",
  DdsColorPaletteGrey100: "#ffffff",
  DdsColorPaletteBlue10: "#090033",
  DdsColorPaletteBlue20: "#110165",
  DdsColorPaletteBlue30: "#1a0198",
  DdsColorPaletteBlue43: "#2401da",
  DdsColorPaletteBlue50: "#2a01fe",
  DdsColorPaletteBlue59: "#2f6aff",
  DdsColorPaletteBlue70: "#6692ff",
  DdsColorPaletteBlue80: "#99b6ff",
  DdsColorPaletteBlue90: "#ccdbff",
  DdsColorPaletteBlue95: "#e5edff",
  DdsColorPaletteGreen10: "#03301c",
  DdsColorPaletteGreen20: "#06603c",
  DdsColorPaletteGreen32: "#0a9959",
  DdsColorPaletteGreen43: "#0ecb76",
  DdsColorPaletteGreen50: "#0fe182",
  DdsColorPaletteGreen60: "#40f2a2",
  DdsColorPaletteGreen70: "#81f3c4",
  DdsColorPaletteGreen82: "#b1f1e2",
  DdsColorPaletteGreen90: "#cffce8",
  DdsColorPaletteGreen94: "#e2fdf1",
  DdsColorPaletteLime10: "#183300",
  DdsColorPaletteLime20: "#366501",
  DdsColorPaletteLime30: "#479801",
  DdsColorPaletteLime40: "#95cb01",
  DdsColorPaletteLime50: "#bffd11",
  DdsColorPaletteLime64: "#cdfe48",
  DdsColorPaletteLime73: "#dafe76",
  DdsColorPaletteLime80: "#e4fe9a",
  DdsColorPaletteLime90: "#ebffcc",
  DdsColorPaletteLime95: "#f5ffe5",
  DdsColorPaletteOrange10: "#2b0d08",
  DdsColorPaletteOrange20: "#561910",
  DdsColorPaletteOrange33: "#8e2a1a",
  DdsColorPaletteOrange38: "#c23200",
  DdsColorPaletteOrange50: "#ff4200",
  DdsColorPaletteOrange60: "#ff6631",
  DdsColorPaletteOrange70: "#ffb068",
  DdsColorPaletteOrange80: "#ffca99",
  DdsColorPaletteOrange90: "#ffe4cc",
  DdsColorPaletteOrange95: "#fff1e5",
  DdsColorPalettePink10: "#33001c",
  DdsColorPalettePink20: "#660039",
  DdsColorPalettePink33: "#a8005e",
  DdsColorPalettePink44: "#e0007d",
  DdsColorPalettePink55: "#ff1a99",
  DdsColorPalettePink66: "#ff54b3",
  DdsColorPalettePink70: "#ff66bb",
  DdsColorPalettePink80: "#ff99d2",
  DdsColorPalettePink90: "#ffcce8",
  DdsColorPalettePink95: "#ffe5fa",
  DdsColorPalettePurple10: "#190033",
  DdsColorPalettePurple20: "#330165",
  DdsColorPalettePurple30: "#4c0198",
  DdsColorPalettePurple40: "#6606c6",
  DdsColorPalettePurple50: "#8008f7",
  DdsColorPalettePurple60: "#a533ff",
  DdsColorPalettePurple75: "#c780ff",
  DdsColorPalettePurple80: "#d299ff",
  DdsColorPalettePurple90: "#e9ccff",
  DdsColorPalettePurple95: "#f4e5ff",
  DdsColorPaletteRed10: "#330000",
  DdsColorPaletteRed20: "#660000",
  DdsColorPaletteRed33: "#a80000",
  DdsColorPaletteRed43: "#db0000",
  DdsColorPaletteRed50: "#ff0000",
  DdsColorPaletteRed60: "#ff3333",
  DdsColorPaletteRed75: "#ff8282",
  DdsColorPaletteRed86: "#ffb8b8",
  DdsColorPaletteRed90: "#ffcccc",
  DdsColorPaletteRed95: "#ffe5e6",
  DdsColorPaletteTeal10: "#002833",
  DdsColorPaletteTeal20: "#005166",
  DdsColorPaletteTeal30: "#007999",
  DdsColorPaletteTeal40: "#099fc3",
  DdsColorPaletteTeal49: "#00ebfa",
  DdsColorPaletteTeal60: "#33daff",
  DdsColorPaletteTeal70: "#6dddf8",
  DdsColorPaletteTeal80: "#9ee9fa",
  DdsColorPaletteTeal90: "#cef4fd",
  DdsColorPaletteTeal95: "#e7f9fe",
  DdsColorPaletteYellow10: "#331c00",
  DdsColorPaletteYellow20: "#663800",
  DdsColorPaletteYellow33: "#a85d00",
  DdsColorPaletteYellow44: "#e0a500",
  DdsColorPaletteYellow50: "#ffbb00",
  DdsColorPaletteYellow66: "#ffe552",
  DdsColorPaletteYellow75: "#ffec80",
  DdsColorPaletteYellow80: "#fff099",
  DdsColorPaletteYellow90: "#fff7cc",
  DdsColorPaletteYellow95: "#fffbe5",
  DdsColorPaletteBlack: "#00040f",
  DdsColorPaletteWhite: "#ffffff",
  DdsColorTextPrimaryOndefault: "#00040f",
  DdsColorTextPrimaryOninverse: "#ffffff",
  DdsColorTextDiminishedOndefault: "#797c86",
  DdsColorTextDiminishedOninverse: "#bbbcc2",
  DdsColorTextDisabledOndefault: "#bbbcc2",
  DdsColorTextLinkDefault: "#6606c6",
  DdsColorTextLinkHover: "#330165",
  DdsColorTextLinkActive: "#4c0198",
  DdsColorTextLinkDisabled: "#d299ff",
  DdsColorTextInvalidOndefault: "#a80000",
  DdsColorTextDangerDefault: "#a80000",
  DdsColorTextDangerHover: "#660000",
  DdsColorTextDangerActive: "#330000",
  DdsColorTextDangerDisabled: "#ffb8b8",
  DdsColorTextWarningDefault: "#a85d00",
  DdsColorBorderControlDefault: "#bbbcc2",
  DdsColorBorderControlHover: "#95979e",
  DdsColorBorderControlActive: "#797c86",
  DdsColorBorderControlDisabled: "#dedfe4",
  DdsColorBorderControlInvalid: "#a80000",
  DdsColorBorderDividerDefault: "#dedfe4",
  DdsColorBorderDividerDark: "#6e7079",
  DdsColorBorderContainerDefault: "#dedfe4",
  DdsColorBorderNotificationCaution: "#ffbb00",
  DdsColorBorderNotificationError: "#a80000",
  DdsColorBorderNotificationHighlight: "#bffd11",
  DdsColorBorderNotificationNote: "#007999",
  DdsColorBorderNotificationSuccess: "#06603c",
  DdsColorBorderAdmin: "#ff8282",
  DdsColorInteractivePrimaryDefault: "#8008f7",
  DdsColorInteractivePrimaryHover: "#6606c6",
  DdsColorInteractivePrimaryActive: "#4c0198",
  DdsColorInteractivePrimaryDisabled: "#e9ccff",
  DdsColorInteractiveSecondaryDefault: "#ffffff",
  DdsColorInteractiveSecondaryHover: "#f8f8fa",
  DdsColorInteractiveSecondaryActive: "#ebecef",
  DdsColorInteractiveSecondaryDisabled: "#f8f8fa",
  DdsColorInteractiveDangerDefault: "#db0000",
  DdsColorInteractiveDangerHover: "#a80000",
  DdsColorInteractiveDangerActive: "#660000",
  DdsColorInteractiveDangerDisabled: "#ffb8b8",
  DdsColorInteractiveFocusringInner: "#ffffff",
  DdsColorInteractiveFocusringOuter: "#00040f",
  DdsColorRequiredindicator: "#a80000",
  DdsColorBackgroundDefault: "#ffffff",
  DdsColorBackgroundAlternative: "#f8f8fa",
  DdsColorBackgroundInverse: "#14161f",
  DdsColorBackgroundNotificationDanger: "#ffe5e6",
  DdsColorBackgroundNotificationError: "#ffe5e6",
  DdsColorBackgroundNotificationSuccess: "#e2fdf1",
  DdsColorBackgroundNotificationCaution: "#fff7cc",
  DdsColorBackgroundNotificationNeutral: "#f8f8fa",
  DdsColorBackgroundNotificationNote: "#e7f9fe",
  DdsColorBackgroundAdmin: "#ff8282",
  DdsColorBackgroundHighlight: "#dafe76",
  DdsColorIconDefault: "#00040f",
  DdsColorIconDiminished: "#797c86",
  DdsColorIconDanger: "#db0000",
  DdsColorIconDisabled: "#95979e",
  DdsColorIconSuccess: "#0a9959",
  DdsColorIconCaution: "#ff6631",
  DdsColorIconWarning: "#ffbb00",
  DdsColorIconNote: "#099fc3",
  DdsColorIconAdmin: "#ff8282",
  DdsColorFillNotificationError: "#db0000",
  DdsColorFillNotificationSuccess: "#0a9959",
  DdsColorFillNotificationCaution: "#ffbb00",
  DdsColorFillNotificationNote: "#099fc3",
  DdsColorFillNotificationHighlight: "#bffd11"
};
const h3 = "dds-icon-v0174";
function y4({
  className: e = "",
  fill: a = "currentColor",
  name: t = "CircleInfo",
  size: r = "medium",
  title: n,
  ...c
}) {
  const u = m4[t], l = a === "currentColor" ? "currentColor" : g4[a], o = {
    "aria-hidden": "true"
  };
  n !== void 0 && (delete o["aria-hidden"], o.role = "img");
  const i = (d = {}) => Object.keys(d).filter((f) => !!d[f]).join(" "), s = {
    [h3]: !0,
    [`${h3}--${r}`]: !0,
    [e]: e.length > 0
  };
  return u ? /* @__PURE__ */ l0(
    "svg",
    {
      className: i(s),
      ...c,
      viewBox: "0 0 8 8",
      preserveAspectRatio: "xMidYMid meet",
      fill: l,
      ...o,
      children: [
        n !== void 0 ? /* @__PURE__ */ Q("title", { children: n }) : "",
        u.map((d, f) => (
          // eslint-disable-next-line react/no-array-index-key
          /* @__PURE__ */ Q("path", { d }, `iconpath-${f}`)
        ))
      ]
    }
  ) : null;
}
const e0 = "dds-modal-v0195";
function n1(e) {
  return !!e && Object.prototype.hasOwnProperty.call(e, "current");
}
function M4({
  activator: e,
  ariaLabel: a,
  ariaLabelledby: t,
  contentWell: r,
  children: n,
  className: c = "",
  footer: u,
  footerActions: l,
  footerVariant: o = "default",
  header: i,
  noCloseButton: s = !1,
  defaultOpen: d = !1,
  onOpened: f,
  onClosed: v,
  open: h,
  setOpen: y,
  roleOverride: g = "dialog",
  noContentPadding: p,
  initialFocusRef: P,
  isLoading: b = !1,
  ...H
}) {
  const [A, m] = F3(d), E = h ?? A, x = y ?? m, { refs: I, context: T } = w3({
    open: E,
    onOpenChange: x
  }), { isMounted: L, status: S } = S3(T, { duration: 500 }), $ = $3(E);
  C1(() => {
    $.current !== L && ($.current = L, L ? f && f() : v && v());
  }, [L, v, f]);
  const Z = T3(T), M = N3(T, { role: g }), C = V3(T, { outsidePressEvent: "mousedown" }), { getReferenceProps: O, getFloatingProps: F } = z3([Z, M, C]), _ = y1(), q = y1(), D = x3([I.setReference, n1(e) ? e : void 0]), N = j3(() => e && !n1(e) && A1(e) ? k3(
    e,
    O({
      ref: D,
      ...e.props,
      "data-state": T.open ? "open" : "closed"
    })
  ) : /* @__PURE__ */ Q("div", { ref: D, ...O(), "data-state": T.open ? "open" : "closed" }), [e, T.open, O, D]), z = W3(() => {
    var j, B;
    n1(e) ? (j = e.current) == null || j.focus() : A1(e) && ((B = D.current) == null || B.focus());
  }, [e, D]);
  C1(() => {
    S === "unmounted" && z();
  }, [z, S]);
  const V = t ?? _;
  return /* @__PURE__ */ l0(O3, { children: [
    N,
    /* @__PURE__ */ Q(I3, { children: L && /* @__PURE__ */ Q(
      Z3,
      {
        lockScroll: !0,
        className: I0({
          [`${e0}__backdrop`]: !0
        }),
        "data-status": S,
        children: /* @__PURE__ */ Q(
          B3,
          {
            context: T,
            disabled: !L,
            initialFocus: P,
            children: /* @__PURE__ */ l0(
              "div",
              {
                "aria-label": a,
                "aria-labelledby": a ? void 0 : V,
                "aria-describedby": q,
                className: I0({
                  [e0]: !0,
                  [c]: c.length > 0,
                  [`${e0}--footer-${o}`]: !0,
                  [`${e0}--loading`]: b
                }),
                ref: I.setFloating,
                "data-status": S,
                "aria-modal": !0,
                ...F(),
                ...H,
                children: [
                  b && /* @__PURE__ */ Q("div", { className: `${e0}__loader`, children: /* @__PURE__ */ Q("div", { className: `${e0}__loaderAnimation` }) }),
                  /* @__PURE__ */ l0("div", { id: _, className: `${e0}__header`, children: [
                    i,
                    !s && /* @__PURE__ */ Q(
                      q4,
                      {
                        variant: "tertiary",
                        className: `${e0}__close-button`,
                        name: "Close modal",
                        "aria-label": "Close modal",
                        iconStart: /* @__PURE__ */ Q(
                          y4,
                          {
                            name: "Close",
                            size: "large",
                            className: `${e0}__close-glyph`
                          }
                        ),
                        onClick: () => x(!1)
                      }
                    )
                  ] }),
                  r && /* @__PURE__ */ Q("div", { className: `${e0}__content-well`, children: r }),
                  /* @__PURE__ */ Q(
                    "div",
                    {
                      id: q,
                      className: I0({
                        [`${e0}__inner`]: !0,
                        [`${e0}__inner-padding`]: !p
                      }),
                      children: n
                    }
                  ),
                  (u || l) && /* @__PURE__ */ l0("div", { className: `${e0}__footer`, children: [
                    u && /* @__PURE__ */ Q("div", { className: `${e0}__footer-left`, children: u }),
                    l && /* @__PURE__ */ Q("div", { className: `${e0}__footer-right`, children: l })
                  ] })
                ]
              }
            )
          }
        )
      }
    ) })
  ] });
}
export {
  M4 as Modal
};
//# sourceMappingURL=index.js.map
